(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired43a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired43a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
'use strict';

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$k = Symbol.for("react.element"), $5ef850295e0236ca$var$l = Symbol.for("react.fragment"), $5ef850295e0236ca$var$m = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$n = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$5ef850295e0236ca$var$m.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $5ef850295e0236ca$var$n.current
    };
}
$5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$l;
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $dd934af551f44020$export$3ba232387fd5d6dd, (v) => $dd934af551f44020$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $dd934af551f44020$export$7568632d0d33d16d, (v) => $dd934af551f44020$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $dd934af551f44020$export$88948ce120ea2619, (v) => $dd934af551f44020$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $dd934af551f44020$export$6a7bc4e911dc01cf, (v) => $dd934af551f44020$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $dd934af551f44020$export$f680877a34711e37, (v) => $dd934af551f44020$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $dd934af551f44020$export$aaabe4eda9ed9969, (v) => $dd934af551f44020$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $dd934af551f44020$export$306c0aa65ff9ec16, (v) => $dd934af551f44020$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $dd934af551f44020$export$7b286972b8d8ccbf, (v) => $dd934af551f44020$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$3ba232387fd5d6dd;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$7568632d0d33d16d;
var $dd934af551f44020$export$88948ce120ea2619;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6a7bc4e911dc01cf;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$f680877a34711e37;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$aaabe4eda9ed9969;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$306c0aa65ff9ec16;
var $dd934af551f44020$export$7b286972b8d8ccbf;
var $dd934af551f44020$export$83d89fbfd8236492;
'use strict';
var $dd934af551f44020$var$l = Symbol.for("react.element"), $dd934af551f44020$var$n = Symbol.for("react.portal"), $dd934af551f44020$var$p = Symbol.for("react.fragment"), $dd934af551f44020$var$q = Symbol.for("react.strict_mode"), $dd934af551f44020$var$r = Symbol.for("react.profiler"), $dd934af551f44020$var$t = Symbol.for("react.provider"), $dd934af551f44020$var$u = Symbol.for("react.context"), $dd934af551f44020$var$v = Symbol.for("react.forward_ref"), $dd934af551f44020$var$w = Symbol.for("react.suspense"), $dd934af551f44020$var$x = Symbol.for("react.memo"), $dd934af551f44020$var$y = Symbol.for("react.lazy"), $dd934af551f44020$var$z = Symbol.iterator;
function $dd934af551f44020$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$z && a[$dd934af551f44020$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd934af551f44020$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$C = Object.assign, $dd934af551f44020$var$D = {};
function $dd934af551f44020$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
$dd934af551f44020$var$E.prototype.isReactComponent = {};
$dd934af551f44020$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$F() {}
$dd934af551f44020$var$F.prototype = $dd934af551f44020$var$E.prototype;
function $dd934af551f44020$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$D;
    this.updater = e || $dd934af551f44020$var$B;
}
var $dd934af551f44020$var$H = $dd934af551f44020$var$G.prototype = new $dd934af551f44020$var$F;
$dd934af551f44020$var$H.constructor = $dd934af551f44020$var$G;
$dd934af551f44020$var$C($dd934af551f44020$var$H, $dd934af551f44020$var$E.prototype);
$dd934af551f44020$var$H.isPureReactComponent = !0;
var $dd934af551f44020$var$I = Array.isArray, $dd934af551f44020$var$J = Object.prototype.hasOwnProperty, $dd934af551f44020$var$K = {
    current: null
}, $dd934af551f44020$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$J.call(b, d) && !$dd934af551f44020$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd934af551f44020$var$K.current
    };
}
function $dd934af551f44020$var$N(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$l;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$P = /\/+/g;
function $dd934af551f44020$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$l:
                case $dd934af551f44020$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd934af551f44020$var$Q(h, 0) : d, $dd934af551f44020$var$I(c) ? (e = "", null != a && (e = a.replace($dd934af551f44020$var$P, "$&/") + "/"), $dd934af551f44020$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd934af551f44020$var$O(c) && (c = $dd934af551f44020$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd934af551f44020$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd934af551f44020$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd934af551f44020$var$Q(k, g);
        h += $dd934af551f44020$var$R(k, b, e, f, c);
    }
    else if (f = $dd934af551f44020$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd934af551f44020$var$Q(k, g++), h += $dd934af551f44020$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd934af551f44020$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd934af551f44020$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd934af551f44020$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd934af551f44020$var$U = {
    current: null
}, $dd934af551f44020$var$V = {
    transition: null
}, $dd934af551f44020$var$W = {
    ReactCurrentDispatcher: $dd934af551f44020$var$U,
    ReactCurrentBatchConfig: $dd934af551f44020$var$V,
    ReactCurrentOwner: $dd934af551f44020$var$K
};
function $dd934af551f44020$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$S,
    forEach: function(a, b, e) {
        $dd934af551f44020$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$E;
$dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$p;
$dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$r;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$G;
$dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$q;
$dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$W;
$dd934af551f44020$export$3ba232387fd5d6dd = $dd934af551f44020$var$X;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd934af551f44020$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$J.call(b, f) && !$dd934af551f44020$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd934af551f44020$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$M;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$O;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$T
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$7568632d0d33d16d = function(a) {
    var b = $dd934af551f44020$var$V.transition;
    $dd934af551f44020$var$V.transition = {};
    try {
        a();
    } finally{
        $dd934af551f44020$var$V.transition = b;
    }
};
$dd934af551f44020$export$88948ce120ea2619 = $dd934af551f44020$var$X;
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$U.current.useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a) {
    return $dd934af551f44020$var$U.current.useContext(a);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6a7bc4e911dc01cf = function(a) {
    return $dd934af551f44020$var$U.current.useDeferredValue(a);
};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$U.current.useEffect(a, b);
};
$dd934af551f44020$export$f680877a34711e37 = function() {
    return $dd934af551f44020$var$U.current.useId();
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useImperativeHandle(a, b, e);
};
$dd934af551f44020$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd934af551f44020$var$U.current.useInsertionEffect(a, b);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$U.current.useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$U.current.useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useReducer(a, b, e);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$U.current.useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$U.current.useState(a);
};
$dd934af551f44020$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd934af551f44020$var$U.current.useSyncExternalStore(a, b, e);
};
$dd934af551f44020$export$7b286972b8d8ccbf = function() {
    return $dd934af551f44020$var$U.current.useTransition();
};
$dd934af551f44020$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("23wBm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $17f526922e4a857c$export$ae55be85d98224ed, (v) => $17f526922e4a857c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $17f526922e4a857c$export$d39a5bbd09211389, (v) => $17f526922e4a857c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $17f526922e4a857c$export$882461b6382ed46c, (v) => $17f526922e4a857c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $17f526922e4a857c$export$466bfc07425424d5, (v) => $17f526922e4a857c$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $17f526922e4a857c$export$cd75ccfd720a3cd4, (v) => $17f526922e4a857c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $17f526922e4a857c$export$fa8d919ba61d84db, (v) => $17f526922e4a857c$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $17f526922e4a857c$export$757ceba2d55c277e, (v) => $17f526922e4a857c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $17f526922e4a857c$export$b3890eb0ae9dca99, (v) => $17f526922e4a857c$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $17f526922e4a857c$export$502457920280e6be, (v) => $17f526922e4a857c$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $17f526922e4a857c$export$c78a37762a8d58e1, (v) => $17f526922e4a857c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $17f526922e4a857c$export$dc54d992c10e8a18, (v) => $17f526922e4a857c$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $17f526922e4a857c$export$83d89fbfd8236492, (v) => $17f526922e4a857c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $17f526922e4a857c$export$ae55be85d98224ed;
var $17f526922e4a857c$export$d39a5bbd09211389;
var $17f526922e4a857c$export$882461b6382ed46c;
var $17f526922e4a857c$export$466bfc07425424d5;
var $17f526922e4a857c$export$cd75ccfd720a3cd4;
var $17f526922e4a857c$export$fa8d919ba61d84db;
var $17f526922e4a857c$export$757ceba2d55c277e;
var $17f526922e4a857c$export$b3890eb0ae9dca99;
var $17f526922e4a857c$export$502457920280e6be;
var $17f526922e4a857c$export$c78a37762a8d58e1;
var $17f526922e4a857c$export$dc54d992c10e8a18;
var $17f526922e4a857c$export$83d89fbfd8236492;
'use strict';

var $8NFma = parcelRequire("8NFma");

var $clk2u = parcelRequire("clk2u");
function $17f526922e4a857c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $17f526922e4a857c$var$da = new Set, $17f526922e4a857c$var$ea = {};
function $17f526922e4a857c$var$fa(a, b) {
    $17f526922e4a857c$var$ha(a, b);
    $17f526922e4a857c$var$ha(a + "Capture", b);
}
function $17f526922e4a857c$var$ha(a, b) {
    $17f526922e4a857c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$17f526922e4a857c$var$da.add(b[a]);
}
var $17f526922e4a857c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $17f526922e4a857c$var$ja = Object.prototype.hasOwnProperty, $17f526922e4a857c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $17f526922e4a857c$var$la = {}, $17f526922e4a857c$var$ma = {};
function $17f526922e4a857c$var$oa(a) {
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$ma, a)) return !0;
    if ($17f526922e4a857c$var$ja.call($17f526922e4a857c$var$la, a)) return !1;
    if ($17f526922e4a857c$var$ka.test(a)) return $17f526922e4a857c$var$ma[a] = !0;
    $17f526922e4a857c$var$la[a] = !0;
    return !1;
}
function $17f526922e4a857c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $17f526922e4a857c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $17f526922e4a857c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $17f526922e4a857c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $17f526922e4a857c$var$ra = /[\-:]([a-z])/g;
function $17f526922e4a857c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($17f526922e4a857c$var$ra, $17f526922e4a857c$var$sa);
    $17f526922e4a857c$var$z[b] = new $17f526922e4a857c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$17f526922e4a857c$var$z.xlinkHref = new $17f526922e4a857c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $17f526922e4a857c$var$z[a] = new $17f526922e4a857c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $17f526922e4a857c$var$ta(a, b, c, d) {
    var e = $17f526922e4a857c$var$z.hasOwnProperty(b) ? $17f526922e4a857c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $17f526922e4a857c$var$qa(b, c, e, d) && (c = null), d || null === e ? $17f526922e4a857c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $17f526922e4a857c$var$ua = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $17f526922e4a857c$var$va = Symbol.for("react.element"), $17f526922e4a857c$var$wa = Symbol.for("react.portal"), $17f526922e4a857c$var$ya = Symbol.for("react.fragment"), $17f526922e4a857c$var$za = Symbol.for("react.strict_mode"), $17f526922e4a857c$var$Aa = Symbol.for("react.profiler"), $17f526922e4a857c$var$Ba = Symbol.for("react.provider"), $17f526922e4a857c$var$Ca = Symbol.for("react.context"), $17f526922e4a857c$var$Da = Symbol.for("react.forward_ref"), $17f526922e4a857c$var$Ea = Symbol.for("react.suspense"), $17f526922e4a857c$var$Fa = Symbol.for("react.suspense_list"), $17f526922e4a857c$var$Ga = Symbol.for("react.memo"), $17f526922e4a857c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $17f526922e4a857c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $17f526922e4a857c$var$Ja = Symbol.iterator;
function $17f526922e4a857c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $17f526922e4a857c$var$Ja && a[$17f526922e4a857c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $17f526922e4a857c$var$A = Object.assign, $17f526922e4a857c$var$La;
function $17f526922e4a857c$var$Ma(a) {
    if (void 0 === $17f526922e4a857c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $17f526922e4a857c$var$La = b && b[1] || "";
    }
    return "\n" + $17f526922e4a857c$var$La + a;
}
var $17f526922e4a857c$var$Na = !1;
function $17f526922e4a857c$var$Oa(a, b) {
    if (!a || $17f526922e4a857c$var$Na) return "";
    $17f526922e4a857c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $17f526922e4a857c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $17f526922e4a857c$var$Ma(a) : "";
}
function $17f526922e4a857c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $17f526922e4a857c$var$Ma(a.type);
        case 16:
            return $17f526922e4a857c$var$Ma("Lazy");
        case 13:
            return $17f526922e4a857c$var$Ma("Suspense");
        case 19:
            return $17f526922e4a857c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $17f526922e4a857c$var$Oa(a.type, !1), a;
        case 11:
            return a = $17f526922e4a857c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $17f526922e4a857c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $17f526922e4a857c$var$ya:
            return "Fragment";
        case $17f526922e4a857c$var$wa:
            return "Portal";
        case $17f526922e4a857c$var$Aa:
            return "Profiler";
        case $17f526922e4a857c$var$za:
            return "StrictMode";
        case $17f526922e4a857c$var$Ea:
            return "Suspense";
        case $17f526922e4a857c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $17f526922e4a857c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $17f526922e4a857c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $17f526922e4a857c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $17f526922e4a857c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $17f526922e4a857c$var$Qa(a.type) || "Memo";
        case $17f526922e4a857c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $17f526922e4a857c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $17f526922e4a857c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $17f526922e4a857c$var$Qa(b);
        case 8:
            return b === $17f526922e4a857c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $17f526922e4a857c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $17f526922e4a857c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $17f526922e4a857c$var$Ua(a) {
    var b = $17f526922e4a857c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $17f526922e4a857c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $17f526922e4a857c$var$Ua(a));
}
function $17f526922e4a857c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $17f526922e4a857c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $17f526922e4a857c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $17f526922e4a857c$var$Ya(a, b) {
    var c = b.checked;
    return $17f526922e4a857c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $17f526922e4a857c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $17f526922e4a857c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $17f526922e4a857c$var$ab(a, b) {
    b = b.checked;
    null != b && $17f526922e4a857c$var$ta(a, "checked", b, !1);
}
function $17f526922e4a857c$var$bb(a, b) {
    $17f526922e4a857c$var$ab(a, b);
    var c = $17f526922e4a857c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $17f526922e4a857c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $17f526922e4a857c$var$cb(a, b.type, $17f526922e4a857c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $17f526922e4a857c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $17f526922e4a857c$var$cb(a, b, c) {
    if ("number" !== b || $17f526922e4a857c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $17f526922e4a857c$var$eb = Array.isArray;
function $17f526922e4a857c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $17f526922e4a857c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $17f526922e4a857c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($17f526922e4a857c$var$p(91));
    return $17f526922e4a857c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $17f526922e4a857c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($17f526922e4a857c$var$p(92));
            if ($17f526922e4a857c$var$eb(c)) {
                if (1 < c.length) throw Error($17f526922e4a857c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $17f526922e4a857c$var$Sa(c)
    };
}
function $17f526922e4a857c$var$ib(a, b) {
    var c = $17f526922e4a857c$var$Sa(b.value), d = $17f526922e4a857c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $17f526922e4a857c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $17f526922e4a857c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $17f526922e4a857c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $17f526922e4a857c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $17f526922e4a857c$var$mb, $17f526922e4a857c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $17f526922e4a857c$var$mb = $17f526922e4a857c$var$mb || document.createElement("div");
        $17f526922e4a857c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $17f526922e4a857c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $17f526922e4a857c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $17f526922e4a857c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $17f526922e4a857c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($17f526922e4a857c$var$pb).forEach(function(a) {
    $17f526922e4a857c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $17f526922e4a857c$var$pb[b] = $17f526922e4a857c$var$pb[a];
    });
});
function $17f526922e4a857c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $17f526922e4a857c$var$pb.hasOwnProperty(a) && $17f526922e4a857c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $17f526922e4a857c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $17f526922e4a857c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $17f526922e4a857c$var$tb = $17f526922e4a857c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $17f526922e4a857c$var$ub(a, b) {
    if (b) {
        if ($17f526922e4a857c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($17f526922e4a857c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($17f526922e4a857c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($17f526922e4a857c$var$p(62));
    }
}
function $17f526922e4a857c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $17f526922e4a857c$var$wb = null;
function $17f526922e4a857c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $17f526922e4a857c$var$yb = null, $17f526922e4a857c$var$zb = null, $17f526922e4a857c$var$Ab = null;
function $17f526922e4a857c$var$Bb(a) {
    if (a = $17f526922e4a857c$var$Cb(a)) {
        if ("function" !== typeof $17f526922e4a857c$var$yb) throw Error($17f526922e4a857c$var$p(280));
        var b = a.stateNode;
        b && (b = $17f526922e4a857c$var$Db(b), $17f526922e4a857c$var$yb(a.stateNode, a.type, b));
    }
}
function $17f526922e4a857c$var$Eb(a) {
    $17f526922e4a857c$var$zb ? $17f526922e4a857c$var$Ab ? $17f526922e4a857c$var$Ab.push(a) : $17f526922e4a857c$var$Ab = [
        a
    ] : $17f526922e4a857c$var$zb = a;
}
function $17f526922e4a857c$var$Fb() {
    if ($17f526922e4a857c$var$zb) {
        var a = $17f526922e4a857c$var$zb, b = $17f526922e4a857c$var$Ab;
        $17f526922e4a857c$var$Ab = $17f526922e4a857c$var$zb = null;
        $17f526922e4a857c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$17f526922e4a857c$var$Bb(b[a]);
    }
}
function $17f526922e4a857c$var$Gb(a, b) {
    return a(b);
}
function $17f526922e4a857c$var$Hb() {}
var $17f526922e4a857c$var$Ib = !1;
function $17f526922e4a857c$var$Jb(a, b, c) {
    if ($17f526922e4a857c$var$Ib) return a(b, c);
    $17f526922e4a857c$var$Ib = !0;
    try {
        return $17f526922e4a857c$var$Gb(a, b, c);
    } finally{
        if ($17f526922e4a857c$var$Ib = !1, null !== $17f526922e4a857c$var$zb || null !== $17f526922e4a857c$var$Ab) $17f526922e4a857c$var$Hb(), $17f526922e4a857c$var$Fb();
    }
}
function $17f526922e4a857c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $17f526922e4a857c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($17f526922e4a857c$var$p(231, b, typeof c));
    return c;
}
var $17f526922e4a857c$var$Lb = !1;
if ($17f526922e4a857c$var$ia) try {
    var $17f526922e4a857c$var$Mb = {};
    Object.defineProperty($17f526922e4a857c$var$Mb, "passive", {
        get: function() {
            $17f526922e4a857c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
    window.removeEventListener("test", $17f526922e4a857c$var$Mb, $17f526922e4a857c$var$Mb);
} catch (a) {
    $17f526922e4a857c$var$Lb = !1;
}
function $17f526922e4a857c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $17f526922e4a857c$var$Ob = !1, $17f526922e4a857c$var$Pb = null, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, $17f526922e4a857c$var$Sb = {
    onError: function(a) {
        $17f526922e4a857c$var$Ob = !0;
        $17f526922e4a857c$var$Pb = a;
    }
};
function $17f526922e4a857c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Ob = !1;
    $17f526922e4a857c$var$Pb = null;
    $17f526922e4a857c$var$Nb.apply($17f526922e4a857c$var$Sb, arguments);
}
function $17f526922e4a857c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $17f526922e4a857c$var$Tb.apply(this, arguments);
    if ($17f526922e4a857c$var$Ob) {
        if ($17f526922e4a857c$var$Ob) {
            var l = $17f526922e4a857c$var$Pb;
            $17f526922e4a857c$var$Ob = !1;
            $17f526922e4a857c$var$Pb = null;
        } else throw Error($17f526922e4a857c$var$p(198));
        $17f526922e4a857c$var$Qb || ($17f526922e4a857c$var$Qb = !0, $17f526922e4a857c$var$Rb = l);
    }
}
function $17f526922e4a857c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $17f526922e4a857c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $17f526922e4a857c$var$Xb(a) {
    if ($17f526922e4a857c$var$Vb(a) !== a) throw Error($17f526922e4a857c$var$p(188));
}
function $17f526922e4a857c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $17f526922e4a857c$var$Vb(a);
        if (null === b) throw Error($17f526922e4a857c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $17f526922e4a857c$var$Xb(e), a;
                if (f === d) return $17f526922e4a857c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($17f526922e4a857c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($17f526922e4a857c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($17f526922e4a857c$var$p(190));
    }
    if (3 !== c.tag) throw Error($17f526922e4a857c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $17f526922e4a857c$var$Zb(a) {
    a = $17f526922e4a857c$var$Yb(a);
    return null !== a ? $17f526922e4a857c$var$$b(a) : null;
}
function $17f526922e4a857c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $17f526922e4a857c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$ac = $clk2u.unstable_scheduleCallback, $17f526922e4a857c$var$bc = $clk2u.unstable_cancelCallback, $17f526922e4a857c$var$cc = $clk2u.unstable_shouldYield, $17f526922e4a857c$var$dc = $clk2u.unstable_requestPaint, $17f526922e4a857c$var$B = $clk2u.unstable_now, $17f526922e4a857c$var$ec = $clk2u.unstable_getCurrentPriorityLevel, $17f526922e4a857c$var$fc = $clk2u.unstable_ImmediatePriority, $17f526922e4a857c$var$gc = $clk2u.unstable_UserBlockingPriority, $17f526922e4a857c$var$hc = $clk2u.unstable_NormalPriority, $17f526922e4a857c$var$ic = $clk2u.unstable_LowPriority, $17f526922e4a857c$var$jc = $clk2u.unstable_IdlePriority, $17f526922e4a857c$var$kc = null, $17f526922e4a857c$var$lc = null;
function $17f526922e4a857c$var$mc(a) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberRoot) try {
        $17f526922e4a857c$var$lc.onCommitFiberRoot($17f526922e4a857c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $17f526922e4a857c$var$oc = Math.clz32 ? Math.clz32 : $17f526922e4a857c$var$nc, $17f526922e4a857c$var$pc = Math.log, $17f526922e4a857c$var$qc = Math.LN2;
function $17f526922e4a857c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($17f526922e4a857c$var$pc(a) / $17f526922e4a857c$var$qc | 0) | 0;
}
var $17f526922e4a857c$var$rc = 64, $17f526922e4a857c$var$sc = 4194304;
function $17f526922e4a857c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $17f526922e4a857c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $17f526922e4a857c$var$tc(h) : (f &= g, 0 !== f && (d = $17f526922e4a857c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $17f526922e4a857c$var$tc(g) : 0 !== f && (d = $17f526922e4a857c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $17f526922e4a857c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $17f526922e4a857c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $17f526922e4a857c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $17f526922e4a857c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $17f526922e4a857c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $17f526922e4a857c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $17f526922e4a857c$var$yc() {
    var a = $17f526922e4a857c$var$rc;
    $17f526922e4a857c$var$rc <<= 1;
    0 === ($17f526922e4a857c$var$rc & 4194240) && ($17f526922e4a857c$var$rc = 64);
    return a;
}
function $17f526922e4a857c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $17f526922e4a857c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $17f526922e4a857c$var$oc(b);
    a[b] = c;
}
function $17f526922e4a857c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $17f526922e4a857c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $17f526922e4a857c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $17f526922e4a857c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $17f526922e4a857c$var$C = 0;
function $17f526922e4a857c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $17f526922e4a857c$var$Ec, $17f526922e4a857c$var$Fc, $17f526922e4a857c$var$Gc, $17f526922e4a857c$var$Hc, $17f526922e4a857c$var$Ic, $17f526922e4a857c$var$Jc = !1, $17f526922e4a857c$var$Kc = [], $17f526922e4a857c$var$Lc = null, $17f526922e4a857c$var$Mc = null, $17f526922e4a857c$var$Nc = null, $17f526922e4a857c$var$Oc = new Map, $17f526922e4a857c$var$Pc = new Map, $17f526922e4a857c$var$Qc = [], $17f526922e4a857c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $17f526922e4a857c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $17f526922e4a857c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $17f526922e4a857c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $17f526922e4a857c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $17f526922e4a857c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $17f526922e4a857c$var$Pc.delete(b.pointerId);
    }
}
function $17f526922e4a857c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $17f526922e4a857c$var$Cb(b), null !== b && $17f526922e4a857c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $17f526922e4a857c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $17f526922e4a857c$var$Lc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $17f526922e4a857c$var$Mc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $17f526922e4a857c$var$Nc = $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $17f526922e4a857c$var$Oc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $17f526922e4a857c$var$Pc.set(f, $17f526922e4a857c$var$Tc($17f526922e4a857c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $17f526922e4a857c$var$Vc(a) {
    var b = $17f526922e4a857c$var$Wc(a.target);
    if (null !== b) {
        var c = $17f526922e4a857c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $17f526922e4a857c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $17f526922e4a857c$var$Ic(a.priority, function() {
                        $17f526922e4a857c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $17f526922e4a857c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $17f526922e4a857c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $17f526922e4a857c$var$wb = d;
            c.target.dispatchEvent(d);
            $17f526922e4a857c$var$wb = null;
        } else return b = $17f526922e4a857c$var$Cb(c), null !== b && $17f526922e4a857c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $17f526922e4a857c$var$Zc(a, b, c) {
    $17f526922e4a857c$var$Xc(a) && c.delete(b);
}
function $17f526922e4a857c$var$$c() {
    $17f526922e4a857c$var$Jc = !1;
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Lc) && ($17f526922e4a857c$var$Lc = null);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Mc) && ($17f526922e4a857c$var$Mc = null);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$Xc($17f526922e4a857c$var$Nc) && ($17f526922e4a857c$var$Nc = null);
    $17f526922e4a857c$var$Oc.forEach($17f526922e4a857c$var$Zc);
    $17f526922e4a857c$var$Pc.forEach($17f526922e4a857c$var$Zc);
}
function $17f526922e4a857c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $17f526922e4a857c$var$Jc || ($17f526922e4a857c$var$Jc = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $17f526922e4a857c$var$$c)));
}
function $17f526922e4a857c$var$bd(a) {
    function b(b) {
        return $17f526922e4a857c$var$ad(b, a);
    }
    if (0 < $17f526922e4a857c$var$Kc.length) {
        $17f526922e4a857c$var$ad($17f526922e4a857c$var$Kc[0], a);
        for(var c = 1; c < $17f526922e4a857c$var$Kc.length; c++){
            var d = $17f526922e4a857c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $17f526922e4a857c$var$Lc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Lc, a);
    null !== $17f526922e4a857c$var$Mc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Mc, a);
    null !== $17f526922e4a857c$var$Nc && $17f526922e4a857c$var$ad($17f526922e4a857c$var$Nc, a);
    $17f526922e4a857c$var$Oc.forEach(b);
    $17f526922e4a857c$var$Pc.forEach(b);
    for(c = 0; c < $17f526922e4a857c$var$Qc.length; c++)d = $17f526922e4a857c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $17f526922e4a857c$var$Qc.length && (c = $17f526922e4a857c$var$Qc[0], null === c.blockedOn);)$17f526922e4a857c$var$Vc(c), null === c.blockedOn && $17f526922e4a857c$var$Qc.shift();
}
var $17f526922e4a857c$var$cd = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$dd = !0;
function $17f526922e4a857c$var$ed(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$gd(a, b, c, d) {
    var e = $17f526922e4a857c$var$C, f = $17f526922e4a857c$var$cd.transition;
    $17f526922e4a857c$var$cd.transition = null;
    try {
        $17f526922e4a857c$var$C = 4, $17f526922e4a857c$var$fd(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$C = e, $17f526922e4a857c$var$cd.transition = f;
    }
}
function $17f526922e4a857c$var$fd(a, b, c, d) {
    if ($17f526922e4a857c$var$dd) {
        var e = $17f526922e4a857c$var$Yc(a, b, c, d);
        if (null === e) $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c), $17f526922e4a857c$var$Sc(a, d);
        else if ($17f526922e4a857c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($17f526922e4a857c$var$Sc(a, d), b & 4 && -1 < $17f526922e4a857c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $17f526922e4a857c$var$Cb(e);
                null !== f && $17f526922e4a857c$var$Ec(f);
                f = $17f526922e4a857c$var$Yc(a, b, c, d);
                null === f && $17f526922e4a857c$var$hd(a, b, d, $17f526922e4a857c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $17f526922e4a857c$var$hd(a, b, d, null, c);
    }
}
var $17f526922e4a857c$var$id = null;
function $17f526922e4a857c$var$Yc(a, b, c, d) {
    $17f526922e4a857c$var$id = null;
    a = $17f526922e4a857c$var$xb(d);
    a = $17f526922e4a857c$var$Wc(a);
    if (null !== a) {
        if (b = $17f526922e4a857c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $17f526922e4a857c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $17f526922e4a857c$var$id = a;
    return null;
}
function $17f526922e4a857c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($17f526922e4a857c$var$ec()){
                case $17f526922e4a857c$var$fc:
                    return 1;
                case $17f526922e4a857c$var$gc:
                    return 4;
                case $17f526922e4a857c$var$hc:
                case $17f526922e4a857c$var$ic:
                    return 16;
                case $17f526922e4a857c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ld = null, $17f526922e4a857c$var$md = null;
function $17f526922e4a857c$var$nd() {
    if ($17f526922e4a857c$var$md) return $17f526922e4a857c$var$md;
    var a, b = $17f526922e4a857c$var$ld, c = b.length, d, e = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $17f526922e4a857c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $17f526922e4a857c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $17f526922e4a857c$var$pd() {
    return !0;
}
function $17f526922e4a857c$var$qd() {
    return !1;
}
function $17f526922e4a857c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $17f526922e4a857c$var$pd : $17f526922e4a857c$var$qd;
        this.isPropagationStopped = $17f526922e4a857c$var$qd;
        return this;
    }
    $17f526922e4a857c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $17f526922e4a857c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $17f526922e4a857c$var$pd);
        },
        persist: function() {},
        isPersistent: $17f526922e4a857c$var$pd
    });
    return b;
}
var $17f526922e4a857c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $17f526922e4a857c$var$td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$sd), $17f526922e4a857c$var$ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    view: 0,
    detail: 0
}), $17f526922e4a857c$var$vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$ud), $17f526922e4a857c$var$wd, $17f526922e4a857c$var$xd, $17f526922e4a857c$var$yd, $17f526922e4a857c$var$Ad = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $17f526922e4a857c$var$yd && ($17f526922e4a857c$var$yd && "mousemove" === a.type ? ($17f526922e4a857c$var$wd = a.screenX - $17f526922e4a857c$var$yd.screenX, $17f526922e4a857c$var$xd = a.screenY - $17f526922e4a857c$var$yd.screenY) : $17f526922e4a857c$var$xd = $17f526922e4a857c$var$wd = 0, $17f526922e4a857c$var$yd = a);
        return $17f526922e4a857c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $17f526922e4a857c$var$xd;
    }
}), $17f526922e4a857c$var$Bd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ad), $17f526922e4a857c$var$Cd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    dataTransfer: 0
}), $17f526922e4a857c$var$Dd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Cd), $17f526922e4a857c$var$Ed = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    relatedTarget: 0
}), $17f526922e4a857c$var$Fd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ed), $17f526922e4a857c$var$Gd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Hd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Gd), $17f526922e4a857c$var$Id = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $17f526922e4a857c$var$Jd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Id), $17f526922e4a857c$var$Kd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    data: 0
}), $17f526922e4a857c$var$Ld = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Kd), $17f526922e4a857c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $17f526922e4a857c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $17f526922e4a857c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $17f526922e4a857c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $17f526922e4a857c$var$Od[a]) ? !!b[a] : !1;
}
function $17f526922e4a857c$var$zd() {
    return $17f526922e4a857c$var$Pd;
}
var $17f526922e4a857c$var$Qd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $17f526922e4a857c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $17f526922e4a857c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $17f526922e4a857c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $17f526922e4a857c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $17f526922e4a857c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $17f526922e4a857c$var$Rd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Qd), $17f526922e4a857c$var$Sd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $17f526922e4a857c$var$Td = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Sd), $17f526922e4a857c$var$Ud = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $17f526922e4a857c$var$zd
}), $17f526922e4a857c$var$Vd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Ud), $17f526922e4a857c$var$Wd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $17f526922e4a857c$var$Xd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Wd), $17f526922e4a857c$var$Yd = $17f526922e4a857c$var$A({}, $17f526922e4a857c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $17f526922e4a857c$var$Zd = $17f526922e4a857c$var$rd($17f526922e4a857c$var$Yd), $17f526922e4a857c$var$$d = [
    9,
    13,
    27,
    32
], $17f526922e4a857c$var$ae = $17f526922e4a857c$var$ia && "CompositionEvent" in window, $17f526922e4a857c$var$be = null;
$17f526922e4a857c$var$ia && "documentMode" in document && ($17f526922e4a857c$var$be = document.documentMode);
var $17f526922e4a857c$var$ce = $17f526922e4a857c$var$ia && "TextEvent" in window && !$17f526922e4a857c$var$be, $17f526922e4a857c$var$de = $17f526922e4a857c$var$ia && (!$17f526922e4a857c$var$ae || $17f526922e4a857c$var$be && 8 < $17f526922e4a857c$var$be && 11 >= $17f526922e4a857c$var$be), $17f526922e4a857c$var$ee = String.fromCharCode(32), $17f526922e4a857c$var$fe = !1;
function $17f526922e4a857c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $17f526922e4a857c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $17f526922e4a857c$var$ie = !1;
function $17f526922e4a857c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $17f526922e4a857c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $17f526922e4a857c$var$fe = !0;
            return $17f526922e4a857c$var$ee;
        case "textInput":
            return a = b.data, a === $17f526922e4a857c$var$ee && $17f526922e4a857c$var$fe ? null : a;
        default:
            return null;
    }
}
function $17f526922e4a857c$var$ke(a, b) {
    if ($17f526922e4a857c$var$ie) return "compositionend" === a || !$17f526922e4a857c$var$ae && $17f526922e4a857c$var$ge(a, b) ? (a = $17f526922e4a857c$var$nd(), $17f526922e4a857c$var$md = $17f526922e4a857c$var$ld = $17f526922e4a857c$var$kd = null, $17f526922e4a857c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $17f526922e4a857c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $17f526922e4a857c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$17f526922e4a857c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $17f526922e4a857c$var$ne(a, b, c, d) {
    $17f526922e4a857c$var$Eb(d);
    b = $17f526922e4a857c$var$oe(b, "onChange");
    0 < b.length && (c = new $17f526922e4a857c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $17f526922e4a857c$var$pe = null, $17f526922e4a857c$var$qe = null;
function $17f526922e4a857c$var$re(a) {
    $17f526922e4a857c$var$se(a, 0);
}
function $17f526922e4a857c$var$te(a) {
    var b = $17f526922e4a857c$var$ue(a);
    if ($17f526922e4a857c$var$Wa(b)) return a;
}
function $17f526922e4a857c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $17f526922e4a857c$var$we = !1;
if ($17f526922e4a857c$var$ia) {
    var $17f526922e4a857c$var$xe;
    if ($17f526922e4a857c$var$ia) {
        var $17f526922e4a857c$var$ye = "oninput" in document;
        if (!$17f526922e4a857c$var$ye) {
            var $17f526922e4a857c$var$ze = document.createElement("div");
            $17f526922e4a857c$var$ze.setAttribute("oninput", "return;");
            $17f526922e4a857c$var$ye = "function" === typeof $17f526922e4a857c$var$ze.oninput;
        }
        $17f526922e4a857c$var$xe = $17f526922e4a857c$var$ye;
    } else $17f526922e4a857c$var$xe = !1;
    $17f526922e4a857c$var$we = $17f526922e4a857c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $17f526922e4a857c$var$Ae() {
    $17f526922e4a857c$var$pe && ($17f526922e4a857c$var$pe.detachEvent("onpropertychange", $17f526922e4a857c$var$Be), $17f526922e4a857c$var$qe = $17f526922e4a857c$var$pe = null);
}
function $17f526922e4a857c$var$Be(a) {
    if ("value" === a.propertyName && $17f526922e4a857c$var$te($17f526922e4a857c$var$qe)) {
        var b = [];
        $17f526922e4a857c$var$ne(b, $17f526922e4a857c$var$qe, a, $17f526922e4a857c$var$xb(a));
        $17f526922e4a857c$var$Jb($17f526922e4a857c$var$re, b);
    }
}
function $17f526922e4a857c$var$Ce(a, b, c) {
    "focusin" === a ? ($17f526922e4a857c$var$Ae(), $17f526922e4a857c$var$pe = b, $17f526922e4a857c$var$qe = c, $17f526922e4a857c$var$pe.attachEvent("onpropertychange", $17f526922e4a857c$var$Be)) : "focusout" === a && $17f526922e4a857c$var$Ae();
}
function $17f526922e4a857c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $17f526922e4a857c$var$te($17f526922e4a857c$var$qe);
}
function $17f526922e4a857c$var$Ee(a, b) {
    if ("click" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $17f526922e4a857c$var$te(b);
}
function $17f526922e4a857c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $17f526922e4a857c$var$He = "function" === typeof Object.is ? Object.is : $17f526922e4a857c$var$Ge;
function $17f526922e4a857c$var$Ie(a, b) {
    if ($17f526922e4a857c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$17f526922e4a857c$var$ja.call(b, e) || !$17f526922e4a857c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $17f526922e4a857c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $17f526922e4a857c$var$Ke(a, b) {
    var c = $17f526922e4a857c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $17f526922e4a857c$var$Je(c);
    }
}
function $17f526922e4a857c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $17f526922e4a857c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $17f526922e4a857c$var$Me() {
    for(var a = window, b = $17f526922e4a857c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $17f526922e4a857c$var$Xa(a.document);
    }
    return b;
}
function $17f526922e4a857c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $17f526922e4a857c$var$Oe(a) {
    var b = $17f526922e4a857c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $17f526922e4a857c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $17f526922e4a857c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $17f526922e4a857c$var$Ke(c, f);
                var g = $17f526922e4a857c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $17f526922e4a857c$var$Pe = $17f526922e4a857c$var$ia && "documentMode" in document && 11 >= document.documentMode, $17f526922e4a857c$var$Qe = null, $17f526922e4a857c$var$Re = null, $17f526922e4a857c$var$Se = null, $17f526922e4a857c$var$Te = !1;
function $17f526922e4a857c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $17f526922e4a857c$var$Te || null == $17f526922e4a857c$var$Qe || $17f526922e4a857c$var$Qe !== $17f526922e4a857c$var$Xa(d) || (d = $17f526922e4a857c$var$Qe, "selectionStart" in d && $17f526922e4a857c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $17f526922e4a857c$var$Se && $17f526922e4a857c$var$Ie($17f526922e4a857c$var$Se, d) || ($17f526922e4a857c$var$Se = d, d = $17f526922e4a857c$var$oe($17f526922e4a857c$var$Re, "onSelect"), 0 < d.length && (b = new $17f526922e4a857c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $17f526922e4a857c$var$Qe)));
}
function $17f526922e4a857c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $17f526922e4a857c$var$We = {
    animationend: $17f526922e4a857c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $17f526922e4a857c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $17f526922e4a857c$var$Ve("Animation", "AnimationStart"),
    transitionend: $17f526922e4a857c$var$Ve("Transition", "TransitionEnd")
}, $17f526922e4a857c$var$Xe = {}, $17f526922e4a857c$var$Ye = {};
$17f526922e4a857c$var$ia && ($17f526922e4a857c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $17f526922e4a857c$var$We.animationend.animation, delete $17f526922e4a857c$var$We.animationiteration.animation, delete $17f526922e4a857c$var$We.animationstart.animation), "TransitionEvent" in window || delete $17f526922e4a857c$var$We.transitionend.transition);
function $17f526922e4a857c$var$Ze(a) {
    if ($17f526922e4a857c$var$Xe[a]) return $17f526922e4a857c$var$Xe[a];
    if (!$17f526922e4a857c$var$We[a]) return a;
    var b = $17f526922e4a857c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $17f526922e4a857c$var$Ye) return $17f526922e4a857c$var$Xe[a] = b[c];
    return a;
}
var $17f526922e4a857c$var$$e = $17f526922e4a857c$var$Ze("animationend"), $17f526922e4a857c$var$af = $17f526922e4a857c$var$Ze("animationiteration"), $17f526922e4a857c$var$bf = $17f526922e4a857c$var$Ze("animationstart"), $17f526922e4a857c$var$cf = $17f526922e4a857c$var$Ze("transitionend"), $17f526922e4a857c$var$df = new Map, $17f526922e4a857c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $17f526922e4a857c$var$ff(a, b) {
    $17f526922e4a857c$var$df.set(a, b);
    $17f526922e4a857c$var$fa(b, [
        a
    ]);
}
for(var $17f526922e4a857c$var$gf = 0; $17f526922e4a857c$var$gf < $17f526922e4a857c$var$ef.length; $17f526922e4a857c$var$gf++){
    var $17f526922e4a857c$var$hf = $17f526922e4a857c$var$ef[$17f526922e4a857c$var$gf], $17f526922e4a857c$var$jf = $17f526922e4a857c$var$hf.toLowerCase(), $17f526922e4a857c$var$kf = $17f526922e4a857c$var$hf[0].toUpperCase() + $17f526922e4a857c$var$hf.slice(1);
    $17f526922e4a857c$var$ff($17f526922e4a857c$var$jf, "on" + $17f526922e4a857c$var$kf);
}
$17f526922e4a857c$var$ff($17f526922e4a857c$var$$e, "onAnimationEnd");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$af, "onAnimationIteration");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$bf, "onAnimationStart");
$17f526922e4a857c$var$ff("dblclick", "onDoubleClick");
$17f526922e4a857c$var$ff("focusin", "onFocus");
$17f526922e4a857c$var$ff("focusout", "onBlur");
$17f526922e4a857c$var$ff($17f526922e4a857c$var$cf, "onTransitionEnd");
$17f526922e4a857c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$17f526922e4a857c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$17f526922e4a857c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$17f526922e4a857c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$17f526922e4a857c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$17f526922e4a857c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $17f526922e4a857c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $17f526922e4a857c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($17f526922e4a857c$var$lf));
function $17f526922e4a857c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $17f526922e4a857c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $17f526922e4a857c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $17f526922e4a857c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($17f526922e4a857c$var$Qb) throw a = $17f526922e4a857c$var$Rb, $17f526922e4a857c$var$Qb = !1, $17f526922e4a857c$var$Rb = null, a;
}
function $17f526922e4a857c$var$D(a, b) {
    var c = b[$17f526922e4a857c$var$of];
    void 0 === c && (c = b[$17f526922e4a857c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($17f526922e4a857c$var$pf(b, a, 2, !1), c.add(d));
}
function $17f526922e4a857c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $17f526922e4a857c$var$pf(c, a, d, b);
}
var $17f526922e4a857c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $17f526922e4a857c$var$sf(a) {
    if (!a[$17f526922e4a857c$var$rf]) {
        a[$17f526922e4a857c$var$rf] = !0;
        $17f526922e4a857c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($17f526922e4a857c$var$mf.has(b) || $17f526922e4a857c$var$qf(b, !1, a), $17f526922e4a857c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$17f526922e4a857c$var$rf] || (b[$17f526922e4a857c$var$rf] = !0, $17f526922e4a857c$var$qf("selectionchange", !1, b));
    }
}
function $17f526922e4a857c$var$pf(a, b, c, d) {
    switch($17f526922e4a857c$var$jd(b)){
        case 1:
            var e = $17f526922e4a857c$var$ed;
            break;
        case 4:
            e = $17f526922e4a857c$var$gd;
            break;
        default:
            e = $17f526922e4a857c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$17f526922e4a857c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $17f526922e4a857c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $17f526922e4a857c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $17f526922e4a857c$var$Jb(function() {
        var d = f, e = $17f526922e4a857c$var$xb(c), g = [];
        a: {
            var h = $17f526922e4a857c$var$df.get(a);
            if (void 0 !== h) {
                var k = $17f526922e4a857c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $17f526922e4a857c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $17f526922e4a857c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $17f526922e4a857c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $17f526922e4a857c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $17f526922e4a857c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $17f526922e4a857c$var$Vd;
                        break;
                    case $17f526922e4a857c$var$$e:
                    case $17f526922e4a857c$var$af:
                    case $17f526922e4a857c$var$bf:
                        k = $17f526922e4a857c$var$Hd;
                        break;
                    case $17f526922e4a857c$var$cf:
                        k = $17f526922e4a857c$var$Xd;
                        break;
                    case "scroll":
                        k = $17f526922e4a857c$var$vd;
                        break;
                    case "wheel":
                        k = $17f526922e4a857c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $17f526922e4a857c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $17f526922e4a857c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $17f526922e4a857c$var$Kb(w, x), null != F && t.push($17f526922e4a857c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $17f526922e4a857c$var$wb && (n = c.relatedTarget || c.fromElement) && ($17f526922e4a857c$var$Wc(n) || n[$17f526922e4a857c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $17f526922e4a857c$var$Wc(n) : null, null !== n && (J = $17f526922e4a857c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $17f526922e4a857c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $17f526922e4a857c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $17f526922e4a857c$var$ue(k);
                        u = null == n ? h : $17f526922e4a857c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $17f526922e4a857c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $17f526922e4a857c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $17f526922e4a857c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $17f526922e4a857c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $17f526922e4a857c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $17f526922e4a857c$var$vf(t);
                                x = $17f526922e4a857c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $17f526922e4a857c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $17f526922e4a857c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $17f526922e4a857c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $17f526922e4a857c$var$ve;
                else if ($17f526922e4a857c$var$me(h)) {
                    if ($17f526922e4a857c$var$we) na = $17f526922e4a857c$var$Fe;
                    else {
                        na = $17f526922e4a857c$var$De;
                        var xa = $17f526922e4a857c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $17f526922e4a857c$var$Ee);
                if (na && (na = na(a, d))) {
                    $17f526922e4a857c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $17f526922e4a857c$var$cb(h, "number", h.value);
            }
            xa = d ? $17f526922e4a857c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($17f526922e4a857c$var$me(xa) || "true" === xa.contentEditable) $17f526922e4a857c$var$Qe = xa, $17f526922e4a857c$var$Re = d, $17f526922e4a857c$var$Se = null;
                    break;
                case "focusout":
                    $17f526922e4a857c$var$Se = $17f526922e4a857c$var$Re = $17f526922e4a857c$var$Qe = null;
                    break;
                case "mousedown":
                    $17f526922e4a857c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $17f526922e4a857c$var$Te = !1;
                    $17f526922e4a857c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($17f526922e4a857c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $17f526922e4a857c$var$Ue(g, c, e);
            }
            var $a;
            if ($17f526922e4a857c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $17f526922e4a857c$var$ie ? $17f526922e4a857c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($17f526922e4a857c$var$de && "ko" !== c.locale && ($17f526922e4a857c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $17f526922e4a857c$var$ie && ($a = $17f526922e4a857c$var$nd()) : ($17f526922e4a857c$var$kd = e, $17f526922e4a857c$var$ld = "value" in $17f526922e4a857c$var$kd ? $17f526922e4a857c$var$kd.value : $17f526922e4a857c$var$kd.textContent, $17f526922e4a857c$var$ie = !0)), xa = $17f526922e4a857c$var$oe(d, ba), 0 < xa.length && (ba = new $17f526922e4a857c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $17f526922e4a857c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $17f526922e4a857c$var$ce ? $17f526922e4a857c$var$je(a, c) : $17f526922e4a857c$var$ke(a, c)) d = $17f526922e4a857c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $17f526922e4a857c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $17f526922e4a857c$var$se(g, b);
    });
}
function $17f526922e4a857c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $17f526922e4a857c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $17f526922e4a857c$var$Kb(a, c), null != f && d.unshift($17f526922e4a857c$var$tf(a, f, e)), f = $17f526922e4a857c$var$Kb(a, b), null != f && d.push($17f526922e4a857c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $17f526922e4a857c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $17f526922e4a857c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.unshift($17f526922e4a857c$var$tf(c, k, h))) : e || (k = $17f526922e4a857c$var$Kb(c, f), null != k && g.push($17f526922e4a857c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $17f526922e4a857c$var$xf = /\r\n?/g, $17f526922e4a857c$var$yf = /\u0000|\uFFFD/g;
function $17f526922e4a857c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($17f526922e4a857c$var$xf, "\n").replace($17f526922e4a857c$var$yf, "");
}
function $17f526922e4a857c$var$Af(a, b, c) {
    b = $17f526922e4a857c$var$zf(b);
    if ($17f526922e4a857c$var$zf(a) !== b && c) throw Error($17f526922e4a857c$var$p(425));
}
function $17f526922e4a857c$var$Bf() {}
var $17f526922e4a857c$var$Cf = null, $17f526922e4a857c$var$Df = null;
function $17f526922e4a857c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $17f526922e4a857c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $17f526922e4a857c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $17f526922e4a857c$var$Hf = "function" === typeof Promise ? Promise : void 0, $17f526922e4a857c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $17f526922e4a857c$var$Hf ? function(a) {
    return $17f526922e4a857c$var$Hf.resolve(null).then(a).catch($17f526922e4a857c$var$If);
} : $17f526922e4a857c$var$Ff;
function $17f526922e4a857c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $17f526922e4a857c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $17f526922e4a857c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $17f526922e4a857c$var$bd(b);
}
function $17f526922e4a857c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $17f526922e4a857c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $17f526922e4a857c$var$Nf = Math.random().toString(36).slice(2), $17f526922e4a857c$var$Of = "__reactFiber$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Pf = "__reactProps$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$uf = "__reactContainer$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$of = "__reactEvents$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Qf = "__reactListeners$" + $17f526922e4a857c$var$Nf, $17f526922e4a857c$var$Rf = "__reactHandles$" + $17f526922e4a857c$var$Nf;
function $17f526922e4a857c$var$Wc(a) {
    var b = a[$17f526922e4a857c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$17f526922e4a857c$var$uf] || c[$17f526922e4a857c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $17f526922e4a857c$var$Mf(a); null !== a;){
                if (c = a[$17f526922e4a857c$var$Of]) return c;
                a = $17f526922e4a857c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $17f526922e4a857c$var$Cb(a) {
    a = a[$17f526922e4a857c$var$Of] || a[$17f526922e4a857c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $17f526922e4a857c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($17f526922e4a857c$var$p(33));
}
function $17f526922e4a857c$var$Db(a) {
    return a[$17f526922e4a857c$var$Pf] || null;
}
var $17f526922e4a857c$var$Sf = [], $17f526922e4a857c$var$Tf = -1;
function $17f526922e4a857c$var$Uf(a) {
    return {
        current: a
    };
}
function $17f526922e4a857c$var$E(a) {
    0 > $17f526922e4a857c$var$Tf || (a.current = $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf], $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = null, $17f526922e4a857c$var$Tf--);
}
function $17f526922e4a857c$var$G(a, b) {
    $17f526922e4a857c$var$Tf++;
    $17f526922e4a857c$var$Sf[$17f526922e4a857c$var$Tf] = a.current;
    a.current = b;
}
var $17f526922e4a857c$var$Vf = {}, $17f526922e4a857c$var$H = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$Vf), $17f526922e4a857c$var$Wf = $17f526922e4a857c$var$Uf(!1), $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$Vf;
function $17f526922e4a857c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $17f526922e4a857c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $17f526922e4a857c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $17f526922e4a857c$var$$f() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
}
function $17f526922e4a857c$var$ag(a, b, c) {
    if ($17f526922e4a857c$var$H.current !== $17f526922e4a857c$var$Vf) throw Error($17f526922e4a857c$var$p(168));
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
function $17f526922e4a857c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($17f526922e4a857c$var$p(108, $17f526922e4a857c$var$Ra(a) || "Unknown", e));
    return $17f526922e4a857c$var$A({}, c, d);
}
function $17f526922e4a857c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $17f526922e4a857c$var$Vf;
    $17f526922e4a857c$var$Xf = $17f526922e4a857c$var$H.current;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, $17f526922e4a857c$var$Wf.current);
    return !0;
}
function $17f526922e4a857c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($17f526922e4a857c$var$p(169));
    c ? (a = $17f526922e4a857c$var$bg(a, b, $17f526922e4a857c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$G($17f526922e4a857c$var$H, a)) : $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$Wf, c);
}
var $17f526922e4a857c$var$eg = null, $17f526922e4a857c$var$fg = !1, $17f526922e4a857c$var$gg = !1;
function $17f526922e4a857c$var$hg(a) {
    null === $17f526922e4a857c$var$eg ? $17f526922e4a857c$var$eg = [
        a
    ] : $17f526922e4a857c$var$eg.push(a);
}
function $17f526922e4a857c$var$ig(a) {
    $17f526922e4a857c$var$fg = !0;
    $17f526922e4a857c$var$hg(a);
}
function $17f526922e4a857c$var$jg() {
    if (!$17f526922e4a857c$var$gg && null !== $17f526922e4a857c$var$eg) {
        $17f526922e4a857c$var$gg = !0;
        var a = 0, b = $17f526922e4a857c$var$C;
        try {
            var c = $17f526922e4a857c$var$eg;
            for($17f526922e4a857c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $17f526922e4a857c$var$eg = null;
            $17f526922e4a857c$var$fg = !1;
        } catch (e) {
            throw null !== $17f526922e4a857c$var$eg && ($17f526922e4a857c$var$eg = $17f526922e4a857c$var$eg.slice(a + 1)), $17f526922e4a857c$var$ac($17f526922e4a857c$var$fc, $17f526922e4a857c$var$jg), e;
        } finally{
            $17f526922e4a857c$var$C = b, $17f526922e4a857c$var$gg = !1;
        }
    }
    return null;
}
var $17f526922e4a857c$var$kg = [], $17f526922e4a857c$var$lg = 0, $17f526922e4a857c$var$mg = null, $17f526922e4a857c$var$ng = 0, $17f526922e4a857c$var$og = [], $17f526922e4a857c$var$pg = 0, $17f526922e4a857c$var$qg = null, $17f526922e4a857c$var$rg = 1, $17f526922e4a857c$var$sg = "";
function $17f526922e4a857c$var$tg(a, b) {
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$ng;
    $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg++] = $17f526922e4a857c$var$mg;
    $17f526922e4a857c$var$mg = a;
    $17f526922e4a857c$var$ng = b;
}
function $17f526922e4a857c$var$ug(a, b, c) {
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg;
    $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg;
    $17f526922e4a857c$var$qg = a;
    var d = $17f526922e4a857c$var$rg;
    a = $17f526922e4a857c$var$sg;
    var e = 32 - $17f526922e4a857c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $17f526922e4a857c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $17f526922e4a857c$var$rg = 1 << 32 - $17f526922e4a857c$var$oc(b) + e | c << e | d;
        $17f526922e4a857c$var$sg = f + a;
    } else $17f526922e4a857c$var$rg = 1 << f | c << e | d, $17f526922e4a857c$var$sg = a;
}
function $17f526922e4a857c$var$vg(a) {
    null !== a.return && ($17f526922e4a857c$var$tg(a, 1), $17f526922e4a857c$var$ug(a, 1, 0));
}
function $17f526922e4a857c$var$wg(a) {
    for(; a === $17f526922e4a857c$var$mg;)$17f526922e4a857c$var$mg = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null, $17f526922e4a857c$var$ng = $17f526922e4a857c$var$kg[--$17f526922e4a857c$var$lg], $17f526922e4a857c$var$kg[$17f526922e4a857c$var$lg] = null;
    for(; a === $17f526922e4a857c$var$qg;)$17f526922e4a857c$var$qg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$sg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null, $17f526922e4a857c$var$rg = $17f526922e4a857c$var$og[--$17f526922e4a857c$var$pg], $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg] = null;
}
var $17f526922e4a857c$var$xg = null, $17f526922e4a857c$var$yg = null, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$zg = null;
function $17f526922e4a857c$var$Ag(a, b) {
    var c = $17f526922e4a857c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $17f526922e4a857c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $17f526922e4a857c$var$qg ? {
                id: $17f526922e4a857c$var$rg,
                overflow: $17f526922e4a857c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $17f526922e4a857c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $17f526922e4a857c$var$xg = a, $17f526922e4a857c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $17f526922e4a857c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $17f526922e4a857c$var$Eg(a) {
    if ($17f526922e4a857c$var$I) {
        var b = $17f526922e4a857c$var$yg;
        if (b) {
            var c = b;
            if (!$17f526922e4a857c$var$Cg(a, b)) {
                if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
                b = $17f526922e4a857c$var$Lf(c.nextSibling);
                var d = $17f526922e4a857c$var$xg;
                b && $17f526922e4a857c$var$Cg(a, b) ? $17f526922e4a857c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $17f526922e4a857c$var$I = !1, $17f526922e4a857c$var$xg = a);
            }
        } else {
            if ($17f526922e4a857c$var$Dg(a)) throw Error($17f526922e4a857c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $17f526922e4a857c$var$I = !1;
            $17f526922e4a857c$var$xg = a;
        }
    }
}
function $17f526922e4a857c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $17f526922e4a857c$var$xg = a;
}
function $17f526922e4a857c$var$Gg(a) {
    if (a !== $17f526922e4a857c$var$xg) return !1;
    if (!$17f526922e4a857c$var$I) return $17f526922e4a857c$var$Fg(a), $17f526922e4a857c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$17f526922e4a857c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $17f526922e4a857c$var$yg)) {
        if ($17f526922e4a857c$var$Dg(a)) throw $17f526922e4a857c$var$Hg(), Error($17f526922e4a857c$var$p(418));
        for(; b;)$17f526922e4a857c$var$Ag(a, b), b = $17f526922e4a857c$var$Lf(b.nextSibling);
    }
    $17f526922e4a857c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($17f526922e4a857c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $17f526922e4a857c$var$yg = null;
        }
    } else $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg ? $17f526922e4a857c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $17f526922e4a857c$var$Hg() {
    for(var a = $17f526922e4a857c$var$yg; a;)a = $17f526922e4a857c$var$Lf(a.nextSibling);
}
function $17f526922e4a857c$var$Ig() {
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$xg = null;
    $17f526922e4a857c$var$I = !1;
}
function $17f526922e4a857c$var$Jg(a) {
    null === $17f526922e4a857c$var$zg ? $17f526922e4a857c$var$zg = [
        a
    ] : $17f526922e4a857c$var$zg.push(a);
}
var $17f526922e4a857c$var$Kg = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig;
function $17f526922e4a857c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($17f526922e4a857c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($17f526922e4a857c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($17f526922e4a857c$var$p(284));
        if (!c._owner) throw Error($17f526922e4a857c$var$p(290, a));
    }
    return a;
}
function $17f526922e4a857c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($17f526922e4a857c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $17f526922e4a857c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $17f526922e4a857c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $17f526922e4a857c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $17f526922e4a857c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $17f526922e4a857c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $17f526922e4a857c$var$Lg(a, b, c), d.return = a, d;
        d = $17f526922e4a857c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $17f526922e4a857c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $17f526922e4a857c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $17f526922e4a857c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $17f526922e4a857c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c = $17f526922e4a857c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $17f526922e4a857c$var$Lg(a, null, b), c.return = a, c;
                case $17f526922e4a857c$var$wa:
                    return b = $17f526922e4a857c$var$Sg(b, a.mode, c), b.return = a, b;
                case $17f526922e4a857c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($17f526922e4a857c$var$eb(b) || $17f526922e4a857c$var$Ka(b)) return b = $17f526922e4a857c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $17f526922e4a857c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $17f526922e4a857c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $17f526922e4a857c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $17f526922e4a857c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($17f526922e4a857c$var$eb(c) || $17f526922e4a857c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $17f526922e4a857c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $17f526922e4a857c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $17f526922e4a857c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $17f526922e4a857c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($17f526922e4a857c$var$eb(d) || $17f526922e4a857c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $17f526922e4a857c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $17f526922e4a857c$var$Ka(h);
        if ("function" !== typeof l) throw Error($17f526922e4a857c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($17f526922e4a857c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $17f526922e4a857c$var$I && $17f526922e4a857c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $17f526922e4a857c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $17f526922e4a857c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $17f526922e4a857c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $17f526922e4a857c$var$Ha && $17f526922e4a857c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $17f526922e4a857c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $17f526922e4a857c$var$ya ? (d = $17f526922e4a857c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $17f526922e4a857c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $17f526922e4a857c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $17f526922e4a857c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $17f526922e4a857c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $17f526922e4a857c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($17f526922e4a857c$var$eb(f)) return n(a, d, f, h);
            if ($17f526922e4a857c$var$Ka(f)) return t(a, d, f, h);
            $17f526922e4a857c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $17f526922e4a857c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $17f526922e4a857c$var$Ug = $17f526922e4a857c$var$Og(!0), $17f526922e4a857c$var$Vg = $17f526922e4a857c$var$Og(!1), $17f526922e4a857c$var$Wg = $17f526922e4a857c$var$Uf(null), $17f526922e4a857c$var$Xg = null, $17f526922e4a857c$var$Yg = null, $17f526922e4a857c$var$Zg = null;
function $17f526922e4a857c$var$$g() {
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Xg = null;
}
function $17f526922e4a857c$var$ah(a) {
    var b = $17f526922e4a857c$var$Wg.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$Wg);
    a._currentValue = b;
}
function $17f526922e4a857c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $17f526922e4a857c$var$ch(a, b) {
    $17f526922e4a857c$var$Xg = a;
    $17f526922e4a857c$var$Zg = $17f526922e4a857c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($17f526922e4a857c$var$dh = !0), a.firstContext = null);
}
function $17f526922e4a857c$var$eh(a) {
    var b = a._currentValue;
    if ($17f526922e4a857c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $17f526922e4a857c$var$Yg) {
            if (null === $17f526922e4a857c$var$Xg) throw Error($17f526922e4a857c$var$p(308));
            $17f526922e4a857c$var$Yg = a;
            $17f526922e4a857c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $17f526922e4a857c$var$Yg = $17f526922e4a857c$var$Yg.next = a;
    }
    return b;
}
var $17f526922e4a857c$var$fh = null;
function $17f526922e4a857c$var$gh(a) {
    null === $17f526922e4a857c$var$fh ? $17f526922e4a857c$var$fh = [
        a
    ] : $17f526922e4a857c$var$fh.push(a);
}
function $17f526922e4a857c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $17f526922e4a857c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $17f526922e4a857c$var$ih(a, d);
}
function $17f526922e4a857c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $17f526922e4a857c$var$jh = !1;
function $17f526922e4a857c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $17f526922e4a857c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $17f526922e4a857c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $17f526922e4a857c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($17f526922e4a857c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $17f526922e4a857c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $17f526922e4a857c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $17f526922e4a857c$var$ih(a, c);
}
function $17f526922e4a857c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
function $17f526922e4a857c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $17f526922e4a857c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $17f526922e4a857c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $17f526922e4a857c$var$A({}, q, r);
                            break a;
                        case 2:
                            $17f526922e4a857c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $17f526922e4a857c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $17f526922e4a857c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($17f526922e4a857c$var$p(191, e));
            e.call(d);
        }
    }
}
var $17f526922e4a857c$var$th = {}, $17f526922e4a857c$var$uh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$vh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th), $17f526922e4a857c$var$wh = $17f526922e4a857c$var$Uf($17f526922e4a857c$var$th);
function $17f526922e4a857c$var$xh(a) {
    if (a === $17f526922e4a857c$var$th) throw Error($17f526922e4a857c$var$p(174));
    return a;
}
function $17f526922e4a857c$var$yh(a, b) {
    $17f526922e4a857c$var$G($17f526922e4a857c$var$wh, b);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, $17f526922e4a857c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $17f526922e4a857c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $17f526922e4a857c$var$lb(b, a);
    }
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, b);
}
function $17f526922e4a857c$var$zh() {
    $17f526922e4a857c$var$E($17f526922e4a857c$var$uh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$vh);
    $17f526922e4a857c$var$E($17f526922e4a857c$var$wh);
}
function $17f526922e4a857c$var$Ah(a) {
    $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
    var b = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
    var c = $17f526922e4a857c$var$lb(b, a.type);
    b !== c && ($17f526922e4a857c$var$G($17f526922e4a857c$var$vh, a), $17f526922e4a857c$var$G($17f526922e4a857c$var$uh, c));
}
function $17f526922e4a857c$var$Bh(a) {
    $17f526922e4a857c$var$vh.current === a && ($17f526922e4a857c$var$E($17f526922e4a857c$var$uh), $17f526922e4a857c$var$E($17f526922e4a857c$var$vh));
}
var $17f526922e4a857c$var$L = $17f526922e4a857c$var$Uf(0);
function $17f526922e4a857c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $17f526922e4a857c$var$Dh = [];
function $17f526922e4a857c$var$Eh() {
    for(var a = 0; a < $17f526922e4a857c$var$Dh.length; a++)$17f526922e4a857c$var$Dh[a]._workInProgressVersionPrimary = null;
    $17f526922e4a857c$var$Dh.length = 0;
}
var $17f526922e4a857c$var$Fh = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$Gh = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$Hh = 0, $17f526922e4a857c$var$M = null, $17f526922e4a857c$var$N = null, $17f526922e4a857c$var$O = null, $17f526922e4a857c$var$Ih = !1, $17f526922e4a857c$var$Jh = !1, $17f526922e4a857c$var$Kh = 0, $17f526922e4a857c$var$Lh = 0;
function $17f526922e4a857c$var$P() {
    throw Error($17f526922e4a857c$var$p(321));
}
function $17f526922e4a857c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$17f526922e4a857c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $17f526922e4a857c$var$Nh(a, b, c, d, e, f) {
    $17f526922e4a857c$var$Hh = f;
    $17f526922e4a857c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $17f526922e4a857c$var$Fh.current = null === a || null === a.memoizedState ? $17f526922e4a857c$var$Oh : $17f526922e4a857c$var$Ph;
    a = c(d, e);
    if ($17f526922e4a857c$var$Jh) {
        f = 0;
        do {
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            if (25 <= f) throw Error($17f526922e4a857c$var$p(301));
            f += 1;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = null;
            b.updateQueue = null;
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Qh;
            a = c(d, e);
        }while ($17f526922e4a857c$var$Jh);
    }
    $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
    b = null !== $17f526922e4a857c$var$N && null !== $17f526922e4a857c$var$N.next;
    $17f526922e4a857c$var$Hh = 0;
    $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
    $17f526922e4a857c$var$Ih = !1;
    if (b) throw Error($17f526922e4a857c$var$p(300));
    return a;
}
function $17f526922e4a857c$var$Sh() {
    var a = 0 !== $17f526922e4a857c$var$Kh;
    $17f526922e4a857c$var$Kh = 0;
    return a;
}
function $17f526922e4a857c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Uh() {
    if (null === $17f526922e4a857c$var$N) {
        var a = $17f526922e4a857c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $17f526922e4a857c$var$N.next;
    var b = null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState : $17f526922e4a857c$var$O.next;
    if (null !== b) $17f526922e4a857c$var$O = b, $17f526922e4a857c$var$N = a;
    else {
        if (null === a) throw Error($17f526922e4a857c$var$p(310));
        $17f526922e4a857c$var$N = a;
        a = {
            memoizedState: $17f526922e4a857c$var$N.memoizedState,
            baseState: $17f526922e4a857c$var$N.baseState,
            baseQueue: $17f526922e4a857c$var$N.baseQueue,
            queue: $17f526922e4a857c$var$N.queue,
            next: null
        };
        null === $17f526922e4a857c$var$O ? $17f526922e4a857c$var$M.memoizedState = $17f526922e4a857c$var$O = a : $17f526922e4a857c$var$O = $17f526922e4a857c$var$O.next = a;
    }
    return $17f526922e4a857c$var$O;
}
function $17f526922e4a857c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $17f526922e4a857c$var$Wh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $17f526922e4a857c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($17f526922e4a857c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $17f526922e4a857c$var$M.lanes |= m;
                $17f526922e4a857c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $17f526922e4a857c$var$He(d, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $17f526922e4a857c$var$M.lanes |= f, $17f526922e4a857c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $17f526922e4a857c$var$Xh(a) {
    var b = $17f526922e4a857c$var$Uh(), c = b.queue;
    if (null === c) throw Error($17f526922e4a857c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $17f526922e4a857c$var$He(f, b.memoizedState) || ($17f526922e4a857c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $17f526922e4a857c$var$Yh() {}
function $17f526922e4a857c$var$Zh(a, b) {
    var c = $17f526922e4a857c$var$M, d = $17f526922e4a857c$var$Uh(), e = b(), f = !$17f526922e4a857c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $17f526922e4a857c$var$dh = !0);
    d = d.queue;
    $17f526922e4a857c$var$$h($17f526922e4a857c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $17f526922e4a857c$var$O && $17f526922e4a857c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
        0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(c, b, e);
    }
    return e;
}
function $17f526922e4a857c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $17f526922e4a857c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
}
function $17f526922e4a857c$var$ai(a, b, c) {
    return c(function() {
        $17f526922e4a857c$var$ei(b) && $17f526922e4a857c$var$fi(a);
    });
}
function $17f526922e4a857c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$17f526922e4a857c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $17f526922e4a857c$var$fi(a) {
    var b = $17f526922e4a857c$var$ih(a, 1);
    null !== b && $17f526922e4a857c$var$gi(b, a, 1, -1);
}
function $17f526922e4a857c$var$hi(a) {
    var b = $17f526922e4a857c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $17f526922e4a857c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $17f526922e4a857c$var$ii.bind(null, $17f526922e4a857c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $17f526922e4a857c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $17f526922e4a857c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $17f526922e4a857c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $17f526922e4a857c$var$ji() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$ki(a, b, c, d) {
    var e = $17f526922e4a857c$var$Th();
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $17f526922e4a857c$var$li(a, b, c, d) {
    var e = $17f526922e4a857c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $17f526922e4a857c$var$N) {
        var g = $17f526922e4a857c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $17f526922e4a857c$var$Mh(d, g.deps)) {
            e.memoizedState = $17f526922e4a857c$var$bi(b, c, f, d);
            return;
        }
    }
    $17f526922e4a857c$var$M.flags |= a;
    e.memoizedState = $17f526922e4a857c$var$bi(1 | b, c, f, d);
}
function $17f526922e4a857c$var$mi(a, b) {
    return $17f526922e4a857c$var$ki(8390656, 8, a, b);
}
function $17f526922e4a857c$var$$h(a, b) {
    return $17f526922e4a857c$var$li(2048, 8, a, b);
}
function $17f526922e4a857c$var$ni(a, b) {
    return $17f526922e4a857c$var$li(4, 2, a, b);
}
function $17f526922e4a857c$var$oi(a, b) {
    return $17f526922e4a857c$var$li(4, 4, a, b);
}
function $17f526922e4a857c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $17f526922e4a857c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $17f526922e4a857c$var$li(4, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
}
function $17f526922e4a857c$var$ri() {}
function $17f526922e4a857c$var$si(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ti(a, b) {
    var c = $17f526922e4a857c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $17f526922e4a857c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $17f526922e4a857c$var$ui(a, b, c) {
    if (0 === ($17f526922e4a857c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $17f526922e4a857c$var$dh = !0), a.memoizedState = c;
    $17f526922e4a857c$var$He(c, b) || (c = $17f526922e4a857c$var$yc(), $17f526922e4a857c$var$M.lanes |= c, $17f526922e4a857c$var$rh |= c, a.baseState = !0);
    return b;
}
function $17f526922e4a857c$var$vi(a, b) {
    var c = $17f526922e4a857c$var$C;
    $17f526922e4a857c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $17f526922e4a857c$var$Gh.transition;
    $17f526922e4a857c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$Gh.transition = d;
    }
}
function $17f526922e4a857c$var$wi() {
    return $17f526922e4a857c$var$Uh().memoizedState;
}
function $17f526922e4a857c$var$xi(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, c);
    else if (c = $17f526922e4a857c$var$hh(a, b, c, d), null !== c) {
        var e = $17f526922e4a857c$var$R();
        $17f526922e4a857c$var$gi(c, a, d, e);
        $17f526922e4a857c$var$Bi(c, b, d);
    }
}
function $17f526922e4a857c$var$ii(a, b, c) {
    var d = $17f526922e4a857c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($17f526922e4a857c$var$zi(a)) $17f526922e4a857c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($17f526922e4a857c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $17f526922e4a857c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $17f526922e4a857c$var$hh(a, b, e, d);
        null !== c && (e = $17f526922e4a857c$var$R(), $17f526922e4a857c$var$gi(c, a, d, e), $17f526922e4a857c$var$Bi(c, b, d));
    }
}
function $17f526922e4a857c$var$zi(a) {
    var b = a.alternate;
    return a === $17f526922e4a857c$var$M || null !== b && b === $17f526922e4a857c$var$M;
}
function $17f526922e4a857c$var$Ai(a, b) {
    $17f526922e4a857c$var$Jh = $17f526922e4a857c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $17f526922e4a857c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $17f526922e4a857c$var$Cc(a, c);
    }
}
var $17f526922e4a857c$var$Rh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$P,
    useContext: $17f526922e4a857c$var$P,
    useEffect: $17f526922e4a857c$var$P,
    useImperativeHandle: $17f526922e4a857c$var$P,
    useInsertionEffect: $17f526922e4a857c$var$P,
    useLayoutEffect: $17f526922e4a857c$var$P,
    useMemo: $17f526922e4a857c$var$P,
    useReducer: $17f526922e4a857c$var$P,
    useRef: $17f526922e4a857c$var$P,
    useState: $17f526922e4a857c$var$P,
    useDebugValue: $17f526922e4a857c$var$P,
    useDeferredValue: $17f526922e4a857c$var$P,
    useTransition: $17f526922e4a857c$var$P,
    useMutableSource: $17f526922e4a857c$var$P,
    useSyncExternalStore: $17f526922e4a857c$var$P,
    useId: $17f526922e4a857c$var$P,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Oh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: function(a, b) {
        $17f526922e4a857c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $17f526922e4a857c$var$ki(4194308, 4, $17f526922e4a857c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $17f526922e4a857c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $17f526922e4a857c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $17f526922e4a857c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $17f526922e4a857c$var$xi.bind(null, $17f526922e4a857c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $17f526922e4a857c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $17f526922e4a857c$var$hi,
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        return $17f526922e4a857c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$hi(!1), b = a[0];
        a = $17f526922e4a857c$var$vi.bind(null, a[1]);
        $17f526922e4a857c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $17f526922e4a857c$var$M, e = $17f526922e4a857c$var$Th();
        if ($17f526922e4a857c$var$I) {
            if (void 0 === c) throw Error($17f526922e4a857c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $17f526922e4a857c$var$Q) throw Error($17f526922e4a857c$var$p(349));
            0 !== ($17f526922e4a857c$var$Hh & 30) || $17f526922e4a857c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $17f526922e4a857c$var$mi($17f526922e4a857c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $17f526922e4a857c$var$bi(9, $17f526922e4a857c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $17f526922e4a857c$var$Th(), b = $17f526922e4a857c$var$Q.identifierPrefix;
        if ($17f526922e4a857c$var$I) {
            var c = $17f526922e4a857c$var$sg;
            var d = $17f526922e4a857c$var$rg;
            c = (d & ~(1 << 32 - $17f526922e4a857c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $17f526922e4a857c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $17f526922e4a857c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Ph = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Wh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Wh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
}, $17f526922e4a857c$var$Qh = {
    readContext: $17f526922e4a857c$var$eh,
    useCallback: $17f526922e4a857c$var$si,
    useContext: $17f526922e4a857c$var$eh,
    useEffect: $17f526922e4a857c$var$$h,
    useImperativeHandle: $17f526922e4a857c$var$qi,
    useInsertionEffect: $17f526922e4a857c$var$ni,
    useLayoutEffect: $17f526922e4a857c$var$oi,
    useMemo: $17f526922e4a857c$var$ti,
    useReducer: $17f526922e4a857c$var$Xh,
    useRef: $17f526922e4a857c$var$ji,
    useState: function() {
        return $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh);
    },
    useDebugValue: $17f526922e4a857c$var$ri,
    useDeferredValue: function(a) {
        var b = $17f526922e4a857c$var$Uh();
        return null === $17f526922e4a857c$var$N ? b.memoizedState = a : $17f526922e4a857c$var$ui(b, $17f526922e4a857c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $17f526922e4a857c$var$Xh($17f526922e4a857c$var$Vh)[0], b = $17f526922e4a857c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $17f526922e4a857c$var$Yh,
    useSyncExternalStore: $17f526922e4a857c$var$Zh,
    useId: $17f526922e4a857c$var$wi,
    unstable_isNewReconciler: !1
};
function $17f526922e4a857c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $17f526922e4a857c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $17f526922e4a857c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17f526922e4a857c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $17f526922e4a857c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $17f526922e4a857c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $17f526922e4a857c$var$R(), e = $17f526922e4a857c$var$yi(a), f = $17f526922e4a857c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $17f526922e4a857c$var$nh(a, f, e);
        null !== b && ($17f526922e4a857c$var$gi(b, a, e, d), $17f526922e4a857c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $17f526922e4a857c$var$R(), d = $17f526922e4a857c$var$yi(a), e = $17f526922e4a857c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $17f526922e4a857c$var$nh(a, e, d);
        null !== b && ($17f526922e4a857c$var$gi(b, a, d, c), $17f526922e4a857c$var$oh(b, a, d));
    }
};
function $17f526922e4a857c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$17f526922e4a857c$var$Ie(c, d) || !$17f526922e4a857c$var$Ie(e, f) : !0;
}
function $17f526922e4a857c$var$Gi(a, b, c) {
    var d = !1, e = $17f526922e4a857c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $17f526922e4a857c$var$eh(f) : (e = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $17f526922e4a857c$var$Yf(a, e) : $17f526922e4a857c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $17f526922e4a857c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $17f526922e4a857c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $17f526922e4a857c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $17f526922e4a857c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $17f526922e4a857c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $17f526922e4a857c$var$eh(f) : (f = $17f526922e4a857c$var$Zf(b) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, e.context = $17f526922e4a857c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($17f526922e4a857c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $17f526922e4a857c$var$Ei.enqueueReplaceState(e, e.state, null), $17f526922e4a857c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $17f526922e4a857c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $17f526922e4a857c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $17f526922e4a857c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $17f526922e4a857c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $17f526922e4a857c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $17f526922e4a857c$var$Ni(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $17f526922e4a857c$var$Oi || ($17f526922e4a857c$var$Oi = !0, $17f526922e4a857c$var$Pi = d);
        $17f526922e4a857c$var$Li(a, b);
    };
    return c;
}
function $17f526922e4a857c$var$Qi(a, b, c) {
    c = $17f526922e4a857c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $17f526922e4a857c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $17f526922e4a857c$var$Li(a, b);
        "function" !== typeof d && (null === $17f526922e4a857c$var$Ri ? $17f526922e4a857c$var$Ri = new Set([
            this
        ]) : $17f526922e4a857c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $17f526922e4a857c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $17f526922e4a857c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $17f526922e4a857c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $17f526922e4a857c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $17f526922e4a857c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $17f526922e4a857c$var$mh(-1, 1), b.tag = 2, $17f526922e4a857c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $17f526922e4a857c$var$Wi = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$dh = !1;
function $17f526922e4a857c$var$Xi(a, b, c, d) {
    b.child = null === a ? $17f526922e4a857c$var$Vg(b, null, c, d) : $17f526922e4a857c$var$Ug(b, a.child, c, d);
}
function $17f526922e4a857c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $17f526922e4a857c$var$ch(b, e);
    d = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    c = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && c && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, d, e);
    return b.child;
}
function $17f526922e4a857c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$17f526922e4a857c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $17f526922e4a857c$var$bj(a, b, f, d, e);
        a = $17f526922e4a857c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $17f526922e4a857c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $17f526922e4a857c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $17f526922e4a857c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $17f526922e4a857c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($17f526922e4a857c$var$Ie(f, d) && a.ref === b.ref) {
            if ($17f526922e4a857c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($17f526922e4a857c$var$dh = !0);
            else return b.lanes = a.lanes, $17f526922e4a857c$var$Zi(a, b, e);
        }
    }
    return $17f526922e4a857c$var$cj(a, b, c, d, e);
}
function $17f526922e4a857c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj);
            $17f526922e4a857c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $17f526922e4a857c$var$G($17f526922e4a857c$var$ej, $17f526922e4a857c$var$fj), $17f526922e4a857c$var$fj |= d;
    $17f526922e4a857c$var$Xi(a, b, e, c);
    return b.child;
}
function $17f526922e4a857c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $17f526922e4a857c$var$cj(a, b, c, d, e) {
    var f = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current;
    f = $17f526922e4a857c$var$Yf(b, f);
    $17f526922e4a857c$var$ch(b, e);
    c = $17f526922e4a857c$var$Nh(a, b, c, d, f, e);
    d = $17f526922e4a857c$var$Sh();
    if (null !== a && !$17f526922e4a857c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $17f526922e4a857c$var$Zi(a, b, e);
    $17f526922e4a857c$var$I && d && $17f526922e4a857c$var$vg(b);
    b.flags |= 1;
    $17f526922e4a857c$var$Xi(a, b, c, e);
    return b.child;
}
function $17f526922e4a857c$var$hj(a, b, c, d, e) {
    if ($17f526922e4a857c$var$Zf(c)) {
        var f = !0;
        $17f526922e4a857c$var$cg(b);
    } else f = !1;
    $17f526922e4a857c$var$ch(b, e);
    if (null === b.stateNode) $17f526922e4a857c$var$ij(a, b), $17f526922e4a857c$var$Gi(b, c, d), $17f526922e4a857c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $17f526922e4a857c$var$eh(l) : (l = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, l = $17f526922e4a857c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $17f526922e4a857c$var$Hi(b, g, d, l);
        $17f526922e4a857c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof m && ($17f526922e4a857c$var$Di(b, c, m, d), k = b.memoizedState), (h = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $17f526922e4a857c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $17f526922e4a857c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $17f526922e4a857c$var$eh(k) : (k = $17f526922e4a857c$var$Zf(c) ? $17f526922e4a857c$var$Xf : $17f526922e4a857c$var$H.current, k = $17f526922e4a857c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $17f526922e4a857c$var$Hi(b, g, d, k);
        $17f526922e4a857c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $17f526922e4a857c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $17f526922e4a857c$var$Wf.current || $17f526922e4a857c$var$jh ? ("function" === typeof y && ($17f526922e4a857c$var$Di(b, c, y, d), n = b.memoizedState), (l = $17f526922e4a857c$var$jh || $17f526922e4a857c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $17f526922e4a857c$var$jj(a, b, c, d, f, e);
}
function $17f526922e4a857c$var$jj(a, b, c, d, e, f) {
    $17f526922e4a857c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $17f526922e4a857c$var$dg(b, c, !1), $17f526922e4a857c$var$Zi(a, b, f);
    d = b.stateNode;
    $17f526922e4a857c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $17f526922e4a857c$var$Ug(b, a.child, null, f), b.child = $17f526922e4a857c$var$Ug(b, null, h, f)) : $17f526922e4a857c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $17f526922e4a857c$var$dg(b, c, !0);
    return b.child;
}
function $17f526922e4a857c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $17f526922e4a857c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $17f526922e4a857c$var$ag(a, b.context, !1);
    $17f526922e4a857c$var$yh(a, b.containerInfo);
}
function $17f526922e4a857c$var$lj(a, b, c, d, e) {
    $17f526922e4a857c$var$Ig();
    $17f526922e4a857c$var$Jg(e);
    b.flags |= 256;
    $17f526922e4a857c$var$Xi(a, b, c, d);
    return b.child;
}
var $17f526922e4a857c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $17f526922e4a857c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $17f526922e4a857c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $17f526922e4a857c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, e & 1);
    if (null === a) {
        $17f526922e4a857c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $17f526922e4a857c$var$pj(g, d, 0, null), a = $17f526922e4a857c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $17f526922e4a857c$var$nj(c), b.memoizedState = $17f526922e4a857c$var$mj, a) : $17f526922e4a857c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $17f526922e4a857c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $17f526922e4a857c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $17f526922e4a857c$var$Pg(h, f) : (f = $17f526922e4a857c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $17f526922e4a857c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $17f526922e4a857c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $17f526922e4a857c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $17f526922e4a857c$var$qj(a, b) {
    b = $17f526922e4a857c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $17f526922e4a857c$var$sj(a, b, c, d) {
    null !== d && $17f526922e4a857c$var$Jg(d);
    $17f526922e4a857c$var$Ug(b, a.child, null, c);
    a = $17f526922e4a857c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $17f526922e4a857c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(422))), $17f526922e4a857c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $17f526922e4a857c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $17f526922e4a857c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $17f526922e4a857c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $17f526922e4a857c$var$nj(g);
        b.memoizedState = $17f526922e4a857c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $17f526922e4a857c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($17f526922e4a857c$var$p(419));
        d = $17f526922e4a857c$var$Ki(f, d, void 0);
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($17f526922e4a857c$var$dh || h) {
        d = $17f526922e4a857c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $17f526922e4a857c$var$ih(a, e), $17f526922e4a857c$var$gi(d, a, e, -1));
        }
        $17f526922e4a857c$var$tj();
        d = $17f526922e4a857c$var$Ki(Error($17f526922e4a857c$var$p(421)));
        return $17f526922e4a857c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $17f526922e4a857c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(e.nextSibling);
    $17f526922e4a857c$var$xg = b;
    $17f526922e4a857c$var$I = !0;
    $17f526922e4a857c$var$zg = null;
    null !== a && ($17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$rg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$sg, $17f526922e4a857c$var$og[$17f526922e4a857c$var$pg++] = $17f526922e4a857c$var$qg, $17f526922e4a857c$var$rg = a.id, $17f526922e4a857c$var$sg = a.overflow, $17f526922e4a857c$var$qg = b);
    b = $17f526922e4a857c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $17f526922e4a857c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $17f526922e4a857c$var$bh(a.return, b, c);
}
function $17f526922e4a857c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $17f526922e4a857c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $17f526922e4a857c$var$Xi(a, b, d.children, c);
    d = $17f526922e4a857c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $17f526922e4a857c$var$vj(a, c, b);
            else if (19 === a.tag) $17f526922e4a857c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $17f526922e4a857c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $17f526922e4a857c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $17f526922e4a857c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $17f526922e4a857c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $17f526922e4a857c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $17f526922e4a857c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $17f526922e4a857c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($17f526922e4a857c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $17f526922e4a857c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $17f526922e4a857c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $17f526922e4a857c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $17f526922e4a857c$var$kj(b);
            $17f526922e4a857c$var$Ig();
            break;
        case 5:
            $17f526922e4a857c$var$Ah(b);
            break;
        case 1:
            $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$cg(b);
            break;
        case 4:
            $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $17f526922e4a857c$var$oj(a, b, c);
                $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
                a = $17f526922e4a857c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $17f526922e4a857c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $17f526922e4a857c$var$dj(a, b, c);
    }
    return $17f526922e4a857c$var$Zi(a, b, c);
}
var $17f526922e4a857c$var$zj, $17f526922e4a857c$var$Aj, $17f526922e4a857c$var$Bj, $17f526922e4a857c$var$Cj;
$17f526922e4a857c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$17f526922e4a857c$var$Aj = function() {};
$17f526922e4a857c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $17f526922e4a857c$var$Ya(a, e);
                d = $17f526922e4a857c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $17f526922e4a857c$var$A({}, e, {
                    value: void 0
                });
                d = $17f526922e4a857c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $17f526922e4a857c$var$gb(a, e);
                d = $17f526922e4a857c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
        }
        $17f526922e4a857c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($17f526922e4a857c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $17f526922e4a857c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$17f526922e4a857c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $17f526922e4a857c$var$Dj(a, b) {
    if (!$17f526922e4a857c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $17f526922e4a857c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $17f526922e4a857c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $17f526922e4a857c$var$S(b), null;
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $17f526922e4a857c$var$zh();
            $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
            $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
            $17f526922e4a857c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $17f526922e4a857c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null));
            $17f526922e4a857c$var$Aj(a, b);
            $17f526922e4a857c$var$S(b);
            return null;
        case 5:
            $17f526922e4a857c$var$Bh(b);
            var e = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $17f526922e4a857c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                    $17f526922e4a857c$var$S(b);
                    return null;
                }
                a = $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    d[$17f526922e4a857c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $17f526922e4a857c$var$D("cancel", d);
                            $17f526922e4a857c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], d);
                            break;
                        case "source":
                            $17f526922e4a857c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $17f526922e4a857c$var$D("error", d);
                            $17f526922e4a857c$var$D("load", d);
                            break;
                        case "details":
                            $17f526922e4a857c$var$D("toggle", d);
                            break;
                        case "input":
                            $17f526922e4a857c$var$Za(d, f);
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $17f526922e4a857c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$hb(d, f), $17f526922e4a857c$var$D("invalid", d);
                    }
                    $17f526922e4a857c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $17f526922e4a857c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $17f526922e4a857c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$Va(d);
                            $17f526922e4a857c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $17f526922e4a857c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $17f526922e4a857c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$17f526922e4a857c$var$Of] = b;
                    a[$17f526922e4a857c$var$Pf] = d;
                    $17f526922e4a857c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $17f526922e4a857c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $17f526922e4a857c$var$D("cancel", a);
                                $17f526922e4a857c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $17f526922e4a857c$var$lf.length; e++)$17f526922e4a857c$var$D($17f526922e4a857c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $17f526922e4a857c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $17f526922e4a857c$var$D("error", a);
                                $17f526922e4a857c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $17f526922e4a857c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $17f526922e4a857c$var$Za(a, d);
                                e = $17f526922e4a857c$var$Ya(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $17f526922e4a857c$var$A({}, d, {
                                    value: void 0
                                });
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$hb(a, d);
                                e = $17f526922e4a857c$var$gb(a, d);
                                $17f526922e4a857c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $17f526922e4a857c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $17f526922e4a857c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $17f526922e4a857c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $17f526922e4a857c$var$ob(a, k) : "number" === typeof k && $17f526922e4a857c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($17f526922e4a857c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $17f526922e4a857c$var$D("scroll", a) : null != k && $17f526922e4a857c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $17f526922e4a857c$var$Va(a);
                                $17f526922e4a857c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $17f526922e4a857c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $17f526922e4a857c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $17f526922e4a857c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $17f526922e4a857c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $17f526922e4a857c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($17f526922e4a857c$var$p(166));
                c = $17f526922e4a857c$var$xh($17f526922e4a857c$var$wh.current);
                $17f526922e4a857c$var$xh($17f526922e4a857c$var$uh.current);
                if ($17f526922e4a857c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$17f526922e4a857c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $17f526922e4a857c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $17f526922e4a857c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$17f526922e4a857c$var$Of] = b, b.stateNode = d;
            }
            $17f526922e4a857c$var$S(b);
            return null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($17f526922e4a857c$var$I && null !== $17f526922e4a857c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $17f526922e4a857c$var$Hg(), $17f526922e4a857c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $17f526922e4a857c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($17f526922e4a857c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($17f526922e4a857c$var$p(317));
                        f[$17f526922e4a857c$var$Of] = b;
                    } else $17f526922e4a857c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $17f526922e4a857c$var$S(b);
                    f = !1;
                } else null !== $17f526922e4a857c$var$zg && ($17f526922e4a857c$var$Fj($17f526922e4a857c$var$zg), $17f526922e4a857c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($17f526922e4a857c$var$L.current & 1) ? 0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 3) : $17f526922e4a857c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $17f526922e4a857c$var$S(b);
            return null;
        case 4:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$Aj(a, b), null === a && $17f526922e4a857c$var$sf(b.stateNode.containerInfo), $17f526922e4a857c$var$S(b), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), $17f526922e4a857c$var$S(b), null;
        case 17:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), $17f526922e4a857c$var$S(b), null;
        case 19:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            f = b.memoizedState;
            if (null === f) return $17f526922e4a857c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $17f526922e4a857c$var$Dj(f, !1);
                else {
                    if (0 !== $17f526922e4a857c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $17f526922e4a857c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $17f526922e4a857c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $17f526922e4a857c$var$G($17f526922e4a857c$var$L, $17f526922e4a857c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $17f526922e4a857c$var$B() > $17f526922e4a857c$var$Gj && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $17f526922e4a857c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $17f526922e4a857c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$17f526922e4a857c$var$I) return $17f526922e4a857c$var$S(b), null;
                    } else 2 * $17f526922e4a857c$var$B() - f.renderingStartTime > $17f526922e4a857c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $17f526922e4a857c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $17f526922e4a857c$var$B(), b.sibling = null, c = $17f526922e4a857c$var$L.current, $17f526922e4a857c$var$G($17f526922e4a857c$var$L, d ? c & 1 | 2 : c & 1), b;
            $17f526922e4a857c$var$S(b);
            return null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($17f526922e4a857c$var$fj & 1073741824) && ($17f526922e4a857c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $17f526922e4a857c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
}
function $17f526922e4a857c$var$Ij(a, b) {
    $17f526922e4a857c$var$wg(b);
    switch(b.tag){
        case 1:
            return $17f526922e4a857c$var$Zf(b.type) && $17f526922e4a857c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $17f526922e4a857c$var$zh(), $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf), $17f526922e4a857c$var$E($17f526922e4a857c$var$H), $17f526922e4a857c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $17f526922e4a857c$var$Bh(b), null;
        case 13:
            $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($17f526922e4a857c$var$p(340));
                $17f526922e4a857c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $17f526922e4a857c$var$E($17f526922e4a857c$var$L), null;
        case 4:
            return $17f526922e4a857c$var$zh(), null;
        case 10:
            return $17f526922e4a857c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $17f526922e4a857c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $17f526922e4a857c$var$Jj = !1, $17f526922e4a857c$var$U = !1, $17f526922e4a857c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $17f526922e4a857c$var$V = null;
function $17f526922e4a857c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $17f526922e4a857c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $17f526922e4a857c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $17f526922e4a857c$var$W(a, b, d);
    }
}
var $17f526922e4a857c$var$Nj = !1;
function $17f526922e4a857c$var$Oj(a, b) {
    $17f526922e4a857c$var$Cf = $17f526922e4a857c$var$dd;
    a = $17f526922e4a857c$var$Me();
    if ($17f526922e4a857c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $17f526922e4a857c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $17f526922e4a857c$var$dd = !1;
    for($17f526922e4a857c$var$V = b; null !== $17f526922e4a857c$var$V;)if (b = $17f526922e4a857c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $17f526922e4a857c$var$V = a;
    else for(; null !== $17f526922e4a857c$var$V;){
        b = $17f526922e4a857c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $17f526922e4a857c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(163));
            }
        } catch (F) {
            $17f526922e4a857c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $17f526922e4a857c$var$V = a;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
    n = $17f526922e4a857c$var$Nj;
    $17f526922e4a857c$var$Nj = !1;
    return n;
}
function $17f526922e4a857c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $17f526922e4a857c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $17f526922e4a857c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $17f526922e4a857c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $17f526922e4a857c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $17f526922e4a857c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$17f526922e4a857c$var$Of], delete b[$17f526922e4a857c$var$Pf], delete b[$17f526922e4a857c$var$of], delete b[$17f526922e4a857c$var$Qf], delete b[$17f526922e4a857c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $17f526922e4a857c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $17f526922e4a857c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $17f526922e4a857c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $17f526922e4a857c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $17f526922e4a857c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Vj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Vj(a, b, c), a = a.sibling;
}
function $17f526922e4a857c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($17f526922e4a857c$var$Wj(a, b, c), a = a.sibling; null !== a;)$17f526922e4a857c$var$Wj(a, b, c), a = a.sibling;
}
var $17f526922e4a857c$var$X = null, $17f526922e4a857c$var$Xj = !1;
function $17f526922e4a857c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$17f526922e4a857c$var$Zj(a, b, c), c = c.sibling;
}
function $17f526922e4a857c$var$Zj(a, b, c) {
    if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onCommitFiberUnmount) try {
        $17f526922e4a857c$var$lc.onCommitFiberUnmount($17f526922e4a857c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $17f526922e4a857c$var$U || $17f526922e4a857c$var$Lj(c, b);
        case 6:
            var d = $17f526922e4a857c$var$X, e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $17f526922e4a857c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $17f526922e4a857c$var$X && ($17f526922e4a857c$var$Xj ? (a = $17f526922e4a857c$var$X, c = c.stateNode, 8 === a.nodeType ? $17f526922e4a857c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $17f526922e4a857c$var$Kf(a, c), $17f526922e4a857c$var$bd(a)) : $17f526922e4a857c$var$Kf($17f526922e4a857c$var$X, c.stateNode));
            break;
        case 4:
            d = $17f526922e4a857c$var$X;
            e = $17f526922e4a857c$var$Xj;
            $17f526922e4a857c$var$X = c.stateNode.containerInfo;
            $17f526922e4a857c$var$Xj = !0;
            $17f526922e4a857c$var$Yj(a, b, c);
            $17f526922e4a857c$var$X = d;
            $17f526922e4a857c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$17f526922e4a857c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $17f526922e4a857c$var$Mj(c, b, g) : 0 !== (f & 4) && $17f526922e4a857c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$17f526922e4a857c$var$U && ($17f526922e4a857c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $17f526922e4a857c$var$W(c, b, h);
            }
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 21:
            $17f526922e4a857c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($17f526922e4a857c$var$U = (d = $17f526922e4a857c$var$U) || null !== c.memoizedState, $17f526922e4a857c$var$Yj(a, b, c), $17f526922e4a857c$var$U = d) : $17f526922e4a857c$var$Yj(a, b, c);
            break;
        default:
            $17f526922e4a857c$var$Yj(a, b, c);
    }
}
function $17f526922e4a857c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $17f526922e4a857c$var$Kj);
        b.forEach(function(b) {
            var d = $17f526922e4a857c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $17f526922e4a857c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $17f526922e4a857c$var$X = h.stateNode;
                        $17f526922e4a857c$var$Xj = !1;
                        break a;
                    case 3:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                    case 4:
                        $17f526922e4a857c$var$X = h.stateNode.containerInfo;
                        $17f526922e4a857c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $17f526922e4a857c$var$X) throw Error($17f526922e4a857c$var$p(160));
            $17f526922e4a857c$var$Zj(f, g, e);
            $17f526922e4a857c$var$X = null;
            $17f526922e4a857c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $17f526922e4a857c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$17f526922e4a857c$var$dk(b, a), b = b.sibling;
}
function $17f526922e4a857c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                try {
                    $17f526922e4a857c$var$Pj(3, a, a.return), $17f526922e4a857c$var$Qj(3, a);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
                try {
                    $17f526922e4a857c$var$Pj(5, a, a.return);
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            break;
        case 5:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 512 && null !== c && $17f526922e4a857c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $17f526922e4a857c$var$ob(e, "");
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $17f526922e4a857c$var$ab(e, f);
                    $17f526922e4a857c$var$vb(h, g);
                    var l = $17f526922e4a857c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $17f526922e4a857c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $17f526922e4a857c$var$nb(e, q) : "children" === m ? $17f526922e4a857c$var$ob(e, q) : $17f526922e4a857c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $17f526922e4a857c$var$bb(e, f);
                            break;
                        case "textarea":
                            $17f526922e4a857c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $17f526922e4a857c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $17f526922e4a857c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $17f526922e4a857c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$17f526922e4a857c$var$Pf] = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($17f526922e4a857c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $17f526922e4a857c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $17f526922e4a857c$var$bd(b.containerInfo);
            } catch (t) {
                $17f526922e4a857c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            break;
        case 13:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($17f526922e4a857c$var$fk = $17f526922e4a857c$var$B()));
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($17f526922e4a857c$var$U = (l = $17f526922e4a857c$var$U) || m, $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$U = l) : $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($17f526922e4a857c$var$V = a, m = a.child; null !== m;){
                    for(q = $17f526922e4a857c$var$V = m; null !== $17f526922e4a857c$var$V;){
                        r = $17f526922e4a857c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $17f526922e4a857c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $17f526922e4a857c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $17f526922e4a857c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $17f526922e4a857c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $17f526922e4a857c$var$V = y) : $17f526922e4a857c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $17f526922e4a857c$var$rb("display", g));
                            } catch (t) {
                                $17f526922e4a857c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $17f526922e4a857c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $17f526922e4a857c$var$ck(b, a);
            $17f526922e4a857c$var$ek(a);
            d & 4 && $17f526922e4a857c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $17f526922e4a857c$var$ck(b, a), $17f526922e4a857c$var$ek(a);
    }
}
function $17f526922e4a857c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($17f526922e4a857c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($17f526922e4a857c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($17f526922e4a857c$var$ob(e, ""), d.flags &= -33);
                    var f = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $17f526922e4a857c$var$Uj(a);
                    $17f526922e4a857c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(161));
            }
        } catch (k) {
            $17f526922e4a857c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $17f526922e4a857c$var$hk(a, b, c) {
    $17f526922e4a857c$var$V = a;
    $17f526922e4a857c$var$ik(a, b, c);
}
function $17f526922e4a857c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $17f526922e4a857c$var$V;){
        var e = $17f526922e4a857c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $17f526922e4a857c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $17f526922e4a857c$var$U;
                h = $17f526922e4a857c$var$Jj;
                var l = $17f526922e4a857c$var$U;
                $17f526922e4a857c$var$Jj = g;
                if (($17f526922e4a857c$var$U = k) && !l) for($17f526922e4a857c$var$V = e; null !== $17f526922e4a857c$var$V;)g = $17f526922e4a857c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $17f526922e4a857c$var$jk(e) : null !== k ? (k.return = g, $17f526922e4a857c$var$V = k) : $17f526922e4a857c$var$jk(e);
                for(; null !== f;)$17f526922e4a857c$var$V = f, $17f526922e4a857c$var$ik(f, b, c), f = f.sibling;
                $17f526922e4a857c$var$V = e;
                $17f526922e4a857c$var$Jj = h;
                $17f526922e4a857c$var$U = l;
            }
            $17f526922e4a857c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $17f526922e4a857c$var$V = f) : $17f526922e4a857c$var$kk(a, b, c);
    }
}
function $17f526922e4a857c$var$kk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $17f526922e4a857c$var$U || $17f526922e4a857c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$17f526922e4a857c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $17f526922e4a857c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $17f526922e4a857c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $17f526922e4a857c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $17f526922e4a857c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($17f526922e4a857c$var$p(163));
                }
                $17f526922e4a857c$var$U || b.flags & 512 && $17f526922e4a857c$var$Rj(b);
            } catch (r) {
                $17f526922e4a857c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$gk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $17f526922e4a857c$var$V = c;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
function $17f526922e4a857c$var$jk(a) {
    for(; null !== $17f526922e4a857c$var$V;){
        var b = $17f526922e4a857c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $17f526922e4a857c$var$Qj(4, b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $17f526922e4a857c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $17f526922e4a857c$var$Rj(b);
                    } catch (k) {
                        $17f526922e4a857c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $17f526922e4a857c$var$W(b, b.return, k);
        }
        if (b === a) {
            $17f526922e4a857c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $17f526922e4a857c$var$V = h;
            break;
        }
        $17f526922e4a857c$var$V = b.return;
    }
}
var $17f526922e4a857c$var$lk = Math.ceil, $17f526922e4a857c$var$mk = $17f526922e4a857c$var$ua.ReactCurrentDispatcher, $17f526922e4a857c$var$nk = $17f526922e4a857c$var$ua.ReactCurrentOwner, $17f526922e4a857c$var$ok = $17f526922e4a857c$var$ua.ReactCurrentBatchConfig, $17f526922e4a857c$var$K = 0, $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Y = null, $17f526922e4a857c$var$Z = 0, $17f526922e4a857c$var$fj = 0, $17f526922e4a857c$var$ej = $17f526922e4a857c$var$Uf(0), $17f526922e4a857c$var$T = 0, $17f526922e4a857c$var$pk = null, $17f526922e4a857c$var$rh = 0, $17f526922e4a857c$var$qk = 0, $17f526922e4a857c$var$rk = 0, $17f526922e4a857c$var$sk = null, $17f526922e4a857c$var$tk = null, $17f526922e4a857c$var$fk = 0, $17f526922e4a857c$var$Gj = Infinity, $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Oi = !1, $17f526922e4a857c$var$Pi = null, $17f526922e4a857c$var$Ri = null, $17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = null, $17f526922e4a857c$var$xk = 0, $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, $17f526922e4a857c$var$Ak = -1, $17f526922e4a857c$var$Bk = 0;
function $17f526922e4a857c$var$R() {
    return 0 !== ($17f526922e4a857c$var$K & 6) ? $17f526922e4a857c$var$B() : -1 !== $17f526922e4a857c$var$Ak ? $17f526922e4a857c$var$Ak : $17f526922e4a857c$var$Ak = $17f526922e4a857c$var$B();
}
function $17f526922e4a857c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($17f526922e4a857c$var$K & 2) && 0 !== $17f526922e4a857c$var$Z) return $17f526922e4a857c$var$Z & -$17f526922e4a857c$var$Z;
    if (null !== $17f526922e4a857c$var$Kg.transition) return 0 === $17f526922e4a857c$var$Bk && ($17f526922e4a857c$var$Bk = $17f526922e4a857c$var$yc()), $17f526922e4a857c$var$Bk;
    a = $17f526922e4a857c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $17f526922e4a857c$var$jd(a.type);
    return a;
}
function $17f526922e4a857c$var$gi(a, b, c, d) {
    if (50 < $17f526922e4a857c$var$yk) throw $17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = null, Error($17f526922e4a857c$var$p(185));
    $17f526922e4a857c$var$Ac(a, c, d);
    if (0 === ($17f526922e4a857c$var$K & 2) || a !== $17f526922e4a857c$var$Q) a === $17f526922e4a857c$var$Q && (0 === ($17f526922e4a857c$var$K & 2) && ($17f526922e4a857c$var$qk |= c), 4 === $17f526922e4a857c$var$T && $17f526922e4a857c$var$Ck(a, $17f526922e4a857c$var$Z)), $17f526922e4a857c$var$Dk(a, d), 1 === c && 0 === $17f526922e4a857c$var$K && 0 === (b.mode & 1) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
}
function $17f526922e4a857c$var$Dk(a, b) {
    var c = a.callbackNode;
    $17f526922e4a857c$var$wc(a, b);
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) null !== c && $17f526922e4a857c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $17f526922e4a857c$var$bc(c);
        if (1 === b) 0 === a.tag ? $17f526922e4a857c$var$ig($17f526922e4a857c$var$Ek.bind(null, a)) : $17f526922e4a857c$var$hg($17f526922e4a857c$var$Ek.bind(null, a)), $17f526922e4a857c$var$Jf(function() {
            0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
        }), c = null;
        else {
            switch($17f526922e4a857c$var$Dc(d)){
                case 1:
                    c = $17f526922e4a857c$var$fc;
                    break;
                case 4:
                    c = $17f526922e4a857c$var$gc;
                    break;
                case 16:
                    c = $17f526922e4a857c$var$hc;
                    break;
                case 536870912:
                    c = $17f526922e4a857c$var$jc;
                    break;
                default:
                    c = $17f526922e4a857c$var$hc;
            }
            c = $17f526922e4a857c$var$Fk(c, $17f526922e4a857c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $17f526922e4a857c$var$Gk(a, b) {
    $17f526922e4a857c$var$Ak = -1;
    $17f526922e4a857c$var$Bk = 0;
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    var c = a.callbackNode;
    if ($17f526922e4a857c$var$Hk() && a.callbackNode !== c) return null;
    var d = $17f526922e4a857c$var$uc(a, a === $17f526922e4a857c$var$Q ? $17f526922e4a857c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $17f526922e4a857c$var$Ik(a, d);
    else {
        b = d;
        var e = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 2;
        var f = $17f526922e4a857c$var$Jk();
        if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$Kk(a, b);
        for(;;)try {
            $17f526922e4a857c$var$Lk();
            break;
        } catch (h) {
            $17f526922e4a857c$var$Mk(a, h);
        }
        $17f526922e4a857c$var$$g();
        $17f526922e4a857c$var$mk.current = f;
        $17f526922e4a857c$var$K = e;
        null !== $17f526922e4a857c$var$Y ? b = 0 : ($17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0, b = $17f526922e4a857c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $17f526922e4a857c$var$xc(a), 0 !== e && (d = e, b = $17f526922e4a857c$var$Nk(a, e)));
        if (1 === b) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
        if (6 === b) $17f526922e4a857c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$17f526922e4a857c$var$Ok(e) && (b = $17f526922e4a857c$var$Ik(a, d), 2 === b && (f = $17f526922e4a857c$var$xc(a), 0 !== f && (d = f, b = $17f526922e4a857c$var$Nk(a, f))), 1 === b)) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, d), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($17f526922e4a857c$var$p(345));
                case 2:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 3:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $17f526922e4a857c$var$fk + 500 - $17f526922e4a857c$var$B(), 10 < b)) {
                        if (0 !== $17f526922e4a857c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $17f526922e4a857c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), b);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 4:
                    $17f526922e4a857c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $17f526922e4a857c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $17f526922e4a857c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $17f526922e4a857c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $17f526922e4a857c$var$Ff($17f526922e4a857c$var$Pk.bind(null, a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk), d);
                        break;
                    }
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                case 5:
                    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
                    break;
                default:
                    throw Error($17f526922e4a857c$var$p(329));
            }
        }
    }
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return a.callbackNode === c ? $17f526922e4a857c$var$Gk.bind(null, a) : null;
}
function $17f526922e4a857c$var$Nk(a, b) {
    var c = $17f526922e4a857c$var$sk;
    a.current.memoizedState.isDehydrated && ($17f526922e4a857c$var$Kk(a, b).flags |= 256);
    a = $17f526922e4a857c$var$Ik(a, b);
    2 !== a && (b = $17f526922e4a857c$var$tk, $17f526922e4a857c$var$tk = c, null !== b && $17f526922e4a857c$var$Fj(b));
    return a;
}
function $17f526922e4a857c$var$Fj(a) {
    null === $17f526922e4a857c$var$tk ? $17f526922e4a857c$var$tk = a : $17f526922e4a857c$var$tk.push.apply($17f526922e4a857c$var$tk, a);
}
function $17f526922e4a857c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$17f526922e4a857c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $17f526922e4a857c$var$Ck(a, b) {
    b &= ~$17f526922e4a857c$var$rk;
    b &= ~$17f526922e4a857c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $17f526922e4a857c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $17f526922e4a857c$var$Ek(a) {
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$uc(a, 0);
    if (0 === (b & 1)) return $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), null;
    var c = $17f526922e4a857c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $17f526922e4a857c$var$xc(a);
        0 !== d && (b = d, c = $17f526922e4a857c$var$Nk(a, d));
    }
    if (1 === c) throw c = $17f526922e4a857c$var$pk, $17f526922e4a857c$var$Kk(a, 0), $17f526922e4a857c$var$Ck(a, b), $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B()), c;
    if (6 === c) throw Error($17f526922e4a857c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $17f526922e4a857c$var$Pk(a, $17f526922e4a857c$var$tk, $17f526922e4a857c$var$uk);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    return null;
}
function $17f526922e4a857c$var$Qk(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $17f526922e4a857c$var$K = c, 0 === $17f526922e4a857c$var$K && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$fg && $17f526922e4a857c$var$jg());
    }
}
function $17f526922e4a857c$var$Rk(a) {
    null !== $17f526922e4a857c$var$wk && 0 === $17f526922e4a857c$var$wk.tag && 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$Hk();
    var b = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 1;
    var c = $17f526922e4a857c$var$ok.transition, d = $17f526922e4a857c$var$C;
    try {
        if ($17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, a) return a();
    } finally{
        $17f526922e4a857c$var$C = d, $17f526922e4a857c$var$ok.transition = c, $17f526922e4a857c$var$K = b, 0 === ($17f526922e4a857c$var$K & 6) && $17f526922e4a857c$var$jg();
    }
}
function $17f526922e4a857c$var$Hj() {
    $17f526922e4a857c$var$fj = $17f526922e4a857c$var$ej.current;
    $17f526922e4a857c$var$E($17f526922e4a857c$var$ej);
}
function $17f526922e4a857c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $17f526922e4a857c$var$Gf(c));
    if (null !== $17f526922e4a857c$var$Y) for(c = $17f526922e4a857c$var$Y.return; null !== c;){
        var d = c;
        $17f526922e4a857c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $17f526922e4a857c$var$$f();
                break;
            case 3:
                $17f526922e4a857c$var$zh();
                $17f526922e4a857c$var$E($17f526922e4a857c$var$Wf);
                $17f526922e4a857c$var$E($17f526922e4a857c$var$H);
                $17f526922e4a857c$var$Eh();
                break;
            case 5:
                $17f526922e4a857c$var$Bh(d);
                break;
            case 4:
                $17f526922e4a857c$var$zh();
                break;
            case 13:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 19:
                $17f526922e4a857c$var$E($17f526922e4a857c$var$L);
                break;
            case 10:
                $17f526922e4a857c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $17f526922e4a857c$var$Hj();
        }
        c = c.return;
    }
    $17f526922e4a857c$var$Q = a;
    $17f526922e4a857c$var$Y = a = $17f526922e4a857c$var$Pg(a.current, null);
    $17f526922e4a857c$var$Z = $17f526922e4a857c$var$fj = b;
    $17f526922e4a857c$var$T = 0;
    $17f526922e4a857c$var$pk = null;
    $17f526922e4a857c$var$rk = $17f526922e4a857c$var$qk = $17f526922e4a857c$var$rh = 0;
    $17f526922e4a857c$var$tk = $17f526922e4a857c$var$sk = null;
    if (null !== $17f526922e4a857c$var$fh) {
        for(b = 0; b < $17f526922e4a857c$var$fh.length; b++)if (c = $17f526922e4a857c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $17f526922e4a857c$var$fh = null;
    }
    return a;
}
function $17f526922e4a857c$var$Mk(a, b) {
    do {
        var c = $17f526922e4a857c$var$Y;
        try {
            $17f526922e4a857c$var$$g();
            $17f526922e4a857c$var$Fh.current = $17f526922e4a857c$var$Rh;
            if ($17f526922e4a857c$var$Ih) {
                for(var d = $17f526922e4a857c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $17f526922e4a857c$var$Ih = !1;
            }
            $17f526922e4a857c$var$Hh = 0;
            $17f526922e4a857c$var$O = $17f526922e4a857c$var$N = $17f526922e4a857c$var$M = null;
            $17f526922e4a857c$var$Jh = !1;
            $17f526922e4a857c$var$Kh = 0;
            $17f526922e4a857c$var$nk.current = null;
            if (null === c || null === c.return) {
                $17f526922e4a857c$var$T = 1;
                $17f526922e4a857c$var$pk = b;
                $17f526922e4a857c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $17f526922e4a857c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $17f526922e4a857c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $17f526922e4a857c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $17f526922e4a857c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $17f526922e4a857c$var$Si(f, l, b);
                            $17f526922e4a857c$var$tj();
                            break a;
                        }
                        k = Error($17f526922e4a857c$var$p(426));
                    }
                } else if ($17f526922e4a857c$var$I && h.mode & 1) {
                    var J = $17f526922e4a857c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $17f526922e4a857c$var$Vi(J, g, h, f, b);
                        $17f526922e4a857c$var$Jg($17f526922e4a857c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $17f526922e4a857c$var$Ji(k, h);
                4 !== $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 2);
                null === $17f526922e4a857c$var$sk ? $17f526922e4a857c$var$sk = [
                    f
                ] : $17f526922e4a857c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $17f526922e4a857c$var$Ni(f, k, b);
                            $17f526922e4a857c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $17f526922e4a857c$var$Qi(f, h, b);
                                $17f526922e4a857c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $17f526922e4a857c$var$Sk(c);
        } catch (na) {
            b = na;
            $17f526922e4a857c$var$Y === c && null !== c && ($17f526922e4a857c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $17f526922e4a857c$var$Jk() {
    var a = $17f526922e4a857c$var$mk.current;
    $17f526922e4a857c$var$mk.current = $17f526922e4a857c$var$Rh;
    return null === a ? $17f526922e4a857c$var$Rh : a;
}
function $17f526922e4a857c$var$tj() {
    if (0 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T || 2 === $17f526922e4a857c$var$T) $17f526922e4a857c$var$T = 4;
    null === $17f526922e4a857c$var$Q || 0 === ($17f526922e4a857c$var$rh & 268435455) && 0 === ($17f526922e4a857c$var$qk & 268435455) || $17f526922e4a857c$var$Ck($17f526922e4a857c$var$Q, $17f526922e4a857c$var$Z);
}
function $17f526922e4a857c$var$Ik(a, b) {
    var c = $17f526922e4a857c$var$K;
    $17f526922e4a857c$var$K |= 2;
    var d = $17f526922e4a857c$var$Jk();
    if ($17f526922e4a857c$var$Q !== a || $17f526922e4a857c$var$Z !== b) $17f526922e4a857c$var$uk = null, $17f526922e4a857c$var$Kk(a, b);
    for(;;)try {
        $17f526922e4a857c$var$Tk();
        break;
    } catch (e) {
        $17f526922e4a857c$var$Mk(a, e);
    }
    $17f526922e4a857c$var$$g();
    $17f526922e4a857c$var$K = c;
    $17f526922e4a857c$var$mk.current = d;
    if (null !== $17f526922e4a857c$var$Y) throw Error($17f526922e4a857c$var$p(261));
    $17f526922e4a857c$var$Q = null;
    $17f526922e4a857c$var$Z = 0;
    return $17f526922e4a857c$var$T;
}
function $17f526922e4a857c$var$Tk() {
    for(; null !== $17f526922e4a857c$var$Y;)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Lk() {
    for(; null !== $17f526922e4a857c$var$Y && !$17f526922e4a857c$var$cc();)$17f526922e4a857c$var$Uk($17f526922e4a857c$var$Y);
}
function $17f526922e4a857c$var$Uk(a) {
    var b = $17f526922e4a857c$var$Vk(a.alternate, a, $17f526922e4a857c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $17f526922e4a857c$var$Sk(a) : $17f526922e4a857c$var$Y = b;
    $17f526922e4a857c$var$nk.current = null;
}
function $17f526922e4a857c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $17f526922e4a857c$var$Ej(c, b, $17f526922e4a857c$var$fj), null !== c) {
                $17f526922e4a857c$var$Y = c;
                return;
            }
        } else {
            c = $17f526922e4a857c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $17f526922e4a857c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $17f526922e4a857c$var$T = 6;
                $17f526922e4a857c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $17f526922e4a857c$var$Y = b;
            return;
        }
        $17f526922e4a857c$var$Y = b = a;
    }while (null !== b);
    0 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$T = 5);
}
function $17f526922e4a857c$var$Pk(a, b, c) {
    var d = $17f526922e4a857c$var$C, e = $17f526922e4a857c$var$ok.transition;
    try {
        $17f526922e4a857c$var$ok.transition = null, $17f526922e4a857c$var$C = 1, $17f526922e4a857c$var$Wk(a, b, c, d);
    } finally{
        $17f526922e4a857c$var$ok.transition = e, $17f526922e4a857c$var$C = d;
    }
    return null;
}
function $17f526922e4a857c$var$Wk(a, b, c, d) {
    do $17f526922e4a857c$var$Hk();
    while (null !== $17f526922e4a857c$var$wk);
    if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($17f526922e4a857c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $17f526922e4a857c$var$Bc(a, f);
    a === $17f526922e4a857c$var$Q && ($17f526922e4a857c$var$Y = $17f526922e4a857c$var$Q = null, $17f526922e4a857c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $17f526922e4a857c$var$vk || ($17f526922e4a857c$var$vk = !0, $17f526922e4a857c$var$Fk($17f526922e4a857c$var$hc, function() {
        $17f526922e4a857c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $17f526922e4a857c$var$ok.transition;
        $17f526922e4a857c$var$ok.transition = null;
        var g = $17f526922e4a857c$var$C;
        $17f526922e4a857c$var$C = 1;
        var h = $17f526922e4a857c$var$K;
        $17f526922e4a857c$var$K |= 4;
        $17f526922e4a857c$var$nk.current = null;
        $17f526922e4a857c$var$Oj(a, c);
        $17f526922e4a857c$var$dk(c, a);
        $17f526922e4a857c$var$Oe($17f526922e4a857c$var$Df);
        $17f526922e4a857c$var$dd = !!$17f526922e4a857c$var$Cf;
        $17f526922e4a857c$var$Df = $17f526922e4a857c$var$Cf = null;
        a.current = c;
        $17f526922e4a857c$var$hk(c, a, e);
        $17f526922e4a857c$var$dc();
        $17f526922e4a857c$var$K = h;
        $17f526922e4a857c$var$C = g;
        $17f526922e4a857c$var$ok.transition = f;
    } else a.current = c;
    $17f526922e4a857c$var$vk && ($17f526922e4a857c$var$vk = !1, $17f526922e4a857c$var$wk = a, $17f526922e4a857c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($17f526922e4a857c$var$Ri = null);
    $17f526922e4a857c$var$mc(c.stateNode, d);
    $17f526922e4a857c$var$Dk(a, $17f526922e4a857c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($17f526922e4a857c$var$Oi) throw $17f526922e4a857c$var$Oi = !1, a = $17f526922e4a857c$var$Pi, $17f526922e4a857c$var$Pi = null, a;
    0 !== ($17f526922e4a857c$var$xk & 1) && 0 !== a.tag && $17f526922e4a857c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $17f526922e4a857c$var$zk ? $17f526922e4a857c$var$yk++ : ($17f526922e4a857c$var$yk = 0, $17f526922e4a857c$var$zk = a) : $17f526922e4a857c$var$yk = 0;
    $17f526922e4a857c$var$jg();
    return null;
}
function $17f526922e4a857c$var$Hk() {
    if (null !== $17f526922e4a857c$var$wk) {
        var a = $17f526922e4a857c$var$Dc($17f526922e4a857c$var$xk), b = $17f526922e4a857c$var$ok.transition, c = $17f526922e4a857c$var$C;
        try {
            $17f526922e4a857c$var$ok.transition = null;
            $17f526922e4a857c$var$C = 16 > a ? 16 : a;
            if (null === $17f526922e4a857c$var$wk) var d = !1;
            else {
                a = $17f526922e4a857c$var$wk;
                $17f526922e4a857c$var$wk = null;
                $17f526922e4a857c$var$xk = 0;
                if (0 !== ($17f526922e4a857c$var$K & 6)) throw Error($17f526922e4a857c$var$p(331));
                var e = $17f526922e4a857c$var$K;
                $17f526922e4a857c$var$K |= 4;
                for($17f526922e4a857c$var$V = a.current; null !== $17f526922e4a857c$var$V;){
                    var f = $17f526922e4a857c$var$V, g = f.child;
                    if (0 !== ($17f526922e4a857c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($17f526922e4a857c$var$V = l; null !== $17f526922e4a857c$var$V;){
                                    var m = $17f526922e4a857c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $17f526922e4a857c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $17f526922e4a857c$var$V = q;
                                    else for(; null !== $17f526922e4a857c$var$V;){
                                        m = $17f526922e4a857c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $17f526922e4a857c$var$Sj(m);
                                        if (m === l) {
                                            $17f526922e4a857c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $17f526922e4a857c$var$V = r;
                                            break;
                                        }
                                        $17f526922e4a857c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $17f526922e4a857c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $17f526922e4a857c$var$V = g;
                    else b: for(; null !== $17f526922e4a857c$var$V;){
                        f = $17f526922e4a857c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $17f526922e4a857c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $17f526922e4a857c$var$V = x;
                            break b;
                        }
                        $17f526922e4a857c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($17f526922e4a857c$var$V = w; null !== $17f526922e4a857c$var$V;){
                    g = $17f526922e4a857c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $17f526922e4a857c$var$V = u;
                    else b: for(g = w; null !== $17f526922e4a857c$var$V;){
                        h = $17f526922e4a857c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $17f526922e4a857c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $17f526922e4a857c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $17f526922e4a857c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $17f526922e4a857c$var$V = F;
                            break b;
                        }
                        $17f526922e4a857c$var$V = h.return;
                    }
                }
                $17f526922e4a857c$var$K = e;
                $17f526922e4a857c$var$jg();
                if ($17f526922e4a857c$var$lc && "function" === typeof $17f526922e4a857c$var$lc.onPostCommitFiberRoot) try {
                    $17f526922e4a857c$var$lc.onPostCommitFiberRoot($17f526922e4a857c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $17f526922e4a857c$var$C = c, $17f526922e4a857c$var$ok.transition = b;
        }
    }
    return !1;
}
function $17f526922e4a857c$var$Xk(a, b, c) {
    b = $17f526922e4a857c$var$Ji(c, b);
    b = $17f526922e4a857c$var$Ni(a, b, 1);
    a = $17f526922e4a857c$var$nh(a, b, 1);
    b = $17f526922e4a857c$var$R();
    null !== a && ($17f526922e4a857c$var$Ac(a, 1, b), $17f526922e4a857c$var$Dk(a, b));
}
function $17f526922e4a857c$var$W(a, b, c) {
    if (3 === a.tag) $17f526922e4a857c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $17f526922e4a857c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $17f526922e4a857c$var$Ri || !$17f526922e4a857c$var$Ri.has(d))) {
                a = $17f526922e4a857c$var$Ji(c, a);
                a = $17f526922e4a857c$var$Qi(b, a, 1);
                b = $17f526922e4a857c$var$nh(b, a, 1);
                a = $17f526922e4a857c$var$R();
                null !== b && ($17f526922e4a857c$var$Ac(b, 1, a), $17f526922e4a857c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $17f526922e4a857c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $17f526922e4a857c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $17f526922e4a857c$var$Q === a && ($17f526922e4a857c$var$Z & c) === c && (4 === $17f526922e4a857c$var$T || 3 === $17f526922e4a857c$var$T && ($17f526922e4a857c$var$Z & 130023424) === $17f526922e4a857c$var$Z && 500 > $17f526922e4a857c$var$B() - $17f526922e4a857c$var$fk ? $17f526922e4a857c$var$Kk(a, 0) : $17f526922e4a857c$var$rk |= c);
    $17f526922e4a857c$var$Dk(a, b);
}
function $17f526922e4a857c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $17f526922e4a857c$var$sc, $17f526922e4a857c$var$sc <<= 1, 0 === ($17f526922e4a857c$var$sc & 130023424) && ($17f526922e4a857c$var$sc = 4194304)));
    var c = $17f526922e4a857c$var$R();
    a = $17f526922e4a857c$var$ih(a, b);
    null !== a && ($17f526922e4a857c$var$Ac(a, b, c), $17f526922e4a857c$var$Dk(a, c));
}
function $17f526922e4a857c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $17f526922e4a857c$var$Yk(a, c);
}
function $17f526922e4a857c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($17f526922e4a857c$var$p(314));
    }
    null !== d && d.delete(b);
    $17f526922e4a857c$var$Yk(a, c);
}
var $17f526922e4a857c$var$Vk;
$17f526922e4a857c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $17f526922e4a857c$var$Wf.current) $17f526922e4a857c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$yj(a, b, c);
            $17f526922e4a857c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $17f526922e4a857c$var$dh = !1, $17f526922e4a857c$var$I && 0 !== (b.flags & 1048576) && $17f526922e4a857c$var$ug(b, $17f526922e4a857c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $17f526922e4a857c$var$ij(a, b);
            a = b.pendingProps;
            var e = $17f526922e4a857c$var$Yf(b, $17f526922e4a857c$var$H.current);
            $17f526922e4a857c$var$ch(b, c);
            e = $17f526922e4a857c$var$Nh(null, b, d, a, e, c);
            var f = $17f526922e4a857c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $17f526922e4a857c$var$Zf(d) ? (f = !0, $17f526922e4a857c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $17f526922e4a857c$var$kh(b), e.updater = $17f526922e4a857c$var$Ei, b.stateNode = e, e._reactInternals = b, $17f526922e4a857c$var$Ii(b, d, a, c), b = $17f526922e4a857c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $17f526922e4a857c$var$I && f && $17f526922e4a857c$var$vg(b), $17f526922e4a857c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $17f526922e4a857c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $17f526922e4a857c$var$Zk(d);
                a = $17f526922e4a857c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $17f526922e4a857c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $17f526922e4a857c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $17f526922e4a857c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $17f526922e4a857c$var$$i(null, b, d, $17f526922e4a857c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($17f526922e4a857c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $17f526922e4a857c$var$kj(b);
                if (null === a) throw Error($17f526922e4a857c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $17f526922e4a857c$var$lh(a, b);
                $17f526922e4a857c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(423)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $17f526922e4a857c$var$Ji(Error($17f526922e4a857c$var$p(424)), b);
                        b = $17f526922e4a857c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($17f526922e4a857c$var$yg = $17f526922e4a857c$var$Lf(b.stateNode.containerInfo.firstChild), $17f526922e4a857c$var$xg = b, $17f526922e4a857c$var$I = !0, $17f526922e4a857c$var$zg = null, c = $17f526922e4a857c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $17f526922e4a857c$var$Ig();
                    if (d === e) {
                        b = $17f526922e4a857c$var$Zi(a, b, c);
                        break a;
                    }
                    $17f526922e4a857c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $17f526922e4a857c$var$Ah(b), null === a && $17f526922e4a857c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $17f526922e4a857c$var$Ef(d, e) ? g = null : null !== f && $17f526922e4a857c$var$Ef(d, f) && (b.flags |= 32), $17f526922e4a857c$var$gj(a, b), $17f526922e4a857c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $17f526922e4a857c$var$Eg(b), null;
        case 13:
            return $17f526922e4a857c$var$oj(a, b, c);
        case 4:
            return $17f526922e4a857c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $17f526922e4a857c$var$Ug(b, null, d, c) : $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$Yi(a, b, d, e, c);
        case 7:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $17f526922e4a857c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $17f526922e4a857c$var$G($17f526922e4a857c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($17f526922e4a857c$var$He(f.value, g)) {
                        if (f.children === e.children && !$17f526922e4a857c$var$Wf.current) {
                            b = $17f526922e4a857c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $17f526922e4a857c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $17f526922e4a857c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($17f526922e4a857c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $17f526922e4a857c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $17f526922e4a857c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $17f526922e4a857c$var$ch(b, c), e = $17f526922e4a857c$var$eh(e), d = d(e), b.flags |= 1, $17f526922e4a857c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $17f526922e4a857c$var$Ci(d, b.pendingProps), e = $17f526922e4a857c$var$Ci(d.type, e), $17f526922e4a857c$var$$i(a, b, d, e, c);
        case 15:
            return $17f526922e4a857c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $17f526922e4a857c$var$Ci(d, e), $17f526922e4a857c$var$ij(a, b), b.tag = 1, $17f526922e4a857c$var$Zf(d) ? (a = !0, $17f526922e4a857c$var$cg(b)) : a = !1, $17f526922e4a857c$var$ch(b, c), $17f526922e4a857c$var$Gi(b, d, e), $17f526922e4a857c$var$Ii(b, d, e, c), $17f526922e4a857c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $17f526922e4a857c$var$xj(a, b, c);
        case 22:
            return $17f526922e4a857c$var$dj(a, b, c);
    }
    throw Error($17f526922e4a857c$var$p(156, b.tag));
};
function $17f526922e4a857c$var$Fk(a, b) {
    return $17f526922e4a857c$var$ac(a, b);
}
function $17f526922e4a857c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $17f526922e4a857c$var$Bg(a, b, c, d) {
    return new $17f526922e4a857c$var$$k(a, b, c, d);
}
function $17f526922e4a857c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $17f526922e4a857c$var$Zk(a) {
    if ("function" === typeof a) return $17f526922e4a857c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $17f526922e4a857c$var$Da) return 11;
        if (a === $17f526922e4a857c$var$Ga) return 14;
    }
    return 2;
}
function $17f526922e4a857c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $17f526922e4a857c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $17f526922e4a857c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $17f526922e4a857c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $17f526922e4a857c$var$ya:
            return $17f526922e4a857c$var$Tg(c.children, e, f, b);
        case $17f526922e4a857c$var$za:
            g = 8;
            e |= 8;
            break;
        case $17f526922e4a857c$var$Aa:
            return a = $17f526922e4a857c$var$Bg(12, c, b, e | 2), a.elementType = $17f526922e4a857c$var$Aa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ea:
            return a = $17f526922e4a857c$var$Bg(13, c, b, e), a.elementType = $17f526922e4a857c$var$Ea, a.lanes = f, a;
        case $17f526922e4a857c$var$Fa:
            return a = $17f526922e4a857c$var$Bg(19, c, b, e), a.elementType = $17f526922e4a857c$var$Fa, a.lanes = f, a;
        case $17f526922e4a857c$var$Ia:
            return $17f526922e4a857c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $17f526922e4a857c$var$Ba:
                    g = 10;
                    break a;
                case $17f526922e4a857c$var$Ca:
                    g = 9;
                    break a;
                case $17f526922e4a857c$var$Da:
                    g = 11;
                    break a;
                case $17f526922e4a857c$var$Ga:
                    g = 14;
                    break a;
                case $17f526922e4a857c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($17f526922e4a857c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $17f526922e4a857c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $17f526922e4a857c$var$Tg(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$pj(a, b, c, d) {
    a = $17f526922e4a857c$var$Bg(22, a, d, b);
    a.elementType = $17f526922e4a857c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $17f526922e4a857c$var$Qg(a, b, c) {
    a = $17f526922e4a857c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $17f526922e4a857c$var$Sg(a, b, c) {
    b = $17f526922e4a857c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $17f526922e4a857c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $17f526922e4a857c$var$zc(0);
    this.expirationTimes = $17f526922e4a857c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $17f526922e4a857c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $17f526922e4a857c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $17f526922e4a857c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $17f526922e4a857c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $17f526922e4a857c$var$kh(f);
    return a;
}
function $17f526922e4a857c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $17f526922e4a857c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $17f526922e4a857c$var$dl(a) {
    if (!a) return $17f526922e4a857c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($17f526922e4a857c$var$Vb(a) !== a || 1 !== a.tag) throw Error($17f526922e4a857c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($17f526922e4a857c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($17f526922e4a857c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($17f526922e4a857c$var$Zf(c)) return $17f526922e4a857c$var$bg(a, c, b);
    }
    return b;
}
function $17f526922e4a857c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $17f526922e4a857c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $17f526922e4a857c$var$dl(null);
    c = a.current;
    d = $17f526922e4a857c$var$R();
    e = $17f526922e4a857c$var$yi(c);
    f = $17f526922e4a857c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $17f526922e4a857c$var$nh(c, f, e);
    a.current.lanes = e;
    $17f526922e4a857c$var$Ac(a, e, d);
    $17f526922e4a857c$var$Dk(a, d);
    return a;
}
function $17f526922e4a857c$var$fl(a, b, c, d) {
    var e = b.current, f = $17f526922e4a857c$var$R(), g = $17f526922e4a857c$var$yi(e);
    c = $17f526922e4a857c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $17f526922e4a857c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $17f526922e4a857c$var$nh(e, b, g);
    null !== a && ($17f526922e4a857c$var$gi(a, e, g, f), $17f526922e4a857c$var$oh(a, e, g));
    return g;
}
function $17f526922e4a857c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $17f526922e4a857c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $17f526922e4a857c$var$il(a, b) {
    $17f526922e4a857c$var$hl(a, b);
    (a = a.alternate) && $17f526922e4a857c$var$hl(a, b);
}
function $17f526922e4a857c$var$jl() {
    return null;
}
var $17f526922e4a857c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $17f526922e4a857c$var$ll(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.render = $17f526922e4a857c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($17f526922e4a857c$var$p(409));
    $17f526922e4a857c$var$fl(a, b, null, null);
};
$17f526922e4a857c$var$ml.prototype.unmount = $17f526922e4a857c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $17f526922e4a857c$var$Rk(function() {
            $17f526922e4a857c$var$fl(null, a, null, null);
        });
        b[$17f526922e4a857c$var$uf] = null;
    }
};
function $17f526922e4a857c$var$ml(a) {
    this._internalRoot = a;
}
$17f526922e4a857c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $17f526922e4a857c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $17f526922e4a857c$var$Qc.length && 0 !== b && b < $17f526922e4a857c$var$Qc[c].priority; c++);
        $17f526922e4a857c$var$Qc.splice(c, 0, a);
        0 === c && $17f526922e4a857c$var$Vc(a);
    }
};
function $17f526922e4a857c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $17f526922e4a857c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $17f526922e4a857c$var$pl() {}
function $17f526922e4a857c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $17f526922e4a857c$var$gl(g);
                f.call(a);
            };
        }
        var g = $17f526922e4a857c$var$el(b, d, a, 0, null, !1, !1, "", $17f526922e4a857c$var$pl);
        a._reactRootContainer = g;
        a[$17f526922e4a857c$var$uf] = g.current;
        $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $17f526922e4a857c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $17f526922e4a857c$var$gl(k);
            h.call(a);
        };
    }
    var k = $17f526922e4a857c$var$bl(a, 0, !1, null, null, !1, !1, "", $17f526922e4a857c$var$pl);
    a._reactRootContainer = k;
    a[$17f526922e4a857c$var$uf] = k.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$fl(b, k, c, d);
    });
    return k;
}
function $17f526922e4a857c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $17f526922e4a857c$var$gl(g);
                h.call(a);
            };
        }
        $17f526922e4a857c$var$fl(b, g, a, e);
    } else g = $17f526922e4a857c$var$ql(c, b, a, e, d);
    return $17f526922e4a857c$var$gl(g);
}
$17f526922e4a857c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $17f526922e4a857c$var$tc(b.pendingLanes);
                0 !== c && ($17f526922e4a857c$var$Cc(b, c | 1), $17f526922e4a857c$var$Dk(b, $17f526922e4a857c$var$B()), 0 === ($17f526922e4a857c$var$K & 6) && ($17f526922e4a857c$var$Gj = $17f526922e4a857c$var$B() + 500, $17f526922e4a857c$var$jg()));
            }
            break;
        case 13:
            $17f526922e4a857c$var$Rk(function() {
                var b = $17f526922e4a857c$var$ih(a, 1);
                if (null !== b) {
                    var c = $17f526922e4a857c$var$R();
                    $17f526922e4a857c$var$gi(b, a, 1, c);
                }
            }), $17f526922e4a857c$var$il(a, 1);
    }
};
$17f526922e4a857c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(b, a, 134217728, c);
        }
        $17f526922e4a857c$var$il(a, 134217728);
    }
};
$17f526922e4a857c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $17f526922e4a857c$var$yi(a), c = $17f526922e4a857c$var$ih(a, b);
        if (null !== c) {
            var d = $17f526922e4a857c$var$R();
            $17f526922e4a857c$var$gi(c, a, b, d);
        }
        $17f526922e4a857c$var$il(a, b);
    }
};
$17f526922e4a857c$var$Hc = function() {
    return $17f526922e4a857c$var$C;
};
$17f526922e4a857c$var$Ic = function(a, b) {
    var c = $17f526922e4a857c$var$C;
    try {
        return $17f526922e4a857c$var$C = a, b();
    } finally{
        $17f526922e4a857c$var$C = c;
    }
};
$17f526922e4a857c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $17f526922e4a857c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $17f526922e4a857c$var$Db(d);
                        if (!e) throw Error($17f526922e4a857c$var$p(90));
                        $17f526922e4a857c$var$Wa(d);
                        $17f526922e4a857c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $17f526922e4a857c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $17f526922e4a857c$var$fb(a, !!c.multiple, b, !1);
    }
};
$17f526922e4a857c$var$Gb = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$var$Hb = $17f526922e4a857c$var$Rk;
var $17f526922e4a857c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $17f526922e4a857c$var$Cb,
        $17f526922e4a857c$var$ue,
        $17f526922e4a857c$var$Db,
        $17f526922e4a857c$var$Eb,
        $17f526922e4a857c$var$Fb,
        $17f526922e4a857c$var$Qk
    ]
}, $17f526922e4a857c$var$tl = {
    findFiberByHostInstance: $17f526922e4a857c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $17f526922e4a857c$var$ul = {
    bundleType: $17f526922e4a857c$var$tl.bundleType,
    version: $17f526922e4a857c$var$tl.version,
    rendererPackageName: $17f526922e4a857c$var$tl.rendererPackageName,
    rendererConfig: $17f526922e4a857c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $17f526922e4a857c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $17f526922e4a857c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $17f526922e4a857c$var$tl.findFiberByHostInstance || $17f526922e4a857c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $17f526922e4a857c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$17f526922e4a857c$var$vl.isDisabled && $17f526922e4a857c$var$vl.supportsFiber) try {
        $17f526922e4a857c$var$kc = $17f526922e4a857c$var$vl.inject($17f526922e4a857c$var$ul), $17f526922e4a857c$var$lc = $17f526922e4a857c$var$vl;
    } catch (a) {}
}
$17f526922e4a857c$export$ae55be85d98224ed = $17f526922e4a857c$var$sl;
$17f526922e4a857c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$17f526922e4a857c$var$nl(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$cl(a, b, null, c);
};
$17f526922e4a857c$export$882461b6382ed46c = function(a, b) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(299));
    var c = !1, d = "", e = $17f526922e4a857c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $17f526922e4a857c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $17f526922e4a857c$var$ll(b);
};
$17f526922e4a857c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($17f526922e4a857c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($17f526922e4a857c$var$p(268, a));
    }
    a = $17f526922e4a857c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$17f526922e4a857c$export$cd75ccfd720a3cd4 = function(a) {
    return $17f526922e4a857c$var$Rk(a);
};
$17f526922e4a857c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !0, c);
};
$17f526922e4a857c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$17f526922e4a857c$var$nl(a)) throw Error($17f526922e4a857c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $17f526922e4a857c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $17f526922e4a857c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$17f526922e4a857c$var$uf] = b.current;
    $17f526922e4a857c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $17f526922e4a857c$var$ml(b);
};
$17f526922e4a857c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$17f526922e4a857c$var$ol(b)) throw Error($17f526922e4a857c$var$p(200));
    return $17f526922e4a857c$var$rl(null, a, b, !1, c);
};
$17f526922e4a857c$export$502457920280e6be = function(a) {
    if (!$17f526922e4a857c$var$ol(a)) throw Error($17f526922e4a857c$var$p(40));
    return a._reactRootContainer ? ($17f526922e4a857c$var$Rk(function() {
        $17f526922e4a857c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$17f526922e4a857c$var$uf] = null;
        });
    }), !0) : !1;
};
$17f526922e4a857c$export$c78a37762a8d58e1 = $17f526922e4a857c$var$Qk;
$17f526922e4a857c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$17f526922e4a857c$var$ol(c)) throw Error($17f526922e4a857c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($17f526922e4a857c$var$p(38));
    return $17f526922e4a857c$var$rl(a, b, c, !1, d);
};
$17f526922e4a857c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
'use strict';
function $3d3ce0c592af0505$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3d3ce0c592af0505$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3d3ce0c592af0505$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3d3ce0c592af0505$var$g(C, c)) n < e && 0 > $3d3ce0c592af0505$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3d3ce0c592af0505$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3d3ce0c592af0505$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
var $3d3ce0c592af0505$var$r = [], $3d3ce0c592af0505$var$t = [], $3d3ce0c592af0505$var$u = 1, $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = 3, $3d3ce0c592af0505$var$z = !1, $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$D = "function" === typeof setTimeout ? setTimeout : null, $3d3ce0c592af0505$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3d3ce0c592af0505$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3d3ce0c592af0505$var$G(a) {
    for(var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$t), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, b);
        else break;
        b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
    }
}
function $3d3ce0c592af0505$var$H(a) {
    $3d3ce0c592af0505$var$B = !1;
    $3d3ce0c592af0505$var$G(a);
    if (!$3d3ce0c592af0505$var$A) {
        if (null !== $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r)) $3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J);
        else {
            var b = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== b && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$J(a, b) {
    $3d3ce0c592af0505$var$A = !1;
    $3d3ce0c592af0505$var$B && ($3d3ce0c592af0505$var$B = !1, $3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1);
    $3d3ce0c592af0505$var$z = !0;
    var c = $3d3ce0c592af0505$var$y;
    try {
        $3d3ce0c592af0505$var$G(b);
        for($3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r); null !== $3d3ce0c592af0505$var$v && (!($3d3ce0c592af0505$var$v.expirationTime > b) || a && !$3d3ce0c592af0505$var$M());){
            var d = $3d3ce0c592af0505$var$v.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$v.callback = null;
                $3d3ce0c592af0505$var$y = $3d3ce0c592af0505$var$v.priorityLevel;
                var e = d($3d3ce0c592af0505$var$v.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$v.callback = e : $3d3ce0c592af0505$var$v === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
                $3d3ce0c592af0505$var$G(b);
            } else $3d3ce0c592af0505$var$k($3d3ce0c592af0505$var$r);
            $3d3ce0c592af0505$var$v = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
        }
        if (null !== $3d3ce0c592af0505$var$v) var w = !0;
        else {
            var m = $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t);
            null !== m && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3d3ce0c592af0505$var$v = null, $3d3ce0c592af0505$var$y = c, $3d3ce0c592af0505$var$z = !1;
    }
}
var $3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$L = -1, $3d3ce0c592af0505$var$P = 5, $3d3ce0c592af0505$var$Q = -1;
function $3d3ce0c592af0505$var$M() {
    return $3d3ce0c592af0505$export$c4744153514ff05d() - $3d3ce0c592af0505$var$Q < $3d3ce0c592af0505$var$P ? !1 : !0;
}
function $3d3ce0c592af0505$var$R() {
    if (null !== $3d3ce0c592af0505$var$O) {
        var a = $3d3ce0c592af0505$export$c4744153514ff05d();
        $3d3ce0c592af0505$var$Q = a;
        var b = !0;
        try {
            b = $3d3ce0c592af0505$var$O(!0, a);
        } finally{
            b ? $3d3ce0c592af0505$var$S() : ($3d3ce0c592af0505$var$N = !1, $3d3ce0c592af0505$var$O = null);
        }
    } else $3d3ce0c592af0505$var$N = !1;
}
var $3d3ce0c592af0505$var$S;
if ("function" === typeof $3d3ce0c592af0505$var$F) $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$F($3d3ce0c592af0505$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$T = new MessageChannel, $3d3ce0c592af0505$var$U = $3d3ce0c592af0505$var$T.port2;
    $3d3ce0c592af0505$var$T.port1.onmessage = $3d3ce0c592af0505$var$R;
    $3d3ce0c592af0505$var$S = function() {
        $3d3ce0c592af0505$var$U.postMessage(null);
    };
} else $3d3ce0c592af0505$var$S = function() {
    $3d3ce0c592af0505$var$D($3d3ce0c592af0505$var$R, 0);
};
function $3d3ce0c592af0505$var$I(a) {
    $3d3ce0c592af0505$var$O = a;
    $3d3ce0c592af0505$var$N || ($3d3ce0c592af0505$var$N = !0, $3d3ce0c592af0505$var$S());
}
function $3d3ce0c592af0505$var$K(a, b) {
    $3d3ce0c592af0505$var$L = $3d3ce0c592af0505$var$D(function() {
        a($3d3ce0c592af0505$export$c4744153514ff05d());
    }, b);
}
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J));
};
$3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$y;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$y;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = function() {};
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$y;
    $3d3ce0c592af0505$var$y = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$y = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$t, a), null === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$r) && a === $3d3ce0c592af0505$var$h($3d3ce0c592af0505$var$t) && ($3d3ce0c592af0505$var$B ? ($3d3ce0c592af0505$var$E($3d3ce0c592af0505$var$L), $3d3ce0c592af0505$var$L = -1) : $3d3ce0c592af0505$var$B = !0, $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$H, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$r, a), $3d3ce0c592af0505$var$A || $3d3ce0c592af0505$var$z || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$I($3d3ce0c592af0505$var$J)));
    return a;
};
$3d3ce0c592af0505$export$b5836b71941fa3ed = $3d3ce0c592af0505$var$M;
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$y;
    return function() {
        var c = $3d3ce0c592af0505$var$y;
        $3d3ce0c592af0505$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$y = c;
        }
    };
};

});




document.addEventListener("DOMContentLoaded", ()=>{
    const burgerButton = document.getElementById("burgerButton");
    const line1 = document.getElementById("line1");
    const line2 = document.getElementById("line2");
    const nav = document.getElementById("nav");
    const header = document.getElementById("header");
    if (!burgerButton || !line1 || !line2 || !nav || !header) return;
    const handler = ()=>{
        if (burgerButton.dataset.page == "home") header.classList.toggle("bg-opacity-70");
        if (line1.classList.contains("rotate-45") && line2.classList.contains("-rotate-45")) {
            line1.classList.remove("rotate-45", "transform", "translate-y-1.5");
            line2.classList.remove("-rotate-45");
            nav.classList.remove("flex");
            nav.classList.add("hidden");
        // document.body.classList.remove("h-screen", "overflow-hidden");
        } else {
            line1.classList.add("rotate-45", "transform", "translate-y-1.5");
            line2.classList.add("-rotate-45");
            nav.classList.remove("hidden");
            nav.classList.add("flex");
        // document.body.classList.add("h-screen", "overflow-hidden");
        }
    };
    burgerButton.addEventListener("click", handler);
    burgerButton.addEventListener("keydown", handler);
});


document.addEventListener("DOMContentLoaded", ()=>{
    const sidebar = document.getElementById("sidebar");
    const btns = document.querySelectorAll("[data-action='toggle-sidebar']");
    const layer40 = document.getElementById("layer-40");
    if (sidebar && btns && layer40) btns.forEach((item)=>{
        item.addEventListener("click", ()=>{
            sidebar.classList.toggle("translate-x-full");
            layer40.classList.toggle("hidden");
            document.body.classList.toggle("h-screen");
            document.body.classList.toggle("overflow-hidden");
        });
    });
});
const $87580384247dcec3$export$2859119d518272d1 = ()=>{
    const sidebar = document.getElementById("sidebar");
    const btns = document.querySelectorAll("[data-action='toggle-sidebar']");
    const layer40 = document.getElementById("layer-40");
    if (sidebar && btns && layer40) {
        sidebar.classList.toggle("translate-x-full");
        layer40.classList.toggle("hidden");
        document.body.classList.toggle("h-screen");
        document.body.classList.toggle("overflow-hidden");
    }
};


var $13f4c0370d7de649$exports = {};
'use strict';

$13f4c0370d7de649$exports = (parcelRequire("89wqa"));



var $8NFma = parcelRequire("8NFma");
var $503937b663c395c4$exports = {};

$parcel$export($503937b663c395c4$exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export($503937b663c395c4$exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';
var $1c0f1e610963dfb8$exports = {};
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

$1c0f1e610963dfb8$exports = (parcelRequire("23wBm"));


var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $1c0f1e610963dfb8$exports.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $1c0f1e610963dfb8$exports.hydrateRoot;


const $68065a6cbe805fdf$var$NoticeComponent = ({ data: data })=>{
    const className = data.success ? "bg-green-100" : "bg-red-100";
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: `${className} px-6 py-3 rounded-md text-sm`,
        children: data.message
    });
};
const $68065a6cbe805fdf$var$PurchaseForm = ()=>{
    const [name, setName] = (0, $8NFma.useState)("");
    const [phone, setPhone] = (0, $8NFma.useState)("");
    const [message, setMessage] = (0, $8NFma.useState)("");
    const [notice, setNotice] = (0, $8NFma.useState)({
        show: false,
        success: false,
        message: ""
    });
    const submit = async (e)=>{
        e.preventDefault();
        if (name == "" || phone == "") {
            setNotice({
                show: true,
                success: false,
                message: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0418\u043C\u044F \u0438 \u0422\u0435\u043B\u0435\u0444\u043E\u043D"
            });
            return;
        }
        const response = await fetch("/api/purchases", {
            method: "POST",
            body: JSON.stringify({
                name: name,
                phone: phone,
                message: message,
                source: window.location.href
            })
        });
        const result = await response.json();
        if (result.ok) {
            setName("");
            setPhone("");
            setMessage("");
            setNotice({
                show: true,
                success: true,
                message: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435, \u043C\u044B \u0441\u043A\u043E\u0440\u043E \u0441 \u0432\u0430\u043C\u0438 \u0441\u0432\u044F\u0436\u0435\u043C\u0441\u044F"
            });
        }
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("form", {
            className: "",
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                            htmlFor: "name",
                            className: "block font-medium text-gray-600",
                            children: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            type: "text",
                            id: "name",
                            name: "name",
                            className: "mt-1 p-2 w-full border-b rounded-md",
                            placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043C\u044F",
                            onChange: (e)=>{
                                setName(e.target.value);
                            },
                            value: name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                            htmlFor: "phone",
                            className: "block font-medium text-gray-600",
                            children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            type: "tel",
                            id: "phone",
                            name: "phone",
                            className: "mt-1 p-2 w-full border-b rounded-md",
                            placeholder: "+7 (000) 000-00-00",
                            onChange: (e)=>{
                                setPhone(e.target.value);
                            },
                            value: phone
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                            htmlFor: "message",
                            className: "block font-medium text-gray-600",
                            children: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                            type: "text",
                            id: "message",
                            name: "phone",
                            className: "mt-1 p-2 w-full border-b rounded-md",
                            placeholder: "\u0425\u043E\u0447\u0443 \u043F\u043E\u0434\u043E\u0431\u0440\u0430\u0442\u044C \u0444\u0443\u043D\u0434\u0430\u043C\u0435\u043D\u0442",
                            onChange: (e)=>{
                                setMessage(e.target.value);
                            },
                            value: message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "py-5 text-sm",
                    children: "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441\xa0\u0423\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\xa0\u0438\xa0\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "mt-4 flex flex-col lg:flex-row gap-3",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "w-full lg:w-1/2",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                type: "submit",
                                className: "rounded-full border border-gray-600 py-4 px-6 text-gray-600",
                                children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "w-full lg:w-1/2",
                            children: notice.show && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($68065a6cbe805fdf$var$NoticeComponent, {
                                data: notice
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $68065a6cbe805fdf$var$container = document.getElementById("purchase-form");
if ($68065a6cbe805fdf$var$container) {
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($503937b663c395c4$exports))).createRoot($68065a6cbe805fdf$var$container);
    root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($68065a6cbe805fdf$var$PurchaseForm, {}));
}


const $614c1f1f1c706c84$var$questions = document.querySelectorAll("[data-action='toggle-faq']");
const $614c1f1f1c706c84$var$findElm = (elm)=>{
    const answer = elm.querySelector("[data-role='faq-answer']");
    const button = elm.querySelector("[data-role='indicator']");
    return {
        answer: answer,
        button: button
    };
};
const $614c1f1f1c706c84$var$hideAll = (clickedElm)=>{
    const { answer: answer, button: button } = $614c1f1f1c706c84$var$findElm(clickedElm);
    let hasShow = true;
    if (!answer || !button) return;
    if (!answer?.classList.contains("hidden")) hasShow = false;
    $614c1f1f1c706c84$var$questions.forEach((elm)=>{
        const { answer: answer, button: button } = $614c1f1f1c706c84$var$findElm(elm);
        if (!button || !answer) return;
        answer.classList.add("hidden");
        button.innerHTML = "+";
    });
    if (hasShow) {
        answer.classList.remove("hidden");
        button.innerHTML = "\u2013";
    }
};
$614c1f1f1c706c84$var$questions.forEach((item)=>{
    item.onclick = (e)=>{
        if (e.currentTarget instanceof HTMLElement) $614c1f1f1c706c84$var$hideAll(e.currentTarget);
    };
    item.onkeyup = (e)=>{
        if (e.currentTarget instanceof HTMLElement) $614c1f1f1c706c84$var$hideAll(e.currentTarget);
    };
});


const $418a74ec9b5274fa$var$elements = document.querySelectorAll(".accordion-zee__item");
const $418a74ec9b5274fa$var$images = document.querySelectorAll("[data-role='zee-image']");
const $418a74ec9b5274fa$var$toggleImages = (id)=>{
    $418a74ec9b5274fa$var$images.forEach((item)=>{
        if (item.getAttribute("data-value") !== `item-${id}`) item.classList.add("hidden");
        else item.classList.remove("hidden");
    });
};
const $418a74ec9b5274fa$var$foo = ()=>{
    $418a74ec9b5274fa$var$elements.forEach((item)=>{
        item.classList.remove("grow");
        item.classList.remove("px-4");
        item.classList.remove("flex");
        item.classList.remove("flex-col");
        item.classList.remove("justify-between");
        const title = item.querySelector("div[data-role='zee-title']");
        const description = item.querySelector("div[data-role='zee-description']");
        if (title == null || description == null) return;
        if (!title.classList.contains("-rotate-90")) {
            title.classList.add("-rotate-90");
            title.classList.add("-translate-x-[105px]");
            title.classList.add("translate-y-[130px]");
            description?.classList.add("hidden");
        }
    });
};
$418a74ec9b5274fa$var$elements.forEach((elm)=>{
    elm.onclick = (e)=>{
        $418a74ec9b5274fa$var$foo();
        const title = elm.querySelector("div[data-role='zee-title']");
        const description = elm.querySelector("div[data-role='zee-description']");
        const id = elm.getAttribute("data-value");
        if (id) $418a74ec9b5274fa$var$toggleImages(id);
        if (title == null || description == null) return;
        title.classList.toggle("-rotate-90");
        title.classList.remove("-translate-x-[105px]");
        title.classList.remove("translate-y-[130px]");
        description.classList.remove("hidden");
        elm.classList.toggle("grow");
        elm.classList.add("px-4");
        elm.classList.add("flex");
        elm.classList.add("flex-col");
        elm.classList.add("justify-between");
    };
});


var $4a05c9542a452669$exports = {};

$parcel$export($4a05c9542a452669$exports, "BaseComponent", () => $7868cd5b229e5c15$export$55ae5207ce896a6b);
$parcel$export($4a05c9542a452669$exports, "Data", () => $7868cd5b229e5c15$export$2d0294657ab35f1b);
$parcel$export($4a05c9542a452669$exports, "Block", () => $e746289f30c91f4f$export$d96a8827a60d6b69);
$parcel$export($4a05c9542a452669$exports, "ActivityBlock", () => $7cc70e522976ff2d$export$5e3ae1ab277e5747);
$parcel$export($4a05c9542a452669$exports, "UploaderBlock", () => $7465cac7cdfffcd5$export$5ece2da0ca12cb21);
$parcel$export($4a05c9542a452669$exports, "Config", () => $b7e2d88f4b1ac8e2$export$29cd7b75162a9425);
$parcel$export($4a05c9542a452669$exports, "Icon", () => $ebd0259c238f433f$export$f04a61298a47a40f);
$parcel$export($4a05c9542a452669$exports, "Img", () => $7b94fac360fd1820$export$cc7b5f925acc71d3);
$parcel$export($4a05c9542a452669$exports, "SimpleBtn", () => $cb76d7cb113a8f69$export$ce3de857dd70689d);
$parcel$export($4a05c9542a452669$exports, "StartFrom", () => $440b3799876f6dd5$export$10a8e4c39671907);
$parcel$export($4a05c9542a452669$exports, "DropArea", () => $5dbc44b2be3820a3$export$a950935544f004b4);
$parcel$export($4a05c9542a452669$exports, "SourceBtn", () => $74d53f248ef49d68$export$86582aae649ac163);
$parcel$export($4a05c9542a452669$exports, "SourceList", () => $3a457df5396c6ab1$export$3748a2f1ceae9e24);
$parcel$export($4a05c9542a452669$exports, "FileItem", () => $50aa2edfac49ad6e$export$a964e6adf466d4a6);
$parcel$export($4a05c9542a452669$exports, "Modal", () => $bfefff980ffa9ae7$export$2b77a92f1a5ad772);
$parcel$export($4a05c9542a452669$exports, "UploadList", () => $3a73d84020afa4a3$export$41ee0b933a746426);
$parcel$export($4a05c9542a452669$exports, "UrlSource", () => $2a73851b1d62f19c$export$cd326b6b2fa63cf5);
$parcel$export($4a05c9542a452669$exports, "CameraSource", () => $7808f47c33c6e823$export$9a93ce53f488cb2e);
$parcel$export($4a05c9542a452669$exports, "UploadCtxProvider", () => $e49d5535c683c8a8$export$6edf8f70f62f022d);
$parcel$export($4a05c9542a452669$exports, "UploadDetails", () => $55031f1dea86a0bb$export$e4ba681f177b2cad);
$parcel$export($4a05c9542a452669$exports, "ConfirmationDialog", () => $30c3bfd4ad929842$export$b8704437d11c7fe7);
$parcel$export($4a05c9542a452669$exports, "ProgressBarCommon", () => $6f8e0aefce596795$export$fcea9c441fb00ad4);
$parcel$export($4a05c9542a452669$exports, "ProgressBar", () => $0374dfef35ba08c7$export$c17561cb55d4db30);
$parcel$export($4a05c9542a452669$exports, "FilePreview", () => $4da4cb141c2fa4c7$export$a127194569a41afb);
$parcel$export($4a05c9542a452669$exports, "CloudImageEditorActivity", () => $65a22f2aae92e351$export$cb7e12222b993acb);
$parcel$export($4a05c9542a452669$exports, "ExternalSource", () => $a47f32e481c99b09$export$ffc19e40a21f08eb);
$parcel$export($4a05c9542a452669$exports, "Tabs", () => $1b696d7bad6d3150$export$b2539bed5023c21c);
$parcel$export($4a05c9542a452669$exports, "FormInput", () => $95a63dc49e5fa8b0$export$fd970bbd10854e43);
$parcel$export($4a05c9542a452669$exports, "ActivityHeader", () => $e98489404589cace$export$cdc1ca0f45c41261);
$parcel$export($4a05c9542a452669$exports, "Select", () => $fd57f1e30ae4cd0e$export$ef9b1a59e592288f);
$parcel$export($4a05c9542a452669$exports, "Video", () => $9fa21cf0fb6e0b82$export$ae01dedf5c052bb);
$parcel$export($4a05c9542a452669$exports, "ShadowWrapper", () => $cb5cf34cacde6aab$export$4ebb490b3ccfc72f);
$parcel$export($4a05c9542a452669$exports, "shadowed", () => $cb5cf34cacde6aab$export$3ba84baa65014afa);
$parcel$export($4a05c9542a452669$exports, "Copyright", () => $74158b9931238736$export$7b024d8cdfcd6192);
$parcel$export($4a05c9542a452669$exports, "FileUploaderRegular", () => $077d76b129d28a75$export$2c9ccda59fbaf1f6);
$parcel$export($4a05c9542a452669$exports, "FileUploaderMinimal", () => $a300d3f190295733$export$e225fbea59169a64);
$parcel$export($4a05c9542a452669$exports, "FileUploaderInline", () => $b8c00f3377f851f8$export$1930c3118e9a7a5e);
$parcel$export($4a05c9542a452669$exports, "CloudImageEditor", () => $1a286198d18de5c3$export$f41f1027242219f6);
$parcel$export($4a05c9542a452669$exports, "registerBlocks", () => $5a62190a7e34aa03$export$30be252fed5ebf56);
$parcel$export($4a05c9542a452669$exports, "connectBlocksFrom", () => $5ba4cc5583602415$export$30b3ebf06e5925ee);
$parcel$export($4a05c9542a452669$exports, "toKebabCase", () => $aaaaa1af795736a6$export$73bda83cddbc7187);
// @ts-check
// Symbiote.js
var $7868cd5b229e5c15$var$__defProp = Object.defineProperty;
var $7868cd5b229e5c15$var$__defNormalProp = (obj, key, value)=>key in obj ? $7868cd5b229e5c15$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7868cd5b229e5c15$var$__publicField = (obj, key, value)=>{
    $7868cd5b229e5c15$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// core/Data.js
function $7868cd5b229e5c15$var$cloneObj(obj) {
    let clone = (o)=>{
        var _a;
        for(let prop in o)if (((_a = o[prop]) == null ? void 0 : _a.constructor) === Object) o[prop] = clone(o[prop]);
        return {
            ...o
        };
    };
    return clone(obj);
}
var $7868cd5b229e5c15$export$2d0294657ab35f1b = class {
    constructor(schema){
        if (schema.constructor === Object) this.store = $7868cd5b229e5c15$var$cloneObj(schema);
        else {
            this._storeIsProxy = true;
            this.store = schema;
        }
        this.callbackMap = Object.create(null);
    }
    static warn(actionName, prop) {
        console.warn(`Symbiote Data: cannot ${actionName}. Prop name: ` + prop);
    }
    read(prop) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("read", prop);
            return null;
        }
        return this.store[prop];
    }
    has(prop) {
        return this._storeIsProxy ? this.store[prop] !== void 0 : this.store.hasOwnProperty(prop);
    }
    add(prop, val, rewrite = false) {
        if (!rewrite && Object.keys(this.store).includes(prop)) return;
        this.store[prop] = val;
        this.notify(prop);
    }
    pub(prop, val) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("publish", prop);
            return;
        }
        this.store[prop] = val;
        this.notify(prop);
    }
    multiPub(updObj) {
        for(let prop in updObj)this.pub(prop, updObj[prop]);
    }
    notify(prop) {
        if (this.callbackMap[prop]) this.callbackMap[prop].forEach((callback)=>{
            callback(this.store[prop]);
        });
    }
    sub(prop, callback, init = true) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("subscribe", prop);
            return null;
        }
        if (!this.callbackMap[prop]) this.callbackMap[prop] = /* @__PURE__ */ new Set();
        this.callbackMap[prop].add(callback);
        if (init) callback(this.store[prop]);
        return {
            remove: ()=>{
                this.callbackMap[prop].delete(callback);
                if (!this.callbackMap[prop].size) delete this.callbackMap[prop];
            },
            callback: callback
        };
    }
    static registerCtx(schema, uid = Symbol()) {
        let data = $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.get(uid);
        if (data) console.warn('State: context UID "' + uid + '" already in use');
        else {
            data = new $7868cd5b229e5c15$export$2d0294657ab35f1b(schema);
            $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.set(uid, data);
        }
        return data;
    }
    static deleteCtx(uid) {
        $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.delete(uid);
    }
    static getCtx(uid, notify = true) {
        return $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.get(uid) || (notify && console.warn('State: wrong context UID - "' + uid + '"'), null);
    }
};
$7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore = /* @__PURE__ */ new Map();
// core/dictionary.js
var $7868cd5b229e5c15$var$DICT = Object.freeze({
    BIND_ATTR: "set",
    ATTR_BIND_PRFX: "@",
    EXT_DATA_CTX_PRFX: "*",
    NAMED_DATA_CTX_SPLTR: "/",
    CTX_NAME_ATTR: "ctx-name",
    CTX_OWNER_ATTR: "ctx-owner",
    CSS_CTX_PROP: "--ctx-name",
    EL_REF_ATTR: "ref",
    AUTO_TAG_PRFX: "sym",
    REPEAT_ATTR: "repeat",
    REPEAT_ITEM_TAG_ATTR: "repeat-item-tag",
    SET_LATER_KEY: "__toSetLater__",
    USE_TPL: "use-template",
    ROOT_STYLE_ATTR_NAME: "sym-component"
});
// utils/UID.js
var $7868cd5b229e5c15$var$CHARS = "1234567890QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm";
var $7868cd5b229e5c15$var$CHLENGTH = $7868cd5b229e5c15$var$CHARS.length - 1;
var $7868cd5b229e5c15$export$c8b4a4d253b84ce0 = class {
    static generate(pattern = "XXXXXXXXX-XXX") {
        let uid = "";
        for(let i = 0; i < pattern.length; i++)uid += pattern[i] === "-" ? pattern[i] : $7868cd5b229e5c15$var$CHARS.charAt(Math.random() * $7868cd5b229e5c15$var$CHLENGTH);
        return uid;
    }
};
// utils/setNestedProp.js
function $7868cd5b229e5c15$export$2231b08ab5f8f72e(parent, path, value) {
    let success = true;
    let lastStep;
    let propPath = path.split(".");
    propPath.forEach((step, idx)=>{
        if (idx < propPath.length - 1) parent = parent[step];
        else lastStep = step;
    });
    if (parent) parent[lastStep] = value;
    else success = false;
    return success;
}
// utils/kebabToCamel.js
function $7868cd5b229e5c15$export$fd546b5ffd1f6a92(string) {
    return string.split("-").map((p, i)=>{
        return p && i ? p[0].toUpperCase() + p.slice(1) : p;
    }).join("").split("_").map((p, i)=>{
        return p && i ? p.toUpperCase() : p;
    }).join("");
}
// core/repeatProcessor.js
function $7868cd5b229e5c15$var$repeatProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.REPEAT_ATTR}]`)
    ].forEach((el)=>{
        let itemTag = el.getAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ITEM_TAG_ATTR);
        let itemClass;
        if (itemTag) itemClass = window.customElements.get(itemTag);
        if (!itemClass) {
            itemClass = class extends fnCtx.BaseComponent {
                constructor(){
                    super();
                    if (!itemTag) this.style.display = "contents";
                }
            };
            let itemTpl = el.innerHTML;
            itemClass.template = itemTpl;
            itemClass.reg(itemTag);
        }
        while(el.firstChild)el.firstChild.remove();
        let repeatDataKey = el.getAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ATTR);
        fnCtx.sub(repeatDataKey, (data)=>{
            if (!data) {
                while(el.firstChild)el.firstChild.remove();
                return;
            }
            let currentList = [
                ...el.children
            ];
            let fragment;
            let fillItems = (items)=>{
                items.forEach((item, idx)=>{
                    if (currentList[idx]) {
                        if (currentList[idx].set$) setTimeout(()=>{
                            currentList[idx].set$(item);
                        });
                        else for(let k in item)currentList[idx][k] = item[k];
                    } else {
                        if (!fragment) fragment = new DocumentFragment();
                        let repeatItem = new itemClass();
                        Object.assign(repeatItem.init$, item);
                        fragment.appendChild(repeatItem);
                    }
                });
                fragment && el.appendChild(fragment);
                let oversize = currentList.slice(items.length, currentList.length);
                for (let exItm of oversize)exItm.remove();
            };
            if (data.constructor === Array) fillItems(data);
            else if (data.constructor === Object) {
                let items = [];
                for(let itemKey in data){
                    let init = data[itemKey];
                    Object.defineProperty(init, "_KEY_", {
                        value: itemKey,
                        enumerable: true
                    });
                    items.push(init);
                }
                fillItems(items);
            } else {
                console.warn("Symbiote repeat data type error:");
                console.log(data);
            }
        });
        el.removeAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ATTR);
        el.removeAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ITEM_TAG_ATTR);
    });
}
// core/tpl-processors.js
var $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY = "__default__";
function $7868cd5b229e5c15$var$slotProcessor(fr, fnCtx) {
    if (fnCtx.shadowRoot) return;
    let slots = [
        ...fr.querySelectorAll("slot")
    ];
    if (!slots.length) return;
    let slotMap = {};
    slots.forEach((slot)=>{
        let slotName = slot.getAttribute("name") || $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY;
        slotMap[slotName] = {
            slot: slot,
            fr: document.createDocumentFragment()
        };
    });
    fnCtx.initChildren.forEach((child)=>{
        var _a;
        let slotName = $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY;
        if (child instanceof Element && child.hasAttribute("slot")) {
            slotName = child.getAttribute("slot");
            child.removeAttribute("slot");
        }
        (_a = slotMap[slotName]) == null || _a.fr.appendChild(child);
    });
    Object.values(slotMap).forEach((mapObj)=>{
        if (mapObj.fr.childNodes.length) mapObj.slot.parentNode.replaceChild(mapObj.fr, mapObj.slot);
        else if (mapObj.slot.childNodes.length) {
            let slotFr = document.createDocumentFragment();
            slotFr.append(...mapObj.slot.childNodes);
            mapObj.slot.parentNode.replaceChild(slotFr, mapObj.slot);
        } else mapObj.slot.remove();
    });
}
function $7868cd5b229e5c15$var$refProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.EL_REF_ATTR}]`)
    ].forEach((el)=>{
        let refName = el.getAttribute($7868cd5b229e5c15$var$DICT.EL_REF_ATTR);
        fnCtx.ref[refName] = el;
        el.removeAttribute($7868cd5b229e5c15$var$DICT.EL_REF_ATTR);
    });
}
function $7868cd5b229e5c15$var$domSetProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.BIND_ATTR}]`)
    ].forEach((el)=>{
        let subStr = el.getAttribute($7868cd5b229e5c15$var$DICT.BIND_ATTR);
        let keyValArr = subStr.split(";");
        [
            ...el.attributes
        ].forEach((attr)=>{
            if (attr.name.startsWith("-") && attr.value) {
                let key = $7868cd5b229e5c15$export$fd546b5ffd1f6a92(attr.name.replace("-", ""));
                keyValArr.push(key + ":" + attr.value);
                el.removeAttribute(attr.name);
            }
        });
        keyValArr.forEach((keyValStr)=>{
            if (!keyValStr) return;
            let kv = keyValStr.split(":").map((str)=>str.trim());
            let prop = kv[0];
            let isAttr;
            if (prop.indexOf($7868cd5b229e5c15$var$DICT.ATTR_BIND_PRFX) === 0) {
                isAttr = true;
                prop = prop.replace($7868cd5b229e5c15$var$DICT.ATTR_BIND_PRFX, "");
            }
            let valKeysArr = kv[1].split(",").map((valKey)=>{
                return valKey.trim();
            });
            for (let valKey of valKeysArr){
                let castType;
                if (valKey.startsWith("!!")) {
                    castType = "double";
                    valKey = valKey.replace("!!", "");
                } else if (valKey.startsWith("!")) {
                    castType = "single";
                    valKey = valKey.replace("!", "");
                }
                fnCtx.sub(valKey, (val)=>{
                    if (castType === "double") val = !!val;
                    else if (castType === "single") val = !val;
                    if (isAttr) {
                        if ((val == null ? void 0 : val.constructor) === Boolean) val ? el.setAttribute(prop, "") : el.removeAttribute(prop);
                        else el.setAttribute(prop, val);
                    } else if (!$7868cd5b229e5c15$export$2231b08ab5f8f72e(el, prop, val)) {
                        if (!el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY]) el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY] = Object.create(null);
                        el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY][prop] = val;
                    }
                });
            }
        });
        el.removeAttribute($7868cd5b229e5c15$var$DICT.BIND_ATTR);
    });
}
var $7868cd5b229e5c15$var$OPEN_TOKEN = "{{";
var $7868cd5b229e5c15$var$CLOSE_TOKEN = "}}";
var $7868cd5b229e5c15$var$SKIP_ATTR = "skip-text";
function $7868cd5b229e5c15$var$getTextNodesWithTokens(el) {
    let node;
    let result = [];
    let walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode: (txt)=>{
            var _a;
            return !((_a = txt.parentElement) == null ? void 0 : _a.hasAttribute($7868cd5b229e5c15$var$SKIP_ATTR)) && txt.textContent.includes($7868cd5b229e5c15$var$OPEN_TOKEN) && txt.textContent.includes($7868cd5b229e5c15$var$CLOSE_TOKEN) && 1;
        }
    });
    while(node = walk.nextNode())result.push(node);
    return result;
}
var $7868cd5b229e5c15$var$txtNodesProcessor = function(fr, fnCtx) {
    let txtNodes = $7868cd5b229e5c15$var$getTextNodesWithTokens(fr);
    txtNodes.forEach((txtNode)=>{
        let tokenNodes = [];
        let offset;
        while(txtNode.textContent.includes($7868cd5b229e5c15$var$CLOSE_TOKEN)){
            if (txtNode.textContent.startsWith($7868cd5b229e5c15$var$OPEN_TOKEN)) {
                offset = txtNode.textContent.indexOf($7868cd5b229e5c15$var$CLOSE_TOKEN) + $7868cd5b229e5c15$var$CLOSE_TOKEN.length;
                txtNode.splitText(offset);
                tokenNodes.push(txtNode);
            } else {
                offset = txtNode.textContent.indexOf($7868cd5b229e5c15$var$OPEN_TOKEN);
                txtNode.splitText(offset);
            }
            txtNode = txtNode.nextSibling;
        }
        tokenNodes.forEach((tNode)=>{
            let prop = tNode.textContent.replace($7868cd5b229e5c15$var$OPEN_TOKEN, "").replace($7868cd5b229e5c15$var$CLOSE_TOKEN, "");
            tNode.textContent = "";
            fnCtx.sub(prop, (val)=>{
                tNode.textContent = val;
            });
        });
    });
};
var $7868cd5b229e5c15$var$tpl_processors_default = [
    $7868cd5b229e5c15$var$repeatProcessor,
    $7868cd5b229e5c15$var$slotProcessor,
    $7868cd5b229e5c15$var$refProcessor,
    $7868cd5b229e5c15$var$domSetProcessor,
    $7868cd5b229e5c15$var$txtNodesProcessor
];
// utils/parseCssPropertyValue.js
var $7868cd5b229e5c15$var$SINGLE_QUOTE = "'";
var $7868cd5b229e5c15$var$DOUBLE_QUOTE = '"';
var $7868cd5b229e5c15$var$ESCAPED_PATTERN = /\\([0-9a-fA-F]{1,6} ?)/g;
function $7868cd5b229e5c15$var$hasLeadingTrailingQuotes(str) {
    return (str[0] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[0] === $7868cd5b229e5c15$var$SINGLE_QUOTE) && (str[str.length - 1] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[str.length - 1] === $7868cd5b229e5c15$var$SINGLE_QUOTE);
}
function $7868cd5b229e5c15$var$trimQuotes(str) {
    if (str[0] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[0] === $7868cd5b229e5c15$var$SINGLE_QUOTE) str = str.slice(1);
    if (str[str.length - 1] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[str.length - 1] === $7868cd5b229e5c15$var$SINGLE_QUOTE) str = str.slice(0, -1);
    return str;
}
function $7868cd5b229e5c15$var$escapeQuotes(str) {
    let result = "";
    let prev = "";
    for(var i = 0; i < str.length; i++){
        const next = str[i + 1];
        if (str[i] === "\\" && next === '"') {
            result += '\\"';
            i++;
        } else if (str[i] === '"' && prev !== "\\") result += '\\"';
        else result += str[i];
        prev = str[i];
    }
    return result;
}
function $7868cd5b229e5c15$var$parseCssPropertyValue(input) {
    let output = input;
    if ($7868cd5b229e5c15$var$hasLeadingTrailingQuotes(input)) {
        output = $7868cd5b229e5c15$var$trimQuotes(output);
        output = output.replace($7868cd5b229e5c15$var$ESCAPED_PATTERN, (match, p1)=>{
            return String.fromCodePoint(parseInt(p1.trim(), 16));
        });
        output = output.replaceAll("\\\n", "\\n");
        output = $7868cd5b229e5c15$var$escapeQuotes(output);
        output = $7868cd5b229e5c15$var$DOUBLE_QUOTE + output + $7868cd5b229e5c15$var$DOUBLE_QUOTE;
    }
    try {
        return JSON.parse(output);
    } catch (err) {
        throw new Error(`Failed to parse CSS property value: ${output}. Original input: ${input}`);
    }
}
// core/BaseComponent.js
var $7868cd5b229e5c15$var$autoTagsCount = 0;
var $7868cd5b229e5c15$var$styleMutationObserver = null;
var $7868cd5b229e5c15$var$styleMutationObserverCbList = null;
var $7868cd5b229e5c15$var$_BaseComponent = class extends HTMLElement {
    constructor(){
        super();
        $7868cd5b229e5c15$var$__publicField(this, "updateCssData", ()=>{
            var _a;
            this.dropCssDataCache();
            (_a = this.__boundCssProps) == null || _a.forEach((ctxProp)=>{
                let val = this.getCssData(this.__extractCssName(ctxProp), true);
                val !== null && this.$[ctxProp] !== val && (this.$[ctxProp] = val);
            });
        });
        this.init$ = Object.create(null);
        this.cssInit$ = Object.create(null);
        this.tplProcessors = /* @__PURE__ */ new Set();
        this.ref = Object.create(null);
        this.allSubs = /* @__PURE__ */ new Set();
        this.pauseRender = false;
        this.renderShadow = false;
        this.readyToDestroy = true;
        this.processInnerHtml = false;
        this.allowCustomTemplate = false;
        this.ctxOwner = false;
    }
    get BaseComponent() {
        return $7868cd5b229e5c15$var$_BaseComponent;
    }
    initCallback() {}
    __initCallback() {
        var _a;
        if (this.__initialized) return;
        this.__initialized = true;
        (_a = this.initCallback) == null || _a.call(this);
    }
    render(template, shadow = this.renderShadow) {
        let fr;
        if ((shadow || this.constructor["__shadowStylesUrl"]) && !this.shadowRoot) this.attachShadow({
            mode: "open"
        });
        if (this.allowCustomTemplate) {
            let customTplSelector = this.getAttribute($7868cd5b229e5c15$var$DICT.USE_TPL);
            if (customTplSelector) {
                let root = this.getRootNode();
                let customTpl = (root == null ? void 0 : root.querySelector(customTplSelector)) || document.querySelector(customTplSelector);
                if (customTpl) template = customTpl.content.cloneNode(true);
                else console.warn(`Symbiote template "${customTplSelector}" is not found...`);
            }
        }
        if (this.processInnerHtml) for (let fn of this.tplProcessors)fn(this, this);
        if (template || this.constructor["template"]) {
            if (this.constructor["template"] && !this.constructor["__tpl"]) {
                this.constructor["__tpl"] = document.createElement("template");
                this.constructor["__tpl"].innerHTML = this.constructor["template"];
            }
            if ((template == null ? void 0 : template.constructor) === DocumentFragment) fr = template;
            else if ((template == null ? void 0 : template.constructor) === String) {
                let tpl = document.createElement("template");
                tpl.innerHTML = template;
                fr = tpl.content.cloneNode(true);
            } else if (this.constructor["__tpl"]) fr = this.constructor["__tpl"].content.cloneNode(true);
            for (let fn of this.tplProcessors)fn(fr, this);
        }
        let addFr = ()=>{
            fr && (shadow && this.shadowRoot.appendChild(fr) || this.appendChild(fr));
            this.__initCallback();
        };
        if (this.constructor["__shadowStylesUrl"]) {
            shadow = true;
            let styleLink = document.createElement("link");
            styleLink.rel = "stylesheet";
            styleLink.href = this.constructor["__shadowStylesUrl"];
            styleLink.onload = addFr;
            this.shadowRoot.prepend(styleLink);
        } else addFr();
    }
    addTemplateProcessor(processorFn) {
        this.tplProcessors.add(processorFn);
    }
    get autoCtxName() {
        if (!this.__autoCtxName) {
            this.__autoCtxName = $7868cd5b229e5c15$export$c8b4a4d253b84ce0.generate();
            this.style.setProperty($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, `'${this.__autoCtxName}'`);
        }
        return this.__autoCtxName;
    }
    get cssCtxName() {
        return this.getCssData($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, true);
    }
    get ctxName() {
        var _a;
        let ctxName = ((_a = this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_NAME_ATTR)) == null ? void 0 : _a.trim()) || this.cssCtxName || this.__cachedCtxName || this.autoCtxName;
        this.__cachedCtxName = ctxName;
        return ctxName;
    }
    get localCtx() {
        if (!this.__localCtx) this.__localCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, this);
        return this.__localCtx;
    }
    get nodeCtx() {
        return $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(this.ctxName, false) || $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, this.ctxName);
    }
    static __parseProp(prop, fnCtx) {
        let ctx;
        let name;
        if (prop.startsWith($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX)) {
            ctx = fnCtx.nodeCtx;
            name = prop.replace($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX, "");
        } else if (prop.includes($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR)) {
            let pArr = prop.split($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR);
            ctx = $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(pArr[0]);
            name = pArr[1];
        } else {
            ctx = fnCtx.localCtx;
            name = prop;
        }
        return {
            ctx: ctx,
            name: name
        };
    }
    sub(prop, handler, init = true) {
        let subCb = (val)=>{
            if (!this.isConnected) return;
            handler(val);
        };
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        if (!parsed.ctx.has(parsed.name)) window.setTimeout(()=>{
            this.allSubs.add(parsed.ctx.sub(parsed.name, subCb, init));
        });
        else this.allSubs.add(parsed.ctx.sub(parsed.name, subCb, init));
    }
    notify(prop) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        parsed.ctx.notify(parsed.name);
    }
    has(prop) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        return parsed.ctx.has(parsed.name);
    }
    add(prop, val, rewrite = false) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        parsed.ctx.add(parsed.name, val, rewrite);
    }
    add$(obj, rewrite = false) {
        for(let prop in obj)this.add(prop, obj[prop], rewrite);
    }
    get $() {
        if (!this.__stateProxy) {
            let o = Object.create(null);
            this.__stateProxy = new Proxy(o, {
                set: (obj, prop, val)=>{
                    let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
                    parsed.ctx.pub(parsed.name, val);
                    return true;
                },
                get: (obj, prop)=>{
                    let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
                    return parsed.ctx.read(parsed.name);
                }
            });
        }
        return this.__stateProxy;
    }
    set$(kvObj, forcePrimitives = false) {
        for(let key in kvObj){
            let val = kvObj[key];
            let primArr = [
                String,
                Number,
                Boolean
            ];
            if (forcePrimitives || !primArr.includes(val == null ? void 0 : val.constructor)) this.$[key] = val;
            else this.$[key] !== val && (this.$[key] = val);
        }
    }
    get __ctxOwner() {
        return this.ctxOwner || this.hasAttribute($7868cd5b229e5c15$var$DICT.CTX_OWNER_ATTR) && this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_OWNER_ATTR) !== "false";
    }
    __initDataCtx() {
        let attrDesc = this.constructor["__attrDesc"];
        if (attrDesc) {
            for (let prop of Object.values(attrDesc))if (!Object.keys(this.init$).includes(prop)) this.init$[prop] = "";
        }
        for(let prop in this.init$){
            if (prop.startsWith($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX)) this.nodeCtx.add(prop.replace($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX, ""), this.init$[prop], this.__ctxOwner);
            else if (prop.includes($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR)) {
                let propArr = prop.split($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR);
                let ctxName = propArr[0].trim();
                let propName = propArr[1].trim();
                if (ctxName && propName) {
                    let namedCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(ctxName, false);
                    if (!namedCtx) namedCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, ctxName);
                    namedCtx.add(propName, this.init$[prop]);
                }
            } else this.localCtx.add(prop, this.init$[prop]);
        }
        for(let cssProp in this.cssInit$)this.bindCssData(cssProp, this.cssInit$[cssProp]);
        this.__dataCtxInitialized = true;
    }
    connectedCallback() {
        var _a;
        if (!this.isConnected) return;
        if (this.__disconnectTimeout) window.clearTimeout(this.__disconnectTimeout);
        if (!this.connectedOnce) {
            let ctxNameAttrVal = (_a = this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_NAME_ATTR)) == null ? void 0 : _a.trim();
            if (ctxNameAttrVal) this.style.setProperty($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, `'${ctxNameAttrVal}'`);
            this.__initDataCtx();
            if (this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY]) {
                for(let prop in this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY])$7868cd5b229e5c15$export$2231b08ab5f8f72e(this, prop, this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY][prop]);
                delete this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY];
            }
            this.initChildren = [
                ...this.childNodes
            ];
            for (let proc of $7868cd5b229e5c15$var$tpl_processors_default)this.addTemplateProcessor(proc);
            if (this.pauseRender) this.__initCallback();
            else if (this.constructor["__rootStylesLink"]) {
                let root = this.getRootNode();
                if (!root) return;
                let hasLink = root == null ? void 0 : root.querySelector(`link[${$7868cd5b229e5c15$var$DICT.ROOT_STYLE_ATTR_NAME}="${this.constructor.is}"]`);
                if (hasLink) {
                    this.render();
                    return;
                }
                let rootLink = this.constructor["__rootStylesLink"].cloneNode(true);
                rootLink.setAttribute($7868cd5b229e5c15$var$DICT.ROOT_STYLE_ATTR_NAME, this.constructor["is"]);
                rootLink.onload = ()=>{
                    this.render();
                };
                root.nodeType === Node.DOCUMENT_NODE ? root.head.appendChild(rootLink) : root.prepend(rootLink);
            } else this.render();
        }
        this.connectedOnce = true;
    }
    destroyCallback() {}
    disconnectedCallback() {
        if (!this.connectedOnce) return;
        this.dropCssDataCache();
        if (!this.readyToDestroy) return;
        if (this.__disconnectTimeout) window.clearTimeout(this.__disconnectTimeout);
        this.__disconnectTimeout = window.setTimeout(()=>{
            this.destroyCallback();
            for (let sub of this.allSubs){
                sub.remove();
                this.allSubs.delete(sub);
            }
            for (let proc of this.tplProcessors)this.tplProcessors.delete(proc);
            $7868cd5b229e5c15$var$styleMutationObserverCbList == null || $7868cd5b229e5c15$var$styleMutationObserverCbList.delete(this.updateCssData);
            if (!($7868cd5b229e5c15$var$styleMutationObserverCbList == null ? void 0 : $7868cd5b229e5c15$var$styleMutationObserverCbList.size)) {
                $7868cd5b229e5c15$var$styleMutationObserver == null || $7868cd5b229e5c15$var$styleMutationObserver.disconnect();
                $7868cd5b229e5c15$var$styleMutationObserver = null;
                $7868cd5b229e5c15$var$styleMutationObserverCbList = null;
            }
        }, 100);
    }
    static reg(tagName, isAlias = false) {
        if (!tagName) {
            $7868cd5b229e5c15$var$autoTagsCount++;
            tagName = `${$7868cd5b229e5c15$var$DICT.AUTO_TAG_PRFX}-${$7868cd5b229e5c15$var$autoTagsCount}`;
        }
        this.__tag = tagName;
        let registeredClass = window.customElements.get(tagName);
        if (registeredClass) {
            if (!isAlias && registeredClass !== this) console.warn([
                `Element with tag name "${tagName}" already registered.`,
                `You're trying to override it with another class "${this.name}".`,
                `This is most likely a mistake.`,
                `New element will not be registered.`
            ].join("\n"));
            return;
        }
        window.customElements.define(tagName, isAlias ? class extends this {
        } : this);
    }
    static get is() {
        if (!this.__tag) this.reg();
        return this.__tag;
    }
    static bindAttributes(desc) {
        this.observedAttributes = Object.keys(desc);
        this.__attrDesc = desc;
    }
    attributeChangedCallback(name, oldVal, newVal) {
        var _a;
        if (oldVal === newVal) return;
        let $prop = (_a = this.constructor["__attrDesc"]) == null ? void 0 : _a[name];
        if ($prop) {
            if (this.__dataCtxInitialized) this.$[$prop] = newVal;
            else this.init$[$prop] = newVal;
        } else this[name] = newVal;
    }
    getCssData(propName, silentCheck = false) {
        if (!this.__cssDataCache) this.__cssDataCache = Object.create(null);
        if (!Object.keys(this.__cssDataCache).includes(propName)) {
            if (!this.__computedStyle) this.__computedStyle = window.getComputedStyle(this);
            let val = this.__computedStyle.getPropertyValue(propName).trim();
            try {
                this.__cssDataCache[propName] = $7868cd5b229e5c15$var$parseCssPropertyValue(val);
            } catch (e) {
                !silentCheck && console.warn(`CSS Data error: ${propName}`);
                this.__cssDataCache[propName] = null;
            }
        }
        return this.__cssDataCache[propName];
    }
    __extractCssName(ctxPropName) {
        return ctxPropName.split("--").map((part, idx)=>{
            return idx === 0 ? "" : part;
        }).join("--");
    }
    __initStyleAttrObserver() {
        if (!$7868cd5b229e5c15$var$styleMutationObserverCbList) $7868cd5b229e5c15$var$styleMutationObserverCbList = /* @__PURE__ */ new Set();
        $7868cd5b229e5c15$var$styleMutationObserverCbList.add(this.updateCssData);
        if (!$7868cd5b229e5c15$var$styleMutationObserver) {
            $7868cd5b229e5c15$var$styleMutationObserver = new MutationObserver((records)=>{
                records[0].type === "attributes" && $7868cd5b229e5c15$var$styleMutationObserverCbList.forEach((cb)=>{
                    cb();
                });
            });
            $7868cd5b229e5c15$var$styleMutationObserver.observe(document, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    "style"
                ]
            });
        }
    }
    bindCssData(propName, initValue = "") {
        if (!this.__boundCssProps) this.__boundCssProps = /* @__PURE__ */ new Set();
        this.__boundCssProps.add(propName);
        let val = this.getCssData(this.__extractCssName(propName), true);
        val === null && (val = initValue);
        this.add(propName, val);
        this.__initStyleAttrObserver();
    }
    dropCssDataCache() {
        this.__cssDataCache = null;
        this.__computedStyle = null;
    }
    defineAccessor(propName, handler, isAsync) {
        let localPropName = "__" + propName;
        this[localPropName] = this[propName];
        Object.defineProperty(this, propName, {
            set: (val)=>{
                this[localPropName] = val;
                if (isAsync) window.setTimeout(()=>{
                    handler == null || handler(val);
                });
                else handler == null || handler(val);
            },
            get: ()=>{
                return this[localPropName];
            }
        });
        this[propName] = this[localPropName];
    }
    static set shadowStyles(cssTxt) {
        let styleBlob = new Blob([
            cssTxt
        ], {
            type: "text/css"
        });
        this.__shadowStylesUrl = URL.createObjectURL(styleBlob);
    }
    static set rootStyles(cssTxt) {
        if (!this.__rootStylesLink) {
            let styleBlob = new Blob([
                cssTxt
            ], {
                type: "text/css"
            });
            let url = URL.createObjectURL(styleBlob);
            let link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            this.__rootStylesLink = link;
        }
    }
};
var $7868cd5b229e5c15$export$55ae5207ce896a6b = $7868cd5b229e5c15$var$_BaseComponent;
$7868cd5b229e5c15$var$__publicField($7868cd5b229e5c15$export$55ae5207ce896a6b, "template");
// core/AppRouter.js
var $7868cd5b229e5c15$export$8707b35fd1c03f46 = class {
    static _print(msg) {
        console.warn(msg);
    }
    static setDefaultTitle(title) {
        this.defaultTitle = title;
    }
    static setRoutingMap(map) {
        Object.assign(this.appMap, map);
        for(let route in this.appMap){
            if (!this.defaultRoute && this.appMap[route].default === true) this.defaultRoute = route;
            else if (!this.errorRoute && this.appMap[route].error === true) this.errorRoute = route;
        }
    }
    static set routingEventName(name) {
        this.__routingEventName = name;
    }
    static get routingEventName() {
        return this.__routingEventName || "sym-on-route";
    }
    static readAddressBar() {
        let result = {
            route: null,
            options: {}
        };
        let paramsArr = window.location.search.split(this.separator);
        paramsArr.forEach((part)=>{
            if (part.includes("?")) result.route = part.replace("?", "");
            else if (part.includes("=")) {
                let pair = part.split("=");
                result.options[pair[0]] = decodeURI(pair[1]);
            } else result.options[part] = true;
        });
        return result;
    }
    static notify() {
        let routeBase = this.readAddressBar();
        let routeScheme = this.appMap[routeBase.route];
        if (routeScheme && routeScheme.title) document.title = routeScheme.title;
        if (routeBase.route === null && this.defaultRoute) {
            this.applyRoute(this.defaultRoute);
            return;
        } else if (!routeScheme && this.errorRoute) {
            this.applyRoute(this.errorRoute);
            return;
        } else if (!routeScheme && this.defaultRoute) {
            this.applyRoute(this.defaultRoute);
            return;
        } else if (!routeScheme) {
            this._print(`Route "${routeBase.route}" not found...`);
            return;
        }
        let event = new CustomEvent($7868cd5b229e5c15$export$8707b35fd1c03f46.routingEventName, {
            detail: {
                route: routeBase.route,
                options: Object.assign(routeScheme || {}, routeBase.options)
            }
        });
        window.dispatchEvent(event);
    }
    static reflect(route, options = {}) {
        let routeScheme = this.appMap[route];
        if (!routeScheme) {
            this._print("Wrong route: " + route);
            return;
        }
        let routeStr = "?" + route;
        for(let prop in options)if (options[prop] === true) routeStr += this.separator + prop;
        else routeStr += this.separator + prop + `=${options[prop]}`;
        let title = routeScheme.title || this.defaultTitle || "";
        window.history.pushState(null, title, routeStr);
        document.title = title;
    }
    static applyRoute(route, options = {}) {
        this.reflect(route, options);
        this.notify();
    }
    static setSeparator(char) {
        this._separator = char;
    }
    static get separator() {
        return this._separator || "&";
    }
    static createRouterData(ctxName, routingMap) {
        this.setRoutingMap(routingMap);
        let routeData = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({
            route: null,
            options: null,
            title: null
        }, ctxName);
        window.addEventListener(this.routingEventName, (e)=>{
            var _a;
            routeData.multiPub({
                route: e.detail.route,
                options: e.detail.options,
                title: ((_a = e.detail.options) == null ? void 0 : _a.title) || this.defaultTitle || ""
            });
        });
        $7868cd5b229e5c15$export$8707b35fd1c03f46.notify();
        this.initPopstateListener();
        return routeData;
    }
    static initPopstateListener() {
        if (this.__onPopstate) return;
        this.__onPopstate = ()=>{
            this.notify();
        };
        window.addEventListener("popstate", this.__onPopstate);
    }
    static removePopstateListener() {
        window.removeEventListener("popstate", this.__onPopstate);
        this.__onPopstate = null;
    }
};
$7868cd5b229e5c15$export$8707b35fd1c03f46.appMap = Object.create(null);
// utils/dom-helpers.js
function $7868cd5b229e5c15$export$41428deff1a0db9e(el, styleMap) {
    for(let prop in styleMap)if (prop.includes("-")) el.style.setProperty(prop, styleMap[prop]);
    else el.style[prop] = styleMap[prop];
}
function $7868cd5b229e5c15$export$dd00578f6781bf5d(el, attrMap) {
    for(let attrName in attrMap)if (attrMap[attrName].constructor === Boolean) {
        if (attrMap[attrName]) el.setAttribute(attrName, "");
        else el.removeAttribute(attrName);
    } else el.setAttribute(attrName, attrMap[attrName]);
}
function $7868cd5b229e5c15$export$185802fd694ee1f5(desc = {
    tag: "div"
}) {
    let el = document.createElement(desc.tag);
    if (desc.attributes) $7868cd5b229e5c15$export$dd00578f6781bf5d(el, desc.attributes);
    if (desc.styles) $7868cd5b229e5c15$export$41428deff1a0db9e(el, desc.styles);
    if (desc.properties) for(let prop in desc.properties)el[prop] = desc.properties[prop];
    if (desc.processors) desc.processors.forEach((fn)=>{
        fn(el);
    });
    if (desc.children) desc.children.forEach((desc2)=>{
        let child = $7868cd5b229e5c15$export$185802fd694ee1f5(desc2);
        el.appendChild(child);
    });
    return el;
}
// utils/IDB.js
var $7868cd5b229e5c15$var$READY_EVENT_NAME = "idb-store-ready";
var $7868cd5b229e5c15$var$DEFAULT_DB_NAME = `symbiote-db`;
var $7868cd5b229e5c15$var$UPD_EVENT_PREFIX = `symbiote-idb-update_`;
var $7868cd5b229e5c15$var$DbInstance = class {
    _notifyWhenReady(event = null) {
        window.dispatchEvent(new CustomEvent($7868cd5b229e5c15$var$READY_EVENT_NAME, {
            detail: {
                dbName: this.name,
                storeName: this.storeName,
                event: event
            }
        }));
    }
    get _updEventName() {
        return $7868cd5b229e5c15$var$UPD_EVENT_PREFIX + this.name;
    }
    _getUpdateEvent(key) {
        return new CustomEvent(this._updEventName, {
            detail: {
                key: this.name,
                newValue: key
            }
        });
    }
    _notifySubscribers(key) {
        window.localStorage.removeItem(this.name);
        window.localStorage.setItem(this.name, key);
        window.dispatchEvent(this._getUpdateEvent(key));
    }
    constructor(dbName, storeName){
        this.name = dbName;
        this.storeName = storeName;
        this.version = 1;
        this.request = window.indexedDB.open(this.name, this.version);
        this.request.onupgradeneeded = (e)=>{
            this.db = e.target["result"];
            this.objStore = this.db.createObjectStore(storeName, {
                keyPath: "_key"
            });
            this.objStore.transaction.oncomplete = (ev)=>{
                this._notifyWhenReady(ev);
            };
        };
        this.request.onsuccess = (e)=>{
            this.db = e.target.result;
            this._notifyWhenReady(e);
        };
        this.request.onerror = (e)=>{
            console.error(e);
        };
        this._subscriptionsMap = {};
        this._updateHandler = (e)=>{
            if (e.key === this.name && this._subscriptionsMap[e.newValue]) {
                let set = this._subscriptionsMap[e.newValue];
                set.forEach(async (callback)=>{
                    callback(await this.read(e.newValue));
                });
            }
        };
        this._localUpdateHandler = (e)=>{
            this._updateHandler(e.detail);
        };
        window.addEventListener("storage", this._updateHandler);
        window.addEventListener(this._updEventName, this._localUpdateHandler);
    }
    read(key) {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).get(key);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                var _a;
                if ((_a = e.target.result) == null ? void 0 : _a._value) resolve(e.target.result._value);
                else {
                    resolve(null);
                    console.warn(`IDB: cannot read "${key}"`);
                }
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    write(key, value, silent = false) {
        let data = {
            _key: key,
            _value: value
        };
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).put(data);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                if (!silent) this._notifySubscribers(key);
                resolve(e.target.result);
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    delete(key, silent = false) {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).delete(key);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                if (!silent) this._notifySubscribers(key);
                resolve(e);
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    getAll() {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).getAll();
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                let all = e.target.result;
                resolve(all.map((obj)=>{
                    return obj._value;
                }));
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    subscribe(key, callback) {
        if (!this._subscriptionsMap[key]) this._subscriptionsMap[key] = /* @__PURE__ */ new Set();
        let set = this._subscriptionsMap[key];
        set.add(callback);
        return {
            remove: ()=>{
                set.delete(callback);
                if (!set.size) delete this._subscriptionsMap[key];
            }
        };
    }
    stop() {
        window.removeEventListener("storage", this._updateHandler);
        this._subscriptionsMap = null;
        $7868cd5b229e5c15$export$30b18c8237ba149e.clear(this.name);
    }
};
var $7868cd5b229e5c15$export$30b18c8237ba149e = class {
    static get readyEventName() {
        return $7868cd5b229e5c15$var$READY_EVENT_NAME;
    }
    static open(dbName = $7868cd5b229e5c15$var$DEFAULT_DB_NAME, storeName = "store") {
        let key = dbName + "/" + storeName;
        if (!this._reg[key]) this._reg[key] = new $7868cd5b229e5c15$var$DbInstance(dbName, storeName);
        return this._reg[key];
    }
    static clear(dbName) {
        window.indexedDB.deleteDatabase(dbName);
        for(let key in this._reg)if (key.split("/")[0] === dbName) delete this._reg[key];
    }
};
$7868cd5b229e5c15$var$__publicField($7868cd5b229e5c15$export$30b18c8237ba149e, "_reg", Object.create(null));


// @ts-check

//  @ts-check
const $a25d4bde048879ae$var$DEFAULT_DEBOUNCE_TIMEOUT = 20;
const $a25d4bde048879ae$export$3d7865934588d77e = Object.freeze({
    FILE_ADDED: 'file-added',
    FILE_REMOVED: 'file-removed',
    FILE_UPLOAD_START: 'file-upload-start',
    FILE_UPLOAD_PROGRESS: 'file-upload-progress',
    FILE_UPLOAD_SUCCESS: 'file-upload-success',
    FILE_UPLOAD_FAILED: 'file-upload-failed',
    FILE_URL_CHANGED: 'file-url-changed',
    MODAL_OPEN: 'modal-open',
    MODAL_CLOSE: 'modal-close',
    DONE_CLICK: 'done-click',
    UPLOAD_CLICK: 'upload-click',
    ACTIVITY_CHANGE: 'activity-change',
    COMMON_UPLOAD_START: 'common-upload-start',
    COMMON_UPLOAD_PROGRESS: 'common-upload-progress',
    COMMON_UPLOAD_SUCCESS: 'common-upload-success',
    COMMON_UPLOAD_FAILED: 'common-upload-failed',
    CHANGE: 'change',
    GROUP_CREATED: 'group-created'
});
class $a25d4bde048879ae$export$4fae95256245c8c0 {
    /**
   * @private
   * @type {Map<string, number>}
   */ _timeoutStore = new Map();
    /**
   * @private
   * @type {Set<import('../../abstract/Block.js').Block>}
   */ _targets = new Set();
    /**
   * @private
   * @type {((...args: unknown[]) => void) | null}
   */ _debugPrint = null;
    /** @param {(...args: unknown[]) => void} debugPrint */ constructor(debugPrint){
        this._debugPrint = debugPrint;
    }
    /** @param {import('../../abstract/Block.js').Block} target */ bindTarget(target) {
        this._targets.add(target);
    }
    /** @param {import('../../abstract/Block.js').Block} target */ unbindTarget(target) {
        this._targets.delete(target);
    }
    /**
   * @private
   * @template {(typeof EventType)[keyof typeof EventType]} T
   * @param {T} type
   * @param {unknown} [payload]
   */ _dispatch(type, payload) {
        for (const target of this._targets)target.dispatchEvent(new CustomEvent(type, {
            detail: payload
        }));
        this._debugPrint?.(()=>{
            const copyPayload = !!payload && typeof payload === 'object' ? {
                ...payload
            } : payload;
            return [
                `event "${type}"`,
                copyPayload
            ];
        });
    }
    /**
   * @template {(typeof EventType)[keyof typeof EventType]} T
   * @template {boolean | number | undefined} TDebounce
   * @param {T} type
   * @param {TDebounce extends false | undefined ? unknown : () => unknown} [payload]
   * @param {{ debounce?: TDebounce }} [options]
   */ emit(type, payload, { debounce: debounce } = {}) {
        if (typeof debounce !== 'number' && !debounce) {
            this._dispatch(type, typeof payload === 'function' ? payload() : payload);
            return;
        }
        if (this._timeoutStore.has(type)) window.clearTimeout(this._timeoutStore.get(type));
        const timeout = typeof debounce === 'number' ? debounce : $a25d4bde048879ae$var$DEFAULT_DEBOUNCE_TIMEOUT;
        const timeoutId = window.setTimeout(()=>{
            this._dispatch(type, typeof payload === 'function' ? payload() : payload);
            this._timeoutStore.delete(type);
        }, timeout);
        this._timeoutStore.set(type, timeoutId);
    }
}


// @ts-check
// @ts-check
/**
 * @template {{ (...args: any[]): any }} T
 * @param {T} callback
 * @param {number} wait
 * @returns {T & { cancel: () => void }} }
 */ function $60594be474a773dd$export$61fc7d43ac8f84b0(callback, wait) {
    /** @type {NodeJS.Timeout} */ let timer;
    const debounced = /** @param {...any} args */ (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>callback(...args), wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timer);
    };
    return /** @type {T & { cancel: () => void }} } */ debounced;
}


const $74a2a35d58e25a3d$var$WINDOW_HEIGHT_TRACKER_PROPERTY = '--uploadcare-blocks-window-height';
class $74a2a35d58e25a3d$export$164c1ecdf58fbaaa {
    /**
   * @private
   * @type {Set<unknown>}
   */ static clientsRegistry = new Set();
    /** @private */ static flush = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(()=>{
        document.documentElement.style.setProperty($74a2a35d58e25a3d$var$WINDOW_HEIGHT_TRACKER_PROPERTY, `${window.innerHeight}px`);
    }, 100);
    /**
   * @param {unknown} client
   * @public
   */ static registerClient(client) {
        if (this.clientsRegistry.size === 0) this.attachTracker();
        this.clientsRegistry.add(client);
    }
    /**
   * @param {unknown} client
   * @public
   */ static unregisterClient(client) {
        this.clientsRegistry.delete(client);
        if (this.clientsRegistry.size === 0) this.detachTracker();
    }
    /** @private */ static attachTracker() {
        window.addEventListener('resize', this.flush, {
            passive: true,
            capture: true
        });
        this.flush();
    }
    /** @private */ static detachTracker() {
        window.removeEventListener('resize', this.flush, {
            capture: true
        });
        document.documentElement.style.removeProperty($74a2a35d58e25a3d$var$WINDOW_HEIGHT_TRACKER_PROPERTY);
    }
}


// @ts-check
/** @typedef {Intl.LDMLPluralRule} PluralForm */ /**
 * @param {string} locale
 * @param {number} count
 * @returns {PluralForm}
 */ const $63338ce7a65902fa$export$9f3f0d2d02951501 = (locale, count)=>{
    const pluralForm = new Intl.PluralRules(locale).select(count);
    return pluralForm;
};


/** @typedef {{ [key: String]: String | Number | Boolean | InputData }} InputData */ const $8fc43c3fd04f0fc3$var$DEFAULT_TRANSFORMER = (value)=>value;
const $8fc43c3fd04f0fc3$var$OPEN_TOKEN = '{{';
const $8fc43c3fd04f0fc3$var$CLOSE_TOKEN = '}}';
const $8fc43c3fd04f0fc3$var$PLURAL_PREFIX = 'plural:';
function $8fc43c3fd04f0fc3$export$34afab4d3a450b60(template, data, options = {}) {
    let { openToken: openToken = $8fc43c3fd04f0fc3$var$OPEN_TOKEN, closeToken: closeToken = $8fc43c3fd04f0fc3$var$CLOSE_TOKEN, transform: transform = $8fc43c3fd04f0fc3$var$DEFAULT_TRANSFORMER } = options;
    for(let key in data){
        let value = data[key]?.toString();
        template = template.replaceAll(openToken + key + closeToken, typeof value === 'string' ? transform(value) : value);
    }
    return template;
}
function $8fc43c3fd04f0fc3$export$eabb0be5d19ba097(template) {
    const pluralObjects = [];
    let open = template.indexOf($8fc43c3fd04f0fc3$var$OPEN_TOKEN);
    while(open !== -1){
        const close = template.indexOf($8fc43c3fd04f0fc3$var$CLOSE_TOKEN, open);
        const variable = template.substring(open + 2, close);
        if (variable.startsWith($8fc43c3fd04f0fc3$var$PLURAL_PREFIX)) {
            const keyValue = template.substring(open + 2, close).replace($8fc43c3fd04f0fc3$var$PLURAL_PREFIX, '');
            const key = keyValue.substring(0, keyValue.indexOf('('));
            const count = keyValue.substring(keyValue.indexOf('(') + 1, keyValue.indexOf(')'));
            pluralObjects.push({
                variable: variable,
                pluralKey: key,
                countVariable: count
            });
        }
        open = template.indexOf($8fc43c3fd04f0fc3$var$OPEN_TOKEN, close);
    }
    return pluralObjects;
}


/**
 * @template {string} T
 * @typedef {T extends `${infer Head} ${infer Tail}` ? `${Lowercase<Head>}-${KebabCase<Tail>}` : Lowercase<T>} KebabCase
 */ /**
 * @template {string} T
 * @param {T} str
 * @returns {KebabCase<T>}
 */ const $aaaaa1af795736a6$export$73bda83cddbc7187 = (str)=>str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)?.map((x)=>x.toLowerCase()).join('-');


// @ts-check
/**
 * @param {{
 *   element: HTMLElement;
 *   attribute: string;
 *   onSuccess: (value: string) => void;
 *   onTimeout: () => void;
 *   timeout?: number;
 * }} options
 */ const $b621c7eab37d9df5$export$bf3e2014f0f6687e = ({ element: element, attribute: attribute, onSuccess: onSuccess, onTimeout: onTimeout, timeout: timeout = 300 })=>{
    const currentAttrValue = element.getAttribute(attribute);
    if (currentAttrValue !== null) {
        onSuccess(currentAttrValue);
        return;
    }
    const observer = new MutationObserver((mutations)=>{
        const mutation = mutations[mutations.length - 1];
        handleMutation(mutation);
    });
    observer.observe(element, {
        attributes: true,
        attributeFilter: [
            attribute
        ]
    });
    const timeoutId = setTimeout(()=>{
        observer.disconnect();
        onTimeout();
    }, timeout);
    /** @param {MutationRecord} mutation */ const handleMutation = (mutation)=>{
        const attrValue = element.getAttribute(attribute);
        if (mutation.type === 'attributes' && mutation.attributeName === attribute && attrValue !== null) {
            clearTimeout(timeoutId);
            observer.disconnect();
            onSuccess(attrValue);
        }
    };
};


const $6a075e397d8438c7$var$warnings = new Set();
function $6a075e397d8438c7$export$5b28268982f175ba(message) {
    if ($6a075e397d8438c7$var$warnings.has(message)) return;
    $6a075e397d8438c7$var$warnings.add(message);
    console.warn(message);
}


// @ts-check
function $3905b2ce68ef12c7$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
const $3905b2ce68ef12c7$var$SEPARATOR = /\W|_/g;
function $3905b2ce68ef12c7$var$camelizeString(text) {
    return text.split($3905b2ce68ef12c7$var$SEPARATOR).map((word, index)=>word.charAt(0)[index > 0 ? 'toUpperCase' : 'toLowerCase']() + word.slice(1)).join('');
}
function $3905b2ce68ef12c7$var$camelizeArrayItems(array, { ignoreKeys: ignoreKeys } = {
    ignoreKeys: []
}) {
    if (!Array.isArray(array)) return array;
    return array.map((item)=>$3905b2ce68ef12c7$var$camelizeKeys(item, {
            ignoreKeys: ignoreKeys
        }));
}
function $3905b2ce68ef12c7$var$camelizeKeys(source, { ignoreKeys: ignoreKeys } = {
    ignoreKeys: []
}) {
    if (Array.isArray(source)) return $3905b2ce68ef12c7$var$camelizeArrayItems(source, {
        ignoreKeys: ignoreKeys
    });
    if (!$3905b2ce68ef12c7$var$isObject(source)) return source;
    const result = {};
    for (const key of Object.keys(source)){
        let value = source[key];
        if (ignoreKeys.includes(key)) {
            result[key] = value;
            continue;
        }
        if ($3905b2ce68ef12c7$var$isObject(value)) value = $3905b2ce68ef12c7$var$camelizeKeys(value, {
            ignoreKeys: ignoreKeys
        });
        else if (Array.isArray(value)) value = $3905b2ce68ef12c7$var$camelizeArrayItems(value, {
            ignoreKeys: ignoreKeys
        });
        result[$3905b2ce68ef12c7$var$camelizeString(key)] = value;
    }
    return result;
}
/**
 * SetTimeout as Promise.
 *
 * @param {number} ms Timeout in milliseconds.
 */ const $3905b2ce68ef12c7$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $3905b2ce68ef12c7$export$7935961ef7719cb0({ libraryName: libraryName, libraryVersion: libraryVersion, userAgent: userAgent, publicKey: publicKey = '', integration: integration = '' }) {
    const languageName = 'JavaScript';
    if (typeof userAgent === 'string') return userAgent;
    if (typeof userAgent === 'function') return userAgent({
        publicKey: publicKey,
        libraryName: libraryName,
        libraryVersion: libraryVersion,
        languageName: languageName,
        integration: integration
    });
    const mainInfo = [
        libraryName,
        libraryVersion,
        publicKey
    ].filter(Boolean).join('/');
    const additionInfo = [
        languageName,
        integration
    ].filter(Boolean).join('; ');
    return `${mainInfo} (${additionInfo})`;
}
const $3905b2ce68ef12c7$var$defaultOptions = {
    factor: 2,
    time: 100
};
function $3905b2ce68ef12c7$var$retrier(fn, options = $3905b2ce68ef12c7$var$defaultOptions) {
    let attempts = 0;
    function runAttempt(fn) {
        const defaultDelayTime = Math.round(options.time * options.factor ** attempts);
        const retry = (ms)=>$3905b2ce68ef12c7$var$delay(ms ?? defaultDelayTime).then(()=>{
                attempts += 1;
                return runAttempt(fn);
            });
        return fn({
            attempt: attempts,
            retry: retry
        });
    }
    return runAttempt(fn);
}
class $3905b2ce68ef12c7$export$2b0985b1459cbeaf extends Error {
}
class $3905b2ce68ef12c7$export$bae979e68e4dc802 extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    originalProgressEvent;
    constructor(progressEvent){
        super();
        this.name = 'NetworkError';
        this.message = 'Network error';
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$bae979e68e4dc802.prototype);
        this.originalProgressEvent = progressEvent;
    }
}
const $3905b2ce68ef12c7$var$onCancel = (signal, callback)=>{
    if (signal) {
        if (signal.aborted) Promise.resolve().then(callback);
        else signal.addEventListener('abort', ()=>callback(), {
            once: true
        });
    }
};
class $3905b2ce68ef12c7$export$d7f5e52d091a66db extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    isCancel = true;
    constructor(message = 'Request canceled'){
        super(message);
        this.name = 'CancelError';
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$d7f5e52d091a66db.prototype);
    }
}
const $3905b2ce68ef12c7$var$DEFAULT_INTERVAL = 500;
const $3905b2ce68ef12c7$var$poll = ({ check: check, interval: interval = $3905b2ce68ef12c7$var$DEFAULT_INTERVAL, timeout: timeout, signal: signal })=>new Promise((resolve, reject)=>{
        let tickTimeoutId;
        let timeoutId;
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            tickTimeoutId && clearTimeout(tickTimeoutId);
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db('Poll cancelled'));
        });
        if (timeout) timeoutId = setTimeout(()=>{
            tickTimeoutId && clearTimeout(tickTimeoutId);
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db('Timed out'));
        }, timeout);
        const tick = ()=>{
            try {
                Promise.resolve(check(signal)).then((result)=>{
                    if (result) {
                        timeoutId && clearTimeout(timeoutId);
                        resolve(result);
                    } else tickTimeoutId = setTimeout(tick, interval);
                }).catch((error)=>{
                    timeoutId && clearTimeout(timeoutId);
                    reject(error);
                });
            } catch (error) {
                timeoutId && clearTimeout(timeoutId);
                reject(error);
            }
        };
        tickTimeoutId = setTimeout(tick, 0);
    });
/*
  Settings for future support:
  parallelDirectUploads: 10,
 */ const $3905b2ce68ef12c7$var$defaultSettings = {
    baseCDN: 'https://ucarecdn.com',
    baseURL: 'https://upload.uploadcare.com',
    maxContentLength: 52428800,
    retryThrottledRequestMaxTimes: 1,
    retryNetworkErrorMaxTimes: 3,
    multipartMinFileSize: 26214400,
    multipartChunkSize: 5242880,
    multipartMinLastPartSize: 1048576,
    maxConcurrentRequests: 4,
    pollingTimeoutMilliseconds: 10000,
    pusherKey: '79ae88bd931ea68464d9'
};
const $3905b2ce68ef12c7$var$defaultContentType = 'application/octet-stream';
const $3905b2ce68ef12c7$var$defaultFilename = 'original';
const $3905b2ce68ef12c7$var$request = ({ method: method, url: url, data: data, headers: headers = {}, signal: signal, onProgress: onProgress })=>new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        const requestMethod = method?.toUpperCase() || 'GET';
        let aborted = false;
        /**
     * Force synchronous flag to be off Some chrome versions gets
     * `InvalidAccessError` error when we set `responseType` See
     * https://xhr.spec.whatwg.org/#synchronous-flag and
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1346628
     */ xhr.open(requestMethod, url, true);
        if (headers) Object.entries(headers).forEach((entry)=>{
            const [key, value] = entry;
            typeof value !== 'undefined' && !Array.isArray(value) && xhr.setRequestHeader(key, value);
        });
        xhr.responseType = 'text';
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            aborted = true;
            xhr.abort();
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db());
        });
        xhr.onload = ()=>{
            if (xhr.status != 200) // analyze HTTP status of the response
            reject(new Error(`Error ${xhr.status}: ${xhr.statusText}`)); // e.g. 404: Not Found
            else {
                const request = {
                    method: requestMethod,
                    url: url,
                    data: data,
                    headers: headers || undefined,
                    signal: signal,
                    onProgress: onProgress
                };
                // Convert the header string into an array
                // of individual headers
                const headersArray = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);
                // Create a map of header names to values
                const responseHeaders = {};
                headersArray.forEach(function(line) {
                    const parts = line.split(': ');
                    const header = parts.shift();
                    const value = parts.join(': ');
                    if (header && typeof header !== 'undefined') responseHeaders[header] = value;
                });
                const responseData = xhr.response;
                const responseStatus = xhr.status;
                resolve({
                    request: request,
                    data: responseData,
                    headers: responseHeaders,
                    status: responseStatus
                });
            }
        };
        xhr.onerror = (progressEvent)=>{
            if (aborted) return;
            // only triggers if the request couldn't be made at all
            reject(new $3905b2ce68ef12c7$export$bae979e68e4dc802(progressEvent));
        };
        if (onProgress && typeof onProgress === 'function') xhr.upload.onprogress = (event)=>{
            if (event.lengthComputable) onProgress({
                isComputable: true,
                value: event.loaded / event.total
            });
            else onProgress({
                isComputable: false
            });
        };
        if (data) xhr.send(data);
        else xhr.send();
    });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3905b2ce68ef12c7$var$identity(obj, ..._args) {
    return obj;
}
const $3905b2ce68ef12c7$var$getFileOptions = ({ name: name })=>name ? [
        name
    ] : [];
const $3905b2ce68ef12c7$var$transformFile = $3905b2ce68ef12c7$var$identity;
var $3905b2ce68ef12c7$var$getFormData = ()=>new FormData();
const $3905b2ce68ef12c7$var$isBuffer = (data)=>false;
const $3905b2ce68ef12c7$var$isBlob = (data)=>{
    return typeof Blob !== 'undefined' && data instanceof Blob;
};
const $3905b2ce68ef12c7$var$isFile = (data)=>{
    return typeof File !== 'undefined' && data instanceof File;
};
const $3905b2ce68ef12c7$var$isReactNativeAsset = (data)=>{
    return !!data && typeof data === 'object' && !Array.isArray(data) && 'uri' in data && typeof data.uri === 'string';
};
const $3905b2ce68ef12c7$var$isFileData = (data)=>{
    return $3905b2ce68ef12c7$var$isBlob(data) || $3905b2ce68ef12c7$var$isFile(data) || $3905b2ce68ef12c7$var$isBuffer() || $3905b2ce68ef12c7$var$isReactNativeAsset(data);
};
const $3905b2ce68ef12c7$var$isSimpleValue = (value)=>{
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'undefined';
};
const $3905b2ce68ef12c7$var$isObjectValue = (value)=>{
    return !!value && typeof value === 'object' && !Array.isArray(value);
};
const $3905b2ce68ef12c7$var$isFileValue = (value)=>!!value && typeof value === 'object' && 'data' in value && $3905b2ce68ef12c7$var$isFileData(value.data);
function $3905b2ce68ef12c7$var$collectParams(params, inputKey, inputValue) {
    if (Array.isArray(inputValue)) for (const value of inputValue)$3905b2ce68ef12c7$var$collectParams(params, `${inputKey}[]`, value);
    else if ($3905b2ce68ef12c7$var$isFileValue(inputValue)) {
        const { name: name, contentType: contentType } = inputValue;
        const file = $3905b2ce68ef12c7$var$transformFile(inputValue.data, name, contentType ?? $3905b2ce68ef12c7$var$defaultContentType);
        const options = $3905b2ce68ef12c7$var$getFileOptions({
            name: name,
            contentType: contentType
        });
        params.push([
            inputKey,
            file,
            ...options
        ]);
    } else if ($3905b2ce68ef12c7$var$isObjectValue(inputValue)) {
        for (const [key, value] of Object.entries(inputValue))if (typeof value !== 'undefined') params.push([
            `${inputKey}[${key}]`,
            String(value)
        ]);
    } else if ($3905b2ce68ef12c7$var$isSimpleValue(inputValue) && inputValue) params.push([
        inputKey,
        inputValue.toString()
    ]);
}
function $3905b2ce68ef12c7$var$getFormDataParams(options) {
    const params = [];
    for (const [key, value] of Object.entries(options))$3905b2ce68ef12c7$var$collectParams(params, key, value);
    return params;
}
function $3905b2ce68ef12c7$var$buildFormData(options) {
    const formData = $3905b2ce68ef12c7$var$getFormData();
    const paramsList = $3905b2ce68ef12c7$var$getFormDataParams(options);
    for (const params of paramsList){
        const [key, value, ...rest] = params;
        // node form-data has another signature for append
        formData.append(key, value, ...rest);
    }
    return formData;
}
class $3905b2ce68ef12c7$export$137ec66182ed30ea extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    code;
    request;
    response;
    headers;
    constructor(message, code, request, response, headers){
        super();
        this.name = 'UploadError';
        this.message = message;
        this.code = code;
        this.request = request;
        this.response = response;
        this.headers = headers;
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$137ec66182ed30ea.prototype);
    }
}
const $3905b2ce68ef12c7$var$buildSearchParams = (query)=>{
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query)){
        if (value && typeof value === 'object' && !Array.isArray(value)) Object.entries(value).filter((entry)=>entry[1] ?? false).forEach((entry)=>searchParams.set(`${key}[${entry[0]}]`, String(entry[1])));
        else if (Array.isArray(value)) value.forEach((val)=>{
            searchParams.append(`${key}[]`, val);
        });
        else if (typeof value === 'string' && value) searchParams.set(key, value);
        else if (typeof value === 'number') searchParams.set(key, value.toString());
    }
    return searchParams.toString();
};
const $3905b2ce68ef12c7$var$getUrl = (base, path, query)=>{
    const url = new URL(base);
    url.pathname = (url.pathname + path).replace('//', '/');
    if (query) url.search = $3905b2ce68ef12c7$var$buildSearchParams(query);
    return url.toString();
};
var $3905b2ce68ef12c7$var$version = '6.14.3';
const $3905b2ce68ef12c7$var$LIBRARY_NAME = 'UploadcareUploadClient';
const $3905b2ce68ef12c7$var$LIBRARY_VERSION = $3905b2ce68ef12c7$var$version;
function $3905b2ce68ef12c7$var$getUserAgent(options) {
    return $3905b2ce68ef12c7$export$7935961ef7719cb0({
        libraryName: $3905b2ce68ef12c7$var$LIBRARY_NAME,
        libraryVersion: $3905b2ce68ef12c7$var$LIBRARY_VERSION,
        ...options
    });
}
const $3905b2ce68ef12c7$var$REQUEST_WAS_THROTTLED_CODE = 'RequestThrottledError';
const $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT = 15000;
const $3905b2ce68ef12c7$var$DEFAULT_NETWORK_ERROR_TIMEOUT = 1000;
function $3905b2ce68ef12c7$var$getTimeoutFromThrottledRequest(error) {
    const { headers: headers } = error || {};
    if (!headers || typeof headers['retry-after'] !== 'string') return $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT;
    const seconds = parseInt(headers['retry-after'], 10);
    if (!Number.isFinite(seconds)) return $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT;
    return seconds * 1000;
}
function $3905b2ce68ef12c7$var$retryIfFailed(fn, options) {
    const { retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes } = options;
    return $3905b2ce68ef12c7$var$retrier(({ attempt: attempt, retry: retry })=>fn().catch((error)=>{
            if ('response' in error && error?.code === $3905b2ce68ef12c7$var$REQUEST_WAS_THROTTLED_CODE && attempt < retryThrottledRequestMaxTimes) return retry($3905b2ce68ef12c7$var$getTimeoutFromThrottledRequest(error));
            if (error instanceof $3905b2ce68ef12c7$export$bae979e68e4dc802 && attempt < retryNetworkErrorMaxTimes) return retry((attempt + 1) * $3905b2ce68ef12c7$var$DEFAULT_NETWORK_ERROR_TIMEOUT);
            throw error;
        }));
}
const $3905b2ce68ef12c7$var$getContentType = (file)=>{
    let contentType = '';
    if ($3905b2ce68ef12c7$var$isBlob(file) || $3905b2ce68ef12c7$var$isFile(file) || $3905b2ce68ef12c7$var$isReactNativeAsset(file)) contentType = file.type;
    return contentType || $3905b2ce68ef12c7$var$defaultContentType;
};
const $3905b2ce68ef12c7$var$getFileName = (file)=>{
    let filename = '';
    if ($3905b2ce68ef12c7$var$isFile(file) && file.name) filename = file.name;
    else if ($3905b2ce68ef12c7$var$isBlob(file) || $3905b2ce68ef12c7$var$isBuffer()) filename = '';
    else if ($3905b2ce68ef12c7$var$isReactNativeAsset(file) && file.name) filename = file.name;
    return filename || $3905b2ce68ef12c7$var$defaultFilename;
};
function $3905b2ce68ef12c7$var$getStoreValue(store) {
    if (typeof store === 'undefined' || store === 'auto') return 'auto';
    return store ? '1' : '0';
}
/**
 * Performs file uploading request to Uploadcare Upload API. Can be canceled and
 * has progress.
 */ function $3905b2ce68ef12c7$export$e2253033e6e1df16(file, { publicKey: publicKey, fileName: fileName, contentType: contentType, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source = 'local', integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'POST',
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/base/', {
                jsonerrors: 1
            }),
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                file: {
                    data: file,
                    name: fileName || $3905b2ce68ef12c7$var$getFileName(file),
                    contentType: contentType || $3905b2ce68ef12c7$var$getContentType(file)
                },
                UPLOADCARE_PUB_KEY: publicKey,
                UPLOADCARE_STORE: $3905b2ce68ef12c7$var$getStoreValue(store),
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal,
            onProgress: onProgress
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
var $3905b2ce68ef12c7$var$TypeEnum;
(function(TypeEnum) {
    TypeEnum["Token"] = "token";
    TypeEnum["FileInfo"] = "file_info";
})($3905b2ce68ef12c7$var$TypeEnum || ($3905b2ce68ef12c7$var$TypeEnum = {}));
/** Uploading files from URL. */ function $3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, store: store, fileName: fileName, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, secureSignature: secureSignature, secureExpire: secureExpire, source: source = 'url', signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'POST',
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/from_url/', {
                jsonerrors: 1,
                pub_key: publicKey,
                source_url: sourceUrl,
                store: $3905b2ce68ef12c7$var$getStoreValue(store),
                filename: fileName,
                check_URL_duplicates: checkForUrlDuplicates ? 1 : undefined,
                save_URL_duplicates: saveUrlForRecurrentUploads ? 1 : undefined,
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
var $3905b2ce68ef12c7$var$Status;
(function(Status) {
    Status["Unknown"] = "unknown";
    Status["Waiting"] = "waiting";
    Status["Progress"] = "progress";
    Status["Error"] = "error";
    Status["Success"] = "success";
})($3905b2ce68ef12c7$var$Status || ($3905b2ce68ef12c7$var$Status = {}));
const $3905b2ce68ef12c7$var$isErrorResponse = (response)=>{
    return 'status' in response && response.status === $3905b2ce68ef12c7$var$Status.Error;
};
/** Checking upload status and working with file tokens. */ function $3905b2ce68ef12c7$export$11ce33276c18fc77(token, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes } = {}) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'GET',
            headers: publicKey ? {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            } : undefined,
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/from_url/status/', {
                jsonerrors: 1,
                token: token
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response && !$3905b2ce68ef12c7$var$isErrorResponse(response)) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
/** Create files group. */ function $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, jsonpCallback: jsonpCallback, secureSignature: secureSignature, secureExpire: secureExpire, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'POST',
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/group/', {
                jsonerrors: 1
            }),
            data: $3905b2ce68ef12c7$var$buildFormData({
                files: uuids,
                callback: jsonpCallback,
                pub_key: publicKey,
                signature: secureSignature,
                expire: secureExpire,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
/** Get info about group. */ function $3905b2ce68ef12c7$export$ff32046efef5c2f5(id, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'GET',
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/group/info/', {
                jsonerrors: 1,
                pub_key: publicKey,
                group_id: id,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Returns a JSON dictionary holding file info. */ function $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'GET',
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/info/', {
                jsonerrors: 1,
                pub_key: publicKey,
                file_id: uuid,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Start multipart uploading. */ function $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, { publicKey: publicKey, contentType: contentType, fileName: fileName, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, baseURL: baseURL = '', secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, source: source = 'local', integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'POST',
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/multipart/start/', {
                jsonerrors: 1
            }),
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                filename: fileName || $3905b2ce68ef12c7$var$defaultFilename,
                size: size,
                content_type: contentType || $3905b2ce68ef12c7$var$defaultContentType,
                part_size: multipartChunkSize,
                UPLOADCARE_STORE: $3905b2ce68ef12c7$var$getStoreValue(store),
                UPLOADCARE_PUB_KEY: publicKey,
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else {
                // convert to array
                response.parts = Object.keys(response.parts).map((key)=>response.parts[Number(key)]);
                return response;
            }
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Complete multipart uploading. */ function $3905b2ce68ef12c7$export$73b98a86a54f96ed(part, url, { contentType: contentType, signal: signal, onProgress: onProgress, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'PUT',
            url: url,
            data: part,
            // Upload request can't be non-computable because we always know exact size
            onProgress: onProgress,
            signal: signal,
            headers: {
                'Content-Type': contentType || $3905b2ce68ef12c7$var$defaultContentType
            }
        }).then((result)=>{
            // hack for node ¯\_(ツ)_/¯
            if (onProgress) onProgress({
                isComputable: true,
                value: 1
            });
            return result;
        }).then(({ status: status })=>({
                code: status
            })), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Complete multipart uploading. */ function $3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, source: source = 'local', signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: 'POST',
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, '/multipart/complete/', {
                jsonerrors: 1
            }),
            headers: {
                'X-UC-User-Agent': $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                uuid: uuid,
                UPLOADCARE_PUB_KEY: publicKey,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ('error' in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
function $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(uuid, { publicKey: publicKey, baseURL: baseURL, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, signal: signal, onProgress: onProgress }) {
    return $3905b2ce68ef12c7$var$poll({
        check: (signal)=>$3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, {
                publicKey: publicKey,
                baseURL: baseURL,
                signal: signal,
                source: source,
                integration: integration,
                userAgent: userAgent,
                retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
            }).then((response)=>{
                if (response.isReady) return response;
                onProgress && onProgress({
                    isComputable: true,
                    value: 1
                });
                return false;
            }),
        signal: signal
    });
}
function $3905b2ce68ef12c7$var$isGroupFileInfo(fileInfo) {
    return 'defaultEffects' in fileInfo;
}
class $3905b2ce68ef12c7$export$92ff693e656b1c76 {
    uuid;
    name;
    size;
    isStored;
    isImage;
    mimeType;
    cdnUrl;
    s3Url;
    originalFilename;
    imageInfo;
    videoInfo;
    contentInfo;
    metadata;
    s3Bucket;
    defaultEffects = null;
    constructor(fileInfo, { baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, fileName: fileName } = {}){
        const { uuid: uuid, s3Bucket: s3Bucket } = fileInfo;
        const cdnUrl = $3905b2ce68ef12c7$var$getUrl(baseCDN, `${uuid}/`);
        const s3Url = s3Bucket ? $3905b2ce68ef12c7$var$getUrl(`https://${s3Bucket}.s3.amazonaws.com/`, `${uuid}/${fileInfo.filename}`) : null;
        this.uuid = uuid;
        this.name = fileName || fileInfo.filename;
        this.size = fileInfo.size;
        this.isStored = fileInfo.isStored;
        this.isImage = fileInfo.isImage;
        this.mimeType = fileInfo.mimeType;
        this.cdnUrl = cdnUrl;
        this.originalFilename = fileInfo.originalFilename;
        this.imageInfo = fileInfo.imageInfo;
        this.videoInfo = fileInfo.videoInfo;
        this.contentInfo = fileInfo.contentInfo;
        this.metadata = fileInfo.metadata || null;
        this.s3Bucket = s3Bucket || null;
        this.s3Url = s3Url;
        if ($3905b2ce68ef12c7$var$isGroupFileInfo(fileInfo)) this.defaultEffects = fileInfo.defaultEffects;
    }
}
const $3905b2ce68ef12c7$export$3bd9b83d6d44a7c = (file, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, contentType: contentType, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, baseCDN: baseCDN, metadata: metadata })=>{
    return $3905b2ce68ef12c7$export$e2253033e6e1df16(file, {
        publicKey: publicKey,
        fileName: fileName,
        contentType: contentType,
        baseURL: baseURL,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        metadata: metadata
    }).then(({ file: file })=>{
        return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(file, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            onProgress: onProgress,
            signal: signal
        });
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
};
const $3905b2ce68ef12c7$export$3bfa52b0ed198643 = (uuid, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, baseCDN: baseCDN })=>{
    return $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, {
        publicKey: publicKey,
        baseURL: baseURL,
        signal: signal,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN,
            fileName: fileName
        })).then((result)=>{
        // hack for node ¯\_(ツ)_/¯
        if (onProgress) onProgress({
            isComputable: true,
            value: 1
        });
        return result;
    });
};
const $3905b2ce68ef12c7$var$race = (fns, { signal: signal } = {})=>{
    let lastError = null;
    let winnerIndex = null;
    const controllers = fns.map(()=>new AbortController());
    const createStopRaceCallback = (i)=>()=>{
            winnerIndex = i;
            controllers.forEach((controller, index)=>index !== i && controller.abort());
        };
    $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
        controllers.forEach((controller)=>controller.abort());
    });
    return Promise.all(fns.map((fn, i)=>{
        const stopRace = createStopRaceCallback(i);
        return Promise.resolve().then(()=>fn({
                stopRace: stopRace,
                signal: controllers[i].signal
            })).then((result)=>{
            stopRace();
            return result;
        }).catch((error)=>{
            lastError = error;
            return null;
        });
    })).then((results)=>{
        if (winnerIndex === null) throw lastError;
        else return results[winnerIndex];
    });
};
var $3905b2ce68ef12c7$var$WebSocket = window.WebSocket;
class $3905b2ce68ef12c7$var$Events {
    events = Object.create({});
    emit(event, data) {
        this.events[event]?.forEach((fn)=>fn(data));
    }
    on(event, callback) {
        this.events[event] = this.events[event] || [];
        this.events[event].push(callback);
    }
    off(event, callback) {
        if (callback) this.events[event] = this.events[event].filter((fn)=>fn !== callback);
        else this.events[event] = [];
    }
}
const $3905b2ce68ef12c7$var$response = (type, data)=>{
    if (type === 'success') return {
        status: $3905b2ce68ef12c7$var$Status.Success,
        ...data
    };
    if (type === 'progress') return {
        status: $3905b2ce68ef12c7$var$Status.Progress,
        ...data
    };
    return {
        status: $3905b2ce68ef12c7$var$Status.Error,
        ...data
    };
};
class $3905b2ce68ef12c7$var$Pusher {
    key;
    disconnectTime;
    ws = undefined;
    queue = [];
    isConnected = false;
    subscribers = 0;
    emmitter = new $3905b2ce68ef12c7$var$Events();
    disconnectTimeoutId = null;
    constructor(pusherKey, disconnectTime = 30000){
        this.key = pusherKey;
        this.disconnectTime = disconnectTime;
    }
    connect() {
        this.disconnectTimeoutId && clearTimeout(this.disconnectTimeoutId);
        if (!this.isConnected && !this.ws) {
            const pusherUrl = `wss://ws.pusherapp.com/app/${this.key}?protocol=5&client=js&version=1.12.2`;
            this.ws = new $3905b2ce68ef12c7$var$WebSocket(pusherUrl);
            this.ws.addEventListener('error', (error)=>{
                this.emmitter.emit('error', new Error(error.message));
            });
            this.emmitter.on('connected', ()=>{
                this.isConnected = true;
                this.queue.forEach((message)=>this.send(message.event, message.data));
                this.queue = [];
            });
            this.ws.addEventListener('message', (e)=>{
                const data = JSON.parse(e.data.toString());
                switch(data.event){
                    case 'pusher:connection_established':
                        this.emmitter.emit('connected', undefined);
                        break;
                    case 'pusher:ping':
                        this.send('pusher:pong', {});
                        break;
                    case 'progress':
                    case 'success':
                    case 'fail':
                        this.emmitter.emit(data.channel, $3905b2ce68ef12c7$var$response(data.event, JSON.parse(data.data)));
                }
            });
        }
    }
    disconnect() {
        const actualDisconect = ()=>{
            this.ws?.close();
            this.ws = undefined;
            this.isConnected = false;
        };
        if (this.disconnectTime) this.disconnectTimeoutId = setTimeout(()=>{
            actualDisconect();
        }, this.disconnectTime);
        else actualDisconect();
    }
    send(event, data) {
        const str = JSON.stringify({
            event: event,
            data: data
        });
        this.ws?.send(str);
    }
    subscribe(token, handler) {
        this.subscribers += 1;
        this.connect();
        const channel = `task-status-${token}`;
        const message = {
            event: 'pusher:subscribe',
            data: {
                channel: channel
            }
        };
        this.emmitter.on(channel, handler);
        if (this.isConnected) this.send(message.event, message.data);
        else this.queue.push(message);
    }
    unsubscribe(token) {
        this.subscribers -= 1;
        const channel = `task-status-${token}`;
        const message = {
            event: 'pusher:unsubscribe',
            data: {
                channel: channel
            }
        };
        this.emmitter.off(channel);
        if (this.isConnected) this.send(message.event, message.data);
        else this.queue = this.queue.filter((msg)=>msg.data.channel !== channel);
        if (this.subscribers === 0) this.disconnect();
    }
    onError(callback) {
        this.emmitter.on('error', callback);
        return ()=>this.emmitter.off('error', callback);
    }
}
let $3905b2ce68ef12c7$var$pusher = null;
const $3905b2ce68ef12c7$var$getPusher = (key)=>{
    if (!$3905b2ce68ef12c7$var$pusher) {
        // no timeout for nodeJS and 30000 ms for browser
        const disconectTimeout = typeof window === 'undefined' ? 0 : 30000;
        $3905b2ce68ef12c7$var$pusher = new $3905b2ce68ef12c7$var$Pusher(key, disconectTimeout);
    }
    return $3905b2ce68ef12c7$var$pusher;
};
const $3905b2ce68ef12c7$var$preconnect = (key)=>{
    $3905b2ce68ef12c7$var$getPusher(key).connect();
};
function $3905b2ce68ef12c7$var$pollStrategy({ token: token, publicKey: publicKey, baseURL: baseURL, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, onProgress: onProgress, signal: signal }) {
    return $3905b2ce68ef12c7$var$poll({
        check: (signal)=>$3905b2ce68ef12c7$export$11ce33276c18fc77(token, {
                publicKey: publicKey,
                baseURL: baseURL,
                integration: integration,
                userAgent: userAgent,
                retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
                signal: signal
            }).then((response)=>{
                switch(response.status){
                    case $3905b2ce68ef12c7$var$Status.Error:
                        return new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error, response.errorCode);
                    case $3905b2ce68ef12c7$var$Status.Waiting:
                        return false;
                    case $3905b2ce68ef12c7$var$Status.Unknown:
                        return new $3905b2ce68ef12c7$export$137ec66182ed30ea(`Token "${token}" was not found.`);
                    case $3905b2ce68ef12c7$var$Status.Progress:
                        if (onProgress) {
                            if (response.total === 'unknown') onProgress({
                                isComputable: false
                            });
                            else onProgress({
                                isComputable: true,
                                value: response.done / response.total
                            });
                        }
                        return false;
                    case $3905b2ce68ef12c7$var$Status.Success:
                        if (onProgress) onProgress({
                            isComputable: true,
                            value: response.done / response.total
                        });
                        return response;
                    default:
                        throw new Error('Unknown status');
                }
            }),
        signal: signal
    });
}
const $3905b2ce68ef12c7$var$pushStrategy = ({ token: token, pusherKey: pusherKey, signal: signal, onProgress: onProgress })=>new Promise((resolve, reject)=>{
        const pusher = $3905b2ce68ef12c7$var$getPusher(pusherKey);
        const unsubErrorHandler = pusher.onError(reject);
        const destroy = ()=>{
            unsubErrorHandler();
            pusher.unsubscribe(token);
        };
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            destroy();
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db('pusher cancelled'));
        });
        pusher.subscribe(token, (result)=>{
            switch(result.status){
                case $3905b2ce68ef12c7$var$Status.Progress:
                    if (onProgress) {
                        if (result.total === 'unknown') onProgress({
                            isComputable: false
                        });
                        else onProgress({
                            isComputable: true,
                            value: result.done / result.total
                        });
                    }
                    break;
                case $3905b2ce68ef12c7$var$Status.Success:
                    destroy();
                    if (onProgress) onProgress({
                        isComputable: true,
                        value: result.done / result.total
                    });
                    resolve(result);
                    break;
                case $3905b2ce68ef12c7$var$Status.Error:
                    destroy();
                    reject(new $3905b2ce68ef12c7$export$137ec66182ed30ea(result.msg, result.error_code));
            }
        });
    });
const $3905b2ce68ef12c7$export$f5b9f3f82b877f1f = (sourceUrl, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, baseCDN: baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, pusherKey: pusherKey = $3905b2ce68ef12c7$var$defaultSettings.pusherKey, metadata: metadata })=>Promise.resolve($3905b2ce68ef12c7$var$preconnect(pusherKey)).then(()=>$3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, {
            publicKey: publicKey,
            fileName: fileName,
            baseURL: baseURL,
            checkForUrlDuplicates: checkForUrlDuplicates,
            saveUrlForRecurrentUploads: saveUrlForRecurrentUploads,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            metadata: metadata
        })).catch((error)=>{
        const pusher = $3905b2ce68ef12c7$var$getPusher(pusherKey);
        pusher?.disconnect();
        return Promise.reject(error);
    }).then((urlResponse)=>{
        if (urlResponse.type === $3905b2ce68ef12c7$var$TypeEnum.FileInfo) return urlResponse;
        else return $3905b2ce68ef12c7$var$race([
            ({ signal: signal })=>$3905b2ce68ef12c7$var$pollStrategy({
                    token: urlResponse.token,
                    publicKey: publicKey,
                    baseURL: baseURL,
                    integration: integration,
                    userAgent: userAgent,
                    retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                    onProgress: onProgress,
                    signal: signal
                }),
            ({ signal: signal })=>$3905b2ce68ef12c7$var$pushStrategy({
                    token: urlResponse.token,
                    pusherKey: pusherKey,
                    signal: signal,
                    onProgress: onProgress
                })
        ], {
            signal: signal
        });
    }).then((result)=>{
        if (result instanceof $3905b2ce68ef12c7$export$137ec66182ed30ea) throw result;
        return result;
    }).then((result)=>$3905b2ce68ef12c7$export$8d1698d1c44a6cfa(result.uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            onProgress: onProgress,
            signal: signal
        })).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
const $3905b2ce68ef12c7$var$memo = new WeakMap();
const $3905b2ce68ef12c7$var$getBlobFromReactNativeAsset = async (asset)=>{
    if ($3905b2ce68ef12c7$var$memo.has(asset)) return $3905b2ce68ef12c7$var$memo.get(asset);
    const blob = await fetch(asset.uri).then((res)=>res.blob());
    $3905b2ce68ef12c7$var$memo.set(asset, blob);
    return blob;
};
const $3905b2ce68ef12c7$var$getFileSize = async (file)=>{
    if ($3905b2ce68ef12c7$var$isFile(file) || $3905b2ce68ef12c7$var$isBlob(file)) return file.size;
    if ($3905b2ce68ef12c7$var$isReactNativeAsset(file)) {
        const blob = await $3905b2ce68ef12c7$var$getBlobFromReactNativeAsset(file);
        return blob.size;
    }
    throw new Error(`Unknown file type. Cannot determine file size.`);
};
/** Check if FileData is multipart data. */ const $3905b2ce68ef12c7$var$isMultipart = (fileSize, multipartMinFileSize = $3905b2ce68ef12c7$var$defaultSettings.multipartMinFileSize)=>{
    return fileSize >= multipartMinFileSize;
};
/** Uuid type guard. */ const $3905b2ce68ef12c7$var$isUuid = (data)=>{
    const UUID_REGEX = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}';
    const regExp = new RegExp(UUID_REGEX);
    return !$3905b2ce68ef12c7$var$isFileData(data) && regExp.test(data);
};
/**
 * Url type guard.
 *
 * @param {SupportedFileInput | Url | Uuid} data
 */ const $3905b2ce68ef12c7$var$isUrl = (data)=>{
    const URL_REGEX = '^(?:\\w+:)?\\/\\/([^\\s\\.]+\\.\\S{2}|localhost[\\:?\\d]*)\\S*$';
    const regExp = new RegExp(URL_REGEX);
    return !$3905b2ce68ef12c7$var$isFileData(data) && regExp.test(data);
};
const $3905b2ce68ef12c7$var$runWithConcurrency = (concurrency, tasks)=>{
    return new Promise((resolve, reject)=>{
        const results = [];
        let rejected = false;
        let settled = tasks.length;
        const forRun = [
            ...tasks
        ];
        const run = ()=>{
            const index = tasks.length - forRun.length;
            const next = forRun.shift();
            if (next) next().then((result)=>{
                if (rejected) return;
                results[index] = result;
                settled -= 1;
                if (settled) run();
                else resolve(results);
            }).catch((error)=>{
                rejected = true;
                reject(error);
            });
        };
        for(let i = 0; i < concurrency; i++)run();
    });
};
const $3905b2ce68ef12c7$var$sliceChunk = (file, index, fileSize, chunkSize)=>{
    const start = chunkSize * index;
    const end = Math.min(start + chunkSize, fileSize);
    return file.slice(start, end);
};
const $3905b2ce68ef12c7$var$prepareChunks = async (file, fileSize, chunkSize)=>{
    return (index)=>$3905b2ce68ef12c7$var$sliceChunk(file, index, fileSize, chunkSize);
};
const $3905b2ce68ef12c7$var$uploadPart = (chunk, url, { publicKey: publicKey, contentType: contentType, onProgress: onProgress, signal: signal, integration: integration, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes })=>$3905b2ce68ef12c7$export$73b98a86a54f96ed(chunk, url, {
        publicKey: publicKey,
        contentType: contentType,
        onProgress: onProgress,
        signal: signal,
        integration: integration,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
const $3905b2ce68ef12c7$export$a2810c3ec0d2473a = async (file, { publicKey: publicKey, fileName: fileName, fileSize: fileSize, baseURL: baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, maxConcurrentRequests: maxConcurrentRequests = $3905b2ce68ef12c7$var$defaultSettings.maxConcurrentRequests, baseCDN: baseCDN, metadata: metadata })=>{
    const size = fileSize ?? await $3905b2ce68ef12c7$var$getFileSize(file);
    let progressValues;
    const createProgressHandler = (totalChunks, chunkIdx)=>{
        if (!onProgress) return;
        if (!progressValues) progressValues = Array(totalChunks).fill(0);
        const sum = (values)=>values.reduce((sum, next)=>sum + next, 0);
        return (info)=>{
            if (!info.isComputable) return;
            progressValues[chunkIdx] = info.value;
            onProgress({
                isComputable: true,
                value: sum(progressValues) / totalChunks
            });
        };
    };
    contentType ||= $3905b2ce68ef12c7$var$getContentType(file);
    return $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, {
        publicKey: publicKey,
        contentType: contentType,
        fileName: fileName || $3905b2ce68ef12c7$var$getFileName(file),
        baseURL: baseURL,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        metadata: metadata,
        multipartChunkSize: multipartChunkSize
    }).then(async ({ uuid: uuid, parts: parts })=>{
        const getChunk = await $3905b2ce68ef12c7$var$prepareChunks(file, size, multipartChunkSize);
        return Promise.all([
            uuid,
            $3905b2ce68ef12c7$var$runWithConcurrency(maxConcurrentRequests, parts.map((url, index)=>()=>$3905b2ce68ef12c7$var$uploadPart(getChunk(index), url, {
                        publicKey: publicKey,
                        contentType: contentType,
                        onProgress: createProgressHandler(parts.length, index),
                        signal: signal,
                        integration: integration,
                        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
                    })))
        ]);
    }).then(([uuid])=>$3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
        })).then((fileInfo)=>{
        if (fileInfo.isReady) return fileInfo;
        else return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(fileInfo.uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            onProgress: onProgress,
            signal: signal
        });
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
};
/** Uploads file from provided data. */ async function $3905b2ce68ef12c7$export$a5575dbeeffdad98(data, { publicKey: publicKey, fileName: fileName, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartMinFileSize: multipartMinFileSize, multipartChunkSize: multipartChunkSize, maxConcurrentRequests: maxConcurrentRequests, baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, pusherKey: pusherKey, metadata: metadata }) {
    if ($3905b2ce68ef12c7$var$isFileData(data)) {
        const fileSize = await $3905b2ce68ef12c7$var$getFileSize(data);
        if ($3905b2ce68ef12c7$var$isMultipart(fileSize, multipartMinFileSize)) return $3905b2ce68ef12c7$export$a2810c3ec0d2473a(data, {
            publicKey: publicKey,
            contentType: contentType,
            multipartChunkSize: multipartChunkSize,
            fileSize: fileSize,
            fileName: fileName,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: onProgress,
            source: source,
            integration: integration,
            userAgent: userAgent,
            maxConcurrentRequests: maxConcurrentRequests,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            baseCDN: baseCDN,
            metadata: metadata
        });
        return $3905b2ce68ef12c7$export$3bd9b83d6d44a7c(data, {
            publicKey: publicKey,
            fileName: fileName,
            contentType: contentType,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: onProgress,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            baseCDN: baseCDN,
            metadata: metadata
        });
    }
    if ($3905b2ce68ef12c7$var$isUrl(data)) return $3905b2ce68ef12c7$export$f5b9f3f82b877f1f(data, {
        publicKey: publicKey,
        fileName: fileName,
        baseURL: baseURL,
        baseCDN: baseCDN,
        checkForUrlDuplicates: checkForUrlDuplicates,
        saveUrlForRecurrentUploads: saveUrlForRecurrentUploads,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        pusherKey: pusherKey,
        metadata: metadata
    });
    if ($3905b2ce68ef12c7$var$isUuid(data)) return $3905b2ce68ef12c7$export$3bfa52b0ed198643(data, {
        publicKey: publicKey,
        fileName: fileName,
        baseURL: baseURL,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        baseCDN: baseCDN
    });
    throw new TypeError(`File uploading from "${data}" is not supported`);
}
class $3905b2ce68ef12c7$export$b13eb28553283718 {
    uuid;
    filesCount;
    totalSize;
    isStored;
    isImage;
    cdnUrl;
    files;
    createdAt;
    storedAt = null;
    constructor(groupInfo, { baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN } = {}){
        this.uuid = groupInfo.id;
        this.filesCount = groupInfo.filesCount;
        const groupFiles = groupInfo.files.filter(Boolean);
        this.totalSize = Object.values(groupFiles).reduce((acc, file)=>acc + file.size, 0);
        this.isStored = !!groupInfo.datetimeStored;
        this.isImage = !!Object.values(groupFiles).filter((file)=>file.isImage).length;
        this.cdnUrl = groupInfo.cdnUrl;
        this.files = groupFiles.map((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
                baseCDN: baseCDN
            }));
        this.createdAt = groupInfo.datetimeCreated;
        this.storedAt = groupInfo.datetimeStored;
    }
}
/** FileData type guard. */ const $3905b2ce68ef12c7$var$isFileDataArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isFileData(item)) return false;
    }
    return true;
};
/** Uuid type guard. */ const $3905b2ce68ef12c7$var$isUuidArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isUuid(item)) return false;
    }
    return true;
};
/** Url type guard. */ const $3905b2ce68ef12c7$var$isUrlArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isUrl(item)) return false;
    }
    return true;
};
function $3905b2ce68ef12c7$export$1116551e0a2a403c(data, { publicKey: publicKey, fileName: fileName, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, jsonpCallback: jsonpCallback }) {
    if (!$3905b2ce68ef12c7$var$isFileDataArray(data) && !$3905b2ce68ef12c7$var$isUrlArray(data) && !$3905b2ce68ef12c7$var$isUuidArray(data)) throw new TypeError(`Group uploading from "${data}" is not supported`);
    let progressValues;
    let isStillComputable = true;
    const filesCount = data.length;
    const createProgressHandler = (size, index)=>{
        if (!onProgress) return;
        if (!progressValues) progressValues = Array(size).fill(0);
        const normalize = (values)=>values.reduce((sum, next)=>sum + next) / size;
        return (info)=>{
            if (!info.isComputable || !isStillComputable) {
                isStillComputable = false;
                onProgress({
                    isComputable: false
                });
                return;
            }
            progressValues[index] = info.value;
            onProgress({
                isComputable: true,
                value: normalize(progressValues)
            });
        };
    };
    return Promise.all(data.map((file, index)=>{
        if ($3905b2ce68ef12c7$var$isFileData(file) || $3905b2ce68ef12c7$var$isUrl(file)) return $3905b2ce68ef12c7$export$a5575dbeeffdad98(file, {
            publicKey: publicKey,
            fileName: fileName,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: createProgressHandler(filesCount, index),
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            contentType: contentType,
            multipartChunkSize: multipartChunkSize,
            baseCDN: baseCDN,
            checkForUrlDuplicates: checkForUrlDuplicates,
            saveUrlForRecurrentUploads: saveUrlForRecurrentUploads
        }).then((fileInfo)=>fileInfo.uuid);
        else // Do not request file info by uuid before creating group because this isn't necessary
        return file;
    })).then((uuids)=>{
        return $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, {
            publicKey: publicKey,
            baseURL: baseURL,
            jsonpCallback: jsonpCallback,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            signal: signal,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
        }).then((groupInfo)=>new $3905b2ce68ef12c7$export$b13eb28553283718(groupInfo, {
                baseCDN: baseCDN
            })).then((group)=>{
            onProgress && onProgress({
                isComputable: true,
                value: 1
            });
            return group;
        });
    });
}
/** Populate options with settings. */ const $3905b2ce68ef12c7$var$populateOptionsWithSettings = (options, settings)=>({
        ...settings,
        ...options
    });
class $3905b2ce68ef12c7$export$4fe1226bcf692a6e {
    settings;
    constructor(settings){
        this.settings = Object.assign({}, $3905b2ce68ef12c7$var$defaultSettings, settings);
    }
    updateSettings(newSettings) {
        this.settings = Object.assign(this.settings, newSettings);
    }
    getSettings() {
        return this.settings;
    }
    base(file, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$e2253033e6e1df16(file, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    info(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    fromUrl(sourceUrl, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    fromUrlStatus(token, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$11ce33276c18fc77(token, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    group(uuids, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    groupInfo(id, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$ff32046efef5c2f5(id, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartStart(size, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartUpload(part, url, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$73b98a86a54f96ed(part, url, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartComplete(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    uploadFile(data, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$a5575dbeeffdad98(data, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    uploadFileGroup(data, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$1116551e0a2a403c(data, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    isReadyPoll(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
}
class $3905b2ce68ef12c7$export$3dc07afe418952bc {
    _concurrency = 1;
    _pending = [];
    _running = 0;
    _resolvers = new Map();
    _rejectors = new Map();
    constructor(concurrency){
        this._concurrency = concurrency;
    }
    _run() {
        const tasksLeft = this._concurrency - this._running;
        for(let i = 0; i < tasksLeft; i++){
            const task = this._pending.shift();
            if (!task) return;
            const resolver = this._resolvers.get(task);
            const rejector = this._rejectors.get(task);
            if (!resolver || !rejector) throw new Error('Unexpected behavior: resolver or rejector is undefined');
            this._running += 1;
            task().finally(()=>{
                this._resolvers.delete(task);
                this._rejectors.delete(task);
                this._running -= 1;
                this._run();
            }).then((value)=>resolver(value)).catch((error)=>rejector(error));
        }
    }
    add(task) {
        return new Promise((resolve, reject)=>{
            this._resolvers.set(task, resolve);
            this._rejectors.set(task, reject);
            this._pending.push(task);
            this._run();
        });
    }
    get pending() {
        return this._pending.length;
    }
    get running() {
        return this._running;
    }
    set concurrency(value) {
        this._concurrency = value;
        this._run();
    }
    get concurrency() {
        return this._concurrency;
    }
}
/* Low-Level API */ /** @deprecated Please use NetworkError instead. */ const $3905b2ce68ef12c7$export$4bec6bfd2c2d47c0 = $3905b2ce68ef12c7$export$bae979e68e4dc802;
/** @deprecated Please use UploadError instead. */ const $3905b2ce68ef12c7$export$2a2eb4af8e8eb7d1 = $3905b2ce68ef12c7$export$137ec66182ed30ea;


const $9a2b059e07de0fba$export$769f81ea46f1d = ()=>({
        /** @type {Set<import('./Block').Block>} */ '*blocksRegistry': new Set(),
        /** @type {import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter | null} */ '*eventEmitter': null
    });
const $9a2b059e07de0fba$export$b6eaf5cda4248fe4 = (fnCtx)=>({
        ...$9a2b059e07de0fba$export$769f81ea46f1d(),
        '*currentActivity': '',
        '*currentActivityParams': {},
        '*history': [],
        '*historyBack': null,
        '*closeModal': ()=>{
            fnCtx.set$({
                '*modalActive': false,
                '*currentActivity': ''
            });
        }
    });
const $9a2b059e07de0fba$export$e6278a3220543f46 = (fnCtx)=>({
        ...$9a2b059e07de0fba$export$b6eaf5cda4248fe4(fnCtx),
        '*commonProgress': 0,
        '*uploadList': [],
        '*focusedEntry': null,
        '*uploadMetadata': null,
        '*uploadQueue': new (0, $3905b2ce68ef12c7$export$3dc07afe418952bc)(1),
        '*uploadCollection': null,
        /** @type {ReturnType<import('../utils/buildOutputError.js').buildCollectionFileError>[]} */ '*collectionErrors': [],
        /** @type {import('../types').OutputCollectionState | null} */ '*collectionState': null,
        /** @type {import('@uploadcare/upload-client').UploadcareGroup | null} */ '*groupInfo': null,
        /** @type {Set<string>} */ '*uploadTrigger': new Set()
    });


/**
 * @template {import('./Block.js').Block} T
 * @param {DocumentFragment} fr
 * @param {T} fnCtx
 */ function $8737b355c26101cb$export$8d48d87b0c41c5e0(fr, fnCtx) {
    [
        ...fr.querySelectorAll('[l10n]')
    ].forEach((el)=>{
        let key = el.getAttribute('l10n');
        let elProp = 'textContent';
        if (key.includes(':')) {
            let arr = key.split(':');
            elProp = arr[0];
            key = arr[1];
        }
        let ctxKey = 'l10n:' + key;
        // @ts-ignore
        fnCtx.__l10nKeys.push(ctxKey);
        fnCtx.add(ctxKey, key);
        fnCtx.sub(ctxKey, (val)=>{
            el[elProp] = fnCtx.l10n(val);
        });
        el.removeAttribute('l10n');
    });
}


// @ts-check
/**
 * @template {keyof import('../types').ConfigType} T
 * @param {T} key
 * @returns {`*cfg/${T}`}
 */ const $1afab31126d79360$export$16930f9e982fa181 = (key)=>`*cfg/${key}`;


const $e746289f30c91f4f$var$TAG_PREFIX = 'lr-';
class $e746289f30c91f4f$export$d96a8827a60d6b69 extends (0, $7868cd5b229e5c15$export$55ae5207ce896a6b) {
    /** @type {string | null} */ static StateConsumerScope = null;
    static className = '';
    requireCtxName = false;
    allowCustomTemplate = true;
    /** @type {import('./ActivityBlock.js').ActivityType} */ activityType = null;
    init$ = (0, $9a2b059e07de0fba$export$769f81ea46f1d)();
    /**
   * @param {String} str
   * @param {{ [key: string]: string | number }} variables
   * @returns {String}
   */ l10n(str, variables = {}) {
        if (!str) return '';
        let template = this.getCssData('--l10n-' + str, true) || str;
        let pluralObjects = (0, $8fc43c3fd04f0fc3$export$eabb0be5d19ba097)(template);
        for (let pluralObject of pluralObjects)variables[pluralObject.variable] = this.pluralize(pluralObject.pluralKey, Number(variables[pluralObject.countVariable]));
        let result = (0, $8fc43c3fd04f0fc3$export$34afab4d3a450b60)(template, variables);
        return result;
    }
    /**
   * @param {string} key
   * @param {number} count
   * @returns {string}
   */ pluralize(key, count) {
        const locale = this.l10n('locale-name') || 'en-US';
        const pluralForm = (0, $63338ce7a65902fa$export$9f3f0d2d02951501)(locale, count);
        return this.l10n(`${key}__${pluralForm}`);
    }
    constructor(){
        super();
        // @ts-ignore TODO: fix this
        this.addTemplateProcessor((0, $8737b355c26101cb$export$8d48d87b0c41c5e0));
        // TODO: inspect template on lr-* elements
        // this.addTemplateProcessor((fr) => {
        //   [...fr.querySelectorAll('*')].forEach((el) => {
        //     if (el.tagName.includes('LR-')) {
        //       let tag = el.tagName.toLowerCase();
        //       console.log(window.customElements.get(tag)?.name);
        //     }
        //   });
        // });
        /**
     * @private
     * @type {String[]}
     */ this.__l10nKeys = [];
    }
    /**
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[0]} type
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[1]} [payload]
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[2]} [options]
   */ emit(type, payload, options) {
        /** @type {import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter} */ const eventEmitter = this.has('*eventEmitter') && this.$['*eventEmitter'];
        if (!eventEmitter) return;
        eventEmitter.emit(type, payload, options);
    }
    /**
   * @param {String} localPropKey
   * @param {String} l10nKey
   */ applyL10nKey(localPropKey, l10nKey) {
        let prop = 'l10n:' + localPropKey;
        this.$[prop] = /** @type {any} */ l10nKey;
        this.__l10nKeys.push(localPropKey);
    }
    /**
   * @param {(block: Block) => boolean} callback
   * @returns {Boolean}
   */ hasBlockInCtx(callback) {
        // @ts-ignore TODO: fix this
        /** @type {Set} */ let blocksRegistry = this.$['*blocksRegistry'];
        for (let block of blocksRegistry){
            if (callback(block)) return true;
        }
        return false;
    }
    /**
   * @param {String} prop
   * @param {any} newVal
   */ setOrAddState(prop, newVal) {
        this.add$({
            [prop]: newVal
        }, true);
    }
    /** @param {import('./ActivityBlock.js').ActivityType} activityType */ setActivity(activityType) {
        if (this.hasBlockInCtx((b)=>b.activityType === activityType)) {
            this.$['*currentActivity'] = activityType;
            return;
        }
        console.warn(`Activity type "${activityType}" not found in the context`);
    }
    connectedCallback() {
        const className = /** @type {typeof Block} */ this.constructor.className;
        if (className) this.classList.toggle(`${$e746289f30c91f4f$var$TAG_PREFIX}${className}`, true);
        if (this.hasAttribute('retpl')) {
            // @ts-ignore TODO: fix this
            this.constructor['template'] = null;
            this.processInnerHtml = true;
        }
        if (this.requireCtxName) (0, $b621c7eab37d9df5$export$bf3e2014f0f6687e)({
            element: this,
            attribute: 'ctx-name',
            onSuccess: ()=>{
                // async wait for ctx-name attribute to be set, needed for Angular because it sets attributes after mount
                // TODO: should be moved to the symbiote core
                super.connectedCallback();
            },
            onTimeout: ()=>{
                console.error('Attribute `ctx-name` is required and it is not set.');
            }
        });
        else super.connectedCallback();
        (0, $74a2a35d58e25a3d$export$164c1ecdf58fbaaa).registerClient(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $74a2a35d58e25a3d$export$164c1ecdf58fbaaa).unregisterClient(this);
    }
    initCallback() {
        let blocksRegistry = this.$['*blocksRegistry'];
        blocksRegistry.add(this);
        if (!this.$['*eventEmitter']) this.$['*eventEmitter'] = new (0, $a25d4bde048879ae$export$4fae95256245c8c0)(this.debugPrint.bind(this));
    }
    destroyCallback() {
        /** @type {Set<Block>} */ let blocksRegistry = this.$['*blocksRegistry'];
        blocksRegistry.delete(this);
        // Destroy local context
        // TODO: this should be done inside symbiote
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this);
        if (blocksRegistry.size === 0) setTimeout(()=>{
            // Destroy global context after all blocks are destroyed and all callbacks are run
            this.destroyCtxCallback();
        }, 0);
    }
    /**
   * Called when the last block is removed from the context. Note that inheritors must run their callback before that.
   *
   * @protected
   */ destroyCtxCallback() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.ctxName);
    }
    /**
   * @param {Number} bytes
   * @param {Number} [decimals]
   */ fileSizeFmt(bytes, decimals = 2) {
        let units = [
            'B',
            'KB',
            'MB',
            'GB',
            'TB'
        ];
        /**
     * @param {String} str
     * @returns {String}
     */ let getUnit = (str)=>{
            return this.getCssData('--l10n-unit-' + str.toLowerCase(), true) || str;
        };
        if (bytes === 0) return `0 ${getUnit(units[0])}`;
        let k = 1024;
        let dm = decimals < 0 ? 0 : decimals;
        let i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + getUnit(units[i]);
    }
    /**
   * @param {String} url
   * @returns {String}
   */ proxyUrl(url) {
        let previewProxy = this.cfg.secureDeliveryProxy;
        if (!previewProxy) return url;
        return (0, $8fc43c3fd04f0fc3$export$34afab4d3a450b60)(previewProxy, {
            previewUrl: url
        }, {
            transform: (value)=>window.encodeURIComponent(value)
        });
    }
    /**
   * @param {String} prop
   * @protected
   */ parseCfgProp(prop) {
        return {
            ctx: this.nodeCtx,
            name: prop.replace('*', '')
        };
    }
    /** @returns {import('../types').ConfigType} } */ get cfg() {
        if (!this.__cfgProxy) {
            let o = Object.create(null);
            /** @private */ this.__cfgProxy = new Proxy(o, {
                set: (obj, key, value)=>{
                    if (typeof key !== 'string') return false;
                    const sharedKey = (0, $1afab31126d79360$export$16930f9e982fa181)(/** @type {keyof import('../types').ConfigType} */ key);
                    this.$[sharedKey] = value;
                    return true;
                },
                /**
         * @param {never} obj
         * @param {keyof import('../types').ConfigType} key
         */ get: (obj, key)=>{
                    const sharedKey = (0, $1afab31126d79360$export$16930f9e982fa181)(key);
                    const parsed = this.parseCfgProp(sharedKey);
                    if (parsed.ctx.has(parsed.name)) return parsed.ctx.read(parsed.name);
                    else {
                        (0, $6a075e397d8438c7$export$5b28268982f175ba)('Using CSS variables for configuration is deprecated. Please use `lr-config` instead. See migration guide: https://uploadcare.com/docs/file-uploader/migration-to-0.25.0/');
                        return this.getCssData(`--cfg-${(0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key)}`);
                    }
                }
            });
        }
        return this.__cfgProxy;
    }
    /**
   * @template {keyof import('../types').ConfigType} T
   * @param {T} key
   * @param {(value: import('../types').ConfigType[T]) => void} callback
   */ subConfigValue(key, callback) {
        const parsed = this.parseCfgProp((0, $1afab31126d79360$export$16930f9e982fa181)(key));
        if (parsed.ctx.has(parsed.name)) this.sub((0, $1afab31126d79360$export$16930f9e982fa181)(key), callback);
        else {
            this.bindCssData(`--cfg-${(0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key)}`);
            this.sub(`--cfg-${(0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key)}`, callback);
        }
    }
    /** @deprecated */ updateCtxCssData = ()=>{
        (0, $6a075e397d8438c7$export$5b28268982f175ba)('Using CSS variables for configuration is deprecated. Please use `lr-config` instead. See migration guide: https://uploadcare.com/docs/file-uploader/migration-to-0.25.0/');
        /** @type {Set<Block>} */ let blocks = this.$['*blocksRegistry'];
        for (let block of blocks)if (block.isConnected) block.updateCssData();
    };
    /** @param {unknown[]} args */ debugPrint(...args) {
        if (!this.cfg.debug) return;
        let consoleArgs = args;
        if (typeof args?.[0] === 'function') {
            const resolver = args[0];
            consoleArgs = resolver();
        }
        console.log(`[${this.debugCtxName}]`, ...consoleArgs);
    }
    get debugCtxName() {
        return this.ctxName;
    }
    /** @param {String} [name] */ static reg(name) {
        if (!name) {
            super.reg();
            return;
        }
        super.reg(name.startsWith($e746289f30c91f4f$var$TAG_PREFIX) ? name : $e746289f30c91f4f$var$TAG_PREFIX + name);
    }
}


// @ts-check




const $7cc70e522976ff2d$var$ACTIVE_ATTR = 'active';
const $7cc70e522976ff2d$var$ACTIVE_PROP = '___ACTIVITY_IS_ACTIVE___';
class $7cc70e522976ff2d$export$5e3ae1ab277e5747 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    historyTracked = false;
    init$ = (0, $9a2b059e07de0fba$export$b6eaf5cda4248fe4)(this);
    _debouncedHistoryFlush = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._historyFlush.bind(this), 10);
    /** @private */ _deactivate() {
        // @ts-ignore TODO: fix this
        let actDesc = $7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry[this.activityKey];
        this[$7cc70e522976ff2d$var$ACTIVE_PROP] = false;
        this.removeAttribute($7cc70e522976ff2d$var$ACTIVE_ATTR);
        actDesc?.deactivateCallback?.();
    }
    /** @private */ _activate() {
        // @ts-ignore TODO: fix this
        let actDesc = $7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry[this.activityKey];
        this.$['*historyBack'] = this.historyBack.bind(this);
        /** @private */ this[$7cc70e522976ff2d$var$ACTIVE_PROP] = true;
        this.setAttribute($7cc70e522976ff2d$var$ACTIVE_ATTR, '');
        actDesc?.activateCallback?.();
        this._debouncedHistoryFlush();
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).ACTIVITY_CHANGE, {
            activity: this.activityType
        });
    }
    initCallback() {
        super.initCallback();
        if (this.hasAttribute('current-activity')) this.sub('*currentActivity', (/** @type {String} */ val)=>{
            this.setAttribute('current-activity', val);
        });
        // TODO: rename activityType to activityId
        if (this.activityType) {
            if (!this.hasAttribute('activity')) this.setAttribute('activity', this.activityType);
            this.sub('*currentActivity', (/** @type {String} */ val)=>{
                if (this.activityType !== val && this[$7cc70e522976ff2d$var$ACTIVE_PROP]) this._deactivate();
                else if (this.activityType === val && !this[$7cc70e522976ff2d$var$ACTIVE_PROP]) this._activate();
                if (!val) this.$['*history'] = [];
            });
            if (this.has('*modalActive')) this.sub('*modalActive', (modalActive)=>{
                if (!modalActive && this.activityType === this.$['*currentActivity']) this.$['*currentActivity'] = null;
            });
        }
    }
    /** @private */ _historyFlush() {
        let history = this.$['*history'];
        if (history) {
            if (history.length > 10) history = history.slice(history.length - 11, history.length - 1);
            if (this.historyTracked && history[history.length - 1] !== this.activityType) history.push(this.activityType);
            this.$['*history'] = history;
        }
    }
    /** @private */ _isActivityRegistered() {
        // @ts-ignore TODO: fix this
        return this.activityType && !!$7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry[this.activityKey];
    }
    /**
   * @private
   * @type {{ String: { activateCallback: Function; deactivateCallback: Function } }}
   */ static _activityRegistry = Object.create(null);
    get isActivityActive() {
        return this[$7cc70e522976ff2d$var$ACTIVE_PROP];
    }
    get couldOpenActivity() {
        return true;
    }
    /**
   * TODO: remove name argument
   *
   * @param {String} name
   * @param {Object} [options]
   * @param {() => void} [options.onActivate]
   * @param {() => void} [options.onDeactivate]
   */ registerActivity(name, options = {}) {
        const { onActivate: onActivate, onDeactivate: onDeactivate } = options;
        if (!$7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry) $7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry = Object.create(null);
        // @ts-ignore TODO: fix this
        $7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry[this.activityKey] = {
            activateCallback: onActivate,
            deactivateCallback: onDeactivate
        };
    }
    unregisterActivity() {
        if (this.isActivityActive) this._deactivate();
        // @ts-ignore TODO: fix this
        $7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry[this.activityKey] = undefined;
    }
    destroyCallback() {
        super.destroyCallback();
        this._isActivityRegistered() && this.unregisterActivity();
        if (Object.keys($7cc70e522976ff2d$export$5e3ae1ab277e5747._activityRegistry).length === 0) // TODO: we should track activities more precise and reset current activity only if there is no such registered activity
        this.$['*currentActivity'] = null;
    }
    get activityKey() {
        return this.ctxName + this.activityType;
    }
    get activityParams() {
        return this.$['*currentActivityParams'];
    }
    /** @type {String} */ get initActivity() {
        return this.getCssData('--cfg-init-activity');
    }
    /** @type {String} */ get doneActivity() {
        return this.getCssData('--cfg-done-activity');
    }
    historyBack() {
        /** @type {String[]} */ let history = this.$['*history'];
        if (history) {
            let nextActivity = history.pop();
            while(nextActivity === this.activityType)nextActivity = history.pop();
            let couldOpenActivity = !!nextActivity;
            if (nextActivity) {
                /** @type {Set<ActivityBlock>} */ let blocksRegistry = this.$['*blocksRegistry'];
                const nextActivityBlock = [
                    ...blocksRegistry
                ].find((block)=>block.activityType === nextActivity);
                couldOpenActivity = nextActivityBlock?.couldOpenActivity ?? false;
            }
            nextActivity = couldOpenActivity ? nextActivity : undefined;
            this.$['*currentActivity'] = nextActivity;
            this.$['*history'] = history;
            if (!nextActivity) this.setOrAddState('*modalActive', false);
        }
    }
}
$7cc70e522976ff2d$export$5e3ae1ab277e5747.activities = Object.freeze({
    START_FROM: 'start-from',
    CAMERA: 'camera',
    DRAW: 'draw',
    UPLOAD_LIST: 'upload-list',
    URL: 'url',
    CONFIRMATION: 'confirmation',
    CLOUD_IMG_EDIT: 'cloud-image-edit',
    EXTERNAL: 'external',
    DETAILS: 'details'
}); /** @typedef {(typeof ActivityBlock)['activities'][keyof (typeof ActivityBlock)['activities']] | null} ActivityType */ 


// @ts-check



// @ts-check
const $d2bb7bf18d255144$export$79bf3aa6ff8a6a3c = 20;
const $d2bb7bf18d255144$export$b69960716b5f670f = 24;
const $d2bb7bf18d255144$export$df6c1d4a19114db4 = 34;
const $d2bb7bf18d255144$export$9fc5d1d39ca040ea = 3;
const $d2bb7bf18d255144$export$4515e32f363eb04b = $d2bb7bf18d255144$export$9fc5d1d39ca040ea / 2;
const $d2bb7bf18d255144$export$1cf2b3e7100e85af = 1;
const $d2bb7bf18d255144$export$f958e4635c8aa22c = 100 / 3;
const $d2bb7bf18d255144$export$9c132ec810e22d8a = 1;
const $d2bb7bf18d255144$export$2950b0064b6e4e77 = 24;
const $d2bb7bf18d255144$export$d00854ad80ddb8a1 = 6;


function $b5c04c21728a4369$export$54374d41e42e9676(node, attrs) {
    for(let p in attrs)node.setAttributeNS(null, p, attrs[p].toString());
}
function $b5c04c21728a4369$export$183806b242873ed9(name, attrs = {}) {
    let node = document.createElementNS('http://www.w3.org/2000/svg', name);
    $b5c04c21728a4369$export$54374d41e42e9676(node, attrs);
    return node;
}
function $b5c04c21728a4369$export$790b609df538a7dd(rect, direction, sizeMultiplier) {
    let { x: x, y: y, width: width, height: height } = rect;
    let wMul = direction.includes('w') ? 0 : 1;
    let hMul = direction.includes('n') ? 0 : 1;
    let xSide = [
        -1,
        1
    ][wMul];
    let ySide = [
        -1,
        1
    ][hMul];
    let p1 = [
        x + wMul * width + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * ySide - (0, $d2bb7bf18d255144$export$b69960716b5f670f) * sizeMultiplier * ySide
    ];
    let p2 = [
        x + wMul * width + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * ySide
    ];
    let p3 = [
        x + wMul * width - (0, $d2bb7bf18d255144$export$b69960716b5f670f) * sizeMultiplier * xSide + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * ySide
    ];
    let path = `M ${p1[0]} ${p1[1]} L ${p2[0]} ${p2[1]} L ${p3[0]} ${p3[1]}`;
    let center = p2;
    return {
        d: path,
        center: center
    };
}
function $b5c04c21728a4369$export$7b179e18f4ee631a(rect, direction, sizeMultiplier) {
    let { x: x, y: y, width: width, height: height } = rect;
    let wMul = [
        'n',
        's'
    ].includes(direction) ? 0.5 : ({
        w: 0,
        e: 1
    })[/** @type {Extract<import('./types.js').Direction, 'w' | 'e'>} */ direction];
    let hMul = [
        'w',
        'e'
    ].includes(direction) ? 0.5 : ({
        n: 0,
        s: 1
    })[/** @type {Extract<import('./types.js').Direction, 'n' | 's'>} */ direction];
    let xSide = [
        -1,
        1
    ][wMul];
    let ySide = [
        -1,
        1
    ][hMul];
    let p1, p2;
    if ([
        'n',
        's'
    ].includes(direction)) {
        p1 = [
            x + wMul * width - (0, $d2bb7bf18d255144$export$df6c1d4a19114db4) * sizeMultiplier / 2,
            y + hMul * height + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * ySide
        ];
        p2 = [
            x + wMul * width + (0, $d2bb7bf18d255144$export$df6c1d4a19114db4) * sizeMultiplier / 2,
            y + hMul * height + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * ySide
        ];
    } else {
        p1 = [
            x + wMul * width + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * xSide,
            y + hMul * height - (0, $d2bb7bf18d255144$export$df6c1d4a19114db4) * sizeMultiplier / 2
        ];
        p2 = [
            x + wMul * width + (0, $d2bb7bf18d255144$export$4515e32f363eb04b) * xSide,
            y + hMul * height + (0, $d2bb7bf18d255144$export$df6c1d4a19114db4) * sizeMultiplier / 2
        ];
    }
    let path = `M ${p1[0]} ${p1[1]} L ${p2[0]} ${p2[1]}`;
    let center = [
        p2[0] - (p2[0] - p1[0]) / 2,
        p2[1] - (p2[1] - p1[1]) / 2
    ];
    return {
        d: path,
        center: center
    };
}
function $b5c04c21728a4369$export$96239d218eb7ece8(direction) {
    if (direction === '') return 'move';
    if ([
        'e',
        'w'
    ].includes(direction)) return 'ew-resize';
    if ([
        'n',
        's'
    ].includes(direction)) return 'ns-resize';
    if ([
        'nw',
        'se'
    ].includes(direction)) return 'nwse-resize';
    return 'nesw-resize';
}
function $b5c04c21728a4369$export$88498a0045263460({ rect: rect, delta: [dx, dy], imageBox: imageBox }) {
    return $b5c04c21728a4369$export$25fd15ab86a7b28b({
        ...rect,
        x: rect.x + dx,
        y: rect.y + dy
    }, imageBox);
}
function $b5c04c21728a4369$export$25fd15ab86a7b28b(rect1, rect2) {
    let { x: x } = rect1;
    let { y: y } = rect1;
    if (rect1.x < rect2.x) x = rect2.x;
    else if (rect1.x + rect1.width > rect2.x + rect2.width) x = rect2.x + rect2.width - rect1.width;
    if (rect1.y < rect2.y) y = rect2.y;
    else if (rect1.y + rect1.height > rect2.y + rect2.height) y = rect2.y + rect2.height - rect1.height;
    return {
        ...rect1,
        x: x,
        y: y
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeNorth({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [, dy] = delta;
    let { y: y, width: width, height: height } = rect;
    y += dy;
    height -= dy;
    if (aspectRatio) width = height * aspectRatio;
    let x = rect.x + rect.width / 2 - width / 2;
    if (y <= imageBox.y) {
        y = imageBox.y;
        height = rect.y + rect.height - y;
        if (aspectRatio) {
            width = height * aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
    }
    if (x <= imageBox.x) {
        x = imageBox.x;
        y = rect.y + rect.height - height;
    }
    if (x + width >= imageBox.x + imageBox.width) {
        x = Math.max(imageBox.x, imageBox.x + imageBox.width - width);
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height - height;
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) {
            width = height * aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
        y = rect.y + rect.height - height;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) {
            height = width / aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [dx] = delta;
    let { x: x, width: width, height: height } = rect;
    x += dx;
    width -= dx;
    if (aspectRatio) height = width / aspectRatio;
    let y = rect.y + rect.height / 2 - height / 2;
    if (x <= imageBox.x) {
        x = imageBox.x;
        width = rect.x + rect.width - x;
        if (aspectRatio) {
            height = width / aspectRatio;
            y = rect.y + rect.height / 2 - height / 2;
        }
    }
    if (y <= imageBox.y) {
        y = imageBox.y;
        x = rect.x + rect.width - width;
    }
    if (y + height >= imageBox.y + imageBox.height) {
        y = Math.max(imageBox.y, imageBox.y + imageBox.height - height);
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
        x = rect.x + rect.width - width;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
        x = rect.x + rect.width - width;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeSouth({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [, dy] = delta;
    let { y: y, width: width, height: height } = rect;
    height += dy;
    if (aspectRatio) width = height * aspectRatio;
    let x = rect.x + rect.width / 2 - width / 2;
    if (y + height >= imageBox.y + imageBox.height) {
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    if (x <= imageBox.x) {
        x = imageBox.x;
        y = rect.y;
    }
    if (x + width >= imageBox.x + imageBox.width) {
        x = Math.max(imageBox.x, imageBox.x + imageBox.width - width);
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y;
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [dx] = delta;
    let { x: x, width: width, height: height } = rect;
    width += dx;
    if (aspectRatio) height = width / aspectRatio;
    let y = rect.y + rect.height / 2 - height / 2;
    if (x + width >= imageBox.x + imageBox.width) {
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    if (y <= imageBox.y) {
        y = imageBox.y;
        x = rect.x;
    }
    if (y + height >= imageBox.y + imageBox.height) {
        y = Math.max(imageBox.y, imageBox.y + imageBox.height - height);
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x;
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeNorthWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + dx < imageBox.x) dx = imageBox.x - x;
    if (y + dy < imageBox.y) dy = imageBox.y - y;
    x += dx;
    width -= dx;
    y += dy;
    height -= dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        y -= dy;
        if (y <= imageBox.y) {
            height = height - (imageBox.y - y);
            width = height * aspectRatio;
            x = rect.x + rect.width - width;
            y = imageBox.y;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width = width + dx;
        x -= dx;
        if (x <= imageBox.x) {
            width = width - (imageBox.x - x);
            height = width / aspectRatio;
            x = imageBox.x;
            y = rect.y + rect.height - height;
        }
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
        y = rect.y + rect.height - height;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width - width;
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeNorthEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + width + dx > imageBox.x + imageBox.width) dx = imageBox.x + imageBox.width - x - width;
    if (y + dy < imageBox.y) dy = imageBox.y - y;
    width += dx;
    y += dy;
    height -= dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        y -= dy;
        if (y <= imageBox.y) {
            height = height - (imageBox.y - y);
            width = height * aspectRatio;
            x = rect.x;
            y = imageBox.y;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        if (x + width >= imageBox.x + imageBox.width) {
            width = imageBox.x + imageBox.width - x;
            height = width / aspectRatio;
            x = imageBox.x + imageBox.width - width;
            y = rect.y + rect.height - height;
        }
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height - height;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeSouthWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + dx < imageBox.x) dx = imageBox.x - x;
    if (y + height + dy > imageBox.y + imageBox.height) dy = imageBox.y + imageBox.height - y - height;
    x += dx;
    width -= dx;
    height += dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        if (y + height >= imageBox.y + imageBox.height) {
            height = imageBox.y + imageBox.height - y;
            width = height * aspectRatio;
            x = rect.x + rect.width - width;
            y = imageBox.y + imageBox.height - height;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        x -= dx;
        if (x <= imageBox.x) {
            width = width - (imageBox.x - x);
            height = width / aspectRatio;
            x = imageBox.x;
            y = rect.y;
        }
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width - width;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $b5c04c21728a4369$var$resizeSouthEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + width + dx > imageBox.x + imageBox.width) dx = imageBox.x + imageBox.width - x - width;
    if (y + height + dy > imageBox.y + imageBox.height) dy = imageBox.y + imageBox.height - y - height;
    width += dx;
    height += dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        if (y + height >= imageBox.y + imageBox.height) {
            height = imageBox.y + imageBox.height - y;
            width = height * aspectRatio;
            x = rect.x;
            y = imageBox.y + imageBox.height - height;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        if (x + width >= imageBox.x + imageBox.width) {
            width = imageBox.x + imageBox.width - x;
            height = width / aspectRatio;
            x = imageBox.x + imageBox.width - width;
            y = rect.y;
        }
    }
    if (height < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        height = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
    }
    if (width < (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) {
        width = (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $b5c04c21728a4369$export$7395518b474faf76({ direction: direction, ...rest }) {
    switch(direction){
        case 'n':
            return $b5c04c21728a4369$var$resizeNorth(rest);
        case 'w':
            return $b5c04c21728a4369$var$resizeWest(rest);
        case 's':
            return $b5c04c21728a4369$var$resizeSouth(rest);
        case 'e':
            return $b5c04c21728a4369$var$resizeEast(rest);
        case 'nw':
            return $b5c04c21728a4369$var$resizeNorthWest(rest);
        case 'ne':
            return $b5c04c21728a4369$var$resizeNorthEast(rest);
        case 'sw':
            return $b5c04c21728a4369$var$resizeSouthWest(rest);
        case 'se':
            return $b5c04c21728a4369$var$resizeSouthEast(rest);
        default:
            return rest.rect;
    }
}
function $b5c04c21728a4369$export$ac4bbe5b05d4ed3f(rect, [x, y]) {
    return rect.x <= x && x <= rect.x + rect.width && rect.y <= y && y <= rect.y + rect.height;
}
function $b5c04c21728a4369$export$5b9ad582f7a393a7(rect1, rect2) {
    return rect1.x >= rect2.x && rect1.y >= rect2.y && rect1.x + rect1.width <= rect2.x + rect2.width && rect1.y + rect1.height <= rect2.y + rect2.height;
}
function $b5c04c21728a4369$export$c875bfe83ce4f5e0(rect, aspectRatio) {
    const THRESHOLD = 0.1;
    return Math.abs(rect.width / rect.height - aspectRatio) < THRESHOLD;
}
function $b5c04c21728a4369$export$9e53471bfbfdc361({ width: width, height: height }, angle) {
    let swap = angle / 90 % 2 !== 0;
    return {
        width: swap ? height : width,
        height: swap ? width : height
    };
}
function $b5c04c21728a4369$export$c770ef1d0f2175d9(width, height, aspectRatio) {
    const imageAspectRatio = width / height;
    let cropWidth, cropHeight;
    if (imageAspectRatio > aspectRatio) {
        cropWidth = Math.round(height * aspectRatio);
        cropHeight = height;
    } else {
        cropWidth = width;
        cropHeight = Math.round(width / aspectRatio);
    }
    const cropX = Math.round((width - cropWidth) / 2);
    const cropY = Math.round((height - cropHeight) / 2);
    if (cropX + cropWidth > width) cropWidth = width - cropX;
    if (cropY + cropHeight > height) cropHeight = height - cropY;
    return {
        x: cropX,
        y: cropY,
        width: cropWidth,
        height: cropHeight
    };
}
function $b5c04c21728a4369$export$166e03518104bf21(rect) {
    return {
        x: Math.round(rect.x),
        y: Math.round(rect.y),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
    };
}
function $b5c04c21728a4369$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}


// @ts-check
/** @param {import('../../../../types/exported.d.ts').ConfigType['cropPreset']} cropPreset */ const $13e12cffb6e7f0c5$export$a99f8a1d2eae458 = (cropPreset)=>{
    if (!cropPreset) return [];
    const [w, h] = cropPreset.split(':').map(Number);
    if (!Number.isFinite(w) || !Number.isFinite(h)) {
        console.error(`Invalid crop preset: ${cropPreset}`);
        return;
    }
    /** @type {import('../types.js').CropAspectRatio} */ const aspectRatio = {
        type: 'aspect-ratio',
        width: w,
        height: h
    };
    return [
        aspectRatio
    ];
};



const $b42bef79572dc8bb$export$5522e73b726d0ec8 = Object.freeze({
    LOCAL: 'local',
    DROP_AREA: 'drop-area',
    URL_TAB: 'url-tab',
    CAMERA: 'camera',
    EXTERNAL: 'external',
    API: 'js-api'
});


// @ts-check
/** @param {string} value */ const $127bf1109bfdfae3$export$ad1a3127869611f1 = (value)=>{
    if (!value) return [];
    return value.split(',').map((item)=>item.trim());
};
const $127bf1109bfdfae3$export$1494b4974e65fb4e = (value)=>{
    if (!value) return '';
    return value.join(',');
};




var $5dd66a549cd783d2$exports = {};

$parcel$export($5dd66a549cd783d2$exports, "PACKAGE_NAME", () => $5dd66a549cd783d2$export$b8b9d90f9e5bd72b);
$parcel$export($5dd66a549cd783d2$exports, "PACKAGE_VERSION", () => $5dd66a549cd783d2$export$4a03ffab3315ee34);
/** Do not edit this file manually. It's generated during build process. */ const $5dd66a549cd783d2$export$b8b9d90f9e5bd72b = 'blocks';
const $5dd66a549cd783d2$export$4a03ffab3315ee34 = '0.36.0';


function $af89a576d170a745$export$bfcf574709d3c346(options) {
    return (0, $3905b2ce68ef12c7$export$7935961ef7719cb0)({
        ...options,
        libraryName: (0, $5dd66a549cd783d2$export$b8b9d90f9e5bd72b),
        libraryVersion: (0, $5dd66a549cd783d2$export$4a03ffab3315ee34)
    });
}


/**
 * @template T
 * @param {import('../types').OutputError<T>} options
 */ const $501714746e5bd4bc$var$buildOutputError = ({ type: type, message: message, ...payload })=>({
        type: type,
        message: message,
        ...payload
    });
const $501714746e5bd4bc$export$771b0fc023f8a167 = $501714746e5bd4bc$var$buildOutputError;
const $501714746e5bd4bc$export$5839635218a3dedd = $501714746e5bd4bc$var$buildOutputError;



const $40a69650bbcf2c17$export$e882f1482b14dfeb = (operation)=>{
    if (typeof operation !== 'string' || !operation) return '';
    let str = operation.trim();
    if (str.startsWith('-/')) str = str.slice(2);
    else if (str.startsWith('/')) str = str.slice(1);
    if (str.endsWith('/')) str = str.slice(0, str.length - 1);
    return str;
};
const $40a69650bbcf2c17$export$7970c0e63fee47d7 = (...operations)=>{
    return operations.filter((op)=>typeof op === 'string' && op).map((op)=>$40a69650bbcf2c17$export$e882f1482b14dfeb(/** @type {String} */ op)).join('/-/');
};
const $40a69650bbcf2c17$export$8fb94a7da5f60007 = (...cdnOperations)=>{
    let joined = $40a69650bbcf2c17$export$7970c0e63fee47d7(...cdnOperations);
    return joined ? `-/${joined}/` : '';
};
function $40a69650bbcf2c17$export$33da1e69df17c6c(cdnUrl) {
    let url = new URL(cdnUrl);
    let noOrigin = url.pathname + url.search + url.hash;
    let urlFilenameIdx = noOrigin.lastIndexOf('http');
    let plainFilenameIdx = noOrigin.lastIndexOf('/');
    let filename = '';
    if (urlFilenameIdx >= 0) filename = noOrigin.slice(urlFilenameIdx);
    else if (plainFilenameIdx >= 0) filename = noOrigin.slice(plainFilenameIdx + 1);
    return filename;
}
function $40a69650bbcf2c17$export$fe804a22e4bdd033(cdnUrl) {
    let url = new URL(cdnUrl);
    let { pathname: pathname } = url;
    const slashIndex = pathname.indexOf('/');
    const secondSlashIndex = pathname.indexOf('/', slashIndex + 1);
    return pathname.substring(slashIndex + 1, secondSlashIndex);
}
function $40a69650bbcf2c17$export$6ae4b875b9f5125(cdnUrl) {
    let withoutFilename = $40a69650bbcf2c17$export$32a95bdaa2ece7a6(cdnUrl);
    let url = new URL(withoutFilename);
    let operationsMarker = url.pathname.indexOf('/-/');
    if (operationsMarker === -1) return [];
    let operationsStr = url.pathname.substring(operationsMarker);
    return operationsStr.split('/-/').filter(Boolean).map((operation)=>$40a69650bbcf2c17$export$e882f1482b14dfeb(operation));
}
function $40a69650bbcf2c17$export$32a95bdaa2ece7a6(cdnUrl) {
    let url = new URL(cdnUrl);
    let filename = $40a69650bbcf2c17$export$33da1e69df17c6c(cdnUrl);
    let filenamePathPart = $40a69650bbcf2c17$export$892d5a23d0d4fd7f(filename) ? $40a69650bbcf2c17$export$a6f286acd04c8890(filename).pathname : filename;
    url.pathname = url.pathname.replace(filenamePathPart, '');
    url.search = '';
    url.hash = '';
    return url.toString();
}
function $40a69650bbcf2c17$export$892d5a23d0d4fd7f(filename) {
    return filename.startsWith('http');
}
function $40a69650bbcf2c17$export$a6f286acd04c8890(fileUrl) {
    let url = new URL(fileUrl);
    return {
        pathname: url.origin + url.pathname || '',
        search: url.search || '',
        hash: url.hash || ''
    };
}
const $40a69650bbcf2c17$export$226a37372a69410c = (baseCdnUrl, cdnModifiers, filename)=>{
    let url = new URL($40a69650bbcf2c17$export$32a95bdaa2ece7a6(baseCdnUrl));
    filename = filename || $40a69650bbcf2c17$export$33da1e69df17c6c(baseCdnUrl);
    // TODO: fix double slash pathname bug (--cfg-cdn-cname: 'https://ucarecdn.com/' - trailing slash case)
    if (url.pathname.startsWith('//')) url.pathname = url.pathname.replace('//', '/');
    if ($40a69650bbcf2c17$export$892d5a23d0d4fd7f(filename)) {
        let splitted = $40a69650bbcf2c17$export$a6f286acd04c8890(filename);
        url.pathname = url.pathname + (cdnModifiers || '') + (splitted.pathname || '');
        url.search = splitted.search;
        url.hash = splitted.hash;
    } else url.pathname = url.pathname + (cdnModifiers || '') + (filename || '');
    return url.toString();
};
const $40a69650bbcf2c17$export$816ae8f9591f1ab2 = (cdnUrl, uuid)=>{
    let url = new URL(cdnUrl);
    url.pathname = uuid + '/';
    return url.toString();
};


// @ts-check
/**
 * @param {string} str
 * @returns {string[]}
 */ const $87af14daf04b29b8$export$b9ca061da17f2d30 = (str, delimiter = ',')=>{
    return str.trim().split(delimiter).map((part)=>part.trim()).filter((part)=>part.length > 0);
};


const $65197131a4ed5785$export$ac87ac3138ad3b2a = [
    'image/*',
    'image/heif',
    'image/heif-sequence',
    'image/heic',
    'image/heic-sequence',
    'image/avif',
    'image/avif-sequence',
    '.heif',
    '.heifs',
    '.heic',
    '.heics',
    '.avif',
    '.avifs'
];
const $65197131a4ed5785$export$90f2b68ae2c5fe52 = (fileTypes)=>{
    if (!fileTypes) return [];
    return fileTypes.filter((item)=>typeof item === 'string').map((str)=>(0, $87af14daf04b29b8$export$b9ca061da17f2d30)(str)).flat();
};
const $65197131a4ed5785$export$b1eb18852d39b12f = (mimeType, allowedFileTypes)=>{
    return allowedFileTypes.some((type)=>{
        if (type.endsWith('*')) {
            type = type.replace('*', '');
            return mimeType.startsWith(type);
        }
        return mimeType === type;
    });
};
const $65197131a4ed5785$export$eef1a5ad5eea15d = (fileName, allowedFileTypes)=>{
    return allowedFileTypes.some((type)=>{
        if (!type.startsWith('.')) return false;
        return fileName.toLowerCase().endsWith(type.toLowerCase());
    });
};
const $65197131a4ed5785$export$9788fb119e95d11e = (file)=>{
    let type = file?.type;
    if (!type) return false;
    return $65197131a4ed5785$export$b1eb18852d39b12f(type, $65197131a4ed5785$export$ac87ac3138ad3b2a);
};
const $65197131a4ed5785$export$5bcd6e94ed871c88 = (data)=>{
    return typeof Blob !== 'undefined' && data instanceof Blob;
};
const $65197131a4ed5785$export$be78b3111c50efdd = (data)=>{
    return typeof File !== 'undefined' && data instanceof File;
};


// @ts-check

const $feb671327827c530$var$BASE = 1000;
const $feb671327827c530$export$5c5e3263d95d3a40 = Object.freeze({
    AUTO: 'auto',
    BYTE: 'byte',
    KB: 'kb',
    MB: 'mb',
    GB: 'gb',
    TB: 'tb',
    PB: 'pb'
});
/**
 * Round a specified number to decimal with two places. Round to larger value, because basically we use it for usage and
 * we charge customers for 1 GB even he consumed 1 byte. Feature limits are usually specified in exact MB/GB/TB, so they
 * will not be rounded.
 *
 * @param {number} number
 * @returns {number}
 */ const $feb671327827c530$var$round = (number)=>Math.ceil(number * 100) / 100;
const $feb671327827c530$export$7746799a10bf2f57 = (bytes, unit = $feb671327827c530$export$5c5e3263d95d3a40.AUTO)=>{
    const isAutoMode = unit === $feb671327827c530$export$5c5e3263d95d3a40.AUTO;
    if (unit === $feb671327827c530$export$5c5e3263d95d3a40.BYTE || isAutoMode && bytes < $feb671327827c530$var$BASE ** 1) {
        // TODO: handle blocks locale
        const pluralForm = /** @type {Extract<import('./getPluralForm').PluralForm, 'one' | 'other'>} */ (0, $63338ce7a65902fa$export$9f3f0d2d02951501)('en-US', bytes);
        const pluralized = {
            one: 'byte',
            other: 'bytes'
        }[pluralForm];
        return `${bytes} ${pluralized}`;
    }
    if (unit === $feb671327827c530$export$5c5e3263d95d3a40.KB || isAutoMode && bytes < $feb671327827c530$var$BASE ** 2) return `${$feb671327827c530$var$round(bytes / $feb671327827c530$var$BASE ** 1)} KB`;
    if (unit === $feb671327827c530$export$5c5e3263d95d3a40.MB || isAutoMode && bytes < $feb671327827c530$var$BASE ** 3) return `${$feb671327827c530$var$round(bytes / $feb671327827c530$var$BASE ** 2)} MB`;
    if (unit === $feb671327827c530$export$5c5e3263d95d3a40.GB || isAutoMode && bytes < $feb671327827c530$var$BASE ** 4) return `${$feb671327827c530$var$round(bytes / $feb671327827c530$var$BASE ** 3)} GB`;
    if (unit === $feb671327827c530$export$5c5e3263d95d3a40.TB || isAutoMode && bytes < $feb671327827c530$var$BASE ** 5) return `${$feb671327827c530$var$round(bytes / $feb671327827c530$var$BASE ** 4)} TB`;
    return `${$feb671327827c530$var$round(bytes / $feb671327827c530$var$BASE ** 5)} PB`;
};







const $ad8805a60b7f88a6$var$MSG_NAME = '[Typed State] Wrong property name: ';
const $ad8805a60b7f88a6$var$MSG_TYPE = '[Typed State] Wrong property type: ';
class $ad8805a60b7f88a6$export$c2ad652e2643afc3 {
    /**
   * @param {Object<string, { type: any; value: any; nullable?: Boolean }>} typedSchema
   * @param {String} [ctxName]
   */ constructor(typedSchema, ctxName){
        /** @private */ this.__typedSchema = typedSchema;
        /** @private */ this.__ctxId = ctxName || (0, $7868cd5b229e5c15$export$c8b4a4d253b84ce0).generate();
        /** @private */ this.__schema = Object.keys(typedSchema).reduce((acc, key)=>{
            acc[key] = typedSchema[key].value;
            return acc;
        }, {});
        /**
     * @private
     * @type {Data}
     */ this.__data = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).registerCtx(this.__schema, this.__ctxId);
    }
    /** @returns {String} */ get uid() {
        return this.__ctxId;
    }
    /**
   * @param {String} prop
   * @param {any} value
   */ setValue(prop, value) {
        if (!this.__typedSchema.hasOwnProperty(prop)) {
            console.warn($ad8805a60b7f88a6$var$MSG_NAME + prop);
            return;
        }
        let pDesc = this.__typedSchema[prop];
        if (value?.constructor === pDesc.type || value instanceof pDesc.type || pDesc.nullable && value === null) {
            this.__data.pub(prop, value);
            return;
        }
        console.warn($ad8805a60b7f88a6$var$MSG_TYPE + prop);
    }
    /** @param {Object<string, any>} updObj */ setMultipleValues(updObj) {
        for(let prop in updObj)this.setValue(prop, updObj[prop]);
    }
    /** @param {String} prop */ getValue(prop) {
        if (!this.__typedSchema.hasOwnProperty(prop)) {
            console.warn($ad8805a60b7f88a6$var$MSG_NAME + prop);
            return undefined;
        }
        return this.__data.read(prop);
    }
    /**
   * @param {String} prop
   * @param {(newVal: any) => void} handler
   */ subscribe(prop, handler) {
        return this.__data.sub(prop, handler);
    }
    remove() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.__ctxId);
    }
}


class $1f2841e0bbbc303a$export$3a688a1eb31a757a {
    /**
   * @param {Object} options
   * @param {Object<string, { type: any; value: any }>} options.typedSchema
   * @param {String[]} [options.watchList]
   * @param {(list: string[], added: Set<any>, removed: Set<any>) => void} [options.handler]
   * @param {String} [options.ctxName]
   */ constructor(options){
        /**
     * @private
     * @type {Object<string, { type: any; value: any }>}
     */ this.__typedSchema = options.typedSchema;
        /**
     * @private
     * @type {String}
     */ this.__ctxId = options.ctxName || (0, $7868cd5b229e5c15$export$c8b4a4d253b84ce0).generate();
        /**
     * @private
     * @type {Data}
     */ this.__data = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).registerCtx({}, this.__ctxId);
        /**
     * @private
     * @type {string[]}
     */ this.__watchList = options.watchList || [];
        /**
     * @private
     * @type {Object<string, any>}
     */ this.__subsMap = Object.create(null);
        /**
     * @private
     * @type {Set<Function>}
     */ this.__propertyObservers = new Set();
        /**
     * @private
     * @type {Set<(list: string[], added: Set<any>, removed: Set<any>) => void>}
     */ this.__collectionObservers = new Set();
        /**
     * @private
     * @type {Set<string>}
     */ this.__items = new Set();
        /**
     * @private
     * @type {Set<any>}
     */ this.__removed = new Set();
        /**
     * @private
     * @type {Set<any>}
     */ this.__added = new Set();
        let changeMap = Object.create(null);
        /**
     * @private
     * @param {String} propName
     * @param {String} ctxId
     */ this.__notifyObservers = (propName, ctxId)=>{
            if (this.__observeTimeout) window.clearTimeout(this.__observeTimeout);
            if (!changeMap[propName]) changeMap[propName] = new Set();
            changeMap[propName].add(ctxId);
            /** @private */ this.__observeTimeout = window.setTimeout(()=>{
                if (Object.keys(changeMap).length === 0) return;
                this.__propertyObservers.forEach((handler)=>{
                    handler({
                        ...changeMap
                    });
                });
                changeMap = Object.create(null);
            });
        };
    }
    notify() {
        if (this.__notifyTimeout) window.clearTimeout(this.__notifyTimeout);
        /** @private */ this.__notifyTimeout = window.setTimeout(()=>{
            let added = new Set(this.__added);
            let removed = new Set(this.__removed);
            this.__added.clear();
            this.__removed.clear();
            for (const handler of this.__collectionObservers)handler?.([
                ...this.__items
            ], added, removed);
        });
    }
    /** @param {(list: string[], added: Set<any>, removed: Set<any>) => void} handler */ observeCollection(handler) {
        this.__collectionObservers.add(handler);
        if (this.__items.size > 0) this.notify();
        return ()=>{
            this.unobserveCollection(handler);
        };
    }
    /** @param {Function} handler */ unobserveCollection(handler) {
        this.__collectionObservers?.delete(handler);
    }
    /**
   * @param {Object<string, any>} init
   * @returns {string}
   */ add(init) {
        let item = new (0, $ad8805a60b7f88a6$export$c2ad652e2643afc3)(this.__typedSchema);
        for(let prop in init)item.setValue(prop, init[prop]);
        this.__items.add(item.uid);
        this.notify();
        this.__data.add(item.uid, item);
        this.__added.add(item);
        this.__watchList.forEach((propName)=>{
            if (!this.__subsMap[item.uid]) this.__subsMap[item.uid] = [];
            this.__subsMap[item.uid].push(item.subscribe(propName, ()=>{
                this.__notifyObservers(propName, item.uid);
            }));
        });
        return item.uid;
    }
    /**
   * @param {String} id
   * @returns {TypedData}
   */ read(id) {
        return this.__data.read(id);
    }
    /**
   * @param {String} id
   * @param {String} propName
   * @returns {any}
   */ readProp(id, propName) {
        let item = this.read(id);
        return item.getValue(propName);
    }
    /**
   * @template T
   * @param {String} id
   * @param {String} propName
   * @param {T} value
   */ publishProp(id, propName, value) {
        let item = this.read(id);
        item.setValue(propName, value);
    }
    /** @param {String} id */ remove(id) {
        this.__removed.add(this.__data.read(id));
        this.__items.delete(id);
        this.notify();
        this.__data.pub(id, null);
        delete this.__subsMap[id];
    }
    clearAll() {
        this.__items.forEach((id)=>{
            this.remove(id);
        });
    }
    /** @param {Function} handler */ observeProperties(handler) {
        this.__propertyObservers.add(handler);
        return ()=>{
            this.unobserveProperties(handler);
        };
    }
    /** @param {Function} handler */ unobserveProperties(handler) {
        this.__propertyObservers?.delete(handler);
    }
    /**
   * @param {(item: TypedData) => Boolean} checkFn
   * @returns {String[]}
   */ findItems(checkFn) {
        let result = [];
        this.__items.forEach((id)=>{
            let item = this.read(id);
            if (checkFn(item)) result.push(id);
        });
        return result;
    }
    items() {
        return [
            ...this.__items
        ];
    }
    get size() {
        return this.__items.size;
    }
    destroy() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.__ctxId);
        this.__propertyObservers = null;
        this.__collectionObservers = null;
        for(let id in this.__subsMap){
            this.__subsMap[id].forEach((sub)=>{
                sub.remove();
            });
            delete this.__subsMap[id];
        }
    }
}


// @ts-check
// @ts-check
/**
 * @template {any[]} TArgs
 * @template {any} TReturn
 * @template {(...args: TArgs) => TReturn} T
 * @param {T} fn
 * @returns {T}
 */ const $8c0f7161b2dd8c18$export$fc10aeed3a532e2a = (fn)=>{
    const cache = new Map();
    return /** @type {T} */ (...args)=>{
        const key = JSON.stringify(args);
        if (cache.has(key)) return cache.get(key);
        const result = fn(...args);
        cache.set(key, result);
        return result;
    };
};



/** @param {string} warning */ function $4168bfe85c153b89$var$createAsyncAssertWrapper(warning) {
    let isAsync = false;
    setTimeout(()=>{
        isAsync = true;
    }, 0);
    /**
   * @template {any[]} TArgs
   * @template {any} TReturn
   * @template {(...args: TArgs) => TReturn} T
   * @param {T} fn
   * @returns {T}
   */ const withAssert = (fn)=>{
        return /** @type {T} */ (...args)=>{
            if (isAsync) (0, $6a075e397d8438c7$export$5b28268982f175ba)(warning);
            return fn(...args);
        };
    };
    return withAssert;
}
function $4168bfe85c153b89$export$45cb442eb820cab7(uploaderBlock) {
    const getters = {
        /** @returns {number} */ progress: ()=>{
            return uploaderBlock.$['*commonProgress'];
        },
        /** @returns {ReturnType<import('../utils/buildOutputError.js').buildCollectionFileError>[]} */ errors: ()=>{
            return uploaderBlock.$['*collectionErrors'];
        },
        /** @returns {import('@uploadcare/upload-client').UploadcareGroup | null} */ group: ()=>{
            return uploaderBlock.$['*groupInfo'];
        },
        totalCount: ()=>{
            return uploaderBlock.uploadCollection.size;
        },
        failedCount: ()=>{
            return state.failedEntries.length;
        },
        successCount: ()=>{
            return state.successEntries.length;
        },
        uploadingCount: ()=>{
            return state.uploadingEntries.length;
        },
        status: ()=>{
            const status = state.isFailed ? 'failed' : state.isUploading ? 'uploading' : state.isSuccess ? 'success' : 'idle';
            return /** @type {TCollectionStatus} */ status;
        },
        isSuccess: ()=>{
            return state.errors.length === 0 && state.successEntries.length === state.allEntries.length;
        },
        isUploading: ()=>{
            return state.allEntries.some((entry)=>entry.status === 'uploading');
        },
        isFailed: ()=>{
            return state.errors.length > 0 || state.failedEntries.length > 0;
        },
        allEntries: ()=>{
            return uploaderBlock.getOutputData();
        },
        successEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === 'success');
        },
        failedEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === 'failed');
        },
        uploadingEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === 'uploading');
        },
        idleEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === 'idle');
        }
    };
    const state = /** @type {unknown} */ {};
    const withAssert = $4168bfe85c153b89$var$createAsyncAssertWrapper("You're trying to access the OutputCollectionState asynchronously. In this case, the data you retrieve will be newer than it was when the OutputCollectionState was created or when the event was dispatched. If you want to retain the state at a specific moment in time, you should use the spread operator like this: `{...outputCollectionState}` or `{...e.detail}`");
    for (const [key, value] of Object.entries(getters)){
        const name = /** @type {keyof typeof getters} */ key;
        const getter = /** @type {(typeof getters)[name]} */ value;
        const wrapped = (0, $8c0f7161b2dd8c18$export$fc10aeed3a532e2a)(withAssert(getter));
        Object.defineProperty(state, name, {
            get: wrapped,
            enumerable: true
        });
    }
    return state;
}


// @ts-check

const $133fe5e33d25d3a7$export$26419364b8551fd7 = Object.freeze({
    file: {
        type: File,
        value: null
    },
    externalUrl: {
        type: String,
        value: null
    },
    fileName: {
        type: String,
        value: null,
        nullable: true
    },
    fileSize: {
        type: Number,
        value: null,
        nullable: true
    },
    lastModified: {
        type: Number,
        value: Date.now()
    },
    uploadProgress: {
        type: Number,
        value: 0
    },
    uuid: {
        type: String,
        value: null
    },
    isImage: {
        type: Boolean,
        value: false
    },
    mimeType: {
        type: String,
        value: null,
        nullable: true
    },
    ctxName: {
        type: String,
        value: null
    },
    cdnUrl: {
        type: String,
        value: null
    },
    cdnUrlModifiers: {
        type: String,
        value: null
    },
    fileInfo: {
        type: (0, $3905b2ce68ef12c7$export$92ff693e656b1c76),
        value: null
    },
    isUploading: {
        type: Boolean,
        value: false
    },
    abortController: {
        type: AbortController,
        value: null,
        nullable: true
    },
    thumbUrl: {
        type: String,
        value: null,
        nullable: true
    },
    silent: {
        type: Boolean,
        value: false
    },
    source: {
        type: String,
        value: false,
        nullable: true
    },
    fullPath: {
        type: String,
        value: null,
        nullable: true
    },
    metadata: {
        type: Object,
        value: null,
        nullable: true
    },
    errors: {
        type: Array,
        value: []
    },
    uploadError: {
        type: Error,
        value: null,
        nullable: true
    },
    isRemoved: {
        type: Boolean,
        value: false
    }
});


const $add013fbbfc68970$var$uuidRegex = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/i;
const $add013fbbfc68970$var$cdnUrlRegex = new RegExp(`^/?(${$add013fbbfc68970$var$uuidRegex.source})(?:/(-/(?:[^/]+/)+)?([^/]*))?$`, 'i');
const $add013fbbfc68970$export$7bc65061b70cfcf6 = ({ url: url, cdnBase: cdnBase })=>{
    const cdnBaseUrlObj = new URL(cdnBase);
    const urlObj = new URL(url);
    if (cdnBaseUrlObj.host !== urlObj.host) return null;
    const [, uuid, cdnUrlModifiers, filename] = $add013fbbfc68970$var$cdnUrlRegex.exec(urlObj.pathname);
    return {
        uuid: uuid,
        cdnUrlModifiers: cdnUrlModifiers || '',
        filename: filename || null
    };
};


class $7465cac7cdfffcd5$export$5ece2da0ca12cb21 extends (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747) {
    couldBeCtxOwner = false;
    isCtxOwner = false;
    init$ = (0, $9a2b059e07de0fba$export$e6278a3220543f46)(this);
    /** @private */ __initialUploadMetadata = null;
    /**
   * @private
   * @type {((
   *   outputEntry: import('../types').OutputFileEntry,
   *   internalEntry?: import('./TypedData.js').TypedData,
   * ) => undefined | ReturnType<typeof import('../utils/buildOutputError.js').buildOutputFileError>)[]}
   */ _fileValidators = [
        this._validateIsImage.bind(this),
        this._validateFileType.bind(this),
        this._validateMaxSizeLimit.bind(this),
        this._validateUploadError.bind(this)
    ];
    /**
   * @private
   * @type {((
   *   collection: TypedCollection,
   * ) =>
   *   | undefined
   *   | ReturnType<typeof import('../utils/buildOutputError.js').buildCollectionFileError>
   *   | ReturnType<typeof import('../utils/buildOutputError.js').buildCollectionFileError>[])[]}
   */ _collectionValidators = [
        (collection)=>{
            const total = collection.size;
            const multipleMin = this.cfg.multiple ? this.cfg.multipleMin : 0;
            const multipleMax = this.cfg.multiple ? this.cfg.multipleMax : 1;
            if (multipleMin && total < multipleMin) {
                const message = this.l10n('files-count-limit-error-too-few', {
                    min: multipleMin,
                    max: multipleMax,
                    total: total
                });
                return (0, $501714746e5bd4bc$export$5839635218a3dedd)({
                    type: 'TOO_FEW_FILES',
                    message: message,
                    total: total,
                    min: multipleMin,
                    max: multipleMax
                });
            }
            if (multipleMax && total > multipleMax) {
                const message = this.l10n('files-count-limit-error-too-many', {
                    min: multipleMin,
                    max: multipleMax,
                    total: total
                });
                return (0, $501714746e5bd4bc$export$5839635218a3dedd)({
                    type: 'TOO_MANY_FILES',
                    message: message,
                    total: total,
                    min: multipleMin,
                    max: multipleMax
                });
            }
        },
        (collection)=>{
            if (collection.items().some((id)=>collection.readProp(id, 'errors').length > 0)) return (0, $501714746e5bd4bc$export$5839635218a3dedd)({
                type: 'SOME_FILES_HAS_ERRORS',
                message: this.l10n('some-files-were-not-uploaded')
            });
        }
    ];
    /**
   * This is Public JS API method. Could be called before block initialization, so we need to delay state interactions
   * until block init.
   *
   * TODO: If we add more public methods, it is better to use the single queue instead of tons of private fields per
   * each method. See https://github.com/uploadcare/blocks/pull/162/
   *
   * @deprecated Use `metadata` instance property on `lr-config` block instead.
   * @param {import('@uploadcare/upload-client').Metadata} metadata
   * @public
   */ setUploadMetadata(metadata) {
        (0, $6a075e397d8438c7$export$5b28268982f175ba)('setUploadMetadata is deprecated. Use `metadata` instance property on `lr-config` block instead. See migration guide: https://uploadcare.com/docs/file-uploader/migration-to-0.25.0/');
        if (!this.connectedOnce) // @ts-ignore TODO: fix this
        this.__initialUploadMetadata = metadata;
        else this.$['*uploadMetadata'] = metadata;
    }
    get hasCtxOwner() {
        return this.hasBlockInCtx((block)=>{
            if (block instanceof $7465cac7cdfffcd5$export$5ece2da0ca12cb21) return block.isCtxOwner && block.isConnected && block !== this;
            return false;
        });
    }
    initCallback() {
        super.initCallback();
        if (!this.$['*uploadCollection']) {
            let uploadCollection = new (0, $1f2841e0bbbc303a$export$3a688a1eb31a757a)({
                typedSchema: (0, $133fe5e33d25d3a7$export$26419364b8551fd7),
                watchList: [
                    'uploadProgress',
                    'uploadError',
                    'fileInfo',
                    'errors',
                    'cdnUrl',
                    'isUploading'
                ]
            });
            this.$['*uploadCollection'] = uploadCollection;
        }
        if (!this.hasCtxOwner && this.couldBeCtxOwner) this.initCtxOwner();
    }
    destroyCtxCallback() {
        this._unobserveCollectionProperties?.();
        this._unobserveCollection?.();
        this.uploadCollection.destroy();
        this.$['*uploadCollection'] = null;
        super.destroyCtxCallback();
    }
    initCtxOwner() {
        this.isCtxOwner = true;
        /** @private */ this._unobserveCollection = this.uploadCollection.observeCollection(this._handleCollectionUpdate);
        /** @private */ this._unobserveCollectionProperties = this.uploadCollection.observeProperties(this._handleCollectionPropertiesUpdate);
        const runAllValidators = ()=>{
            this._runFileValidators();
            this._runCollectionValidators();
        };
        this.subConfigValue('maxLocalFileSizeBytes', runAllValidators);
        this.subConfigValue('multipleMin', runAllValidators);
        this.subConfigValue('multipleMax', runAllValidators);
        this.subConfigValue('multiple', runAllValidators);
        this.subConfigValue('imgOnly', runAllValidators);
        this.subConfigValue('accept', runAllValidators);
        this.subConfigValue('maxConcurrentRequests', (value)=>{
            this.$['*uploadQueue'].concurrency = Number(value) || 1;
        });
        if (this.__initialUploadMetadata) this.$['*uploadMetadata'] = this.__initialUploadMetadata;
    }
    // TODO: Probably we should not allow user to override `source` property
    /**
   * @param {string} url
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromUrl(url, { silent: silent, fileName: fileName, source: source } = {}) {
        const internalId = this.uploadCollection.add({
            externalUrl: url,
            fileName: fileName ?? null,
            silent: silent ?? false,
            source: source ?? (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    }
    /**
   * @param {string} uuid
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromUuid(uuid, { silent: silent, fileName: fileName, source: source } = {}) {
        const internalId = this.uploadCollection.add({
            uuid: uuid,
            fileName: fileName ?? null,
            silent: silent ?? false,
            source: source ?? (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    }
    /**
   * @param {string} cdnUrl
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromCdnUrl(cdnUrl, { silent: silent, fileName: fileName, source: source } = {}) {
        const parsedCdnUrl = (0, $add013fbbfc68970$export$7bc65061b70cfcf6)({
            url: cdnUrl,
            cdnBase: this.cfg.cdnCname
        });
        if (!parsedCdnUrl) throw new Error('Invalid CDN URL');
        const internalId = this.uploadCollection.add({
            uuid: parsedCdnUrl.uuid,
            cdnUrl: cdnUrl,
            cdnUrlModifiers: parsedCdnUrl.cdnUrlModifiers,
            fileName: fileName ?? parsedCdnUrl.filename ?? null,
            silent: silent ?? false,
            source: source ?? (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    }
    /**
   * @param {File} file
   * @param {{ silent?: boolean; fileName?: string; source?: string; fullPath?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromObject(file, { silent: silent, fileName: fileName, source: source, fullPath: fullPath } = {}) {
        const internalId = this.uploadCollection.add({
            file: file,
            isImage: (0, $65197131a4ed5785$export$9788fb119e95d11e)(file),
            mimeType: file.type,
            fileName: fileName ?? file.name,
            fileSize: file.size,
            silent: silent ?? false,
            source: source ?? (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).API,
            fullPath: fullPath ?? null
        });
        return this.getOutputItem(internalId);
    }
    /**
   * @deprecated Will be removed in the near future. Please use `addFileFromObject`, `addFileFromUrl` or
   *   `addFileFromUuid` instead.
   * @param {File[]} files
   * @returns {import('../types').OutputFileEntry<'idle'>[]}
   */ addFiles(files) {
        console.warn('`addFiles` method is deprecated. Please use `addFileFromObject`, `addFileFromUrl` or `addFileFromUuid` instead.');
        return files.map((/** @type {File} */ file)=>{
            const internalId = this.uploadCollection.add({
                file: file,
                isImage: (0, $65197131a4ed5785$export$9788fb119e95d11e)(file),
                mimeType: file.type,
                fileName: file.name,
                fileSize: file.size
            });
            return this.getOutputItem(internalId);
        });
    }
    /** @param {string} internalId */ removeFileByInternalId(internalId) {
        if (!this.uploadCollection.read(internalId)) throw new Error(`File with internalId ${internalId} not found`);
        this.uploadCollection.remove(internalId);
    }
    removeAllFiles() {
        this.uploadCollection.clearAll();
    }
    uploadAll = ()=>{
        const itemsToUpload = this.uploadCollection.items().filter((id)=>{
            const entry = this.uploadCollection.read(id);
            return !entry.getValue('isRemoved') && !entry.getValue('isUploading') && !entry.getValue('fileInfo');
        });
        if (itemsToUpload.length === 0) return;
        this.$['*uploadTrigger'] = new Set(itemsToUpload);
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).COMMON_UPLOAD_START, /** @type {import('../types').OutputCollectionState<'uploading'>} */ this.getOutputCollectionState());
    };
    /** @param {{ captureCamera?: boolean }} options */ openSystemDialog(options = {}) {
        let accept = (0, $127bf1109bfdfae3$export$1494b4974e65fb4e)((0, $65197131a4ed5785$export$90f2b68ae2c5fe52)([
            this.cfg.accept ?? '',
            ...this.cfg.imgOnly ? (0, $65197131a4ed5785$export$ac87ac3138ad3b2a) : []
        ]));
        if (this.cfg.accept && !!this.cfg.imgOnly) console.warn("There could be a mistake.\nBoth `accept` and `imgOnly` parameters are set.\nThe value of `accept` will be concatenated with the internal image mime types list.");
        this.fileInput = document.createElement('input');
        this.fileInput.type = 'file';
        this.fileInput.multiple = this.cfg.multiple;
        if (options.captureCamera) {
            this.fileInput.capture = this.cfg.cameraCapture;
            this.fileInput.accept = 'image/*';
        } else this.fileInput.accept = accept;
        this.fileInput.dispatchEvent(new MouseEvent('click'));
        this.fileInput.onchange = ()=>{
            // @ts-ignore TODO: fix this
            [
                ...this.fileInput['files']
            ].forEach((file)=>this.addFileFromObject(file, {
                    source: options.captureCamera ? (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).CAMERA : (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).LOCAL
                }));
            // To call uploadTrigger UploadList should draw file items first:
            this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            this.setOrAddState('*modalActive', true);
            // @ts-ignore TODO: fix this
            this.fileInput['value'] = '';
            this.fileInput = null;
        };
    }
    /** @type {string[]} */ get sourceList() {
        /** @type {string[]} */ let list = [];
        if (this.cfg.sourceList) list = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(this.cfg.sourceList);
        // @ts-ignore TODO: fix this
        return list;
    }
    /** @param {Boolean} [force] */ initFlow(force = false) {
        if (this.uploadCollection.size > 0 && !force) {
            this.set$({
                '*currentActivity': (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
            });
            this.setOrAddState('*modalActive', true);
        } else if (this.sourceList?.length === 1) {
            const srcKey = this.sourceList[0];
            // TODO: We should refactor those handlers
            if (srcKey === 'local') {
                this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
                this?.['openSystemDialog']();
                return;
            }
            /** @type {Set<import('./Block').Block>} */ const blocksRegistry = this.$['*blocksRegistry'];
            /**
         * @param {import('./Block').Block} block
         * @returns {block is import('../blocks/SourceBtn/SourceBtn.js').SourceBtn}
         */ const isSourceBtn = (block)=>'type' in block && block.type === srcKey;
            const sourceBtnBlock = [
                ...blocksRegistry
            ].find(isSourceBtn);
            // TODO: This is weird that we have this logic inside UI component, we should consider to move it somewhere else
            sourceBtnBlock?.activate();
            if (this.$['*currentActivity']) this.setOrAddState('*modalActive', true);
        } else {
            // Multiple sources case:
            this.set$({
                '*currentActivity': (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM
            });
            this.setOrAddState('*modalActive', true);
        }
    }
    doneFlow() {
        this.set$({
            '*currentActivity': this.doneActivity,
            '*history': this.doneActivity ? [
                this.doneActivity
            ] : []
        });
        if (!this.$['*currentActivity']) this.setOrAddState('*modalActive', false);
    }
    /** @returns {TypedCollection} */ get uploadCollection() {
        return this.$['*uploadCollection'];
    }
    /**
   * @private
   * @param {import('../types').OutputFileEntry} outputEntry
   */ _validateFileType(outputEntry) {
        const imagesOnly = this.cfg.imgOnly;
        const accept = this.cfg.accept;
        const allowedFileTypes = (0, $65197131a4ed5785$export$90f2b68ae2c5fe52)([
            ...imagesOnly ? (0, $65197131a4ed5785$export$ac87ac3138ad3b2a) : [],
            accept
        ]);
        if (!allowedFileTypes.length) return;
        const mimeType = outputEntry.mimeType;
        const fileName = outputEntry.name;
        if (!mimeType || !fileName) // Skip client validation if mime type or file name are not available for some reasons
        return;
        const mimeOk = (0, $65197131a4ed5785$export$b1eb18852d39b12f)(mimeType, allowedFileTypes);
        const extOk = (0, $65197131a4ed5785$export$eef1a5ad5eea15d)(fileName, allowedFileTypes);
        if (!mimeOk && !extOk) // Assume file type is not allowed if both mime and ext checks fail
        return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
            type: 'FORBIDDEN_FILE_TYPE',
            message: this.l10n('file-type-not-allowed'),
            entry: outputEntry
        });
    }
    /**
   * @private
   * @param {import('../types').OutputFileEntry} outputEntry
   */ _validateMaxSizeLimit(outputEntry) {
        const maxFileSize = this.cfg.maxLocalFileSizeBytes;
        const fileSize = outputEntry.size;
        if (maxFileSize && fileSize && fileSize > maxFileSize) return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
            type: 'FILE_SIZE_EXCEEDED',
            message: this.l10n('files-max-size-limit-error', {
                maxFileSize: (0, $feb671327827c530$export$7746799a10bf2f57)(maxFileSize)
            }),
            entry: outputEntry
        });
    }
    /**
   * @private
   * @param {import('../types').OutputFileEntry} outputEntry
   * @param {import('./TypedData.js').TypedData} [internalEntry]
   */ _validateUploadError(outputEntry, internalEntry) {
        /** @type {unknown} */ const cause = internalEntry?.getValue('uploadError');
        if (!cause) return;
        if (cause instanceof (0, $3905b2ce68ef12c7$export$137ec66182ed30ea)) return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
            type: 'UPLOAD_ERROR',
            message: cause.message,
            entry: outputEntry,
            error: cause
        });
        else if (cause instanceof (0, $3905b2ce68ef12c7$export$bae979e68e4dc802)) return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
            type: 'NETWORK_ERROR',
            message: cause.message,
            entry: outputEntry,
            error: cause
        });
        else {
            const error = cause instanceof Error ? cause : new Error('Unknown error', {
                cause: cause
            });
            return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
                type: 'UNKNOWN_ERROR',
                message: error.message,
                entry: outputEntry,
                error: error
            });
        }
    }
    /**
   * @private
   * @param {import('../types').OutputFileEntry} outputEntry
   */ _validateIsImage(outputEntry) {
        const imagesOnly = this.cfg.imgOnly;
        const isImage = outputEntry.isImage;
        if (!imagesOnly || isImage) return;
        if (!outputEntry.fileInfo && outputEntry.externalUrl) // skip validation for not uploaded files with external url, cause we don't know if they're images or not
        return;
        if (!outputEntry.fileInfo && !outputEntry.mimeType) // skip validation for not uploaded files without mime-type, cause we don't know if they're images or not
        return;
        return (0, $501714746e5bd4bc$export$771b0fc023f8a167)({
            type: 'NOT_AN_IMAGE',
            message: this.l10n('images-only-accepted'),
            entry: outputEntry
        });
    }
    /**
   * @private
   * @param {import('./TypedData.js').TypedData} entry
   */ _runFileValidatorsForEntry(entry) {
        const outputEntry = this.getOutputItem(entry.uid);
        const errors = [];
        for (const validator of this._fileValidators){
            const error = validator(outputEntry, entry);
            if (error) errors.push(error);
        }
        entry.setValue('errors', errors);
    }
    /**
   * @private
   * @param {string[]} [entryIds]
   */ _runFileValidators(entryIds) {
        const ids = entryIds ?? this.uploadCollection.items();
        for (const id of ids){
            const entry = this.uploadCollection.read(id);
            entry && this._runFileValidatorsForEntry(entry);
        }
    }
    /** @private */ _runCollectionValidators() {
        const collection = this.uploadCollection;
        const errors = [];
        for (const validator of this._collectionValidators){
            const errorOrErrors = validator(collection);
            if (!errorOrErrors) continue;
            if (Array.isArray(errorOrErrors)) errors.push(...errorOrErrors);
            else errors.push(errorOrErrors);
        }
        this.$['*collectionErrors'] = errors;
        if (errors.length > 0) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).COMMON_UPLOAD_FAILED, ()=>/** @type {import('../types').OutputCollectionState<'failed'>} */ this.getOutputCollectionState(), {
            debounce: true
        });
    }
    /**
   * @private
   * @param {import('../types').OutputCollectionState} collectionState
   */ async _createGroup(collectionState) {
        const uploadClientOptions = this.getUploadClientOptions();
        const uuidList = collectionState.allEntries.map((entry)=>{
            return entry.uuid + (entry.cdnUrlModifiers ? `/${entry.cdnUrlModifiers}` : '');
        });
        const abortController = new AbortController();
        const resp = await (0, $3905b2ce68ef12c7$export$1116551e0a2a403c)(uuidList, {
            ...uploadClientOptions,
            signal: abortController.signal
        });
        if (this.$['*collectionState'] !== collectionState) {
            abortController.abort();
            return;
        }
        this.$['*groupInfo'] = resp;
        const collectionStateWithGroup = /** @type {import('../types').OutputCollectionState<'success', 'has-group'>} */ this.getOutputCollectionState();
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).GROUP_CREATED, collectionStateWithGroup);
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).CHANGE, ()=>this.getOutputCollectionState(), {
            debounce: true
        });
        this.$['*collectionState'] = collectionStateWithGroup;
    }
    /** @private */ _flushOutputItems = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(async ()=>{
        const data = this.getOutputData();
        if (data.length !== this.uploadCollection.size) return;
        const collectionState = this.getOutputCollectionState();
        this.$['*collectionState'] = collectionState;
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).CHANGE, ()=>this.getOutputCollectionState(), {
            debounce: true
        });
        if (this.cfg.groupOutput && collectionState.totalCount > 0 && collectionState.status === 'success') this._createGroup(collectionState);
    }, 300);
    /**
   * @private
   * @type {Parameters<import('./TypedCollection.js').TypedCollection['observeCollection']>[0]}
   * @param {Set<import('./TypedData.js').TypedData>} removed
   */ _handleCollectionUpdate = (entries, added, removed)=>{
        if (added.size || removed.size) this.$['*groupInfo'] = null;
        this._runFileValidators();
        this._runCollectionValidators();
        for (const entry of added)if (!entry.getValue('silent')) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_ADDED, this.getOutputItem(entry.uid));
        for (const entry of removed){
            /** @type {Set<string>} */ this.$['*uploadTrigger'].delete(entry.uid);
            entry.getValue('abortController')?.abort();
            entry.setMultipleValues({
                isRemoved: true,
                abortController: null,
                isUploading: false,
                uploadProgress: 0
            });
            URL.revokeObjectURL(entry?.getValue('thumbUrl'));
            this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_REMOVED, this.getOutputItem(entry.uid));
        }
        this.$['*uploadList'] = entries.map((uid)=>{
            return {
                uid: uid
            };
        });
        this._flushCommonUploadProgress();
        this._flushOutputItems();
    };
    /**
   * @private
   * @param {Record<keyof import('./uploadEntrySchema.js').UploadEntry, Set<string>>} changeMap
   */ _handleCollectionPropertiesUpdate = (changeMap)=>{
        this._flushOutputItems();
        const uploadCollection = this.uploadCollection;
        const entriesToRunValidation = [
            ...new Set(Object.entries(changeMap).filter(([key])=>[
                    'uploadError',
                    'fileInfo'
                ].includes(key)).map(([, ids])=>[
                    ...ids
                ]).flat())
        ];
        entriesToRunValidation.length > 0 && setTimeout(()=>{
            // We can't modify entry properties in the same tick, so we need to wait a bit
            this._runFileValidators(entriesToRunValidation);
        });
        if (changeMap.uploadProgress) {
            for (const entryId of changeMap.uploadProgress){
                const { isUploading: isUploading, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
                if (isUploading && !silent) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_UPLOAD_PROGRESS, this.getOutputItem(entryId));
            }
            this._flushCommonUploadProgress();
        }
        if (changeMap.isUploading) for (const entryId of changeMap.isUploading){
            const { isUploading: isUploading, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
            if (isUploading && !silent) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_UPLOAD_START, this.getOutputItem(entryId));
        }
        if (changeMap.fileInfo) {
            for (const entryId of changeMap.fileInfo){
                const { fileInfo: fileInfo, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
                if (fileInfo && !silent) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_UPLOAD_SUCCESS, this.getOutputItem(entryId));
            }
            if (this.cfg.cropPreset) this.setInitialCrop();
            let loadedItems = uploadCollection.findItems((entry)=>{
                return !!entry.getValue('fileInfo');
            });
            let errorItems = uploadCollection.findItems((entry)=>{
                return entry.getValue('errors').length > 0;
            });
            if (errorItems.length === 0 && uploadCollection.size === loadedItems.length) this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).COMMON_UPLOAD_SUCCESS, /** @type {import('../types').OutputCollectionState<'success'>} */ this.getOutputCollectionState());
        }
        if (changeMap.errors) for (const entryId of changeMap.errors){
            const { errors: errors } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
            if (errors.length > 0) {
                this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_UPLOAD_FAILED, this.getOutputItem(entryId));
                this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).COMMON_UPLOAD_FAILED, ()=>/** @type {import('../types').OutputCollectionState<'failed'>} */ this.getOutputCollectionState(), {
                    debounce: true
                });
            }
        }
        if (changeMap.cdnUrl) {
            const uids = [
                ...changeMap.cdnUrl
            ].filter((uid)=>{
                return !!this.uploadCollection.read(uid)?.getValue('cdnUrl');
            });
            uids.forEach((uid)=>{
                this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).FILE_URL_CHANGED, this.getOutputItem(uid));
            });
            this.$['*groupInfo'] = null;
        }
    };
    /** @private */ _flushCommonUploadProgress = ()=>{
        let commonProgress = 0;
        /** @type {Set<string>} */ const uploadTrigger = this.$['*uploadTrigger'];
        const items = [
            ...uploadTrigger
        ].filter((id)=>!!this.uploadCollection.read(id));
        items.forEach((id)=>{
            const uploadProgress = this.uploadCollection.readProp(id, 'uploadProgress');
            commonProgress += uploadProgress;
        });
        const progress = items.length ? Math.round(commonProgress / items.length) : 0;
        if (this.$['*commonProgress'] === progress) return;
        this.$['*commonProgress'] = progress;
        this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).COMMON_UPLOAD_PROGRESS, /** @type {import('../types').OutputCollectionState<'uploading'>} */ this.getOutputCollectionState());
    };
    /** @private */ setInitialCrop() {
        const cropPreset = (0, $13e12cffb6e7f0c5$export$a99f8a1d2eae458)(this.cfg.cropPreset);
        if (cropPreset) {
            const [aspectRatioPreset] = cropPreset;
            const entries = this.uploadCollection.findItems((entry)=>entry.getValue('fileInfo') && entry.getValue('isImage') && !entry.getValue('cdnUrlModifiers')?.includes('/crop/')).map((id)=>this.uploadCollection.read(id));
            for (const entry of entries){
                const fileInfo = entry.getValue('fileInfo');
                const { width: width, height: height } = fileInfo.imageInfo;
                const expectedAspectRatio = aspectRatioPreset.width / aspectRatioPreset.height;
                const crop = (0, $b5c04c21728a4369$export$c770ef1d0f2175d9)(width, height, expectedAspectRatio);
                const cdnUrlModifiers = (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)(`crop/${crop.width}x${crop.height}/${crop.x},${crop.y}`, 'preview');
                entry.setMultipleValues({
                    cdnUrlModifiers: cdnUrlModifiers,
                    cdnUrl: (0, $40a69650bbcf2c17$export$226a37372a69410c)(entry.getValue('cdnUrl'), cdnUrlModifiers)
                });
                if (this.uploadCollection.size === 1 && this.cfg.useCloudImageEditor && this.hasBlockInCtx((block)=>block.activityType === (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT)) {
                    this.$['*focusedEntry'] = entry;
                    this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
                }
            }
        }
    }
    /**
   * @param {string} entryId
   * @protected
   */ async getMetadataFor(entryId) {
        const configValue = this.cfg.metadata ?? /** @type {import('../types').Metadata} */ this.$['*uploadMetadata'];
        if (typeof configValue === 'function') {
            const outputFileEntry = this.getOutputItem(entryId);
            const metadata = await configValue(outputFileEntry);
            return metadata;
        }
        return configValue;
    }
    /** @returns {import('@uploadcare/upload-client').FileFromOptions} */ getUploadClientOptions() {
        let options = {
            store: this.cfg.store,
            publicKey: this.cfg.pubkey,
            baseCDN: this.cfg.cdnCname,
            baseURL: this.cfg.baseUrl,
            userAgent: (0, $af89a576d170a745$export$bfcf574709d3c346),
            integration: this.cfg.userAgentIntegration,
            secureSignature: this.cfg.secureSignature,
            secureExpire: this.cfg.secureExpire,
            retryThrottledRequestMaxTimes: this.cfg.retryThrottledRequestMaxTimes,
            multipartMinFileSize: this.cfg.multipartMinFileSize,
            multipartChunkSize: this.cfg.multipartChunkSize,
            maxConcurrentRequests: this.cfg.multipartMaxConcurrentRequests,
            multipartMaxAttempts: this.cfg.multipartMaxAttempts,
            checkForUrlDuplicates: !!this.cfg.checkForUrlDuplicates,
            saveUrlForRecurrentUploads: !!this.cfg.saveUrlForRecurrentUploads
        };
        return options;
    }
    /**
   * @template {import('../types').OutputFileStatus} TStatus
   * @param {string} entryId
   * @returns {import('../types/exported.js').OutputFileEntry<TStatus>}
   */ getOutputItem(entryId) {
        const uploadEntryData = /** @type {import('./uploadEntrySchema.js').UploadEntry} */ (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
        /** @type {import('@uploadcare/upload-client').UploadcareFile?} */ const fileInfo = uploadEntryData.fileInfo;
        /** @type {import('../types').OutputFileEntry['status']} */ let status = uploadEntryData.isRemoved ? 'removed' : uploadEntryData.errors.length > 0 ? 'failed' : !!uploadEntryData.fileInfo ? 'success' : uploadEntryData.isUploading ? 'uploading' : 'idle';
        /** @type {unknown} */ const outputItem = {
            uuid: fileInfo?.uuid ?? uploadEntryData.uuid ?? null,
            internalId: entryId,
            name: fileInfo?.originalFilename ?? uploadEntryData.fileName,
            size: fileInfo?.size ?? uploadEntryData.fileSize,
            isImage: fileInfo?.isImage ?? uploadEntryData.isImage,
            mimeType: fileInfo?.mimeType ?? uploadEntryData.mimeType,
            file: uploadEntryData.file,
            externalUrl: uploadEntryData.externalUrl,
            cdnUrlModifiers: uploadEntryData.cdnUrlModifiers,
            cdnUrl: uploadEntryData.cdnUrl ?? fileInfo?.cdnUrl ?? null,
            fullPath: uploadEntryData.fullPath,
            uploadProgress: uploadEntryData.uploadProgress,
            fileInfo: fileInfo ?? null,
            metadata: uploadEntryData.metadata ?? fileInfo?.metadata ?? null,
            isSuccess: status === 'success',
            isUploading: status === 'uploading',
            isFailed: status === 'failed',
            isRemoved: status === 'removed',
            errors: /** @type {import('../types/exported.js').OutputFileEntry['errors']} */ uploadEntryData.errors,
            status: status
        };
        return /** @type {import('../types/exported.js').OutputFileEntry<TStatus>} */ outputItem;
    }
    /**
   * @param {(item: import('./TypedData.js').TypedData) => Boolean} [checkFn]
   * @returns {import('../types/exported.js').OutputFileEntry[]}
   */ getOutputData(checkFn) {
        const entriesIds = checkFn ? this.uploadCollection.findItems(checkFn) : this.uploadCollection.items();
        const data = entriesIds.map((itemId)=>this.getOutputItem(itemId));
        return data;
    }
    /** @template {import('../types').OutputCollectionStatus} TStatus */ getOutputCollectionState() {
        return /** @type {ReturnType<typeof buildOutputCollectionState<TStatus>>} */ (0, $4168bfe85c153b89$export$45cb442eb820cab7)(this);
    }
}
/** @enum {String} */ $7465cac7cdfffcd5$export$5ece2da0ca12cb21.extSrcList = Object.freeze({
    FACEBOOK: 'facebook',
    DROPBOX: 'dropbox',
    GDRIVE: 'gdrive',
    GPHOTOS: 'gphotos',
    INSTAGRAM: 'instagram',
    FLICKR: 'flickr',
    VK: 'vk',
    EVERNOTE: 'evernote',
    BOX: 'box',
    ONEDRIVE: 'onedrive',
    HUDDLE: 'huddle'
});
/** @enum {String} */ $7465cac7cdfffcd5$export$5ece2da0ca12cb21.sourceTypes = Object.freeze({
    LOCAL: 'local',
    URL: 'url',
    CAMERA: 'camera',
    DRAW: 'draw',
    ...$7465cac7cdfffcd5$export$5ece2da0ca12cb21.extSrcList
});


// @ts-check

// @ts-check
// @ts-check
// @ts-check


const $1b348a031d3b3585$export$8341498d3d7a32f = Object.freeze({
    brightness: 0,
    exposure: 0,
    gamma: 100,
    contrast: 0,
    saturation: 0,
    vibrance: 0,
    warmth: 0,
    enhance: 0,
    filter: 0,
    rotate: 0,
    mirror: false,
    flip: false,
    crop: undefined
});
/** @type {readonly (keyof import('../types').Transformations)[]} */ const $1b348a031d3b3585$var$SUPPORTED_OPERATIONS_ORDERED = /** @type {const} */ [
    'enhance',
    'brightness',
    'exposure',
    'gamma',
    'contrast',
    'saturation',
    'vibrance',
    'warmth',
    'filter',
    'mirror',
    'flip',
    'rotate',
    'crop'
];
/**
 * @template {keyof import('../types').Transformations} T
 * @param {T} operation
 * @param {import('../types').Transformations[T]} options
 */ function $1b348a031d3b3585$var$transformationToStr(operation, options) {
    if (typeof options === 'number') {
        const value = options;
        return $1b348a031d3b3585$export$8341498d3d7a32f[operation] !== value ? `${operation}/${value}` : '';
    }
    if (typeof options === 'boolean') {
        const value = options;
        return $1b348a031d3b3585$export$8341498d3d7a32f[operation] !== value ? `${operation}` : '';
    }
    if (operation === 'filter' && options) {
        const { name: name, amount: amount } = /** @type {NonNullable<import('../types').Transformations['filter']>} */ options;
        if ($1b348a031d3b3585$export$8341498d3d7a32f.filter === amount) return '';
        return `${operation}/${name}/${amount}`;
    }
    if (operation === 'crop' && options) {
        let { dimensions: dimensions, coords: coords } = /** @type {NonNullable<import('../types').Transformations['crop']>} */ options;
        return `${operation}/${dimensions.join('x')}/${coords.join(',')}`;
    }
    return '';
}
function $1b348a031d3b3585$export$d901e4e307b689de(transformations) {
    return (0, $40a69650bbcf2c17$export$7970c0e63fee47d7)(...$1b348a031d3b3585$var$SUPPORTED_OPERATIONS_ORDERED.filter((operation)=>typeof transformations[operation] !== 'undefined' && transformations[operation] !== null).map((operation)=>{
        let options = transformations[operation];
        return $1b348a031d3b3585$var$transformationToStr(operation, options);
    }).filter((str)=>!!str));
}
const $1b348a031d3b3585$export$b73a625f3ee32c8 = (0, $40a69650bbcf2c17$export$7970c0e63fee47d7)('format/auto', 'progressive/yes');
/** @param {[unknown]} arg */ const $1b348a031d3b3585$var$asNumber = ([value])=>typeof value !== 'undefined' ? Number(value) : undefined;
const $1b348a031d3b3585$var$asBoolean = ()=>true;
/** @param {[string, unknown]} arg */ const $1b348a031d3b3585$var$asFilter = ([name, amount])=>({
        name: name,
        amount: typeof amount !== 'undefined' ? Number(amount) : 100
    });
/**
 * Docs: https://uploadcare.com/docs/transformations/image/resize-crop/#operation-crop We don't support percentages and
 * alignment presets, Because it's unclear how to handle them in the Editor UI TODO: add support for percentages and
 * alignment presets
 *
 * @param {[string, string]} arg
 */ const $1b348a031d3b3585$var$asCrop = ([dimensions, alignment])=>{
    if (!/\d+x\d+/.test(dimensions) || !/\d+,\d+/.test(alignment)) throw new Error('Crop by aspect ratio, percentage or alignment shortcuts is not supported.');
    return /** @type {{ dimensions: [number, number]; coords: [number, number] }} */ {
        dimensions: (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(dimensions, 'x').map(Number),
        coords: (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(alignment).map(Number)
    };
};
/**
 * @type {{
 *   [K in keyof Required<import('../types').Transformations>]: (args: any) => import('../types').Transformations[K];
 * }}
 */ const $1b348a031d3b3585$var$OPERATION_PROCESSORS = Object.freeze({
    enhance: $1b348a031d3b3585$var$asNumber,
    brightness: $1b348a031d3b3585$var$asNumber,
    exposure: $1b348a031d3b3585$var$asNumber,
    gamma: $1b348a031d3b3585$var$asNumber,
    contrast: $1b348a031d3b3585$var$asNumber,
    saturation: $1b348a031d3b3585$var$asNumber,
    vibrance: $1b348a031d3b3585$var$asNumber,
    warmth: $1b348a031d3b3585$var$asNumber,
    filter: $1b348a031d3b3585$var$asFilter,
    mirror: $1b348a031d3b3585$var$asBoolean,
    flip: $1b348a031d3b3585$var$asBoolean,
    rotate: $1b348a031d3b3585$var$asNumber,
    crop: $1b348a031d3b3585$var$asCrop
});
function $1b348a031d3b3585$export$df8366105975a86f(operations) {
    /** @type {Record<string, unknown>} */ const transformations = {};
    for (const operation of operations){
        const [name, ...args] = operation.split('/');
        if (!$1b348a031d3b3585$var$SUPPORTED_OPERATIONS_ORDERED.includes(name)) continue;
        const operationName = /** @type {(typeof SUPPORTED_OPERATIONS_ORDERED)[number]} */ name;
        const processor = $1b348a031d3b3585$var$OPERATION_PROCESSORS[operationName];
        try {
            const value = processor(args);
            transformations[operationName] = value;
        } catch (err) {
            console.warn([
                `Failed to parse URL operation "${operation}". It will be ignored.`,
                err instanceof Error ? `Error message: "${err.message}"` : err,
                'If you need this functionality, please feel free to open an issue at https://github.com/uploadcare/blocks/issues/new'
            ].join('\n'));
        }
    }
    return /** @type {import('../types.js').Transformations} */ transformations;
}


const $1ce1dd3703477f5c$export$bb9ea7aab152411a = Object.freeze({
    CROP: 'crop',
    TUNING: 'tuning',
    FILTERS: 'filters'
});
const $1ce1dd3703477f5c$export$d9a4cca3740decc7 = [
    $1ce1dd3703477f5c$export$bb9ea7aab152411a.CROP,
    $1ce1dd3703477f5c$export$bb9ea7aab152411a.TUNING,
    $1ce1dd3703477f5c$export$bb9ea7aab152411a.FILTERS
];
const $1ce1dd3703477f5c$export$68b0885f31248db9 = [
    'brightness',
    'exposure',
    'gamma',
    'contrast',
    'saturation',
    'vibrance',
    'warmth',
    'enhance'
];
const $1ce1dd3703477f5c$export$5773a777940e5760 = [
    'adaris',
    'briaril',
    'calarel',
    'carris',
    'cynarel',
    'cyren',
    'elmet',
    'elonni',
    'enzana',
    'erydark',
    'fenralan',
    'ferand',
    'galen',
    'gavin',
    'gethriel',
    'iorill',
    'iothari',
    'iselva',
    'jadis',
    'lavra',
    'misiara',
    'namala',
    'nerion',
    'nethari',
    'pamaya',
    'sarnar',
    'sedis',
    'sewen',
    'sorahel',
    'sorlen',
    'tarian',
    'thellassan',
    'varriel',
    'varven',
    'vevera',
    'virkas',
    'yedis',
    'yllara',
    'zatvel',
    'zevcen'
];
const $1ce1dd3703477f5c$export$daf320f6382e1d0a = [
    'rotate',
    'mirror',
    'flip'
];
const $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9 = Object.freeze({
    brightness: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).brightness,
        range: [
            -100,
            100
        ],
        keypointsNumber: 2
    },
    exposure: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).exposure,
        range: [
            -500,
            500
        ],
        keypointsNumber: 2
    },
    gamma: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).gamma,
        range: [
            0,
            1000
        ],
        keypointsNumber: 2
    },
    contrast: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).contrast,
        range: [
            -100,
            500
        ],
        keypointsNumber: 2
    },
    saturation: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).saturation,
        range: [
            -100,
            500
        ],
        keypointsNumber: 1
    },
    vibrance: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).vibrance,
        range: [
            -100,
            500
        ],
        keypointsNumber: 1
    },
    warmth: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).warmth,
        range: [
            -100,
            100
        ],
        keypointsNumber: 1
    },
    enhance: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).enhance,
        range: [
            0,
            100
        ],
        keypointsNumber: 1
    },
    filter: {
        zero: (0, $1b348a031d3b3585$export$8341498d3d7a32f).filter,
        range: [
            0,
            100
        ],
        keypointsNumber: 1
    }
});



const $67fdaaf7407e3f95$export$62db5c549ced9180 = 'https://ucarecdn.com';
const $67fdaaf7407e3f95$export$6554e0e4e82f1b3a = 'https://upload.uploadcare.com';
const $67fdaaf7407e3f95$export$4d917129503a6a33 = 'https://social.uploadcare.com';
const $67fdaaf7407e3f95$export$288021aefa12c882 = {
    pubkey: '',
    multiple: true,
    multipleMin: 0,
    multipleMax: Number.MAX_SAFE_INTEGER,
    confirmUpload: false,
    imgOnly: false,
    accept: '',
    externalSourcesPreferredTypes: '',
    store: 'auto',
    cameraMirror: false,
    cameraCapture: '',
    sourceList: 'local, url, camera, dropbox, gdrive',
    cloudImageEditorTabs: (0, $127bf1109bfdfae3$export$1494b4974e65fb4e)((0, $1ce1dd3703477f5c$export$d9a4cca3740decc7)),
    maxLocalFileSizeBytes: 0,
    thumbSize: 76,
    showEmptyList: false,
    useLocalImageEditor: false,
    useCloudImageEditor: true,
    removeCopyright: false,
    cropPreset: '',
    imageShrink: '',
    modalScrollLock: true,
    modalBackdropStrokes: false,
    sourceListWrap: true,
    remoteTabSessionKey: '',
    cdnCname: $67fdaaf7407e3f95$export$62db5c549ced9180,
    baseUrl: $67fdaaf7407e3f95$export$6554e0e4e82f1b3a,
    socialBaseUrl: $67fdaaf7407e3f95$export$4d917129503a6a33,
    secureSignature: '',
    secureExpire: '',
    secureDeliveryProxy: '',
    retryThrottledRequestMaxTimes: 1,
    multipartMinFileSize: 26214400,
    multipartChunkSize: 5242880,
    maxConcurrentRequests: 10,
    multipartMaxConcurrentRequests: 4,
    multipartMaxAttempts: 3,
    checkForUrlDuplicates: false,
    saveUrlForRecurrentUploads: false,
    groupOutput: false,
    userAgentIntegration: '',
    debug: false,
    metadata: null
};




// @ts-check

/** @param {unknown} value */ const $e59e35cbd66761e7$var$asString = (value)=>String(value);
/** @param {unknown} value */ const $e59e35cbd66761e7$var$asNumber = (value)=>{
    const number = Number(value);
    if (Number.isNaN(number)) throw new Error(`Invalid number: "${value}"`);
    return number;
};
const $e59e35cbd66761e7$export$ffde277b1072591c = (value)=>{
    if (typeof value === 'undefined' || value === null) return false;
    if (typeof value === 'boolean') return value;
    // for attr like multiple="true" (react will pass it as string)
    if (value === 'true') return true;
    // for attr flags like multiple="" (some other libs will pass it as empty string)
    if (value === '') return true;
    // for attr like multiple="false" (react will pass it as string)
    if (value === 'false') return false;
    throw new Error(`Invalid boolean: "${value}"`);
};
/** @param {unknown} value */ const $e59e35cbd66761e7$var$asStore = (value)=>value === 'auto' ? value : $e59e35cbd66761e7$export$ffde277b1072591c(value);
/** @param {unknown} value */ const $e59e35cbd66761e7$var$asCameraCapture = (value)=>{
    const strValue = $e59e35cbd66761e7$var$asString(value);
    if (strValue !== 'user' && strValue !== 'environment' && strValue !== '') throw new Error(`Invalid "cameraCapture" value: "${strValue}"`);
    return strValue;
};
/**
 * @type {{
 *   [Key in keyof import('../../types').ConfigPlainType]: (
 *     value: unknown,
 *   ) => import('../../types').ConfigType[Key] | undefined;
 * }}
 */ const $e59e35cbd66761e7$var$mapping = {
    pubkey: $e59e35cbd66761e7$var$asString,
    multiple: $e59e35cbd66761e7$export$ffde277b1072591c,
    multipleMin: $e59e35cbd66761e7$var$asNumber,
    multipleMax: $e59e35cbd66761e7$var$asNumber,
    confirmUpload: $e59e35cbd66761e7$export$ffde277b1072591c,
    imgOnly: $e59e35cbd66761e7$export$ffde277b1072591c,
    accept: $e59e35cbd66761e7$var$asString,
    externalSourcesPreferredTypes: $e59e35cbd66761e7$var$asString,
    store: $e59e35cbd66761e7$var$asStore,
    cameraMirror: $e59e35cbd66761e7$export$ffde277b1072591c,
    cameraCapture: $e59e35cbd66761e7$var$asCameraCapture,
    sourceList: $e59e35cbd66761e7$var$asString,
    maxLocalFileSizeBytes: $e59e35cbd66761e7$var$asNumber,
    thumbSize: $e59e35cbd66761e7$var$asNumber,
    showEmptyList: $e59e35cbd66761e7$export$ffde277b1072591c,
    useLocalImageEditor: $e59e35cbd66761e7$export$ffde277b1072591c,
    useCloudImageEditor: $e59e35cbd66761e7$export$ffde277b1072591c,
    cloudImageEditorTabs: $e59e35cbd66761e7$var$asString,
    removeCopyright: $e59e35cbd66761e7$export$ffde277b1072591c,
    cropPreset: $e59e35cbd66761e7$var$asString,
    imageShrink: $e59e35cbd66761e7$var$asString,
    modalScrollLock: $e59e35cbd66761e7$export$ffde277b1072591c,
    modalBackdropStrokes: $e59e35cbd66761e7$export$ffde277b1072591c,
    sourceListWrap: $e59e35cbd66761e7$export$ffde277b1072591c,
    remoteTabSessionKey: $e59e35cbd66761e7$var$asString,
    cdnCname: $e59e35cbd66761e7$var$asString,
    baseUrl: $e59e35cbd66761e7$var$asString,
    socialBaseUrl: $e59e35cbd66761e7$var$asString,
    secureSignature: $e59e35cbd66761e7$var$asString,
    secureExpire: $e59e35cbd66761e7$var$asString,
    secureDeliveryProxy: $e59e35cbd66761e7$var$asString,
    retryThrottledRequestMaxTimes: $e59e35cbd66761e7$var$asNumber,
    multipartMinFileSize: $e59e35cbd66761e7$var$asNumber,
    multipartChunkSize: $e59e35cbd66761e7$var$asNumber,
    maxConcurrentRequests: $e59e35cbd66761e7$var$asNumber,
    multipartMaxConcurrentRequests: $e59e35cbd66761e7$var$asNumber,
    multipartMaxAttempts: $e59e35cbd66761e7$var$asNumber,
    checkForUrlDuplicates: $e59e35cbd66761e7$export$ffde277b1072591c,
    saveUrlForRecurrentUploads: $e59e35cbd66761e7$export$ffde277b1072591c,
    groupOutput: $e59e35cbd66761e7$export$ffde277b1072591c,
    userAgentIntegration: $e59e35cbd66761e7$var$asString,
    debug: $e59e35cbd66761e7$export$ffde277b1072591c
};
const $e59e35cbd66761e7$export$fa1437ef11056dea = (key, value)=>{
    if (typeof value === 'undefined' || value === null) return undefined;
    try {
        return $e59e35cbd66761e7$var$mapping[key](value);
    } catch (reason) {
        console.error(`Invalid value for config key "${key}".`, reason);
        return (0, $67fdaaf7407e3f95$export$288021aefa12c882)[key];
    }
};



const $b7e2d88f4b1ac8e2$var$allConfigKeys = /** @type {(keyof import('../../types').ConfigType)[]} */ Object.keys((0, $67fdaaf7407e3f95$export$288021aefa12c882));
/**
 * Config keys that can't be passed as atrtibute (because they are object or function)
 *
 * @type {(keyof import('../../types').ConfigComplexType)[]}
 */ const $b7e2d88f4b1ac8e2$var$complexConfigKeys = [
    'metadata'
];
/** @type {(key: keyof import('../../types').ConfigType) => key is keyof import('../../types').ConfigComplexType} */ const $b7e2d88f4b1ac8e2$var$isComplexKey = (key)=>$b7e2d88f4b1ac8e2$var$complexConfigKeys.includes(key);
/** Config keys that can be passed as atrtibute */ const $b7e2d88f4b1ac8e2$var$plainConfigKeys = /** @type {(keyof import('../../types').ConfigPlainType)[]} */ $b7e2d88f4b1ac8e2$var$allConfigKeys.filter((key)=>!$b7e2d88f4b1ac8e2$var$isComplexKey(key));
/**
 * Mapping of attribute names to config keys Kebab-case and lowercase are supported. lowercase could be used by
 * frameworks like vue and react.
 */ const $b7e2d88f4b1ac8e2$var$attrKeyMapping = /** @type {Record<keyof import('../../types').ConfigAttributesType, keyof import('../../types').ConfigPlainType>} */ {
    ...Object.fromEntries($b7e2d88f4b1ac8e2$var$plainConfigKeys.map((key)=>[
            (0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key),
            key
        ])),
    ...Object.fromEntries($b7e2d88f4b1ac8e2$var$plainConfigKeys.map((key)=>[
            key.toLowerCase(),
            key
        ]))
};
/** Mapping of attribute names to state */ const $b7e2d88f4b1ac8e2$var$attrStateMapping = /** @type {Record<keyof import('../../types').ConfigAttributesType, string>} */ {
    ...Object.fromEntries($b7e2d88f4b1ac8e2$var$allConfigKeys.map((key)=>[
            (0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key),
            (0, $1afab31126d79360$export$16930f9e982fa181)(key)
        ])),
    ...Object.fromEntries($b7e2d88f4b1ac8e2$var$allConfigKeys.map((key)=>[
            key.toLowerCase(),
            (0, $1afab31126d79360$export$16930f9e982fa181)(key)
        ]))
};
class $b7e2d88f4b1ac8e2$var$ConfigClass extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    requireCtxName = true;
    constructor(){
        super();
        /** @type {Block['init$'] & import('../../types').ConfigType} */ this.init$ = {
            ...this.init$,
            ...Object.fromEntries(Object.entries((0, $67fdaaf7407e3f95$export$288021aefa12c882)).map(([key, value])=>[
                    (0, $1afab31126d79360$export$16930f9e982fa181)(/** @type {keyof import('../../types').ConfigType} */ key),
                    value
                ]))
        };
    }
    initCallback() {
        super.initCallback();
        const anyThis = /** @type {typeof this & any} */ this;
        for (const key of $b7e2d88f4b1ac8e2$var$plainConfigKeys)this.sub((0, $1afab31126d79360$export$16930f9e982fa181)(key), (value)=>{
            if (value !== (0, $67fdaaf7407e3f95$export$288021aefa12c882)[key]) anyThis[key] = value;
        }, false);
        for (const key of $b7e2d88f4b1ac8e2$var$allConfigKeys){
            let localPropName = '__' + key;
            anyThis[localPropName] = anyThis[key];
            Object.defineProperty(this, key, {
                /** @param {unknown} value */ set: (value)=>{
                    anyThis[localPropName] = value;
                    if ($b7e2d88f4b1ac8e2$var$plainConfigKeys.includes(key)) {
                        const attrs = [
                            ...new Set([
                                (0, $aaaaa1af795736a6$export$73bda83cddbc7187)(key),
                                key.toLowerCase()
                            ])
                        ];
                        for (const attr of attrs)if (typeof value === 'undefined' || value === null) this.removeAttribute(attr);
                        else this.setAttribute(attr, value.toString());
                    }
                    if (this.$[(0, $1afab31126d79360$export$16930f9e982fa181)(key)] !== value) {
                        if (typeof value === 'undefined' || value === null) this.$[(0, $1afab31126d79360$export$16930f9e982fa181)(key)] = (0, $67fdaaf7407e3f95$export$288021aefa12c882)[key];
                        else this.$[(0, $1afab31126d79360$export$16930f9e982fa181)(key)] = value;
                    }
                },
                get: ()=>{
                    return this.$[(0, $1afab31126d79360$export$16930f9e982fa181)(key)];
                }
            });
            if (typeof anyThis[key] !== 'undefined' && anyThis[key] !== null) anyThis[key] = anyThis[localPropName];
        }
    }
    /**
   * @param {keyof typeof attrStateMapping} name
   * @param {string} oldVal
   * @param {string} newVal
   */ attributeChangedCallback(name, oldVal, newVal) {
        if (oldVal === newVal) return;
        const key = $b7e2d88f4b1ac8e2$var$attrKeyMapping[name];
        const normalizedVal = (0, $e59e35cbd66761e7$export$fa1437ef11056dea)(key, newVal);
        const val = normalizedVal ?? (0, $67fdaaf7407e3f95$export$288021aefa12c882)[key];
        const anyThis = /** @type {typeof this & any} */ this;
        anyThis[key] = val;
    }
    /** @private */ _debugPrint = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(()=>{
        /** @type {Partial<Record<keyof import('../../types').ConfigType, never>>} */ const config = Object.create(null);
        for (const key of $b7e2d88f4b1ac8e2$var$allConfigKeys)config[key] = this.$[(0, $1afab31126d79360$export$16930f9e982fa181)(key)];
        this.debugPrint('config', config);
    }, 0);
}
$b7e2d88f4b1ac8e2$var$ConfigClass.bindAttributes($b7e2d88f4b1ac8e2$var$attrStateMapping);
const $b7e2d88f4b1ac8e2$export$29cd7b75162a9425 = /** @type {unknown} */ $b7e2d88f4b1ac8e2$var$ConfigClass;



class $ebd0259c238f433f$export$f04a61298a47a40f extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        name: '',
        path: '',
        size: '24',
        viewBox: ''
    };
    initCallback() {
        super.initCallback();
        this.sub('name', (val)=>{
            if (!val) return;
            let path = this.getCssData(`--icon-${val}`);
            if (path) this.$.path = path;
        });
        this.sub('path', (path)=>{
            if (!path) return;
            let isRaw = path.trimStart().startsWith('<');
            if (isRaw) {
                this.setAttribute('raw', '');
                this.ref.svg.innerHTML = path;
            } else {
                this.removeAttribute('raw');
                this.ref.svg.innerHTML = `<path fill-rule="evenodd" d="${path}"></path>`;
            }
        });
        this.sub('size', (size)=>{
            this.$.viewBox = `0 0 ${size} ${size}`;
        });
    }
}
$ebd0259c238f433f$export$f04a61298a47a40f.template = /* HTML */ `
  <svg ref="svg" xmlns="http://www.w3.org/2000/svg" set="@viewBox: viewBox; @height: size; @width: size"></svg>
`;
$ebd0259c238f433f$export$f04a61298a47a40f.bindAttributes({
    name: 'name',
    size: 'size'
});





/**
 * @template T
 * @param {T[]} arr
 * @returns {T[]}
 */ const $45bd69b02e054b74$export$bbd17ecb0679edd7 = (arr)=>{
    return [
        ...new Set(arr)
    ];
};


const $c4233de50d693a9f$export$8ee33fdb5e138629 = (params)=>Object.entries(params).filter(([key, value])=>value !== undefined && value !== '').map(([key, value])=>{
        if (key === 'cdn-operations') return value;
        if (key === 'analytics') return value;
        return `${key}/${value}`;
    });



const $0f420bf427e9ff0d$var$DEFAULT_CDN_BASE = 'https://ucarecdn.com';
const $0f420bf427e9ff0d$export$16388cec917aaec5 = Object.freeze({
    'dev-mode': {},
    pubkey: {},
    uuid: {},
    src: {},
    // alt: {},
    // 'placeholder-src': {}, // available via CSS
    lazy: {
        default: 1
    },
    intersection: {},
    breakpoints: {
    },
    'cdn-cname': {
        default: $0f420bf427e9ff0d$var$DEFAULT_CDN_BASE
    },
    'proxy-cname': {},
    'secure-delivery-proxy': {},
    'hi-res-support': {
        default: 1
    },
    'ultra-res-support': {},
    format: {},
    'cdn-operations': {},
    progressive: {},
    quality: {},
    'is-background-for': {},
    'is-preview-blur': {
        default: 1
    }
});


const $28f7af7741de653c$export$571a84e7679dfc34 = '--lr-img-';
const $28f7af7741de653c$export$d8b6186ee6102965 = 'unresolved';
const $28f7af7741de653c$export$a1464453b4b0b11 = 2;
const $28f7af7741de653c$export$d40396ab3f783ece = 3;
const $28f7af7741de653c$export$c338f1d796ca0b28 = !window.location.host.trim() || window.location.host.includes(':') || window.location.hostname.includes('localhost');
const $28f7af7741de653c$export$157e21b1e4c118d6 = 3000;
const $28f7af7741de653c$export$639e222b32614f23 = 5000;
const $28f7af7741de653c$export$84eecae4606a100 = Object.freeze({
    PREVIEW: 'PREVIEW',
    MAIN: 'MAIN'
});



const $35d603200edc97dd$var$CSS_PROPS = Object.create(null);
for(let prop in 0, $0f420bf427e9ff0d$export$16388cec917aaec5)$35d603200edc97dd$var$CSS_PROPS[(0, $28f7af7741de653c$export$571a84e7679dfc34) + prop] = (0, $0f420bf427e9ff0d$export$16388cec917aaec5)[prop]?.default || '';
class $35d603200edc97dd$export$e57f3f42ad40d4f8 extends (0, $7868cd5b229e5c15$export$55ae5207ce896a6b) {
    cssInit$ = $35d603200edc97dd$var$CSS_PROPS;
    /**
   * @param {String} key
   * @returns {any}
   */ $$(key) {
        return this.$[(0, $28f7af7741de653c$export$571a84e7679dfc34) + key];
    }
    /** @param {Object<String, String | Number>} kvObj */ set$$(kvObj) {
        for(let key in kvObj)this.$[(0, $28f7af7741de653c$export$571a84e7679dfc34) + key] = kvObj[key];
    }
    /**
   * @param {String} key
   * @param {(val: any) => void} kbFn
   */ sub$$(key, kbFn) {
        this.sub((0, $28f7af7741de653c$export$571a84e7679dfc34) + key, (val)=>{
            // null comes from CSS context property
            // empty string comes from attribute value
            if (val === null || val === '') return;
            kbFn(val);
        });
    }
    analyticsParams() {
        return `-/@clib/${0, $5dd66a549cd783d2$export$b8b9d90f9e5bd72b}/${0, $5dd66a549cd783d2$export$4a03ffab3315ee34}/lr-img/`;
    }
    initAttributes(el) {
        [
            ...this.attributes
        ].forEach((attr)=>{
            if (!(0, $0f420bf427e9ff0d$export$16388cec917aaec5)[attr.name]) el.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HTMLElement} el
   * @param {() => void} cbkFn
   */ initIntersection(el, cbkFn) {
        let opts = {
            root: null,
            rootMargin: '0px'
        };
        /** @private */ this._isnObserver = new IntersectionObserver((entries)=>{
            entries.forEach((ent)=>{
                if (ent.isIntersecting) {
                    cbkFn();
                    this._isnObserver.unobserve(el);
                }
            });
        }, opts);
        this._isnObserver.observe(el);
        if (!this._observed) /** @private */ this._observed = new Set();
        this._observed.add(el);
    }
    destroyCallback() {
        super.destroyCallback();
        if (this._isnObserver) {
            this._observed.forEach((el)=>{
                this._isnObserver.unobserve(el);
            });
            this._isnObserver = null;
        }
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this);
    }
    static get observedAttributes() {
        return Object.keys((0, $0f420bf427e9ff0d$export$16388cec917aaec5));
    }
    attributeChangedCallback(name, oldVal, newVal) {
        window.setTimeout(()=>{
            this.$[(0, $28f7af7741de653c$export$571a84e7679dfc34) + name] = newVal;
        });
    }
}



class $d283b57c432f01d1$export$34a767944be4878a extends (0, $35d603200edc97dd$export$e57f3f42ad40d4f8) {
    _img = new Image();
    _imgPreview = new Image();
    /**
   * @private
   * @param {String} src
   */ _fmtAbs(src) {
        let isRel = !src.includes('//');
        if (isRel && !(0, $28f7af7741de653c$export$c338f1d796ca0b28)) src = new URL(src, document.baseURI).href;
        return src;
    }
    /**
   * Validate size
   *
   * @param {String} [size]
   * @returns {String | Number}
   */ _validateSize(size) {
        if (size?.trim() !== '') {
            // Extract numeric part
            let numericPart = size.match(/\d+/)[0];
            // Extract alphabetic part
            let alphabeticPart = size.match(/[a-zA-Z]+/)[0];
            const bp = parseInt(numericPart, 10);
            if (Number(bp) > (0, $28f7af7741de653c$export$639e222b32614f23) && this.hasFormatJPG) return (0, $28f7af7741de653c$export$639e222b32614f23) + alphabeticPart;
            else if (Number(bp) > (0, $28f7af7741de653c$export$157e21b1e4c118d6) && !this.hasFormatJPG) return (0, $28f7af7741de653c$export$157e21b1e4c118d6) + alphabeticPart;
        }
        return size;
    }
    /**
   * Image operations
   *
   * @param {String} [size]
   * @param {String} [blur]
   */ _getCdnModifiers(size, blur) {
        const params = {
            format: this.$$('format'),
            quality: this.$$('quality'),
            resize: this._validateSize(size),
            blur: blur,
            'cdn-operations': this.$$('cdn-operations'),
            analytics: this.analyticsParams()
        };
        return (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)(...(0, $c4233de50d693a9f$export$8ee33fdb5e138629)(params));
    }
    /**
   * @private
   * @param {String} [size]
   * @param {String} [blur]
   * @returns {any}
   */ _getUrlBase(size = '', blur = '') {
        if (this.$$('src').startsWith('data:') || this.$$('src').startsWith('blob:')) return this.$$('src');
        // Localhost + relative image path (DO NOTHING):
        if ((0, $28f7af7741de653c$export$c338f1d796ca0b28) && this.$$('src') && !this.$$('src').includes('//')) return this._proxyUrl(this.$$('src'));
        let cdnModifiers = this._getCdnModifiers(size, blur);
        if (this.$$('src').startsWith(this.$$('cdn-cname'))) return (0, $40a69650bbcf2c17$export$226a37372a69410c)(this.$$('src'), cdnModifiers);
        // Alternative CDN name:
        if (this.$$('cdn-cname') && this.$$('uuid')) return this._proxyUrl((0, $40a69650bbcf2c17$export$226a37372a69410c)(//
        (0, $40a69650bbcf2c17$export$816ae8f9591f1ab2)(this.$$('cdn-cname'), this.$$('uuid')), cdnModifiers));
        // UUID only:
        if (this.$$('uuid')) return this._proxyUrl((0, $40a69650bbcf2c17$export$226a37372a69410c)(//
        (0, $40a69650bbcf2c17$export$816ae8f9591f1ab2)(this.$$('cdn-cname'), this.$$('uuid')), cdnModifiers));
        // Alternative proxy name:
        if (this.$$('proxy-cname')) return this._proxyUrl((0, $40a69650bbcf2c17$export$226a37372a69410c)(//
        this.$$('proxy-cname'), cdnModifiers, this._fmtAbs(this.$$('src'))));
        // Project pubkey only:
        if (this.$$('pubkey')) return this._proxyUrl((0, $40a69650bbcf2c17$export$226a37372a69410c)(//
        `https://${this.$$('pubkey')}.ucr.io/`, cdnModifiers, this._fmtAbs(this.$$('src'))));
    }
    /**
   * @private
   * @param {String} url
   * @returns {String}
   */ _proxyUrl(url) {
        let previewProxy = this.$$('secure-delivery-proxy');
        if (!previewProxy) return url;
        return (0, $8fc43c3fd04f0fc3$export$34afab4d3a450b60)(this.$$('secure-delivery-proxy'), {
            previewUrl: url
        }, {
            transform: (value)=>window.encodeURIComponent(value)
        });
    }
    /**
   * @param {HTMLElement} el
   * @param {Number} [k]
   * @param {Boolean} [wOnly]
   */ _getElSize(el, k = 1, wOnly = true) {
        let rect = el.getBoundingClientRect();
        let w = k * Math.round(rect.width);
        let h = wOnly ? '' : k * Math.round(rect.height);
        if (w || h) return `${w ? w : ''}x${h ? h : ''}`;
        else return null;
    }
    /** @param {HTMLImageElement} img */ _setupEventProxy(img) {
        /** @param {Event} e */ let proxifyEvent = (e)=>{
            e.stopPropagation();
            let event = new Event(e.type, e);
            this.dispatchEvent(event);
        };
        let EVENTS = [
            'load',
            'error'
        ];
        for (let event of EVENTS)img.addEventListener(event, proxifyEvent);
    }
    /** @type {HTMLImageElement} */ get img() {
        if (!this.hasPreviewImage) {
            this._setupConfigForImage({
                elNode: this._img
            });
            this.appendChild(this._img);
        }
        return this._img;
    }
    get currentImg() {
        return this.hasPreviewImage ? {
            type: (0, $28f7af7741de653c$export$84eecae4606a100).PREVIEW,
            img: this._imgPreview
        } : {
            type: (0, $28f7af7741de653c$export$84eecae4606a100).MAIN,
            img: this.img
        };
    }
    get hasPreviewImage() {
        return this.$$('is-preview-blur');
    }
    get bgSelector() {
        return this.$$('is-background-for');
    }
    get breakpoints() {
        if (this.$$('breakpoints')) {
            const list = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(this.$$('breakpoints'));
            return (0, $45bd69b02e054b74$export$bbd17ecb0679edd7)(list.map((bp)=>parseInt(bp, 10)));
        } else return null;
    }
    get hasFormatJPG() {
        return this.$$('format').toLowerCase() === 'jpeg';
    }
    /** @param {HTMLElement} el */ renderBg(el) {
        let imgSet = new Set();
        imgSet.add(`url("${this._getUrlBase(this._getElSize(el))}") 1x`);
        if (this.$$('hi-res-support')) imgSet.add(`url("${this._getUrlBase(this._getElSize(el, (0, $28f7af7741de653c$export$a1464453b4b0b11)))}") ${(0, $28f7af7741de653c$export$a1464453b4b0b11)}x`);
        if (this.$$('ultra-res-support')) imgSet.add(`url("${this._getUrlBase(this._getElSize(el, (0, $28f7af7741de653c$export$d40396ab3f783ece)))}") ${(0, $28f7af7741de653c$export$d40396ab3f783ece)}x`);
        let iSet = `image-set(${[
            ...imgSet
        ].join(', ')})`;
        el.style.setProperty('background-image', iSet);
        el.style.setProperty('background-image', '-webkit-' + iSet);
    }
    getSrcset() {
        let srcset = new Set();
        if (this.breakpoints) this.breakpoints.forEach((bp)=>{
            srcset.add(this._getUrlBase(bp + 'x') + ` ${this._validateSize(bp + 'w')}`);
            if (this.$$('hi-res-support')) srcset.add(this._getUrlBase(bp * (0, $28f7af7741de653c$export$a1464453b4b0b11) + 'x') + ` ${this._validateSize(bp * (0, $28f7af7741de653c$export$a1464453b4b0b11) + 'w')}`);
            if (this.$$('ultra-res-support')) srcset.add(this._getUrlBase(bp * (0, $28f7af7741de653c$export$d40396ab3f783ece) + 'x') + ` ${this._validateSize(bp * (0, $28f7af7741de653c$export$d40396ab3f783ece) + 'w')}`);
        });
        else {
            srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img)) + ' 1x');
            if (this.$$('hi-res-support')) srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img, 2)) + ' 2x');
            if (this.$$('ultra-res-support')) srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img, 3)) + ' 3x');
        }
        return [
            ...srcset
        ].join();
    }
    getSrc() {
        return this._getUrlBase();
    }
    get srcUrlPreview() {
        return this._getUrlBase('100x', '100');
    }
    renderBackground() {
        [
            ...document.querySelectorAll(this.bgSelector)
        ].forEach((el)=>{
            if (this.$$('intersection')) this.initIntersection(el, ()=>{
                this.renderBg(el);
            });
            else this.renderBg(el);
        });
    }
    _appendURL({ elNode: elNode, src: src, srcset: srcset }) {
        if (src) elNode.src = src;
        if (srcset) elNode.srcset = srcset;
    }
    _setupConfigForImage({ elNode: elNode }) {
        this._setupEventProxy(elNode);
        this.initAttributes(elNode);
    }
    loaderImage({ src: src, srcset: srcset, elNode: elNode }) {
        return new Promise((resolve, reject)=>{
            this._setupConfigForImage({
                elNode: elNode
            });
            elNode.setAttribute((0, $28f7af7741de653c$export$d8b6186ee6102965), '');
            elNode.addEventListener('load', ()=>{
                elNode.removeAttribute((0, $28f7af7741de653c$export$d8b6186ee6102965));
                resolve(elNode);
            });
            elNode.addEventListener('error', ()=>{
                reject(false);
            });
            this._appendURL({
                elNode: elNode,
                src: src,
                srcset: srcset
            });
        });
    }
    async renderImage() {
        if (this.$$('intersection')) {
            if (this.hasPreviewImage) {
                this._setupConfigForImage({
                    elNode: this._imgPreview
                });
                this.appendChild(this._imgPreview);
            }
            this.initIntersection(this.currentImg.img, async ()=>{
                if (this.hasPreviewImage) this._imgPreview.src = this.srcUrlPreview;
                try {
                    await this.loaderImage({
                        src: this.getSrc(),
                        srcset: this.getSrcset(),
                        elNode: this._img
                    });
                    if (this.hasPreviewImage) await this._imgPreview.remove();
                    this.appendChild(this._img);
                } catch (e) {
                    if (this.hasPreviewImage) await this._imgPreview?.remove();
                    this.appendChild(this._img);
                }
            });
            return;
        }
        try {
            if (this.hasPreviewImage) {
                await this.loaderImage({
                    src: this.srcUrlPreview,
                    elNode: this._imgPreview
                });
                this.appendChild(this._imgPreview);
            }
            await this.loaderImage({
                src: this.getSrc(),
                srcset: this.getSrcset(),
                elNode: this._img
            });
            if (this.hasPreviewImage) await this._imgPreview?.remove();
            this.appendChild(this._img);
        } catch (e) {
            if (this.hasPreviewImage) await this._imgPreview?.remove();
            this.appendChild(this._img);
        }
    }
    init() {
        if (this.bgSelector) this.renderBackground();
        else this.renderImage();
    }
}


class $7b94fac360fd1820$export$cc7b5f925acc71d3 extends (0, $d283b57c432f01d1$export$34a767944be4878a) {
    initCallback() {
        super.initCallback();
        this.sub$$('src', ()=>{
            this.init();
        });
        this.sub$$('uuid', ()=>{
            this.init();
        });
        this.sub$$('lazy', (val)=>{
            if (!this.$$('is-background-for') && !this.$$('is-preview-blur')) this.img.loading = val ? 'lazy' : 'eager';
        });
    }
}


// @ts-check


class $cb76d7cb113a8f69$export$ce3de857dd70689d extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            '*simpleButtonText': '',
            withDropZone: true,
            onClick: ()=>{
                this.initFlow();
            }
        };
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor('dropzone', /** @param {unknown} val */ (val)=>{
            if (typeof val === 'undefined') return;
            this.$.withDropZone = (0, $e59e35cbd66761e7$export$ffde277b1072591c)(val);
        });
        this.subConfigValue('multiple', (val)=>{
            this.$['*simpleButtonText'] = val ? this.l10n('upload-files') : this.l10n('upload-file');
        });
    }
}
$cb76d7cb113a8f69$export$ce3de857dd70689d.template = /* HTML */ `
  <lr-drop-area set="@disabled: !withDropZone">
    <button type="button" set="onclick: onClick">
      <lr-icon name="upload"></lr-icon>
      <span>{{*simpleButtonText}}</span>
      <slot></slot>
      <div class="visual-drop-area"></div>
    </button>
  </lr-drop-area>
`;
$cb76d7cb113a8f69$export$ce3de857dd70689d.bindAttributes({
    // @ts-expect-error TODO: we need to update symbiote types
    dropzone: null
});



class $440b3799876f6dd5$export$10a8e4c39671907 extends (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747) {
    historyTracked = true;
    /** @type {import('../../abstract/ActivityBlock.js').ActivityType} */ activityType = 'start-from';
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType);
    }
}
$440b3799876f6dd5$export$10a8e4c39671907.template = /* HTML */ ` <div class="content"><slot></slot></div> `;


// @ts-check






// @ts-check
/**
 * @typedef {{
 *       type: 'file';
 *       file: File;
 *       fullPath?: string;
 *     }
 *   | {
 *       type: 'url';
 *       url: string;
 *     }} DropItem
 */ /**
 * @param {File} file
 * @returns {Promise<boolean>}
 */ function $817586b303c2352b$var$checkIsDirectory(file) {
    return new Promise((resolve)=>{
        if (typeof window.FileReader !== 'function') resolve(false);
        try {
            let reader = new FileReader();
            reader.onerror = ()=>{
                resolve(true);
            };
            /** @param {Event} e */ let onLoad = (e)=>{
                if (e.type !== 'loadend') reader.abort();
                resolve(false);
            };
            reader.onloadend = onLoad;
            reader.onprogress = onLoad;
            reader.readAsDataURL(file);
        } catch (err) {
            resolve(false);
        }
    });
}
/**
 * @param {FileSystemEntry} webkitEntry
 * @param {string} dataTransferItemType
 * @returns {Promise<DropItem[] | null>}
 */ function $817586b303c2352b$var$readEntryContentAsync(webkitEntry, dataTransferItemType) {
    return new Promise((resolve)=>{
        let reading = 0;
        /** @type {DropItem[]} */ const dropItems = [];
        /** @param {FileSystemEntry} entry */ const readEntry = (entry)=>{
            if (!entry) {
                console.warn('Unexpectedly received empty content entry', {
                    scope: 'drag-and-drop'
                });
                resolve(null);
            }
            if (entry.isFile) {
                reading++;
                /** @type {FileSystemFileEntry} */ entry.file((file)=>{
                    reading--;
                    // webkitGetAsEntry don't provide type for HEIC images at least, so we use type value from dataTransferItem
                    const clonedFile = new File([
                        file
                    ], file.name, {
                        type: file.type || dataTransferItemType
                    });
                    dropItems.push({
                        type: 'file',
                        file: clonedFile,
                        fullPath: entry.fullPath
                    });
                    if (reading === 0) resolve(dropItems);
                });
            } else if (entry.isDirectory) readReaderContent(/** @type {FileSystemDirectoryEntry} */ entry.createReader());
        };
        /** @param {FileSystemDirectoryReader} reader */ let readReaderContent = (reader)=>{
            reading++;
            reader.readEntries((entries)=>{
                reading--;
                for (let entry of entries)readEntry(entry);
                if (reading === 0) resolve(dropItems);
            });
        };
        readEntry(webkitEntry);
    });
}
function $817586b303c2352b$export$6b1b1fea528d8dda(dataTransfer) {
    /** @type {DropItem[]} */ const dropItems = [];
    const promises = [];
    for(let i = 0; i < dataTransfer.items.length; i++){
        let item = dataTransfer.items[i];
        if (!item) continue;
        if (item.kind === 'file') {
            const itemType = item.type;
            if (typeof item.webkitGetAsEntry === 'function' || typeof /** @type {any} */ item.getAsEntry === 'function') {
                let entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : /** @type {any} */ item.getAsEntry();
                promises.push($817586b303c2352b$var$readEntryContentAsync(entry, itemType).then((items)=>{
                    if (items) dropItems.push(...items);
                }));
                continue;
            }
            const file = item.getAsFile();
            file && promises.push($817586b303c2352b$var$checkIsDirectory(file).then((isDirectory)=>{
                if (isDirectory) ;
                else dropItems.push({
                    type: 'file',
                    file: file
                });
            }));
        } else if (item.kind === 'string' && item.type.match('^text/uri-list')) promises.push(new Promise((resolve)=>{
            item.getAsString((value)=>{
                dropItems.push({
                    type: 'url',
                    url: value
                });
                resolve(undefined);
            });
        }));
    }
    return Promise.all(promises).then(()=>dropItems);
}


const $401786769c52d989$export$e0edc031b86cc335 = {
    ACTIVE: 0,
    INACTIVE: 1,
    NEAR: 2,
    OVER: 3
};
let $401786769c52d989$var$RESET_EVENTS = [
    'focus'
];
let $401786769c52d989$var$NEAR_OFFSET = 100;
let $401786769c52d989$var$nearnessRegistry = new Map();
/**
 * @param {[x: number, y: number]} p
 * @param {{ x: number; y: number; width: number; height: number }} r
 * @returns {number}
 */ function $401786769c52d989$var$distance(p, r) {
    let cx = Math.max(Math.min(p[0], r.x + r.width), r.x);
    let cy = Math.max(Math.min(p[1], r.y + r.height), r.y);
    return Math.sqrt((p[0] - cx) * (p[0] - cx) + (p[1] - cy) * (p[1] - cy));
}
function $401786769c52d989$export$4a249ef0d5b8b861(desc) {
    let eventCounter = 0;
    let body = document.body;
    let switchHandlers = new Set();
    let handleSwitch = (fn)=>switchHandlers.add(fn);
    let state = $401786769c52d989$export$e0edc031b86cc335.INACTIVE;
    let setState = (newState)=>{
        if (desc.shouldIgnore() && newState !== $401786769c52d989$export$e0edc031b86cc335.INACTIVE) return;
        if (state !== newState) switchHandlers.forEach((fn)=>fn(newState));
        state = newState;
    };
    let isDragging = ()=>eventCounter > 0;
    handleSwitch((newState)=>desc.onChange(newState));
    let onResetEvent = ()=>{
        eventCounter = 0;
        setState($401786769c52d989$export$e0edc031b86cc335.INACTIVE);
    };
    let onDragEnter = ()=>{
        eventCounter += 1;
        if (state === $401786769c52d989$export$e0edc031b86cc335.INACTIVE) setState($401786769c52d989$export$e0edc031b86cc335.ACTIVE);
    };
    let onDragLeave = ()=>{
        eventCounter -= 1;
        if (!isDragging()) setState($401786769c52d989$export$e0edc031b86cc335.INACTIVE);
    };
    let onDrop = (e)=>{
        e.preventDefault();
        eventCounter = 0;
        setState($401786769c52d989$export$e0edc031b86cc335.INACTIVE);
    };
    let onDragOver = (e)=>{
        if (desc.shouldIgnore()) return;
        if (!isDragging()) eventCounter += 1;
        /** @type {[Number, Number]} */ let dragPoint = [
            e.x,
            e.y
        ];
        let targetRect = desc.element.getBoundingClientRect();
        let nearness = Math.floor($401786769c52d989$var$distance(dragPoint, targetRect));
        let isNear = nearness < $401786769c52d989$var$NEAR_OFFSET;
        let isOver = e.composedPath().includes(desc.element);
        $401786769c52d989$var$nearnessRegistry.set(desc.element, nearness);
        let isNearest = Math.min(...$401786769c52d989$var$nearnessRegistry.values()) === nearness;
        if (isOver && isNearest) {
            e.preventDefault();
            setState($401786769c52d989$export$e0edc031b86cc335.OVER);
        } else if (isNear && isNearest) setState($401786769c52d989$export$e0edc031b86cc335.NEAR);
        else setState($401786769c52d989$export$e0edc031b86cc335.ACTIVE);
    };
    let onElementDrop = async (e)=>{
        if (desc.shouldIgnore()) return;
        e.preventDefault();
        let items = await (0, $817586b303c2352b$export$6b1b1fea528d8dda)(e.dataTransfer);
        desc.onItems(items);
        setState($401786769c52d989$export$e0edc031b86cc335.INACTIVE);
    };
    body.addEventListener('drop', onDrop);
    body.addEventListener('dragleave', onDragLeave);
    body.addEventListener('dragenter', onDragEnter);
    body.addEventListener('dragover', onDragOver);
    desc.element.addEventListener('drop', onElementDrop);
    $401786769c52d989$var$RESET_EVENTS.forEach((eventName)=>{
        window.addEventListener(eventName, onResetEvent);
    });
    return ()=>{
        $401786769c52d989$var$nearnessRegistry.delete(desc.element);
        body.removeEventListener('drop', onDrop);
        body.removeEventListener('dragleave', onDragLeave);
        body.removeEventListener('dragenter', onDragEnter);
        body.removeEventListener('dragover', onDragOver);
        desc.element.removeEventListener('drop', onElementDrop);
        $401786769c52d989$var$RESET_EVENTS.forEach((eventName)=>{
            window.removeEventListener(eventName, onResetEvent);
        });
    };
}


const $5dbc44b2be3820a3$var$GLOBAL_CTX_NAME = 'lr-drop-area';
const $5dbc44b2be3820a3$var$REGISTRY_KEY = `${$5dbc44b2be3820a3$var$GLOBAL_CTX_NAME}/registry`;
class $5dbc44b2be3820a3$export$a950935544f004b4 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            state: (0, $401786769c52d989$export$e0edc031b86cc335).INACTIVE,
            withIcon: false,
            isClickable: false,
            isFullscreen: false,
            isEnabled: true,
            isVisible: true,
            text: this.l10n('drop-files-here'),
            [$5dbc44b2be3820a3$var$REGISTRY_KEY]: null
        };
    }
    isActive() {
        if (!this.$.isEnabled) return false;
        const bounds = this.getBoundingClientRect();
        const hasSize = bounds.width > 0 && bounds.height > 0;
        const isInViewport = bounds.top >= 0 && bounds.left >= 0 && bounds.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounds.right <= (window.innerWidth || document.documentElement.clientWidth);
        const style = window.getComputedStyle(this);
        const visible = style.visibility !== 'hidden' && style.display !== 'none';
        return hasSize && visible && isInViewport;
    }
    initCallback() {
        super.initCallback();
        if (!this.$[$5dbc44b2be3820a3$var$REGISTRY_KEY]) this.$[$5dbc44b2be3820a3$var$REGISTRY_KEY] = new Set();
        this.$[$5dbc44b2be3820a3$var$REGISTRY_KEY].add(this);
        this.defineAccessor('disabled', /** @param {unknown} value */ (value)=>{
            this.set$({
                isEnabled: !(0, $e59e35cbd66761e7$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor('clickable', /** @param {unknown} value */ (value)=>{
            this.set$({
                isClickable: (0, $e59e35cbd66761e7$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor('with-icon', /** @param {unknown} value */ (value)=>{
            this.set$({
                withIcon: (0, $e59e35cbd66761e7$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor('fullscreen', /** @param {unknown} value */ (value)=>{
            this.set$({
                isFullscreen: (0, $e59e35cbd66761e7$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor('text', /** @param {unknown} value */ (value)=>{
            if (typeof value === 'string') this.set$({
                text: this.l10n(value) || value
            });
            else this.set$({
                text: this.l10n('drop-files-here')
            });
        });
        /** @private */ this._destroyDropzone = (0, $401786769c52d989$export$4a249ef0d5b8b861)({
            element: this,
            shouldIgnore: ()=>this._shouldIgnore(),
            /** @param {DropzoneState} state */ onChange: (state)=>{
                this.$.state = state;
            },
            /** @param {import('./getDropItems.js').DropItem[]} items */ onItems: (items)=>{
                if (!items.length) return;
                items.forEach((/** @type {import('./getDropItems.js').DropItem} */ item)=>{
                    if (item.type === 'url') this.addFileFromUrl(item.url, {
                        source: (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).DROP_AREA
                    });
                    else if (item.type === 'file') this.addFileFromObject(item.file, {
                        source: (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).DROP_AREA,
                        fullPath: item.fullPath
                    });
                });
                if (this.uploadCollection.size) {
                    this.set$({
                        '*currentActivity': (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
                    });
                    this.setOrAddState('*modalActive', true);
                }
            }
        });
        let contentWrapperEl = this.ref['content-wrapper'];
        if (contentWrapperEl) this._destroyContentWrapperDropzone = (0, $401786769c52d989$export$4a249ef0d5b8b861)({
            element: contentWrapperEl,
            /** @param {DropzoneState} state */ onChange: (state)=>{
                const stateText = Object.entries((0, $401786769c52d989$export$e0edc031b86cc335)).find(([, value])=>value === state)?.[0].toLowerCase();
                stateText && contentWrapperEl.setAttribute('drag-state', stateText);
            },
            onItems: ()=>{},
            shouldIgnore: ()=>this._shouldIgnore()
        });
        this.sub('state', (state)=>{
            const stateText = Object.entries((0, $401786769c52d989$export$e0edc031b86cc335)).find(([, value])=>value === state)?.[0].toLowerCase();
            if (stateText) this.setAttribute('drag-state', stateText);
        });
        this.subConfigValue('sourceList', (value)=>{
            const list = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(value);
            // Enable drop area if local files are allowed
            this.$.isEnabled = list.includes((0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21).sourceTypes.LOCAL);
            // Show drop area if it's enabled or default slot is overrided
            this.$.isVisible = this.$.isEnabled || !this.querySelector('[data-default-slot]');
        });
        this.sub('isVisible', (value)=>{
            this.toggleAttribute('hidden', !value);
        });
        this.sub('isClickable', (value)=>{
            this.toggleAttribute('clickable', value);
        });
        if (this.$.isClickable) {
            // @private
            this._onAreaClicked = ()=>{
                this.openSystemDialog();
            };
            this.addEventListener('click', this._onAreaClicked);
        }
    }
    /**
   * Ignore drop events if there are other visible drop areas on the page
   *
   * @private
   * @returns {Boolean}
   */ _shouldIgnore() {
        if (!this.$.isEnabled) return true;
        if (!this._couldHandleFiles()) return true;
        if (!this.$.isFullscreen) return false;
        const otherTargets = [
            ...this.$[$5dbc44b2be3820a3$var$REGISTRY_KEY]
        ].filter((el)=>el !== this);
        const activeTargets = otherTargets.filter((/** @type {typeof this} */ el)=>{
            return el.isActive();
        });
        return activeTargets.length > 0;
    }
    /** @private */ _couldHandleFiles() {
        let isMultiple = this.cfg.multiple;
        let multipleMax = this.cfg.multipleMax;
        let currentFilesCount = this.uploadCollection.size;
        if (isMultiple && multipleMax && currentFilesCount >= multipleMax) return false;
        if (!isMultiple && currentFilesCount > 0) return false;
        return true;
    }
    destroyCallback() {
        super.destroyCallback();
        /** @type {Set<DropArea>} */ const registry = this.$[$5dbc44b2be3820a3$var$REGISTRY_KEY];
        if (registry) {
            registry.delete(this);
            if (registry.size === 0) (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx($5dbc44b2be3820a3$var$GLOBAL_CTX_NAME);
        }
        this._destroyDropzone?.();
        this._destroyContentWrapperDropzone?.();
        if (this._onAreaClicked) this.removeEventListener('click', this._onAreaClicked);
    }
}
$5dbc44b2be3820a3$export$a950935544f004b4.template = /* HTML */ `
  <slot>
    <div data-default-slot hidden></div>
    <div ref="content-wrapper" class="content-wrapper" set="@hidden: !isVisible">
      <div class="icon-container" set="@hidden: !withIcon">
        <lr-icon name="default"></lr-icon>
        <lr-icon name="arrow-down"></lr-icon>
      </div>
      <span class="text">{{text}}</span>
    </div>
  </slot>
`;
$5dbc44b2be3820a3$export$a950935544f004b4.bindAttributes({
    // @ts-expect-error TODO: fix types inside symbiote
    'with-icon': null,
    // @ts-expect-error TODO: fix types inside symbiote
    clickable: null,
    // @ts-expect-error TODO: fix types inside symbiote
    text: null,
    // @ts-expect-error TODO: fix types inside symbiote
    fullscreen: null,
    // @ts-expect-error TODO: fix types inside symbiote
    disabled: null
});


// @ts-check


const $74d53f248ef49d68$var$L10N_PREFIX = 'src-type-';
class $74d53f248ef49d68$export$86582aae649ac163 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    /** @type {string | undefined} */ type = undefined;
    /**
   * @private
   * @type {Record<string, TConfig>}
   */ _registeredTypes = {};
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            iconName: 'default'
        };
    }
    initTypes() {
        this.registerType({
            type: (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21).sourceTypes.LOCAL,
            activate: ()=>{
                this.openSystemDialog();
                return false;
            }
        });
        this.registerType({
            type: (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21).sourceTypes.URL,
            activity: (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.URL,
            textKey: 'from-url'
        });
        this.registerType({
            type: (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21).sourceTypes.CAMERA,
            activity: (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CAMERA,
            activate: ()=>{
                const supportsCapture = 'capture' in document.createElement('input');
                if (supportsCapture) this.openSystemDialog({
                    captureCamera: true
                });
                return !supportsCapture;
            }
        });
        this.registerType({
            type: 'draw',
            activity: (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.DRAW,
            icon: 'edit-draw'
        });
        for (let externalSourceType of Object.values((0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21).extSrcList))this.registerType({
            type: externalSourceType,
            activity: (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.EXTERNAL,
            activityParams: {
                externalSourceType: externalSourceType
            }
        });
    }
    initCallback() {
        super.initCallback();
        this.initTypes();
        this.setAttribute('role', 'button');
        this.defineAccessor('type', /** @param {string} val */ (val)=>{
            if (!val) return;
            this.applyType(val);
        });
    }
    /** @param {TConfig} typeConfig */ registerType(typeConfig) {
        this._registeredTypes[typeConfig.type] = typeConfig;
    }
    /** @param {string} type */ getType(type) {
        return this._registeredTypes[type];
    }
    activate() {
        if (!this.type) return;
        const configType = this._registeredTypes[this.type];
        const { activity: activity, activate: activate, activityParams: activityParams = {} } = configType;
        const showActivity = activate ? activate() : !!activity;
        showActivity && this.set$({
            '*currentActivityParams': activityParams,
            '*currentActivity': activity
        });
    }
    /** @param {string} type */ applyType(type) {
        const configType = this._registeredTypes[type];
        if (!configType) {
            console.warn('Unsupported source type: ' + type);
            return;
        }
        const { textKey: textKey = type, icon: icon = type } = configType;
        this.applyL10nKey('src-type', `${$74d53f248ef49d68$var$L10N_PREFIX}${textKey}`);
        this.$.iconName = icon;
        this.onclick = ()=>{
            this.activate();
        };
    }
}
$74d53f248ef49d68$export$86582aae649ac163.template = /* HTML */ `
  <lr-icon set="@name: iconName"></lr-icon>
  <div class="txt" l10n="src-type"></div>
`;
$74d53f248ef49d68$export$86582aae649ac163.bindAttributes({
    // @ts-expect-error symbiote types bug
    type: null
});




class $3a457df5396c6ab1$export$3748a2f1ceae9e24 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    initCallback() {
        super.initCallback();
        this.subConfigValue('sourceList', (/** @type {String} */ val)=>{
            let list = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(val);
            let html = '';
            list.forEach((srcName)=>{
                html += /* HTML */ `<lr-source-btn type="${srcName}"></lr-source-btn>`;
            });
            if (this.cfg.sourceListWrap) this.innerHTML = html;
            else this.outerHTML = html;
        });
    }
}


// @ts-check

// TODO: unwrap promises
const $5f63a07ca859c63a$var$readJpegChunks = ()=>{
    const stack = [];
    const promiseReadJpegChunks = (blob)=>new Promise((resolve, reject)=>{
            let pos = 2;
            const readToView = (blob, cb)=>{
                const reader = new FileReader();
                reader.addEventListener('load', ()=>{
                    cb(new DataView(reader.result));
                });
                reader.addEventListener('error', (e)=>{
                    reject(`Reader error: ${e}`);
                });
                reader.readAsArrayBuffer(blob);
            };
            const readNext = ()=>readToView(blob.slice(pos, pos + 128), (view)=>{
                    let i, j, ref;
                    for(i = j = 0, ref = view.byteLength; ref >= 0 ? j < ref : j > ref; i = ref >= 0 ? ++j : --j)if (view.getUint8(i) === 0xff) {
                        pos += i;
                        break;
                    }
                    readNextChunk();
                });
            const readNextChunk = ()=>{
                const startPos = pos;
                return readToView(blob.slice(pos, pos += 4), (view)=>{
                    if (view.byteLength !== 4 || view.getUint8(0) !== 0xff) {
                        reject('Corrupted');
                        return;
                    }
                    const marker = view.getUint8(1);
                    if (marker === 0xda) {
                        resolve(true);
                        return;
                    }
                    const length = view.getUint16(2) - 2;
                    return readToView(blob.slice(pos, pos += length), (view)=>{
                        if (view.byteLength !== length) {
                            reject('Corrupted');
                            return;
                        }
                        stack.push({
                            startPos: startPos,
                            length: length,
                            marker: marker,
                            view: view
                        });
                        readNext();
                    });
                });
            };
            if (!(FileReader && DataView)) reject('Not Support');
            readToView(blob.slice(0, 2), (view)=>{
                if (view.getUint16(0) !== 0xffd8) reject('Not jpeg');
                readNext();
            });
        });
    return {
        stack: stack,
        promiseReadJpegChunks: promiseReadJpegChunks
    };
};
const $5f63a07ca859c63a$var$getIccProfile = async (blob)=>{
    const iccProfile = [];
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    await promiseReadJpegChunks(blob);
    stack.forEach(({ marker: marker, view: view })=>{
        if (marker === 0xe2) {
            if (// check for "ICC_PROFILE\0"
            view.getUint32(0) === 0x4943435f && view.getUint32(4) === 0x50524f46 && view.getUint32(8) === 0x494c4500) iccProfile.push(view);
        }
    });
    return iccProfile;
};
const $5f63a07ca859c63a$var$replaceJpegChunk = async (blob, marker, chunks)=>{
    {
        const oldChunkPos = [];
        const oldChunkLength = [];
        const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
        await promiseReadJpegChunks(blob);
        stack.forEach((chunk)=>{
            if (chunk.marker === marker) {
                oldChunkPos.push(chunk.startPos);
                return oldChunkLength.push(chunk.length);
            }
        });
        const newChunks = [
            blob.slice(0, 2)
        ];
        for (const chunk of chunks){
            const intro = new DataView(new ArrayBuffer(4));
            intro.setUint16(0, 0xff00 + marker);
            intro.setUint16(2, chunk.byteLength + 2);
            newChunks.push(intro.buffer);
            newChunks.push(chunk);
        }
        let pos = 2;
        for(let i = 0; i < oldChunkPos.length; i++){
            if (oldChunkPos[i] > pos) newChunks.push(blob.slice(pos, oldChunkPos[i]));
            pos = oldChunkPos[i] + oldChunkLength[i] + 4;
        }
        newChunks.push(blob.slice(pos, blob.size));
        return new Blob(newChunks, {
            type: blob.type
        });
    }
};
const $5f63a07ca859c63a$var$MARKER = 0xe2;
const $5f63a07ca859c63a$var$replaceIccProfile = (blob, iccProfiles)=>{
    return $5f63a07ca859c63a$var$replaceJpegChunk(blob, $5f63a07ca859c63a$var$MARKER, iccProfiles.map((chunk)=>chunk.buffer));
};
const $5f63a07ca859c63a$var$stripIccProfile = async (blob)=>{
    try {
        return await $5f63a07ca859c63a$var$replaceIccProfile(blob, []);
    } catch (e) {
        throw new Error(`Failed to strip ICC profile: ${e}`);
    }
};
const $5f63a07ca859c63a$var$canvasToBlob = (canvas, type, quality)=>{
    return new Promise((resolve, reject)=>{
        const callback = (blob)=>{
            if (!blob) {
                reject('Failed to convert canvas to blob');
                return;
            }
            resolve(blob);
        };
        canvas.toBlob(callback, type, quality);
        canvas.width = canvas.height = 1;
    });
};
const $5f63a07ca859c63a$var$createCanvas = ()=>{
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    return {
        canvas: canvas,
        ctx: ctx
    };
};
const $5f63a07ca859c63a$var$hasTransparency = (img)=>{
    const canvasSize = 50;
    // Create a canvas element and get 2D rendering context
    const { ctx: ctx, canvas: canvas } = $5f63a07ca859c63a$var$createCanvas();
    canvas.width = canvas.height = canvasSize;
    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0, canvasSize, canvasSize);
    // Get the image data
    const imageData = ctx.getImageData(0, 0, canvasSize, canvasSize).data;
    // Reset the canvas dimensions
    canvas.width = canvas.height = 1;
    // Check for transparency in the alpha channel
    for(let i = 3; i < imageData.length; i += 4){
        if (imageData[i] < 254) return true;
    }
    // No transparency found
    return false;
};
const $5f63a07ca859c63a$var$getExif = async (blob)=>{
    let exif = null;
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    await promiseReadJpegChunks(blob);
    stack.forEach(({ marker: marker, view: view })=>{
        if (!exif && marker === 0xe1) {
            if (view.byteLength >= 14) {
                if (// check for "Exif\0"
                view.getUint32(0) === 0x45786966 && view.getUint16(4) === 0) {
                    exif = view;
                    return;
                }
            }
        }
    });
    return exif;
};
// 2x1 pixel image 90CW rotated with orientation header
const $5f63a07ca859c63a$var$base64ImageSrc = "data:image/jpg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4QA6RXhpZgAATU0AKgAAAAgAAwESAAMAAAABAAYAAAEoAAMAAAABAAIAAAITAAMAAAABAAEAAAAAAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAIBASIA/8QAJgABAAAAAAAAAAAAAAAAAAAAAxABAAAAAAAAAAAAAAAAAAAAAP/aAAgBAQAAPwBH/9k=";
let $5f63a07ca859c63a$var$isApplied = undefined;
const $5f63a07ca859c63a$var$isBrowserApplyExifOrientation = ()=>{
    return new Promise((resolve)=>{
        if ($5f63a07ca859c63a$var$isApplied !== undefined) resolve($5f63a07ca859c63a$var$isApplied);
        else {
            const image = new Image();
            image.addEventListener('load', ()=>{
                $5f63a07ca859c63a$var$isApplied = image.naturalWidth < image.naturalHeight;
                image.src = '//:0';
                resolve($5f63a07ca859c63a$var$isApplied);
            });
            image.src = $5f63a07ca859c63a$var$base64ImageSrc;
        }
    });
};
const $5f63a07ca859c63a$var$findExifOrientation = (exif, exifCallback)=>{
    let j, little, offset, ref;
    if (!exif || exif.byteLength < 14 || exif.getUint32(0) !== 0x45786966 || exif.getUint16(4) !== 0) return;
    if (exif.getUint16(6) === 0x4949) little = true;
    else if (exif.getUint16(6) === 0x4d4d) little = false;
    else return;
    if (exif.getUint16(8, little) !== 0x002a) return;
    offset = 8 + exif.getUint32(10, little);
    const count = exif.getUint16(offset - 2, little);
    for(j = 0, ref = count; ref >= 0 ? j < ref : j > ref; ref >= 0 ? ++j : --j){
        if (exif.byteLength < offset + 10) return;
        if (exif.getUint16(offset, little) === 0x0112) exifCallback(offset + 8, little);
        offset += 12;
    }
};
const $5f63a07ca859c63a$var$setExifOrientation = (exif, orientation)=>{
    $5f63a07ca859c63a$var$findExifOrientation(exif, (offset, littleEndian)=>exif.setUint16(offset, orientation, littleEndian));
};
const $5f63a07ca859c63a$var$replaceExif = async (blob, exif, isExifApplied)=>{
    if (isExifApplied) $5f63a07ca859c63a$var$setExifOrientation(exif, 1);
    return $5f63a07ca859c63a$var$replaceJpegChunk(blob, 0xe1, [
        exif.buffer
    ]);
};
const $5f63a07ca859c63a$var$processImage = (image, src)=>{
    return new Promise((resolve, reject)=>{
        if (src) image.src = src;
        if (image.complete) resolve(image);
        else {
            image.addEventListener('load', ()=>{
                resolve(image);
            });
            image.addEventListener('error', ()=>{
                reject(new Error('Failed to load image. Probably not an image.'));
            });
        }
    });
};
const $5f63a07ca859c63a$var$imageLoader = (image)=>{
    return $5f63a07ca859c63a$var$processImage(new Image(), image);
};
const $5f63a07ca859c63a$var$allowLayers = [
    1,
    3 // RGB
];
const $5f63a07ca859c63a$var$markers = [
    0xc0,
    0xc1,
    0xc2,
    0xc3,
    0xc5,
    0xc6,
    0xc7,
    0xc9,
    0xca,
    0xcb,
    0xcd,
    0xce,
    0xcf // ("SOF15", "Differential spatial (AC)", SOF)
];
const $5f63a07ca859c63a$var$sizes = {
    squareSide: [
        // Safari (iOS < 9, ram >= 256)
        // We are supported mobile safari < 9 since widget v2, by 5 Mpx limit
        // so it's better to continue support despite the absence of this browser in the support table
        Math.floor(Math.sqrt(5000000)),
        // IE Mobile (Windows Phone 8.x)
        // Safari (iOS >= 9)
        4096,
        // IE 9 (Win)
        8192,
        // Firefox 63 (Mac, Win)
        11180,
        // Chrome 68 (Android 6)
        10836,
        // Chrome 68 (Android 5)
        11402,
        // Chrome 68 (Android 7.1-9)
        14188,
        // Chrome 70 (Mac, Win)
        // Chrome 68 (Android 4.4)
        // Edge 17 (Win)
        // Safari 7-12 (Mac)
        16384
    ],
    dimension: [
        // IE Mobile (Windows Phone 8.x)
        4096,
        // IE 9 (Win)
        8192,
        // Edge 17 (Win)
        // IE11 (Win)
        16384,
        // Chrome 70 (Mac, Win)
        // Chrome 68 (Android 4.4-9)
        // Firefox 63 (Mac, Win)
        32767,
        // Chrome 83 (Mac, Win)
        // Safari 7-12 (Mac)
        // Safari (iOS 9-12)
        // Actually Safari has a much bigger limits - 4194303 of width and 8388607 of height,
        // but we will not use them
        65535
    ]
};
const $5f63a07ca859c63a$var$shouldSkipShrink = async (blob)=>{
    let skip = false;
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    return await promiseReadJpegChunks(blob).then(()=>{
        stack.forEach(({ marker: marker, view: view })=>{
            if (!skip && $5f63a07ca859c63a$var$markers.indexOf(marker) >= 0) {
                const layer = view.getUint8(5);
                if ($5f63a07ca859c63a$var$allowLayers.indexOf(layer) < 0) skip = true;
            }
        });
        return skip;
    }).catch(()=>skip);
};
const $5f63a07ca859c63a$var$memoize = (fn, serializer)=>{
    const cache = {};
    return (...args)=>{
        const key = serializer(args, cache);
        return key in cache ? cache[key] : cache[key] = fn(...args);
    };
};
/**
 * Memoization key serealizer, that prevents unnecessary canvas tests. No need
 * to make test if we know that:
 *
 * - Browser supports higher canvas size
 * - Browser doesn't support lower canvas size
 */ const $5f63a07ca859c63a$var$memoKeySerializer = (args, cache)=>{
    const [w] = args;
    const cachedWidths = Object.keys(cache).map((val)=>parseInt(val, 10)).sort((a, b)=>a - b);
    for(let i = 0; i < cachedWidths.length; i++){
        const cachedWidth = cachedWidths[i];
        const isSupported = !!cache[cachedWidth];
        // higher supported canvas size, return it
        if (cachedWidth > w && isSupported) return cachedWidth;
        // lower unsupported canvas size, return it
        if (cachedWidth < w && !isSupported) return cachedWidth;
    }
    // use canvas width as the key,
    // because we're doing dimension test by width - [dimension, 1]
    return w;
};
// add constants
const $5f63a07ca859c63a$var$TestPixel = {
    R: 55,
    G: 110,
    B: 165,
    A: 255
};
const $5f63a07ca859c63a$var$FILL_STYLE = `rgba(${$5f63a07ca859c63a$var$TestPixel.R}, ${$5f63a07ca859c63a$var$TestPixel.G}, ${$5f63a07ca859c63a$var$TestPixel.B}, ${$5f63a07ca859c63a$var$TestPixel.A / 255})`;
const $5f63a07ca859c63a$var$canvasTest = (width, height)=>{
    try {
        const fill = [
            width - 1,
            height - 1,
            1,
            1
        ]; // x, y, width, height
        const { canvas: cropCvs, ctx: cropCtx } = $5f63a07ca859c63a$var$createCanvas();
        cropCvs.width = 1;
        cropCvs.height = 1;
        const { canvas: testCvs, ctx: testCtx } = $5f63a07ca859c63a$var$createCanvas();
        testCvs.width = width;
        testCvs.height = height;
        if (testCtx) {
            testCtx.fillStyle = $5f63a07ca859c63a$var$FILL_STYLE;
            testCtx.fillRect(...fill);
            // Render the test pixel in the bottom-right corner of the
            // test canvas in the top-left of the 1x1 crop canvas. This
            // dramatically reducing the time for getImageData to complete.
            cropCtx.drawImage(testCvs, width - 1, height - 1, 1, 1, 0, 0, 1, 1);
        }
        const imageData = cropCtx && cropCtx.getImageData(0, 0, 1, 1).data;
        let isTestPass = false;
        if (imageData) // On IE10, imageData have type CanvasPixelArray, not Uint8ClampedArray.
        // CanvasPixelArray supports index access operations only.
        // Array buffers can't be destructuredd and compared with JSON.stringify
        isTestPass = imageData[0] === $5f63a07ca859c63a$var$TestPixel.R && imageData[1] === $5f63a07ca859c63a$var$TestPixel.G && imageData[2] === $5f63a07ca859c63a$var$TestPixel.B && imageData[3] === $5f63a07ca859c63a$var$TestPixel.A;
        testCvs.width = testCvs.height = 1;
        return isTestPass;
    } catch (e) {
        console.error(`Failed to test for max canvas size of ${width}x${height}.`);
        return false;
    }
};
function $5f63a07ca859c63a$var$wrapAsync(fn) {
    return (...args)=>{
        return new Promise((resolve)=>{
            setTimeout(()=>{
                const result = fn(...args);
                resolve(result);
            }, 0);
        });
    };
}
const $5f63a07ca859c63a$var$squareTest = $5f63a07ca859c63a$var$wrapAsync($5f63a07ca859c63a$var$memoize($5f63a07ca859c63a$var$canvasTest, $5f63a07ca859c63a$var$memoKeySerializer));
const $5f63a07ca859c63a$var$dimensionTest = $5f63a07ca859c63a$var$wrapAsync($5f63a07ca859c63a$var$memoize($5f63a07ca859c63a$var$canvasTest, $5f63a07ca859c63a$var$memoKeySerializer));
const $5f63a07ca859c63a$var$testCanvasSize = async (w, h)=>{
    const testSquareSide = $5f63a07ca859c63a$var$sizes.squareSide.find((side)=>side * side >= w * h);
    const testDimension = $5f63a07ca859c63a$var$sizes.dimension.find((side)=>side >= w && side >= h);
    if (!testSquareSide || !testDimension) throw new Error('Not supported');
    const [squareSupported, dimensionSupported] = await Promise.all([
        $5f63a07ca859c63a$var$squareTest(testSquareSide, testSquareSide),
        $5f63a07ca859c63a$var$dimensionTest(testDimension, 1)
    ]);
    if (squareSupported && dimensionSupported) return true;
    else throw new Error('Not supported');
};
const $5f63a07ca859c63a$var$canvasResize = async (img, w, h)=>{
    try {
        const { ctx: ctx, canvas: canvas } = $5f63a07ca859c63a$var$createCanvas();
        canvas.width = w;
        canvas.height = h;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, w, h);
        if (img instanceof HTMLImageElement) img.src = '//:0'; // free memory
        if (img instanceof HTMLCanvasElement) img.width = img.height = 1; // free memory
        return canvas;
    } catch (e) {
        throw new Error('Canvas resize error', {
            cause: e
        });
    }
};
/**
 * Native high-quality canvas resampling
 *
 * Browser support:
 * https://caniuse.com/mdn-api_canvasrenderingcontext2d_imagesmoothingenabled
 * Target dimensions expected to be supported by browser.
 */ const $5f63a07ca859c63a$var$native = ({ img: img, targetW: targetW, targetH: targetH })=>$5f63a07ca859c63a$var$canvasResize(img, targetW, targetH);
/**
 * Goes from target to source by step, the last incomplete step is dropped.
 * Always returns at least one step - target. Source step is not included.
 * Sorted descending.
 *
 * Example with step = 0.71, source = 2000, target = 400 400 (target) <- 563 <-
 * 793 <- 1117 <- 1574 (dropped) <- [2000 (source)]
 */ const $5f63a07ca859c63a$var$calcShrinkSteps = function({ sourceW: sourceW, targetW: targetW, targetH: targetH, step: step }) {
    const steps = [];
    let sW = targetW;
    let sH = targetH;
    // result should include at least one target step,
    // even if abs(source - target) < step * source
    // just to be sure nothing will break
    // if the original resolution / target resolution condition changes
    do {
        steps.push([
            sW,
            sH
        ]);
        sW = Math.round(sW / step);
        sH = Math.round(sH / step);
    }while (sW < sourceW * step);
    return steps.reverse();
};
/**
 * Fallback resampling algorithm
 *
 * Reduces dimensions by step until reaches target dimensions, this gives a
 * better output quality than one-step method
 *
 * Target dimensions expected to be supported by browser, unsupported steps will
 * be dropped.
 */ const $5f63a07ca859c63a$var$fallback = ({ img: img, sourceW: sourceW, targetW: targetW, targetH: targetH, step: step })=>{
    const steps = $5f63a07ca859c63a$var$calcShrinkSteps({
        sourceW: sourceW,
        targetW: targetW,
        targetH: targetH,
        step: step
    });
    return steps.reduce((chain, [w, h], idx)=>{
        return chain.then((canvas)=>{
            return $5f63a07ca859c63a$var$testCanvasSize(w, h).then(()=>$5f63a07ca859c63a$var$canvasResize(canvas, w, h)).catch(()=>{
                if (idx === steps.length - 1) // If the last step is failed then we assume that we can't shrink the image at all
                throw new Error('Not supported');
                return canvas;
            });
        });
    }, Promise.resolve(img));
};
const $5f63a07ca859c63a$var$isIOS = ()=>{
    if (/iPad|iPhone|iPod/.test(navigator.platform)) return true;
    else return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $5f63a07ca859c63a$var$isIpadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
const $5f63a07ca859c63a$var$STEP = 0.71; // should be > sqrt(0.5)
const $5f63a07ca859c63a$var$shrinkImage = (img, settings)=>{
    // do not shrink image if original resolution / target resolution ratio falls behind 2.0
    if (img.width * $5f63a07ca859c63a$var$STEP * img.height * $5f63a07ca859c63a$var$STEP < settings.size) throw new Error('Not required');
    const sourceW = img.width;
    const sourceH = img.height;
    const ratio = sourceW / sourceH;
    // target size shouldn't be greater than settings.size in any case
    const targetW = Math.floor(Math.sqrt(settings.size * ratio));
    const targetH = Math.floor(settings.size / Math.sqrt(settings.size * ratio));
    // we test the last step because we can skip all intermediate steps
    return $5f63a07ca859c63a$var$testCanvasSize(targetW, targetH).then(()=>{
        const { ctx: ctx } = $5f63a07ca859c63a$var$createCanvas();
        const supportNative = 'imageSmoothingQuality' in ctx;
        // native scaling on ios gives blurry results
        // TODO: check if it's still true
        const useNativeScaling = supportNative && !$5f63a07ca859c63a$var$isIOS() && !$5f63a07ca859c63a$var$isIpadOS;
        return useNativeScaling ? $5f63a07ca859c63a$var$native({
            img: img,
            targetW: targetW,
            targetH: targetH
        }) : $5f63a07ca859c63a$var$fallback({
            img: img,
            sourceW: sourceW,
            targetW: targetW,
            targetH: targetH,
            step: $5f63a07ca859c63a$var$STEP
        });
    }).catch(()=>Promise.reject('Not supported'));
};
const $5f63a07ca859c63a$export$d92be28d49332e45 = async (inputBlob, settings)=>{
    try {
        const shouldSkip = await $5f63a07ca859c63a$var$shouldSkipShrink(inputBlob);
        if (shouldSkip) throw new Error('Should skipped');
        // Try to extract EXIF and ICC profile
        const exifResults = await Promise.allSettled([
            $5f63a07ca859c63a$var$getExif(inputBlob),
            $5f63a07ca859c63a$var$isBrowserApplyExifOrientation(),
            $5f63a07ca859c63a$var$getIccProfile(inputBlob)
        ]);
        const isRejected = exifResults.some((result)=>result.status === 'rejected');
        // If any of the promises is rejected, this is not a JPEG image
        const isJPEG = !isRejected;
        const [exifResult, isExifOrientationAppliedResult, iccProfileResult] = exifResults;
        // Load blob into the image
        const inputBlobWithoutIcc = await $5f63a07ca859c63a$var$stripIccProfile(inputBlob).catch(()=>inputBlob);
        const image = await $5f63a07ca859c63a$var$imageLoader(URL.createObjectURL(inputBlobWithoutIcc));
        URL.revokeObjectURL(image.src);
        // Shrink the image
        const canvas = await $5f63a07ca859c63a$var$shrinkImage(image, settings);
        let format = 'image/jpeg';
        let quality = settings?.quality || 0.8;
        if (!isJPEG && $5f63a07ca859c63a$var$hasTransparency(canvas)) {
            format = 'image/png';
            quality = undefined;
        }
        // Convert canvas to blob
        let newBlob = await $5f63a07ca859c63a$var$canvasToBlob(canvas, format, quality);
        // Set EXIF for the new blob
        if (isJPEG && exifResult.status === 'fulfilled' && exifResult.value) {
            const exif = exifResult.value;
            const isExifOrientationApplied = isExifOrientationAppliedResult.status === 'fulfilled' ? isExifOrientationAppliedResult.value : false;
            newBlob = await $5f63a07ca859c63a$var$replaceExif(newBlob, exif, isExifOrientationApplied);
        // TODO: should we continue shrink if failed to replace EXIF?
        // .catch(() => newBlob)
        }
        // Set ICC profile for the new blob
        if (isJPEG && iccProfileResult.status === 'fulfilled' && iccProfileResult.value.length > 0) newBlob = await $5f63a07ca859c63a$var$replaceIccProfile(newBlob, iccProfileResult.value);
        return newBlob;
    } catch (e) {
        let message;
        if (e instanceof Error) message = e.message;
        if (typeof e === 'string') message = e;
        throw new Error(`Failed to shrink image. ${message ? `Message: "${message}".` : ''}`, {
            cause: e
        });
    }
};





/**
 * @param {String} svg
 * @returns {String}
 */ function $213c41776f7daa31$var$createSvgBlobUrl(svg) {
    let blob = new Blob([
        svg
    ], {
        type: 'image/svg+xml'
    });
    return URL.createObjectURL(blob);
}
function $213c41776f7daa31$export$94a13a3239cc67e3(color1 = '#fff', color2 = 'rgba(0, 0, 0, .1)') {
    return $213c41776f7daa31$var$createSvgBlobUrl(/*svg*/ `<svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="20" height="20" fill="${color1}" />
    <rect x="0" y="0" width="10" height="10" fill="${color2}" />
    <rect x="10" y="10" width="10" height="10" fill="${color2}" />
  </svg>`);
}
function $213c41776f7daa31$export$26900049b1fd0fec(color = 'rgba(0, 0, 0, .1)') {
    return $213c41776f7daa31$var$createSvgBlobUrl(/*svg*/ `<svg height="10" width="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="10" x2="10" y2="0" stroke="${color}" />
  </svg>`);
}
function $213c41776f7daa31$export$138da82c49e1ea0e(color = 'hsl(209, 21%, 65%)', width = 32, height = 32) {
    return $213c41776f7daa31$var$createSvgBlobUrl(/*svg*/ `
  <svg width="${width}" height="${height}" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${color}" d="M9.68848 8.70068C9.68848 8.42454 9.91233 8.20068 10.1885 8.20068H15.0885C15.2211 8.20068 15.3483 8.25336 15.442 8.34713L20.342 13.2471C20.4358 13.3409 20.4885 13.4681 20.4885 13.6007V21.3007C20.4885 21.5768 20.2646 21.8007 19.9885 21.8007H10.1885C9.91233 21.8007 9.68848 21.5768 9.68848 21.3007V8.70068ZM10.6885 9.20068V20.8007H19.4885V14.1007L15.0885 14.1007C14.8123 14.1007 14.5885 13.8768 14.5885 13.6007L14.5885 9.20068H10.6885ZM15.5885 9.90779L18.7814 13.1007L15.5885 13.1007L15.5885 9.90779Z"/>
  </svg>
  `);
}



/**
 * @param {File} imgFile
 * @param {Number} [size]
 */ function $fd4410bd1e954deb$export$1c6697d6d7c7cdc2(imgFile, size = 40) {
    if (imgFile.type === 'image/svg+xml') return URL.createObjectURL(imgFile);
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    let img = new Image();
    let promise = new Promise((resolve, reject)=>{
        img.onload = ()=>{
            let ratio = img.height / img.width;
            if (ratio > 1) {
                canvas.width = size;
                canvas.height = size * ratio;
            } else {
                canvas.height = size;
                canvas.width = size / ratio;
            }
            ctx.fillStyle = 'rgb(240, 240, 240)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject();
                    return;
                }
                let url = URL.createObjectURL(blob);
                resolve(url);
            });
        };
        img.onerror = (err)=>{
            reject(err);
        };
    });
    img.src = URL.createObjectURL(imgFile);
    return promise;
}


/** TODO parseShrink move to package @uploadcare/image-shrink */ const $a90307b91a939105$var$MAX_SQUARE_SIDE = 16384;
const $a90307b91a939105$var$regExpShrink = /^([0-9]+)x([0-9]+)(?:\s+(\d{1,2}|100)%)?$/i;
const $a90307b91a939105$export$5722be5ae0d8d78a = (value)=>{
    const terms = $a90307b91a939105$var$regExpShrink.exec(value?.toLocaleLowerCase()) || [];
    if (!terms.length) return false;
    const sizeShrink = terms[1] * terms[2];
    const maxSize = $a90307b91a939105$var$MAX_SQUARE_SIDE * $a90307b91a939105$var$MAX_SQUARE_SIDE;
    if (sizeShrink > maxSize) {
        console.warn(`Shrinked size can not be larger than ${Math.floor(maxSize / 1000 / 1000)}MP. ` + `You have set ${terms[1]}x${terms[2]} (` + `${Math.ceil(sizeShrink / 1000 / 100) / 10}MP).`);
        return false;
    }
    return {
        quality: terms[3] ? terms[3] / 100 : undefined,
        size: sizeShrink
    };
};


const $50aa2edfac49ad6e$var$FileItemState = Object.freeze({
    FINISHED: Symbol(0),
    FAILED: Symbol(1),
    UPLOADING: Symbol(2),
    IDLE: Symbol(3)
});
class $50aa2edfac49ad6e$export$a964e6adf466d4a6 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    pauseRender = true;
    /** @private */ _entrySubs = new Set();
    /**
   * @private
   * @type {any} TODO: Add types for upload entry
   */ _entry = null;
    /** @private */ _isIntersecting = false;
    /** @private */ _debouncedGenerateThumb = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._generateThumbnail.bind(this), 100);
    /** @private */ _debouncedCalculateState = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._calculateState.bind(this), 100);
    /** @private */ _renderedOnce = false;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            uid: '',
            itemName: '',
            errorText: '',
            thumbUrl: '',
            progressValue: 0,
            progressVisible: false,
            badgeIcon: '',
            isFinished: false,
            isFailed: false,
            isUploading: false,
            isFocused: false,
            isEditable: false,
            state: $50aa2edfac49ad6e$var$FileItemState.IDLE,
            onEdit: ()=>{
                this.set$({
                    '*focusedEntry': this._entry
                });
                if (this.hasBlockInCtx((b)=>b.activityType === (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.DETAILS)) this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.DETAILS;
                else this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
            },
            onRemove: ()=>{
                this.uploadCollection.remove(this.$.uid);
            },
            onUpload: ()=>{
                this.upload();
            }
        };
    }
    _reset() {
        for (let sub of this._entrySubs)sub.remove();
        this._debouncedGenerateThumb.cancel();
        this._debouncedCalculateState.cancel();
        this._entrySubs = new Set();
        this._entry = null;
    }
    /**
   * @private
   * @param {IntersectionObserverEntry[]} entries
   */ _observerCallback(entries) {
        let [entry] = entries;
        this._isIntersecting = entry.isIntersecting;
        if (entry.isIntersecting && !this._renderedOnce) {
            this.render();
            this._renderedOnce = true;
        }
        if (entry.intersectionRatio === 0) this._debouncedGenerateThumb.cancel();
        else this._debouncedGenerateThumb();
    }
    /** @private */ _calculateState() {
        if (!this._entry) return;
        let entry = this._entry;
        let state = $50aa2edfac49ad6e$var$FileItemState.IDLE;
        if (entry.getValue('errors').length > 0) state = $50aa2edfac49ad6e$var$FileItemState.FAILED;
        else if (entry.getValue('isUploading')) state = $50aa2edfac49ad6e$var$FileItemState.UPLOADING;
        else if (entry.getValue('fileInfo')) state = $50aa2edfac49ad6e$var$FileItemState.FINISHED;
        this.$.state = state;
    }
    /** @private */ async _generateThumbnail() {
        if (!this._entry) return;
        let entry = this._entry;
        if (entry.getValue('fileInfo') && entry.getValue('isImage')) {
            let size = this.cfg.thumbSize;
            let thumbUrl = this.proxyUrl((0, $40a69650bbcf2c17$export$226a37372a69410c)((0, $40a69650bbcf2c17$export$816ae8f9591f1ab2)(this.cfg.cdnCname, this._entry.getValue('uuid')), (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)(entry.getValue('cdnUrlModifiers'), `scale_crop/${size}x${size}/center`)));
            let currentThumbUrl = entry.getValue('thumbUrl');
            if (currentThumbUrl !== thumbUrl) {
                entry.setValue('thumbUrl', thumbUrl);
                currentThumbUrl?.startsWith('blob:') && URL.revokeObjectURL(currentThumbUrl);
            }
            return;
        }
        if (entry.getValue('thumbUrl')) return;
        if (entry.getValue('file')?.type.includes('image')) try {
            let thumbUrl = await (0, $fd4410bd1e954deb$export$1c6697d6d7c7cdc2)(entry.getValue('file'), this.cfg.thumbSize);
            entry.setValue('thumbUrl', thumbUrl);
        } catch (err) {
            let color = window.getComputedStyle(this).getPropertyValue('--clr-generic-file-icon');
            entry.setValue('thumbUrl', (0, $213c41776f7daa31$export$138da82c49e1ea0e)(color));
        }
        else {
            let color = window.getComputedStyle(this).getPropertyValue('--clr-generic-file-icon');
            entry.setValue('thumbUrl', (0, $213c41776f7daa31$export$138da82c49e1ea0e)(color));
        }
    }
    /**
   * @private
   * @param {string} prop
   * @param {(value: any) => void} handler
   */ _subEntry(prop, handler) {
        let sub = this._entry.subscribe(prop, /** @param {any} value */ (value)=>{
            if (this.isConnected) handler(value);
        });
        this._entrySubs.add(sub);
    }
    /**
   * @private
   * @param {String} id
   */ _handleEntryId(id) {
        this._reset();
        /** @type {import('../../abstract/TypedData.js').TypedData} */ let entry = this.uploadCollection?.read(id);
        this._entry = entry;
        if (!entry) return;
        this._subEntry('uploadProgress', (uploadProgress)=>{
            this.$.progressValue = uploadProgress;
        });
        this._subEntry('fileName', (name)=>{
            this.$.itemName = name || entry.getValue('externalUrl') || this.l10n('file-no-name');
            this._debouncedCalculateState();
        });
        this._subEntry('externalUrl', (externalUrl)=>{
            this.$.itemName = entry.getValue('fileName') || externalUrl || this.l10n('file-no-name');
        });
        this._subEntry('fileInfo', (fileInfo)=>{
            this._debouncedCalculateState();
            if (fileInfo && this._isIntersecting) this._debouncedGenerateThumb();
        });
        this._subEntry('cdnUrlModifiers', ()=>{
            if (this._isIntersecting) this._debouncedGenerateThumb();
        });
        this._subEntry('thumbUrl', (thumbUrl)=>{
            this.$.thumbUrl = thumbUrl ? `url(${thumbUrl})` : '';
        });
        this._subEntry('errors', ()=>this._debouncedCalculateState());
        this._subEntry('isUploading', ()=>this._debouncedCalculateState());
        this._subEntry('fileSize', ()=>this._debouncedCalculateState());
        this._subEntry('mimeType', ()=>this._debouncedCalculateState());
        this._subEntry('isImage', ()=>this._debouncedCalculateState());
        if (this._isIntersecting) this._debouncedGenerateThumb();
    }
    initCallback() {
        super.initCallback();
        this.sub('uid', (uid)=>{
            this._handleEntryId(uid);
        });
        this.sub('state', (state)=>{
            this._handleState(state);
        });
        this.subConfigValue('useCloudImageEditor', ()=>this._debouncedCalculateState());
        this.onclick = ()=>{
            $50aa2edfac49ad6e$export$a964e6adf466d4a6.activeInstances.forEach((inst)=>{
                if (inst === this) inst.setAttribute('focused', '');
                else inst.removeAttribute('focused');
            });
        };
        this.sub('*uploadTrigger', /** @param {Set<string>} itemsToUpload */ (itemsToUpload)=>{
            if (!itemsToUpload.has(this._entry.uid)) return;
            setTimeout(()=>this.isConnected && this.upload());
        });
        $50aa2edfac49ad6e$export$a964e6adf466d4a6.activeInstances.add(this);
    }
    /** @param {(typeof FileItemState)[keyof typeof FileItemState]} state */ _handleState(state) {
        if (state === $50aa2edfac49ad6e$var$FileItemState.FAILED) this.$.badgeIcon = 'badge-error';
        else if (state === $50aa2edfac49ad6e$var$FileItemState.FINISHED) this.$.badgeIcon = 'badge-success';
        if (state === $50aa2edfac49ad6e$var$FileItemState.UPLOADING) this.$.isFocused = false;
        else this.$.progressValue = 0;
        this.set$({
            isFailed: state === $50aa2edfac49ad6e$var$FileItemState.FAILED,
            isUploading: state === $50aa2edfac49ad6e$var$FileItemState.UPLOADING,
            isFinished: state === $50aa2edfac49ad6e$var$FileItemState.FINISHED,
            progressVisible: state === $50aa2edfac49ad6e$var$FileItemState.UPLOADING,
            isEditable: this.cfg.useCloudImageEditor && this._entry?.getValue('isImage') && this._entry?.getValue('cdnUrl'),
            errorText: this._entry.getValue('errors')?.[0]?.message
        });
    }
    destroyCallback() {
        super.destroyCallback();
        $50aa2edfac49ad6e$export$a964e6adf466d4a6.activeInstances.delete(this);
        this._reset();
    }
    connectedCallback() {
        super.connectedCallback();
        /** @private */ this._observer = new window.IntersectionObserver(this._observerCallback.bind(this), {
            root: this.parentElement,
            rootMargin: '50% 0px 50% 0px',
            threshold: [
                0,
                1
            ]
        });
        this._observer.observe(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._debouncedGenerateThumb.cancel();
        this._observer?.disconnect();
    }
    _settingsOfShrink() {
        return (0, $a90307b91a939105$export$5722be5ae0d8d78a)(this.cfg.imageShrink);
    }
    /**
   * @private
   * @param {File} file
   */ _processShrink(file) {
        return (0, $5f63a07ca859c63a$export$d92be28d49332e45)(file, this._settingsOfShrink());
    }
    async upload() {
        let entry = this._entry;
        if (!this.uploadCollection.read(entry.uid)) return;
        if (entry.getValue('fileInfo') || entry.getValue('isUploading') || entry.getValue('errors').length > 0) return;
        const multipleMax = this.cfg.multiple ? this.cfg.multipleMax : 1;
        if (multipleMax && this.uploadCollection.size > multipleMax) return;
        this._debouncedCalculateState();
        entry.setValue('isUploading', true);
        entry.setValue('errors', []);
        try {
            let abortController = new AbortController();
            entry.setValue('abortController', abortController);
            const uploadTask = async ()=>{
                let file = entry.getValue('file');
                if (file && this.cfg.imageShrink) file = await this._processShrink(file).catch(()=>file);
                const fileInput = file || entry.getValue('externalUrl') || entry.getValue('uuid');
                const baseUploadClientOptions = this.getUploadClientOptions();
                /** @type {import('@uploadcare/upload-client').FileFromOptions} */ const uploadClientOptions = {
                    ...baseUploadClientOptions,
                    fileName: entry.getValue('fileName'),
                    source: entry.getValue('source'),
                    onProgress: (progress)=>{
                        if (progress.isComputable) {
                            let percentage = progress.value * 100;
                            entry.setValue('uploadProgress', percentage);
                        }
                    },
                    signal: abortController.signal,
                    metadata: await this.getMetadataFor(entry.uid)
                };
                this.debugPrint('upload options', fileInput, uploadClientOptions);
                return (0, $3905b2ce68ef12c7$export$a5575dbeeffdad98)(fileInput, uploadClientOptions);
            };
            /** @type {import('@uploadcare/upload-client').UploadcareFile} */ let fileInfo = await this.$['*uploadQueue'].add(uploadTask);
            entry.setMultipleValues({
                fileInfo: fileInfo,
                isUploading: false,
                fileName: fileInfo.originalFilename,
                fileSize: fileInfo.size,
                isImage: fileInfo.isImage,
                mimeType: fileInfo.contentInfo?.mime?.mime ?? fileInfo.mimeType,
                uuid: fileInfo.uuid,
                cdnUrl: entry.getValue('cdnUrl') ?? fileInfo.cdnUrl,
                cdnUrlModifiers: entry.getValue('cdnUrlModifiers') ?? '',
                uploadProgress: 100
            });
            if (entry === this._entry) this._debouncedCalculateState();
        } catch (cause) {
            if (cause instanceof (0, $3905b2ce68ef12c7$export$d7f5e52d091a66db) && cause.isCancel) entry.setMultipleValues({
                isUploading: false,
                uploadProgress: 0
            });
            else entry.setMultipleValues({
                isUploading: false,
                uploadProgress: 0,
                uploadError: cause
            });
            if (entry === this._entry) this._debouncedCalculateState();
        }
    }
}
$50aa2edfac49ad6e$export$a964e6adf466d4a6.template = /* HTML */ `
  <div class="inner" set="@finished: isFinished; @uploading: isUploading; @failed: isFailed; @focused: isFocused">
    <div class="thumb" set="style.backgroundImage: thumbUrl">
      <div class="badge">
        <lr-icon set="@name: badgeIcon"></lr-icon>
      </div>
    </div>
    <div class="file-name-wrapper">
      <span class="file-name" set="@title: itemName">{{itemName}}</span>
      <span class="file-error" set="@hidden: !errorText">{{errorText}}</span>
    </div>
    <div class="file-actions">
      <button type="button" class="edit-btn mini-btn" set="onclick: onEdit; @hidden: !isEditable">
        <lr-icon name="edit-file"></lr-icon>
      </button>
      <button type="button" class="remove-btn mini-btn" set="onclick: onRemove;">
        <lr-icon name="remove-file"></lr-icon>
      </button>
      <button type="button" class="upload-btn mini-btn" set="onclick: onUpload;">
        <lr-icon name="upload"></lr-icon>
      </button>
    </div>
    <lr-progress-bar class="progress-bar" set="value: progressValue; visible: progressVisible;"> </lr-progress-bar>
  </div>
`;
$50aa2edfac49ad6e$export$a964e6adf466d4a6.activeInstances = new Set();


// @ts-check

class $bfefff980ffa9ae7$export$2b77a92f1a5ad772 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    static StateConsumerScope = 'modal';
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            '*modalActive': false,
            isOpen: false,
            closeClicked: this._handleDialogClose
        };
    }
    _handleBackdropClick = ()=>{
        this._closeDialog();
    };
    _closeDialog = ()=>{
        this.setOrAddState('*modalActive', false);
    };
    _handleDialogClose = ()=>{
        this._closeDialog();
    };
    /** @param {Event} e */ _handleDialogMouseDown = (e)=>{
        /** @private */ this._mouseDownTarget = e.target;
    };
    /** @param {Event} e */ _handleDialogMouseUp = (e)=>{
        if (e.target === this.ref.dialog && e.target === this._mouseDownTarget) this._closeDialog();
    };
    show() {
        if (this.ref.dialog.showModal) this.ref.dialog.showModal();
        else this.ref.dialog.setAttribute('open', '');
    }
    hide() {
        if (this.ref.dialog.close) this.ref.dialog.close();
        else this.ref.dialog.removeAttribute('open');
    }
    initCallback() {
        super.initCallback();
        if (typeof HTMLDialogElement === 'function') {
            this.ref.dialog.addEventListener('close', this._handleDialogClose);
            this.ref.dialog.addEventListener('mousedown', this._handleDialogMouseDown);
            this.ref.dialog.addEventListener('mouseup', this._handleDialogMouseUp);
        } else {
            this.setAttribute('dialog-fallback', '');
            let backdrop = document.createElement('div');
            backdrop.className = 'backdrop';
            this.appendChild(backdrop);
            backdrop.addEventListener('click', this._handleBackdropClick);
        }
        this.sub('*modalActive', (modalActive)=>{
            if (this.$.isOpen !== modalActive) this.$.isOpen = modalActive;
            if (modalActive && this.cfg.modalScrollLock) document.body.style.overflow = 'hidden';
            else document.body.style.overflow = '';
        });
        this.subConfigValue('modalBackdropStrokes', (val)=>{
            if (val) this.setAttribute('strokes', '');
            else this.removeAttribute('strokes');
        });
        this.sub('isOpen', (isOpen)=>{
            if (isOpen) this.show();
            else this.hide();
        });
    }
    destroyCallback() {
        super.destroyCallback();
        document.body.style.overflow = '';
        this._mouseDownTarget = undefined;
        this.ref.dialog.removeEventListener('close', this._handleDialogClose);
        this.ref.dialog.removeEventListener('mousedown', this._handleDialogMouseDown);
        this.ref.dialog.removeEventListener('mouseup', this._handleDialogMouseUp);
    }
}
$bfefff980ffa9ae7$export$2b77a92f1a5ad772.template = /* HTML */ `
  <dialog ref="dialog">
    <slot></slot>
  </dialog>
`;


// @ts-check



// @ts-check
/**
 * @template {{ (...args: any[]): void }} T
 * @param {T} fn
 * @param {number} wait
 * @returns {T & { readonly cancel: () => void }} }
 */ const $db68f0fff3f52aa4$export$de363e709c412c8a = (fn, wait)=>{
    /** @type {boolean} */ let inThrottle;
    /** @type {ReturnType<typeof setTimeout>} */ let lastFn;
    /** @type {number} */ let lastTime;
    /** @param {...any} args */ const throttled = (...args)=>{
        if (!inThrottle) {
            fn(...args);
            lastTime = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFn);
            lastFn = setTimeout(()=>{
                if (Date.now() - lastTime >= wait) {
                    fn(...args);
                    lastTime = Date.now();
                }
            }, Math.max(wait - (Date.now() - lastTime), 0));
        }
    };
    Object.defineProperty(throttled, 'cancel', {
        configurable: false,
        writable: false,
        enumerable: false,
        value: ()=>{
            clearTimeout(lastFn);
        }
    });
    return /** @type {unknown} */ throttled;
};


class $3a73d84020afa4a3$export$41ee0b933a746426 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    // Context owner should have access to CSS l10n
    // TODO: We need to move away l10n from CSS
    couldBeCtxOwner = true;
    historyTracked = true;
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            doneBtnVisible: false,
            doneBtnEnabled: false,
            uploadBtnVisible: false,
            addMoreBtnVisible: false,
            addMoreBtnEnabled: false,
            headerText: '',
            commonErrorMessage: '',
            hasFiles: false,
            onAdd: ()=>{
                this.initFlow(true);
            },
            onUpload: ()=>{
                this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).UPLOAD_CLICK);
                this.uploadAll();
                this._throttledHandleCollectionUpdate();
            },
            onDone: ()=>{
                this.emit((0, $a25d4bde048879ae$export$3d7865934588d77e).DONE_CLICK, this.getOutputCollectionState());
                this.doneFlow();
            },
            onCancel: ()=>{
                this.uploadCollection.clearAll();
            }
        };
    }
    /** @private */ _throttledHandleCollectionUpdate = (0, $db68f0fff3f52aa4$export$de363e709c412c8a)(()=>{
        if (!this.isConnected) return;
        this._updateUploadsState();
        if (!this.couldOpenActivity && this.$['*currentActivity'] === this.activityType) this.historyBack();
    }, 300);
    /** @private */ _updateUploadsState() {
        const collectionState = this.getOutputCollectionState();
        /** @type {Summary} */ const summary = {
            total: collectionState.totalCount,
            succeed: collectionState.successCount,
            uploading: collectionState.uploadingCount,
            failed: collectionState.failedCount
        };
        const fitCountRestrictions = !collectionState.errors.some((err)=>err.type === 'TOO_MANY_FILES' || err.type === 'TOO_FEW_FILES');
        const tooMany = collectionState.errors.some((err)=>err.type === 'TOO_MANY_FILES');
        const exact = collectionState.totalCount === (this.cfg.multiple ? this.cfg.multipleMax : 1);
        const validationOk = summary.failed === 0;
        let uploadBtnVisible = false;
        let allDone = false;
        let doneBtnEnabled = false;
        const readyToUpload = summary.total - summary.succeed - summary.uploading - summary.failed;
        if (readyToUpload > 0 && fitCountRestrictions) uploadBtnVisible = true;
        else {
            allDone = true;
            doneBtnEnabled = summary.total === summary.succeed && fitCountRestrictions && validationOk;
        }
        this.set$({
            doneBtnVisible: allDone,
            doneBtnEnabled: doneBtnEnabled,
            uploadBtnVisible: uploadBtnVisible,
            addMoreBtnEnabled: summary.total === 0 || !tooMany && !exact,
            addMoreBtnVisible: !exact || this.cfg.multiple,
            headerText: this._getHeaderText(summary)
        });
    }
    /**
   * @private
   * @param {Summary} summary
   */ _getHeaderText(summary) {
        /** @param {keyof Summary} status */ const localizedText = (status)=>{
            const count = summary[status];
            return this.l10n(`header-${status}`, {
                count: count
            });
        };
        if (summary.uploading > 0) return localizedText('uploading');
        if (summary.failed > 0) return localizedText('failed');
        if (summary.succeed > 0) return localizedText('succeed');
        return localizedText('total');
    }
    get couldOpenActivity() {
        return this.cfg.showEmptyList || this.uploadCollection.size > 0;
    }
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType);
        this.subConfigValue('multiple', this._throttledHandleCollectionUpdate);
        this.subConfigValue('multipleMin', this._throttledHandleCollectionUpdate);
        this.subConfigValue('multipleMax', this._throttledHandleCollectionUpdate);
        this.sub('*currentActivity', (currentActivity)=>{
            if (!this.couldOpenActivity && currentActivity === this.activityType) this.$['*currentActivity'] = this.initActivity;
        });
        // TODO: could be performance issue on many files
        // there is no need to update buttons state on every progress tick
        this.uploadCollection.observeProperties(this._throttledHandleCollectionUpdate);
        this.sub('*uploadList', (list)=>{
            this._throttledHandleCollectionUpdate();
            this.set$({
                hasFiles: list.length > 0
            });
            if (!this.cfg.confirmUpload) this.uploadAll();
        }, false);
        this.sub('*collectionErrors', /** @param {import('../../types').OutputError<import('../../types').OutputCollectionErrorType>[]} errors */ (errors)=>{
            const firstError = errors.filter((err)=>err.type !== 'SOME_FILES_HAS_ERRORS')[0];
            if (!firstError) {
                this.set$({
                    commonErrorMessage: null
                });
                return;
            }
            this.set$({
                commonErrorMessage: firstError.message
            });
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this.uploadCollection.unobserveProperties(this._throttledHandleCollectionUpdate);
    }
}
$3a73d84020afa4a3$export$41ee0b933a746426.template = /* HTML */ `
  <lr-activity-header>
    <span class="header-text">{{headerText}}</span>
    <button type="button" class="mini-btn close-btn" set="onclick: *closeModal">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>

  <div class="no-files" set="@hidden: hasFiles">
    <slot name="empty"><span l10n="no-files"></span></slot>
  </div>

  <div class="files" repeat="*uploadList" repeat-item-tag="lr-file-item"></div>

  <div class="common-error" set="@hidden: !commonErrorMessage; textContent: commonErrorMessage;"></div>

  <div class="toolbar">
    <button type="button" class="cancel-btn secondary-btn" set="onclick: onCancel;" l10n="clear"></button>
    <div class="toolbar-spacer"></div>
    <button
      type="button"
      class="add-more-btn secondary-btn"
      set="onclick: onAdd; @disabled: !addMoreBtnEnabled; @hidden: !addMoreBtnVisible"
    >
      <lr-icon name="add"></lr-icon><span l10n="add-more"></span>
    </button>
    <button
      type="button"
      class="upload-btn primary-btn"
      set="@hidden: !uploadBtnVisible; onclick: onUpload;"
      l10n="upload"
    ></button>
    <button
      type="button"
      class="done-btn primary-btn"
      set="@hidden: !doneBtnVisible; onclick: onDone;  @disabled: !doneBtnEnabled"
      l10n="done"
    ></button>
  </div>

  <lr-drop-area ghost></lr-drop-area>
`;





class $2a73851b1d62f19c$export$cd326b6b2fa63cf5 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.URL;
    init$ = {
        ...this.init$,
        importDisabled: true,
        onUpload: (e)=>{
            e.preventDefault();
            let url = this.ref.input['value'];
            this.addFileFromUrl(url, {
                source: (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).URL_TAB
            });
            this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
        },
        onCancel: ()=>{
            this.historyBack();
        },
        onInput: (e)=>{
            let value = /** @type {HTMLInputElement} */ e.target.value;
            this.set$({
                importDisabled: !value
            });
        }
    };
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>{
                this.ref.input['value'] = '';
                this.ref.input.focus();
            }
        });
    }
}
$2a73851b1d62f19c$export$cd326b6b2fa63cf5.template = /* HTML */ `
  <lr-activity-header>
    <button type="button" class="mini-btn" set="onclick: *historyBack">
      <lr-icon name="back"></lr-icon>
    </button>
    <div>
      <lr-icon name="url"></lr-icon>
      <span l10n="caption-from-url"></span>
    </div>
    <button type="button" class="mini-btn close-btn" set="onclick: *closeModal">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>
  <form class="content">
    <input placeholder="https://" class="url-input" type="text" ref="input" set="oninput: onInput" />
    <button
      type="submit"
      class="url-upload-btn primary-btn"
      set="onclick: onUpload; @disabled: importDisabled"
    ></button>
  </form>
`;




const $9f9cc9f04d36e701$export$8123dd108ae7e125 = ()=>{
    return typeof navigator.permissions !== 'undefined';
};




class $7808f47c33c6e823$export$9a93ce53f488cb2e extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CAMERA;
    /** @private */ _unsubPermissions = null;
    init$ = {
        ...this.init$,
        video: null,
        videoTransformCss: null,
        shotBtnDisabled: true,
        videoHidden: true,
        messageHidden: true,
        requestBtnHidden: (0, $9f9cc9f04d36e701$export$8123dd108ae7e125)(),
        l10nMessage: null,
        originalErrorMessage: null,
        cameraSelectOptions: null,
        cameraSelectHidden: true,
        onCameraSelectChange: (e)=>{
            /** @type {String} */ this._selectedCameraId = e.target.value;
            this._capture();
        },
        onCancel: ()=>{
            this.historyBack();
        },
        onShot: ()=>{
            this._shot();
        },
        onRequestPermissions: ()=>{
            this._capture();
        }
    };
    /** @private */ _onActivate = ()=>{
        if ((0, $9f9cc9f04d36e701$export$8123dd108ae7e125)()) this._subscribePermissions();
        this._capture();
    };
    /** @private */ _onDeactivate = ()=>{
        if (this._unsubPermissions) this._unsubPermissions();
        this._stopCapture();
    };
    /** @private */ _handlePermissionsChange = ()=>{
        this._capture();
    };
    /**
   * @private
   * @param {'granted' | 'denied' | 'prompt'} state
   */ _setPermissionsState = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)((state)=>{
        this.$.originalErrorMessage = null;
        this.classList.toggle('initialized', state === 'granted');
        if (state === 'granted') this.set$({
            videoHidden: false,
            shotBtnDisabled: false,
            messageHidden: true
        });
        else if (state === 'prompt') {
            this.$.l10nMessage = this.l10n('camera-permissions-prompt');
            this.set$({
                videoHidden: true,
                shotBtnDisabled: true,
                messageHidden: false
            });
            this._stopCapture();
        } else {
            this.$.l10nMessage = this.l10n('camera-permissions-denied');
            this.set$({
                videoHidden: true,
                shotBtnDisabled: true,
                messageHidden: false
            });
            this._stopCapture();
        }
    }, 300);
    /** @private */ async _subscribePermissions() {
        try {
            // @ts-ignore
            let permissionsResponse = await navigator.permissions.query({
                name: 'camera'
            });
            permissionsResponse.addEventListener('change', this._handlePermissionsChange);
        } catch (err) {
            console.log('Failed to use permissions API. Fallback to manual request mode.', err);
            this._capture();
        }
    }
    /** @private */ async _capture() {
        let constr = {
            video: {
                width: {
                    ideal: 1920
                },
                height: {
                    ideal: 1080
                },
                frameRate: {
                    ideal: 30
                }
            },
            audio: false
        };
        if (this._selectedCameraId) constr.video.deviceId = {
            exact: this._selectedCameraId
        };
        /** @private */ this._canvas = document.createElement('canvas');
        /** @private */ this._ctx = this._canvas.getContext('2d');
        try {
            this._setPermissionsState('prompt');
            let stream = await navigator.mediaDevices.getUserMedia(constr);
            stream.addEventListener('inactive', ()=>{
                this._setPermissionsState('denied');
            });
            this.$.video = stream;
            /** @private */ this._capturing = true;
            this._setPermissionsState('granted');
        } catch (err) {
            this._setPermissionsState('denied');
            this.$.originalErrorMessage = err.message;
        }
    }
    /** @private */ _stopCapture() {
        if (this._capturing) {
            this.$.video?.getTracks()[0].stop();
            this.$.video = null;
            this._capturing = false;
        }
    }
    /** @private */ _shot() {
        this._canvas.height = this.ref.video['videoHeight'];
        this._canvas.width = this.ref.video['videoWidth'];
        // @ts-ignore
        this._ctx.drawImage(this.ref.video, 0, 0);
        const date = Date.now();
        const name = `camera-${date}.jpeg`;
        const format = 'image/jpeg';
        this._canvas.toBlob((blob)=>{
            let file = new File([
                blob
            ], name, {
                lastModified: date,
                type: format
            });
            this.addFileFromObject(file, {
                source: (0, $b42bef79572dc8bb$export$5522e73b726d0ec8).CAMERA
            });
            this.set$({
                '*currentActivity': (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
            });
        }, format);
    }
    async initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: this._onActivate,
            onDeactivate: this._onDeactivate
        });
        this.subConfigValue('cameraMirror', (val)=>{
            this.$.videoTransformCss = val ? 'scaleX(-1)' : null;
        });
        try {
            let deviceList = await navigator.mediaDevices.enumerateDevices();
            let cameraSelectOptions = deviceList.filter((info)=>{
                return info.kind === 'videoinput';
            }).map((info, idx)=>{
                return {
                    text: info.label.trim() || `${this.l10n('caption-camera')} ${idx + 1}`,
                    value: info.deviceId
                };
            });
            if (cameraSelectOptions.length > 1) {
                this.$.cameraSelectOptions = cameraSelectOptions;
                this.$.cameraSelectHidden = false;
            }
        } catch (err) {
        // mediaDevices isn't available for HTTP
        // TODO: handle this case
        }
    }
}
$7808f47c33c6e823$export$9a93ce53f488cb2e.template = /* HTML */ `
  <lr-activity-header>
    <button type="button" class="mini-btn" set="onclick: *historyBack">
      <lr-icon name="back"></lr-icon>
    </button>
    <div set="@hidden: !cameraSelectHidden">
      <lr-icon name="camera"></lr-icon>
      <span l10n="caption-camera"></span>
    </div>
    <lr-select
      class="camera-select"
      set="$.options: cameraSelectOptions; @hidden: cameraSelectHidden; onchange: onCameraSelectChange"
    >
    </lr-select>
    <button type="button" class="mini-btn close-btn" set="onclick: *closeModal">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>
  <div class="content">
    <video
      autoplay
      playsinline
      set="srcObject: video; style.transform: videoTransformCss; @hidden: videoHidden"
      ref="video"
    ></video>
    <div class="message-box" set="@hidden: messageHidden">
      <span>{{l10nMessage}}</span>
      <span>{{originalErrorMessage}}</span>
      <button
        type="button"
        set="onclick: onRequestPermissions; @hidden: requestBtnHidden"
        l10n="camera-permissions-request"
      ></button>
    </div>
    <button type="button" class="shot-btn" set="onclick: onShot; @disabled: shotBtnDisabled">
      <lr-icon name="camera"></lr-icon>
    </button>
  </div>
`;


// @ts-check


class $e49d5535c683c8a8$var$UploadCtxProviderClass extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    requireCtxName = true;
    initCallback() {
        super.initCallback();
        this.$['*eventEmitter'].bindTarget(this);
    }
    destroyCallback() {
        super.destroyCallback();
        this.$['*eventEmitter'].unbindTarget(this);
    }
}
$e49d5535c683c8a8$var$UploadCtxProviderClass.EventType = (0, $a25d4bde048879ae$export$3d7865934588d77e);
const $e49d5535c683c8a8$export$6edf8f70f62f022d = /** @type {unknown} */ $e49d5535c683c8a8$var$UploadCtxProviderClass;







class $55031f1dea86a0bb$export$e4ba681f177b2cad extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.DETAILS;
    pauseRender = true;
    init$ = {
        ...this.init$,
        checkerboard: false,
        fileSize: null,
        fileName: '',
        cdnUrl: '',
        errorTxt: '',
        cloudEditBtnHidden: true,
        onNameInput: null,
        onBack: ()=>{
            this.historyBack();
        },
        onRemove: ()=>{
            /** @type {File[]} */ this.uploadCollection.remove(this.entry.uid);
            this.historyBack();
        },
        onCloudEdit: ()=>{
            if (this.entry.getValue('uuid')) this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
        }
    };
    showNonImageThumb() {
        let color = window.getComputedStyle(this).getPropertyValue('--clr-generic-file-icon');
        let url = (0, $213c41776f7daa31$export$138da82c49e1ea0e)(color, 108, 108);
        this.ref.filePreview.setImageUrl(url);
        this.set$({
            checkerboard: false
        });
    }
    initCallback() {
        super.initCallback();
        // Rendering is postponed for the CSS-context-properties usage in template:
        this.render();
        this.$.fileSize = this.l10n('file-size-unknown');
        this.registerActivity(this.activityType, {
            onDeactivate: ()=>{
                this.ref.filePreview.clear();
            }
        });
        /** @type {import('../FilePreview/FilePreview.js').FilePreview} */ this.sub('*focusedEntry', (/** @type {import('../../abstract/TypedData.js').TypedData} */ entry)=>{
            if (!entry) return;
            if (this._entrySubs) this._entrySubs.forEach((sub)=>{
                this._entrySubs.delete(sub);
                sub.remove();
            });
            else /** @private */ this._entrySubs = new Set();
            this.entry = entry;
            /** @type {File} */ let file = entry.getValue('file');
            if (file) {
                /**
         * @private
         * @type {File}
         */ this._file = file;
                let isImage = (0, $65197131a4ed5785$export$9788fb119e95d11e)(this._file);
                if (isImage && !entry.getValue('cdnUrl')) {
                    this.ref.filePreview.setImageFile(this._file);
                    this.set$({
                        checkerboard: true
                    });
                }
                if (!isImage) this.showNonImageThumb();
            }
            let tmpSub = (prop, callback)=>{
                this._entrySubs.add(this.entry.subscribe(prop, callback));
            };
            tmpSub('fileName', (name)=>{
                this.$.fileName = name;
                this.$.onNameInput = ()=>{
                    let value = this.ref.file_name_input['value'];
                    Object.defineProperty(this._file, 'name', {
                        writable: true,
                        value: value
                    });
                    this.entry.setValue('fileName', value);
                };
            });
            tmpSub('fileSize', (size)=>{
                this.$.fileSize = Number.isFinite(size) ? this.fileSizeFmt(size) : this.l10n('file-size-unknown');
            });
            tmpSub('errors', (errors)=>{
                this.$.errorTxt = errors[0]?.message;
            });
            tmpSub('externalUrl', (url)=>{
                if (!url) return;
                if (!this.entry.getValue('uuid')) this.showNonImageThumb();
            });
            tmpSub('cdnUrl', (cdnUrl)=>{
                const canUseCloudEditor = this.cfg.useCloudImageEditor && cdnUrl && this.entry.getValue('isImage');
                cdnUrl && this.ref.filePreview.clear();
                this.set$({
                    cdnUrl: cdnUrl,
                    cloudEditBtnHidden: !canUseCloudEditor
                });
                if (cdnUrl && this.entry.getValue('isImage')) {
                    // TODO: need to resize image to fit the canvas size
                    let imageUrl = (0, $40a69650bbcf2c17$export$226a37372a69410c)(cdnUrl, (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)('format/auto', 'preview'));
                    this.ref.filePreview.setImageUrl(this.proxyUrl(imageUrl));
                }
            });
        });
    }
}
$55031f1dea86a0bb$export$e4ba681f177b2cad.template = /* HTML */ `
  <lr-activity-header>
    <button type="button" class="mini-btn" set="onclick: *historyBack">
      <lr-icon name="back"></lr-icon>
    </button>
    <span l10n="caption-edit-file"></span>
    <button type="button" class="mini-btn close-btn" set="onclick: *closeModal">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>
  <div class="content">
    <lr-tabs tab-list="tab-view, tab-details">
      <div tab-ctx="tab-details" class="details">
        <div class="info-block">
          <div class="info-block_name" l10n="file-name"></div>
          <input
            name="name-input"
            ref="file_name_input"
            set="value: fileName; oninput: onNameInput; @disabled: !!cdnUrl"
            type="text"
          />
        </div>

        <div class="info-block">
          <div class="info-block_name" l10n="file-size"></div>
          <div>{{fileSize}}</div>
        </div>

        <div class="info-block">
          <div class="info-block_name" l10n="cdn-url"></div>
          <a class="cdn-link" target="_blank" set="@href: cdnUrl; @disabled: !cdnUrl">{{cdnUrl}}</a>
        </div>

        <div>{{errorTxt}}</div>
      </div>

      <lr-file-preview tab-ctx="tab-view" set="@checkerboard: checkerboard;" ref="filePreview"> </lr-file-preview>
    </lr-tabs>

    <div class="toolbar" set="@edit-disabled: cloudEditBtnHidden">
      <button type="button" class="edit-btn secondary-btn" set="onclick: onCloudEdit; @hidden: cloudEditBtnHidden;">
        <lr-icon name="edit"></lr-icon>
        <span l10n="edit-image"></span>
      </button>
      <button type="button" class="remove-btn secondary-btn" set="onclick: onRemove">
        <lr-icon name="remove"></lr-icon>
        <span l10n="remove-from-list"></span>
      </button>
      <div></div>
      <button type="button" class="back-btn primary-btn" set="onclick: onBack">
        <span l10n="ok"></span>
      </button>
    </div>
  </div>
`;



class $30c3bfd4ad929842$export$fbac4eea39f404d3 {
    captionL10nStr = 'confirm-your-action';
    messageL10Str = 'are-you-sure';
    confirmL10nStr = 'yes';
    denyL10nStr = 'no';
    confirmAction() {
        console.log('Confirmed');
    }
    denyAction() {
        this['historyBack']();
    }
}
class $30c3bfd4ad929842$export$b8704437d11c7fe7 extends (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747) {
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CONFIRMATION;
    /** @private */ _defaults = new $30c3bfd4ad929842$export$fbac4eea39f404d3();
    init$ = {
        ...this.init$,
        activityCaption: '',
        messageTxt: '',
        confirmBtnTxt: '',
        denyBtnTxt: '',
        '*confirmation': null,
        onConfirm: this._defaults.confirmAction,
        onDeny: this._defaults.denyAction.bind(this)
    };
    initCallback() {
        super.initCallback();
        this.set$({
            messageTxt: this.l10n(this._defaults.messageL10Str),
            confirmBtnTxt: this.l10n(this._defaults.confirmL10nStr),
            denyBtnTxt: this.l10n(this._defaults.denyL10nStr)
        });
        this.sub('*confirmation', (/** @type {UiConfirmation} */ cfn)=>{
            if (!cfn) return;
            this.set$({
                '*currentActivity': (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CONFIRMATION,
                activityCaption: this.l10n(cfn.captionL10nStr),
                messageTxt: this.l10n(cfn.messageL10Str),
                confirmBtnTxt: this.l10n(cfn.confirmL10nStr),
                denyBtnTxt: this.l10n(cfn.denyL10nStr),
                onDeny: ()=>{
                    cfn.denyAction();
                },
                onConfirm: ()=>{
                    cfn.confirmAction();
                }
            });
        });
    }
}
$30c3bfd4ad929842$export$b8704437d11c7fe7.template = /* HTML */ `
  <lr-activity-header>
    <button type="button" class="mini-btn" set="onclick: *historyBack">
      <lr-icon name="back"></lr-icon>
    </button>
    <span>{{activityCaption}}</span>
    <button type="button" class="mini-btn close-btn" set="onclick: *closeModal">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>

  <div class="message">{{messageTxt}}</div>
  <div class="toolbar">
    <button type="button" class="deny-btn secondary-btn" set="onclick: onDeny">{{denyBtnTxt}}</button>
    <button type="button" class="confirm-btn primary-btn" set="onclick: onConfirm">{{confirmBtnTxt}}</button>
  </div>
`;



class $6f8e0aefce596795$export$fcea9c441fb00ad4 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    init$ = {
        ...this.init$,
        visible: false,
        value: 0,
        '*commonProgress': 0
    };
    initCallback() {
        super.initCallback();
        /** @private */ this._unobserveCollection = this.uploadCollection.observeProperties(()=>{
            let anyUploading = this.uploadCollection.items().some((id)=>{
                let item = this.uploadCollection.read(id);
                return item.getValue('isUploading');
            });
            this.$.visible = anyUploading;
        });
        this.sub('visible', (visible)=>{
            if (visible) this.setAttribute('active', '');
            else this.removeAttribute('active');
        });
        this.sub('*commonProgress', (progress)=>{
            this.$.value = progress;
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this._unobserveCollection?.();
    }
}
$6f8e0aefce596795$export$fcea9c441fb00ad4.template = /* HTML */ ` <lr-progress-bar set="visible: visible; value: value"></lr-progress-bar> `;



class $0374dfef35ba08c7$export$c17561cb55d4db30 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    /** @type {Number} */ _value = 0;
    init$ = {
        ...this.init$,
        width: 0,
        opacity: 0
    };
    initCallback() {
        super.initCallback();
        this.defineAccessor('value', (value)=>{
            if (value === undefined) return;
            const prevValue = this._value;
            this._value = value;
            if (value === 0 && prevValue > 0) {
                this.ref.line.addEventListener('transitionend', ()=>{
                    this.style.setProperty('--l-width', this._value.toString());
                });
                return;
            }
            this.style.setProperty('--l-width', this._value.toString());
        });
        this.defineAccessor('visible', (visible)=>{
            this.ref.line.classList.toggle('progress--hidden', !visible);
        });
    }
}
$0374dfef35ba08c7$export$c17561cb55d4db30.template = /* HTML */ ` <div ref="line" class="progress"></div> `;




const $c6e67fc7ecc40345$export$67da346bbbd9b9d4 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';


class $4da4cb141c2fa4c7$export$a127194569a41afb extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        checkerboard: false,
        src: (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4)
    };
    constructor(){
        super();
    }
    initCallback() {
        super.initCallback();
        this.sub('checkerboard', ()=>{
            this.style.backgroundImage = this.hasAttribute('checkerboard') ? `url(${(0, $213c41776f7daa31$export$94a13a3239cc67e3)()})` : 'unset';
        });
    }
    destroyCallback() {
        super.destroyCallback();
        URL.revokeObjectURL(this._lastObjectUrl);
    }
    /** @param {HTMLImageElement} img */ setImage(img) {
        this.$.src = img.src;
    }
    /** @param {File} imgFile */ setImageFile(imgFile) {
        let url = URL.createObjectURL(imgFile);
        this.$.src = url;
        this._lastObjectUrl = url;
    }
    /** @param {String} url */ setImageUrl(url) {
        this.$.src = url;
    }
    clear() {
        URL.revokeObjectURL(this._lastObjectUrl);
        this.$.src = (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4);
    }
}
$4da4cb141c2fa4c7$export$a127194569a41afb.template = /* HTML */ ` <lr-img class="img-view" ref="img" set="@src: src; style.aa: src;" /> `;
$4da4cb141c2fa4c7$export$a127194569a41afb.bindAttributes({
    checkerboard: 'checkerboard'
});


var $016f44b216a56b5b$exports = {};
var $2049556ade30f986$exports = {};

$parcel$export($2049556ade30f986$exports, "CloudImageEditorBlock", () => $dfe930b7333347e3$export$20cace3f5dd477e2);
$parcel$export($2049556ade30f986$exports, "CropFrame", () => $3f5a15532f2cfbab$export$eaec7dd192dada87);
$parcel$export($2049556ade30f986$exports, "EditorCropButtonControl", () => $e33b22ad871900d8$export$603075e7d8e604b2);
$parcel$export($2049556ade30f986$exports, "EditorFilterControl", () => $4b898949c88745a4$export$1cf4b09278d815ee);
$parcel$export($2049556ade30f986$exports, "EditorOperationControl", () => $a3c4677821912179$export$cf5be688aafa2355);
$parcel$export($2049556ade30f986$exports, "EditorImageCropper", () => $2faf70473f377dd1$export$fc01d462d57ea6e6);
$parcel$export($2049556ade30f986$exports, "EditorImageFader", () => $37112e1b54821784$export$15eaf4dbf84459f1);
$parcel$export($2049556ade30f986$exports, "EditorScroller", () => $f18686f36602dda4$export$88b72cf03cc30a69);
$parcel$export($2049556ade30f986$exports, "EditorSlider", () => $127203a35c886dd7$export$9ab173fa70108ef4);
$parcel$export($2049556ade30f986$exports, "EditorToolbar", () => $79853253e74da0e3$export$477aaffea178bc4e);
$parcel$export($2049556ade30f986$exports, "LrBtnUi", () => $8c5555ff86dfc600$export$3899e04dfd1bb237);
$parcel$export($2049556ade30f986$exports, "LineLoaderUi", () => $0b5e3841f204f961$export$21cd7d08dbb08eff);
$parcel$export($2049556ade30f986$exports, "PresenceToggle", () => $a2e1e00685856b5d$export$62b432f031007740);
$parcel$export($2049556ade30f986$exports, "SliderUi", () => $05fbd40f7ffb2d55$export$facfb944826701a2);
// @ts-check



// @ts-check


const $030d48f659208578$var$CSS_CFG_CTX_NAME = '--cfg-ctx-name';
class $030d48f659208578$export$bfab8e80be0da35 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    /**
   * @private
   * @returns {string}
   */ get cfgCssCtxName() {
        return this.getCssData($030d48f659208578$var$CSS_CFG_CTX_NAME, true);
    }
    /** @private */ get cfgCtxName() {
        const ctxName = this.getAttribute('ctx-name')?.trim() || this.cfgCssCtxName || this.__cachedCfgCtxName;
        if (!ctxName) throw new Error(`ctx-name attribute is required for ${this.constructor.name}`);
        /**
     * Cache last ctx name to be able to access context when element becames disconnected
     *
     * @type {String}
     */ this.__cachedCfgCtxName = ctxName;
        return ctxName;
    }
    connectedCallback() {
        if (!this.connectedOnce) {
            const ctxName = this.getAttribute('ctx-name')?.trim();
            if (ctxName) this.style.setProperty($030d48f659208578$var$CSS_CFG_CTX_NAME, `'${ctxName}'`);
        }
        super.connectedCallback();
    }
    /**
   * Resolve cfg from context passed with ctx-name attribute
   *
   * @param {String} prop
   * @returns {any}
   * @protected
   */ parseCfgProp(prop) {
        const parsed = {
            ...super.parseCfgProp(prop),
            ctx: (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(this.cfgCtxName)
        };
        return parsed;
    }
    get debugCtxName() {
        return this.cfgCtxName;
    }
}


function $1de04e4a7162860e$var$normalize(...args) {
    return args.reduce((result, arg)=>{
        if (typeof arg === 'string') {
            result[arg] = true;
            return result;
        }
        for (let token of Object.keys(arg))result[token] = arg[token];
        return result;
    }, {});
}
function $1de04e4a7162860e$export$ce4ab0c55987d1ff(...args) {
    let mapping = $1de04e4a7162860e$var$normalize(...args);
    return Object.keys(mapping).reduce((result, token)=>{
        if (mapping[token]) result.push(token);
        return result;
    }, []).join(' ');
}
function $1de04e4a7162860e$export$7efcd118c973e827(element, ...args) {
    let mapping = $1de04e4a7162860e$var$normalize(...args);
    for (let token of Object.keys(mapping))element.classList.toggle(token, mapping[token]);
}



// @ts-check


const $421bf232de0dd79f$export$26e282a18fc21889 = (tabs)=>{
    if (!tabs) return 0, $1ce1dd3703477f5c$export$d9a4cca3740decc7;
    const tabList = (0, $127bf1109bfdfae3$export$ad1a3127869611f1)(tabs).filter((tab)=>(0, $1ce1dd3703477f5c$export$d9a4cca3740decc7).includes(tab));
    if (tabList.length === 0) return 0, $1ce1dd3703477f5c$export$d9a4cca3740decc7;
    return tabList;
};



// @ts-check





function $691c9009f7745b15$export$f6196a6c6bb539b4(fnCtx) {
    return {
        '*originalUrl': null,
        '*faderEl': null,
        '*cropperEl': null,
        '*imgEl': null,
        '*imgContainerEl': null,
        '*networkProblems': false,
        '*imageSize': null,
        /** @type {import('./types.js').Transformations} */ '*editorTransformations': {},
        /** @type {import('./types.js').CropPresetList} */ '*cropPresetList': [],
        '*tabList': (0, $1ce1dd3703477f5c$export$d9a4cca3740decc7),
        '*tabId': (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP,
        entry: null,
        extension: null,
        editorMode: false,
        modalCaption: '',
        isImage: false,
        msg: '',
        src: (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4),
        fileType: '',
        showLoader: false,
        // options
        uuid: null,
        cdnUrl: null,
        cropPreset: '',
        tabs: (0, $127bf1109bfdfae3$export$1494b4974e65fb4e)((0, $1ce1dd3703477f5c$export$d9a4cca3740decc7)),
        'presence.networkProblems': false,
        'presence.modalCaption': true,
        'presence.editorToolbar': false,
        'presence.viewerToolbar': true,
        // TODO: beware of wrong ctx in case of element re-creation:
        '*on.retryNetwork': ()=>{
            let images = fnCtx.querySelectorAll('img');
            for (let img of images){
                let originalSrc = img.src;
                img.src = (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4);
                img.src = originalSrc;
            }
            fnCtx.$['*networkProblems'] = false;
        },
        /** @param {import('./types.js').Transformations} transformations */ '*on.apply': (transformations)=>{
            if (!transformations) return;
            let originalUrl = fnCtx.$['*originalUrl'];
            let cdnUrlModifiers = (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)((0, $1b348a031d3b3585$export$d901e4e307b689de)(transformations), 'preview');
            let cdnUrl = (0, $40a69650bbcf2c17$export$226a37372a69410c)(originalUrl, cdnUrlModifiers);
            /** @type {import('./types.js').ApplyResult} */ let eventData = {
                originalUrl: originalUrl,
                cdnUrlModifiers: cdnUrlModifiers,
                cdnUrl: cdnUrl,
                transformations: transformations
            };
            fnCtx.dispatchEvent(new CustomEvent('apply', {
                detail: eventData,
                bubbles: true,
                composed: true
            }));
            fnCtx.remove();
        },
        '*on.cancel': ()=>{
            fnCtx.remove();
            fnCtx.dispatchEvent(new CustomEvent('cancel', {
                bubbles: true,
                composed: true
            }));
        }
    };
}



const $ba47818dc7d567f1$export$b3167c59aca35da5 = /* HTML */ `
  <div class="wrapper wrapper_desktop">
    <lr-presence-toggle class="network_problems_splash" set="visible: presence.networkProblems;">
      <div class="network_problems_content">
        <div class="network_problems_icon">
          <lr-icon size="20" name="sad"></lr-icon>
        </div>
        <div class="network_problems_text">Network error</div>
      </div>
      <div class="network_problems_footer">
        <lr-btn-ui theme="primary" text="Retry" set="onclick: *on.retryNetwork"></lr-btn-ui>
      </div>
    </lr-presence-toggle>
    <div class="viewport">
      <div class="file_type_outer">
        <div class="file_type">{{fileType}}</div>
      </div>
      <div class="image_container" ref="img-container-el">
        <img src="${(0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4)}" class="image image_visible_from_editor" ref="img-el" />
        <lr-editor-image-cropper ref="cropper-el"></lr-editor-image-cropper>
        <lr-editor-image-fader ref="fader-el"></lr-editor-image-fader>
      </div>
      <div class="info_pan">{{msg}}</div>
    </div>
    <div class="toolbar">
      <lr-line-loader-ui set="active: showLoader"></lr-line-loader-ui>
      <div class="toolbar_content toolbar_content__editor">
        <lr-editor-toolbar></lr-editor-toolbar>
      </div>
    </div>
  </div>
`;



class $dfe930b7333347e3$export$20cace3f5dd477e2 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    static className = 'cloud-image-editor';
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            ...(0, $691c9009f7745b15$export$f6196a6c6bb539b4)(this)
        };
    }
    /** Force cloud editor to always use own context */ get ctxName() {
        return this.autoCtxName;
    }
    /** @private */ _debouncedShowLoader = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._showLoader.bind(this), 300);
    /**
   * @private
   * @param {boolean} show
   */ _showLoader(show) {
        this.$.showLoader = show;
    }
    /**
   * To proper work, we need non-zero size the element. So, we'll wait for it.
   *
   * @private
   * @returns {Promise<void>}
   */ _waitForSize() {
        const TIMEOUT = 3000;
        return new Promise((resolve, reject)=>{
            const timeoutId = setTimeout(()=>{
                reject(new Error('[cloud-image-editor] timeout waiting for non-zero container size'));
            }, TIMEOUT);
            const resizeObserver = new ResizeObserver(([element])=>{
                if (element.contentRect.width > 0 && element.contentRect.height > 0) {
                    resolve();
                    clearTimeout(timeoutId);
                    resizeObserver.disconnect();
                }
            });
            resizeObserver.observe(this);
        });
    }
    initCallback() {
        super.initCallback();
        this.$['*faderEl'] = this.ref['fader-el'];
        this.$['*cropperEl'] = this.ref['cropper-el'];
        this.$['*imgContainerEl'] = this.ref['img-container-el'];
        this.initEditor();
    }
    async updateImage() {
        if (!this.isConnected) return;
        await this._waitForSize();
        if (this.$.cdnUrl) {
            const uuid = (0, $40a69650bbcf2c17$export$fe804a22e4bdd033)(this.$.cdnUrl);
            const originalUrl = (0, $40a69650bbcf2c17$export$816ae8f9591f1ab2)(this.$.cdnUrl, uuid);
            if (originalUrl === this.$['*originalUrl']) return;
            this.$['*originalUrl'] = originalUrl;
            const operations = (0, $40a69650bbcf2c17$export$6ae4b875b9f5125)(this.$.cdnUrl);
            const transformations = (0, $1b348a031d3b3585$export$df8366105975a86f)(operations);
            this.$['*editorTransformations'] = transformations;
        } else if (this.$.uuid) {
            const originalUrl = (0, $40a69650bbcf2c17$export$816ae8f9591f1ab2)(this.cfg.cdnCname, this.$.uuid);
            if (originalUrl === this.$['*originalUrl']) return;
            this.$['*originalUrl'] = originalUrl;
            this.$['*editorTransformations'] = {};
        } else throw new Error('No UUID nor CDN URL provided');
        if (this.$['*tabId'] === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP) this.$['*cropperEl'].deactivate({
            reset: true
        });
        else this.$['*faderEl'].deactivate();
        try {
            const cdnUrl = (0, $40a69650bbcf2c17$export$226a37372a69410c)(this.$['*originalUrl'], (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)('json'));
            const json = await fetch(cdnUrl).then((response)=>response.json());
            const { width: width, height: height } = /** @type {{ width: number; height: number }} */ json;
            this.$['*imageSize'] = {
                width: width,
                height: height
            };
            if (this.$['*tabId'] === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP) this.$['*cropperEl'].activate(this.$['*imageSize']);
            else this.$['*faderEl'].activate({
                url: this.$['*originalUrl']
            });
        } catch (err) {
            if (err) console.error('Failed to load image info', err);
        }
    }
    async initEditor() {
        try {
            await this._waitForSize();
        } catch (err) {
            if (this.isConnected) // @ts-ignore TODO: fix this
            console.error(err.message);
            return;
        }
        this.ref['img-el'].addEventListener('load', ()=>{
            this._imgLoading = false;
            this._debouncedShowLoader(false);
            if (this.$.src !== (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4)) this.$['*networkProblems'] = false;
        });
        this.ref['img-el'].addEventListener('error', ()=>{
            this._imgLoading = false;
            this._debouncedShowLoader(false);
            this.$['*networkProblems'] = true;
        });
        this.sub('src', (src)=>{
            let el = this.ref['img-el'];
            if (el.src !== src) {
                this._imgLoading = true;
                el.src = src || (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4);
            }
        });
        this.sub('cropPreset', (val)=>{
            this.$['*cropPresetList'] = (0, $13e12cffb6e7f0c5$export$a99f8a1d2eae458)(val);
        });
        this.sub('tabs', /** @param {string} val */ (val)=>{
            this.$['*tabList'] = (0, $421bf232de0dd79f$export$26e282a18fc21889)(val);
        });
        this.sub('*tabId', (tabId)=>{
            this.ref['img-el'].className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)('image', {
                image_hidden_to_cropper: tabId === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP,
                image_hidden_effects: tabId !== (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP
            });
        });
        this.classList.add('editor_ON');
        this.sub('*networkProblems', (networkProblems)=>{
            this.$['presence.networkProblems'] = networkProblems;
            this.$['presence.modalCaption'] = !networkProblems;
        });
        this.sub('*editorTransformations', (transformations)=>{
            if (Object.keys(transformations).length === 0) return;
            let originalUrl = this.$['*originalUrl'];
            let cdnUrlModifiers = (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)((0, $1b348a031d3b3585$export$d901e4e307b689de)(transformations), 'preview');
            let cdnUrl = (0, $40a69650bbcf2c17$export$226a37372a69410c)(originalUrl, cdnUrlModifiers);
            /** @type {import('./types.js').ApplyResult} */ let eventData = {
                originalUrl: originalUrl,
                cdnUrlModifiers: cdnUrlModifiers,
                cdnUrl: cdnUrl,
                transformations: transformations
            };
            this.dispatchEvent(new CustomEvent('change', {
                detail: eventData,
                bubbles: true,
                composed: true
            }));
        }, false);
        this.sub('uuid', (val)=>val && this.updateImage());
        this.sub('cdnUrl', (val)=>val && this.updateImage());
    }
}
$dfe930b7333347e3$export$20cace3f5dd477e2.template = (0, $ba47818dc7d567f1$export$b3167c59aca35da5);
$dfe930b7333347e3$export$20cace3f5dd477e2.bindAttributes({
    uuid: 'uuid',
    'cdn-url': 'cdnUrl',
    'crop-preset': 'cropPreset',
    tabs: 'tabs'
});


// @ts-check




class $3f5a15532f2cfbab$export$eaec7dd192dada87 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            dragging: false
        };
        /** @private */ this._handlePointerUp = this._handlePointerUp_.bind(this);
        /** @private */ this._handlePointerMove = this._handlePointerMove_.bind(this);
        /** @private */ this._handleSvgPointerMove = this._handleSvgPointerMove_.bind(this);
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   */ _shouldThumbBeDisabled(direction) {
        let imageBox = this.$['*imageBox'];
        if (!imageBox) return;
        if (direction === '' && imageBox.height <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a) && imageBox.width <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a)) return true;
        let tooHigh = imageBox.height <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a) && (direction.includes('n') || direction.includes('s'));
        let tooWide = imageBox.width <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a) && (direction.includes('e') || direction.includes('w'));
        return tooHigh || tooWide;
    }
    /** @private */ _createBackdrop() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$['*cropBox'];
        if (!cropBox) return;
        let { x: x, y: y, width: width, height: height } = cropBox;
        let svg = this.ref['svg-el'];
        let mask = (0, $b5c04c21728a4369$export$183806b242873ed9)('mask', {
            id: 'backdrop-mask'
        });
        let maskRectOuter = (0, $b5c04c21728a4369$export$183806b242873ed9)('rect', {
            x: 0,
            y: 0,
            width: '100%',
            height: '100%',
            fill: 'white'
        });
        let maskRectInner = (0, $b5c04c21728a4369$export$183806b242873ed9)('rect', {
            x: x,
            y: y,
            width: width,
            height: height,
            fill: 'black'
        });
        mask.appendChild(maskRectOuter);
        mask.appendChild(maskRectInner);
        let backdropRect = (0, $b5c04c21728a4369$export$183806b242873ed9)('rect', {
            x: 0,
            y: 0,
            width: '100%',
            height: '100%',
            fill: 'var(--color-image-background)',
            'fill-opacity': 0.85,
            mask: 'url(#backdrop-mask)'
        });
        svg.appendChild(backdropRect);
        svg.appendChild(mask);
        this._backdropMask = mask;
        this._backdropMaskInner = maskRectInner;
    }
    /**
   * @private Super Tricky workaround for the chromium bug See
   *   https://bugs.chromium.org/p/chromium/issues/detail?id=330815
   */ _resizeBackdrop() {
        if (!this._backdropMask) return;
        this._backdropMask.style.display = 'none';
        window.requestAnimationFrame(()=>{
            if (this._backdropMask) this._backdropMask.style.display = 'block';
        });
    }
    /** @private */ _updateBackdrop() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$['*cropBox'];
        if (!cropBox) return;
        let { x: x, y: y, width: width, height: height } = cropBox;
        this._backdropMaskInner && (0, $b5c04c21728a4369$export$54374d41e42e9676)(this._backdropMaskInner, {
            x: x,
            y: y,
            width: width,
            height: height
        });
    }
    /** @private */ _updateFrame() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$['*cropBox'];
        if (!cropBox || !this._frameGuides || !this._frameThumbs) return;
        for (let thumb of Object.values(this._frameThumbs)){
            let { direction: direction, pathNode: pathNode, interactionNode: interactionNode, groupNode: groupNode } = thumb;
            let isCenter = direction === '';
            let isCorner = direction.length === 2;
            let { x: x, y: y, width: width, height: height } = cropBox;
            if (isCenter) {
                const moveThumbRect = {
                    x: x + width / 3,
                    y: y + height / 3,
                    width: width / 3,
                    height: height / 3
                };
                (0, $b5c04c21728a4369$export$54374d41e42e9676)(interactionNode, moveThumbRect);
            } else {
                const thumbSizeMultiplier = (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.min(width, height) / ((0, $d2bb7bf18d255144$export$b69960716b5f670f) * 2 + (0, $d2bb7bf18d255144$export$df6c1d4a19114db4)) / 2, 0, 1);
                let { d: d, center: center } = isCorner ? (0, $b5c04c21728a4369$export$790b609df538a7dd)(cropBox, direction, thumbSizeMultiplier) : (0, $b5c04c21728a4369$export$7b179e18f4ee631a)(cropBox, /** @type {Extract<import('./types.js').Direction, 'n' | 's' | 'w' | 'e'>} */ direction, thumbSizeMultiplier);
                const size = Math.max((0, $d2bb7bf18d255144$export$2950b0064b6e4e77) * (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.min(width, height) / (0, $d2bb7bf18d255144$export$2950b0064b6e4e77) / 3, 0, 1), (0, $d2bb7bf18d255144$export$d00854ad80ddb8a1));
                (0, $b5c04c21728a4369$export$54374d41e42e9676)(interactionNode, {
                    x: center[0] - size,
                    y: center[1] - size,
                    width: size * 2,
                    height: size * 2
                });
                (0, $b5c04c21728a4369$export$54374d41e42e9676)(pathNode, {
                    d: d
                });
            }
            let disableThumb = this._shouldThumbBeDisabled(direction);
            groupNode.setAttribute('class', (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)('thumb', {
                'thumb--hidden': disableThumb,
                'thumb--visible': !disableThumb
            }));
        }
        (0, $b5c04c21728a4369$export$54374d41e42e9676)(this._frameGuides, {
            x: cropBox.x - (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af) * 0.5,
            y: cropBox.y - (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af) * 0.5,
            width: cropBox.width + (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af),
            height: cropBox.height + (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af)
        });
    }
    /** @private */ _createThumbs() {
        /**
     * @type {Partial<{
     *   [K in import('./types.js').Direction]: {
     *     direction: import('./types.js').Direction;
     *     pathNode: SVGElement;
     *     interactionNode: SVGElement;
     *     groupNode: SVGElement;
     *   };
     * }>}
     */ const frameThumbs = {};
        for(let i = 0; i < 3; i++)for(let j = 0; j < 3; j++){
            let direction = /** @type {import('./types.js').Direction} */ `${[
                'n',
                '',
                's'
            ][i]}${[
                'w',
                '',
                'e'
            ][j]}`;
            let groupNode = (0, $b5c04c21728a4369$export$183806b242873ed9)('g');
            groupNode.classList.add('thumb');
            groupNode.setAttribute('with-effects', '');
            let interactionNode = (0, $b5c04c21728a4369$export$183806b242873ed9)('rect', {
                fill: 'transparent'
            });
            let pathNode = (0, $b5c04c21728a4369$export$183806b242873ed9)('path', {
                stroke: 'currentColor',
                fill: 'none',
                'stroke-width': (0, $d2bb7bf18d255144$export$9fc5d1d39ca040ea)
            });
            groupNode.appendChild(pathNode);
            groupNode.appendChild(interactionNode);
            frameThumbs[direction] = {
                direction: direction,
                pathNode: pathNode,
                interactionNode: interactionNode,
                groupNode: groupNode
            };
            interactionNode.addEventListener('pointerdown', this._handlePointerDown.bind(this, direction));
        }
        return frameThumbs;
    }
    /** @private */ _createGuides() {
        let svg = (0, $b5c04c21728a4369$export$183806b242873ed9)('svg');
        let rect = (0, $b5c04c21728a4369$export$183806b242873ed9)('rect', {
            x: 0,
            y: 0,
            width: '100%',
            height: '100%',
            fill: 'none',
            stroke: '#000000',
            'stroke-width': (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af),
            'stroke-opacity': 0.5
        });
        svg.appendChild(rect);
        for(let i = 1; i <= 2; i++){
            let line = (0, $b5c04c21728a4369$export$183806b242873ed9)('line', {
                x1: `${(0, $d2bb7bf18d255144$export$f958e4635c8aa22c) * i}%`,
                y1: `0%`,
                x2: `${(0, $d2bb7bf18d255144$export$f958e4635c8aa22c) * i}%`,
                y2: `100%`,
                stroke: '#000000',
                'stroke-width': (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af),
                'stroke-opacity': 0.3
            });
            svg.appendChild(line);
        }
        for(let i = 1; i <= 2; i++){
            let line = (0, $b5c04c21728a4369$export$183806b242873ed9)('line', {
                x1: `0%`,
                y1: `${(0, $d2bb7bf18d255144$export$f958e4635c8aa22c) * i}%`,
                x2: `100%`,
                y2: `${(0, $d2bb7bf18d255144$export$f958e4635c8aa22c) * i}%`,
                stroke: '#000000',
                'stroke-width': (0, $d2bb7bf18d255144$export$1cf2b3e7100e85af),
                'stroke-opacity': 0.3
            });
            svg.appendChild(line);
        }
        svg.classList.add('guides', 'guides--semi-hidden');
        return svg;
    }
    /** @private */ _createFrame() {
        let svg = this.ref['svg-el'];
        let fr = document.createDocumentFragment();
        let frameGuides = this._createGuides();
        fr.appendChild(frameGuides);
        let frameThumbs = this._createThumbs();
        for (let { groupNode: groupNode } of Object.values(frameThumbs))fr.appendChild(groupNode);
        svg.appendChild(fr);
        this._frameThumbs = frameThumbs;
        this._frameGuides = frameGuides;
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   * @param {PointerEvent} e
   */ _handlePointerDown(direction, e) {
        if (!this._frameThumbs) return;
        let thumb = this._frameThumbs[direction];
        if (this._shouldThumbBeDisabled(direction)) return;
        let cropBox = this.$['*cropBox'];
        let { x: svgX, y: svgY } = this.ref['svg-el'].getBoundingClientRect();
        let x = e.x - svgX;
        let y = e.y - svgY;
        this.$.dragging = true;
        this._draggingThumb = thumb;
        this._dragStartPoint = [
            x,
            y
        ];
        /** @type {import('./types.js').Rectangle} */ this._dragStartCrop = {
            ...cropBox
        };
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handlePointerUp_(e) {
        this._updateCursor();
        if (!this.$.dragging) return;
        e.stopPropagation();
        e.preventDefault();
        this.$.dragging = false;
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handlePointerMove_(e) {
        if (!this.$.dragging || !this._dragStartPoint || !this._draggingThumb) return;
        e.stopPropagation();
        e.preventDefault();
        let svg = this.ref['svg-el'];
        let { x: svgX, y: svgY } = svg.getBoundingClientRect();
        let x = e.x - svgX;
        let y = e.y - svgY;
        let dx = x - this._dragStartPoint[0];
        let dy = y - this._dragStartPoint[1];
        let { direction: direction } = this._draggingThumb;
        const movedCropBox = this._calcCropBox(direction, [
            dx,
            dy
        ]);
        if (movedCropBox) this.$['*cropBox'] = movedCropBox;
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   * @param {[Number, Number]} delta
   */ _calcCropBox(direction, delta) {
        const [dx, dy] = delta;
        /** @type {import('./types.js').Rectangle} */ let imageBox = this.$['*imageBox'];
        let rect = /** @type {import('./types.js').Rectangle} */ this._dragStartCrop ?? this.$['*cropBox'];
        /** @type {import('./types.js').CropPresetList[0]} */ const cropPreset = this.$['*cropPresetList']?.[0];
        const aspectRatio = cropPreset ? cropPreset.width / cropPreset.height : undefined;
        if (direction === '') rect = (0, $b5c04c21728a4369$export$88498a0045263460)({
            rect: rect,
            delta: [
                dx,
                dy
            ],
            imageBox: imageBox
        });
        else rect = (0, $b5c04c21728a4369$export$7395518b474faf76)({
            rect: rect,
            delta: [
                dx,
                dy
            ],
            direction: direction,
            aspectRatio: aspectRatio,
            imageBox: imageBox
        });
        if (!Object.values(rect).every((number)=>Number.isFinite(number) && number >= 0)) {
            console.error('CropFrame is trying to create invalid rectangle', {
                payload: rect
            });
            return;
        }
        return (0, $b5c04c21728a4369$export$25fd15ab86a7b28b)((0, $b5c04c21728a4369$export$166e03518104bf21)(rect), this.$['*imageBox']);
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handleSvgPointerMove_(e) {
        if (!this._frameThumbs) return;
        let hoverThumb = Object.values(this._frameThumbs).find((thumb)=>{
            if (this._shouldThumbBeDisabled(thumb.direction)) return false;
            let node = thumb.interactionNode;
            let bounds = node.getBoundingClientRect();
            let rect = {
                x: bounds.x,
                y: bounds.y,
                width: bounds.width,
                height: bounds.height
            };
            let hover = (0, $b5c04c21728a4369$export$ac4bbe5b05d4ed3f)(rect, [
                e.x,
                e.y
            ]);
            return hover;
        });
        this._hoverThumb = hoverThumb;
        this._updateCursor();
    }
    /** @private */ _updateCursor() {
        let hoverThumb = this._hoverThumb;
        this.ref['svg-el'].style.cursor = hoverThumb ? (0, $b5c04c21728a4369$export$96239d218eb7ece8)(hoverThumb.direction) : 'initial';
    }
    /** @private */ _render() {
        this._updateBackdrop();
        this._updateFrame();
    }
    /** @param {boolean} visible */ toggleThumbs(visible) {
        if (!this._frameThumbs) return;
        Object.values(this._frameThumbs).map(({ groupNode: groupNode })=>groupNode).forEach((groupNode)=>{
            groupNode.setAttribute('class', (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)('thumb', {
                'thumb--hidden': !visible,
                'thumb--visible': visible
            }));
        });
    }
    initCallback() {
        super.initCallback();
        this._createBackdrop();
        this._createFrame();
        this.sub('*imageBox', ()=>{
            this._resizeBackdrop();
            window.requestAnimationFrame(()=>{
                this._render();
            });
        });
        this.sub('*cropBox', (cropBox)=>{
            if (!cropBox) return;
            this._guidesHidden = cropBox.height <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a) || cropBox.width <= (0, $d2bb7bf18d255144$export$9c132ec810e22d8a);
            window.requestAnimationFrame(()=>{
                this._render();
            });
        });
        this.sub('dragging', (dragging)=>{
            if (!this._frameGuides) return;
            this._frameGuides.setAttribute('class', (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                'guides--hidden': this._guidesHidden,
                'guides--visible': !this._guidesHidden && dragging,
                'guides--semi-hidden': !this._guidesHidden && !dragging
            }));
        });
        this.ref['svg-el'].addEventListener('pointermove', this._handleSvgPointerMove, true);
        document.addEventListener('pointermove', this._handlePointerMove, true);
        document.addEventListener('pointerup', this._handlePointerUp, true);
    }
    destroyCallback() {
        super.destroyCallback();
        document.removeEventListener('pointermove', this._handlePointerMove);
        document.removeEventListener('pointerup', this._handlePointerUp);
    }
}
$3f5a15532f2cfbab$export$eaec7dd192dada87.template = /* HTML */ ` <svg class="svg" ref="svg-el" xmlns="http://www.w3.org/2000/svg"></svg> `;




class $db377c1adb87dc65$export$3aa7800404f83f6e extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    init$ = {
        ...this.init$,
        active: false,
        title: '',
        icon: '',
        'on.click': null
    };
    initCallback() {
        super.initCallback();
        this._titleEl = this.ref['title-el'];
        this._iconEl = this.ref['icon-el'];
        this.setAttribute('role', 'button');
        if (this.tabIndex === -1) this.tabIndex = 0;
        this.sub('title', (title)=>{
            let titleEl = this._titleEl;
            if (titleEl) this._titleEl.style.display = title ? 'block' : 'none';
        });
        this.sub('active', (active)=>{
            this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                active: active,
                not_active: !active
            });
        });
        this.sub('on.click', (onClick)=>{
            this.onclick = onClick;
        });
    }
}
$db377c1adb87dc65$export$3aa7800404f83f6e.template = /* HTML */ `
  <div class="before"></div>
  <lr-icon size="20" set="@name: icon;"></lr-icon>
  <div class="title" ref="title-el">{{title}}</div>
`;


function $e33b22ad871900d8$var$nextAngle(prev) {
    let angle = prev + 90;
    angle = angle >= 360 ? 0 : angle;
    return angle;
}
function $e33b22ad871900d8$var$nextValue(operation, prev) {
    if (operation === 'rotate') return $e33b22ad871900d8$var$nextAngle(prev);
    if ([
        'mirror',
        'flip'
    ].includes(operation)) return !prev;
    return null;
}
class $e33b22ad871900d8$export$603075e7d8e604b2 extends (0, $db377c1adb87dc65$export$3aa7800404f83f6e) {
    initCallback() {
        super.initCallback();
        this.defineAccessor('operation', (operation)=>{
            if (!operation) return;
            /** @private */ this._operation = operation;
            this.$['icon'] = operation;
        });
        this.$['on.click'] = (e)=>{
            let prev = this.$['*cropperEl'].getValue(this._operation);
            let next = $e33b22ad871900d8$var$nextValue(this._operation, prev);
            this.$['*cropperEl'].setValue(this._operation, next);
        };
    }
}






const $127203a35c886dd7$var$ControlType = {
    FILTER: 'filter',
    COLOR_OPERATION: 'color_operation'
};
const $127203a35c886dd7$export$e252352c431a3ba = 'original';
class $127203a35c886dd7$export$9ab173fa70108ef4 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    init$ = {
        ...this.init$,
        disabled: false,
        min: 0,
        max: 100,
        value: 0,
        defaultValue: 0,
        zero: 0,
        'on.input': (value)=>{
            this.$['*faderEl'].set(value);
            this.$.value = value;
        }
    };
    /**
   * @param {String} operation
   * @param {String} [filter]
   */ setOperation(operation, filter) {
        this._controlType = operation === 'filter' ? $127203a35c886dd7$var$ControlType.FILTER : $127203a35c886dd7$var$ControlType.COLOR_OPERATION;
        this._operation = operation;
        this._iconName = operation;
        this._title = operation.toUpperCase();
        this._filter = filter;
        this._initializeValues();
        this.$['*faderEl'].activate({
            url: this.$['*originalUrl'],
            operation: this._operation,
            value: this._filter === $127203a35c886dd7$export$e252352c431a3ba ? undefined : this.$.value,
            filter: this._filter === $127203a35c886dd7$export$e252352c431a3ba ? undefined : this._filter,
            fromViewer: false
        });
    }
    /** @private */ _initializeValues() {
        let { range: range, zero: zero } = (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[this._operation];
        let [min, max] = range;
        this.$.min = min;
        this.$.max = max;
        this.$.zero = zero;
        let transformation = this.$['*editorTransformations'][this._operation];
        if (this._controlType === $127203a35c886dd7$var$ControlType.FILTER) {
            let value = max;
            if (transformation) {
                let { name: name, amount: amount } = transformation;
                value = name === this._filter ? amount : max;
            }
            this.$.value = value;
            this.$.defaultValue = value;
        }
        if (this._controlType === $127203a35c886dd7$var$ControlType.COLOR_OPERATION) {
            let value = typeof transformation !== 'undefined' ? transformation : zero;
            this.$.value = value;
            this.$.defaultValue = value;
        }
    }
    apply() {
        let operationValue;
        if (this._controlType === $127203a35c886dd7$var$ControlType.FILTER) {
            if (this._filter === $127203a35c886dd7$export$e252352c431a3ba) operationValue = null;
            else operationValue = {
                name: this._filter,
                amount: this.$.value
            };
        } else operationValue = this.$.value;
        /** @type {import('./types.js').Transformations} */ let transformations = {
            ...this.$['*editorTransformations'],
            [this._operation]: operationValue
        };
        this.$['*editorTransformations'] = transformations;
    }
    cancel() {
        this.$['*faderEl'].deactivate({
            hide: false
        });
    }
    initCallback() {
        super.initCallback();
        this.sub('*originalUrl', (originalUrl)=>{
            this._originalUrl = originalUrl;
        });
        this.sub('value', (value)=>{
            let tooltip = `${this._filter || this._operation} ${value}`;
            this.$['*operationTooltip'] = tooltip;
        });
    }
}
$127203a35c886dd7$export$9ab173fa70108ef4.template = /* HTML */ `
  <lr-slider-ui
    ref="slider-el"
    set="disabled: disabled; min: min; max: max; defaultValue: defaultValue; zero: zero; onInput: on.input;"
  ></lr-slider-ui>
`;




function $f210f3bd10d5f203$export$d8536155e595e20f(src) {
    let image = new Image();
    let promise = new Promise((resolve, reject)=>{
        image.src = src;
        image.onload = resolve;
        image.onerror = reject;
    });
    let cancel = ()=>{
        if (image.naturalWidth === 0) image.src = (0, $c6e67fc7ecc40345$export$67da346bbbd9b9d4);
    };
    return {
        promise: promise,
        image: image,
        cancel: cancel
    };
}
function $f210f3bd10d5f203$export$e425c08b8185563d(list) {
    let preloaders = [];
    for (let src of list){
        let preload = $f210f3bd10d5f203$export$d8536155e595e20f(src);
        preloaders.push(preload);
    }
    let images = preloaders.map((preload)=>preload.image);
    let promise = Promise.allSettled(preloaders.map((preload)=>preload.promise));
    let cancel = ()=>{
        preloaders.forEach((preload)=>{
            preload.cancel();
        });
    };
    return {
        promise: promise,
        images: images,
        cancel: cancel
    };
}


class $4b898949c88745a4$export$1cf4b09278d815ee extends (0, $db377c1adb87dc65$export$3aa7800404f83f6e) {
    init$ = {
        ...this.init$,
        active: false,
        title: '',
        icon: '',
        isOriginal: false,
        iconSize: '20',
        'on.click': null
    };
    _previewSrc() {
        let previewSize = parseInt(window.getComputedStyle(this).getPropertyValue('--l-base-min-width'), 10);
        let dpr = window.devicePixelRatio;
        let size = Math.ceil(dpr * previewSize);
        let quality = dpr >= 2 ? 'lightest' : 'normal';
        let filterValue = 100;
        /** @type {import('./types.js').Transformations} */ let transformations = {
            ...this.$['*editorTransformations']
        };
        transformations[this._operation] = this._filter !== (0, $127203a35c886dd7$export$e252352c431a3ba) ? {
            name: this._filter,
            amount: filterValue
        } : undefined;
        return (0, $40a69650bbcf2c17$export$226a37372a69410c)(this._originalUrl, (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)((0, $1b348a031d3b3585$export$b73a625f3ee32c8), (0, $1b348a031d3b3585$export$d901e4e307b689de)(transformations), `quality/${quality}`, `scale_crop/${size}x${size}/center`));
    }
    /**
   * @param {IntersectionObserverEntry[]} entries
   * @param {IntersectionObserver} observer
   */ _observerCallback(entries, observer) {
        let intersectionEntry = entries[0];
        if (intersectionEntry.isIntersecting) {
            let src = this.proxyUrl(this._previewSrc());
            let previewEl = this.ref['preview-el'];
            let { promise: promise, cancel: cancel } = (0, $f210f3bd10d5f203$export$d8536155e595e20f)(src);
            this._cancelPreload = cancel;
            promise.catch((err)=>{
                this.$['*networkProblems'] = true;
                console.error('Failed to load image', {
                    error: err
                });
            }).finally(()=>{
                previewEl.style.backgroundImage = `url(${src})`;
                previewEl.setAttribute('loaded', '');
                observer.unobserve(this);
            });
        } else this._cancelPreload && this._cancelPreload();
    }
    initCallback() {
        super.initCallback();
        this.$['on.click'] = (e)=>{
            if (!this.$.active) {
                this.$['*sliderEl'].setOperation(this._operation, this._filter);
                this.$['*sliderEl'].apply();
            } else if (!this.$.isOriginal) {
                this.$['*sliderEl'].setOperation(this._operation, this._filter);
                this.$['*showSlider'] = true;
            }
            this.$['*currentFilter'] = this._filter;
        };
        this.defineAccessor('filter', (filter)=>{
            this._operation = 'filter';
            this._filter = filter;
            this.$.isOriginal = filter === (0, $127203a35c886dd7$export$e252352c431a3ba);
            this.$.icon = this.$.isOriginal ? 'original' : 'slider';
        });
        this._observer = new window.IntersectionObserver(this._observerCallback.bind(this), {
            threshold: [
                0,
                1
            ]
        });
        let originalUrl = this.$['*originalUrl'];
        this._originalUrl = originalUrl;
        if (this.$.isOriginal) this.ref['icon-el'].classList.add('original-icon');
        else this._observer.observe(this);
        this.sub('*currentFilter', (currentFilter)=>{
            this.$.active = currentFilter && currentFilter === this._filter;
        });
        this.sub('isOriginal', (isOriginal)=>{
            this.$.iconSize = isOriginal ? 40 : 20;
        });
        this.sub('active', (active)=>{
            if (this.$.isOriginal) return;
            let iconEl = this.ref['icon-el'];
            iconEl.style.opacity = active ? '1' : '0';
            let previewEl = this.ref['preview-el'];
            if (active) previewEl.style.opacity = '0';
            else if (previewEl.style.backgroundImage) previewEl.style.opacity = '1';
        });
        this.sub('*networkProblems', (networkProblems)=>{
            if (!networkProblems) {
                let src = this.proxyUrl(this._previewSrc());
                let previewEl = this.ref['preview-el'];
                if (previewEl.style.backgroundImage) {
                    previewEl.style.backgroundImage = 'none';
                    previewEl.style.backgroundImage = `url(${src})`;
                }
            }
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this._observer?.disconnect();
        this._cancelPreload && this._cancelPreload();
    }
}
$4b898949c88745a4$export$1cf4b09278d815ee.template = /* HTML */ `
  <div class="before"></div>
  <div class="preview" ref="preview-el"></div>
  <lr-icon size="40" ref="icon-el" set="@name: icon; @size: iconSize;"></lr-icon>
`;




class $a3c4677821912179$export$cf5be688aafa2355 extends (0, $db377c1adb87dc65$export$3aa7800404f83f6e) {
    /**
   * @private
   * @type {String}
   */ _operation = '';
    initCallback() {
        super.initCallback();
        this.$['on.click'] = (e)=>{
            this.$['*sliderEl'].setOperation(this._operation);
            this.$['*showSlider'] = true;
            this.$['*currentOperation'] = this._operation;
        };
        this.defineAccessor('operation', (operation)=>{
            if (operation) {
                this._operation = operation;
                this.$['icon'] = operation;
                this.$.title = this.l10n(operation);
            }
        });
        this.sub('*editorTransformations', (editorTransformations)=>{
            if (!this._operation) return;
            let { zero: zero } = (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[this._operation];
            let value = editorTransformations[this._operation];
            let isActive = typeof value !== 'undefined' ? value !== zero : false;
            this.$.active = isActive;
        });
    }
}


// @ts-check






/**
 * @param {{}} obj
 * @param {String[]} keys
 * @returns {{}}
 */ function $ed40c4e911cba3b4$export$357523c63a2253b9(obj, keys) {
    let result = {};
    for (let key of keys){
        let value = obj[key];
        if (obj.hasOwnProperty(key) || value !== undefined) result[key] = value;
    }
    return result;
}





function $eb0010873b7f2095$export$fac0f4feef8b6807(originalUrl, width, transformations) {
    const MAX_CDN_DIMENSION = 3000;
    let dpr = window.devicePixelRatio;
    let size = Math.min(Math.ceil(width * dpr), MAX_CDN_DIMENSION);
    let quality = dpr >= 2 ? 'lightest' : 'normal';
    return (0, $40a69650bbcf2c17$export$226a37372a69410c)(originalUrl, (0, $40a69650bbcf2c17$export$8fb94a7da5f60007)((0, $1b348a031d3b3585$export$b73a625f3ee32c8), (0, $1b348a031d3b3585$export$d901e4e307b689de)(transformations), `quality/${quality}`, `stretch/off/-/resize/${size}x`));
}


/**
 * @typedef {Object} Operations
 * @property {boolean} flip
 * @property {boolean} mirror
 * @property {Number} rotate
 */ /**
 * @param {import('./types.js').Transformations['crop']} crop
 * @returns {boolean}
 */ function $2faf70473f377dd1$var$validateCrop(crop) {
    if (!crop) return true;
    /** @type {((arg: NonNullable<typeof crop>) => boolean)[]} */ let shouldMatch = [
        ({ dimensions: dimensions, coords: coords })=>[
                ...dimensions,
                ...coords
            ].every((number)=>Number.isInteger(number) && Number.isFinite(number)),
        ({ dimensions: dimensions, coords: coords })=>dimensions.every((d)=>d > 0) && coords.every((c)=>c >= 0)
    ];
    return shouldMatch.every((matcher)=>matcher(crop));
}
class $2faf70473f377dd1$export$fc01d462d57ea6e6 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            image: null,
            '*padding': (0, $d2bb7bf18d255144$export$79bf3aa6ff8a6a3c),
            /** @type {Operations} */ '*operations': {
                rotate: 0,
                mirror: false,
                flip: false
            },
            /** @type {import('./types.js').Rectangle} */ '*imageBox': {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            /** @type {import('./types.js').Rectangle} */ '*cropBox': {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        /** @private */ this._commitDebounced = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._commit.bind(this), 300);
        /** @private */ this._handleResizeThrottled = (0, $db68f0fff3f52aa4$export$de363e709c412c8a)(this._handleResize.bind(this), 100);
        this._imageSize = {
            width: 0,
            height: 0
        };
    }
    /** @private */ _handleResize() {
        if (!this.isConnected || !this._isActive) return;
        this._initCanvas();
        this._syncTransformations();
        this._alignImage();
        this._alignCrop();
        this._draw();
    }
    /** @private */ _syncTransformations() {
        let transformations = this.$['*editorTransformations'];
        let pickedTransformations = (0, $ed40c4e911cba3b4$export$357523c63a2253b9)(transformations, Object.keys(this.$['*operations']));
        let operations = {
            ...this.$['*operations'],
            ...pickedTransformations
        };
        this.$['*operations'] = operations;
    }
    /** @private */ _initCanvas() {
        /** @type {HTMLCanvasElement} */ let canvas = this.ref['canvas-el'];
        let ctx = canvas.getContext('2d');
        let width = this.offsetWidth;
        let height = this.offsetHeight;
        let dpr = window.devicePixelRatio;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx?.scale(dpr, dpr);
        this._canvas = canvas;
        this._ctx = ctx;
    }
    /** @private */ _alignImage() {
        if (!this._isActive || !this.$.image) return;
        let image = this.$.image;
        let padding = this.$['*padding'];
        let operations = this.$['*operations'];
        let { rotate: rotate } = operations;
        let bounds = {
            width: this.offsetWidth,
            height: this.offsetHeight
        };
        let naturalSize = (0, $b5c04c21728a4369$export$9e53471bfbfdc361)({
            width: image.naturalWidth,
            height: image.naturalHeight
        }, rotate);
        let imageBox;
        if (naturalSize.width > bounds.width - padding * 2 || naturalSize.height > bounds.height - padding * 2) {
            let imageAspectRatio = naturalSize.width / naturalSize.height;
            let viewportAspectRatio = bounds.width / bounds.height;
            if (imageAspectRatio > viewportAspectRatio) {
                let width = bounds.width - padding * 2;
                let height = width / imageAspectRatio;
                let x = 0 + padding;
                let y = padding + (bounds.height - padding * 2) / 2 - height / 2;
                imageBox = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
            } else {
                let height = bounds.height - padding * 2;
                let width = height * imageAspectRatio;
                let x = padding + (bounds.width - padding * 2) / 2 - width / 2;
                let y = 0 + padding;
                imageBox = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
            }
        } else {
            let { width: width, height: height } = naturalSize;
            let x = padding + (bounds.width - padding * 2) / 2 - width / 2;
            let y = padding + (bounds.height - padding * 2) / 2 - height / 2;
            imageBox = {
                x: x,
                y: y,
                width: width,
                height: height
            };
        }
        this.$['*imageBox'] = (0, $b5c04c21728a4369$export$166e03518104bf21)(imageBox);
    }
    /** @private */ _alignCrop() {
        let cropBox = this.$['*cropBox'];
        let imageBox = this.$['*imageBox'];
        let operations = this.$['*operations'];
        let { rotate: rotate } = operations;
        let cropTransformation = this.$['*editorTransformations']['crop'];
        let { width: previewWidth, x: previewX, y: previewY } = this.$['*imageBox'];
        if (cropTransformation) {
            let { dimensions: [width, height], coords: [x, y] } = cropTransformation;
            let { width: sourceWidth } = (0, $b5c04c21728a4369$export$9e53471bfbfdc361)(this._imageSize, rotate);
            let ratio = previewWidth / sourceWidth;
            cropBox = (0, $b5c04c21728a4369$export$25fd15ab86a7b28b)((0, $b5c04c21728a4369$export$166e03518104bf21)({
                x: previewX + x * ratio,
                y: previewY + y * ratio,
                width: width * ratio,
                height: height * ratio
            }), this.$['*imageBox']);
        }
        /** @type {import('./types.js').CropPresetList[0] | undefined} */ const cropPreset = this.$['*cropPresetList']?.[0];
        const cropAspectRatio = cropPreset ? cropPreset.width / cropPreset.height : undefined;
        if (!(0, $b5c04c21728a4369$export$5b9ad582f7a393a7)(cropBox, imageBox) || cropAspectRatio && !(0, $b5c04c21728a4369$export$c875bfe83ce4f5e0)(cropBox, cropAspectRatio)) {
            const imageAspectRatio = imageBox.width / imageBox.height;
            let width = imageBox.width;
            let height = imageBox.height;
            if (cropAspectRatio) {
                if (imageAspectRatio > cropAspectRatio) width = Math.min(imageBox.height * cropAspectRatio, imageBox.width);
                else height = Math.min(imageBox.width / cropAspectRatio, imageBox.height);
            }
            cropBox = {
                x: imageBox.x + imageBox.width / 2 - width / 2,
                y: imageBox.y + imageBox.height / 2 - height / 2,
                width: width,
                height: height
            };
        }
        this.$['*cropBox'] = (0, $b5c04c21728a4369$export$25fd15ab86a7b28b)((0, $b5c04c21728a4369$export$166e03518104bf21)(cropBox), this.$['*imageBox']);
    }
    /** @private */ _drawImage() {
        let ctx = this._ctx;
        if (!ctx) return;
        let image = this.$.image;
        let imageBox = this.$['*imageBox'];
        let operations = this.$['*operations'];
        let { mirror: mirror, flip: flip, rotate: rotate } = operations;
        let rotated = (0, $b5c04c21728a4369$export$9e53471bfbfdc361)({
            width: imageBox.width,
            height: imageBox.height
        }, rotate);
        ctx.save();
        ctx.translate(imageBox.x + imageBox.width / 2, imageBox.y + imageBox.height / 2);
        ctx.rotate(rotate * Math.PI * -1 / 180);
        ctx.scale(mirror ? -1 : 1, flip ? -1 : 1);
        ctx.drawImage(image, -rotated.width / 2, -rotated.height / 2, rotated.width, rotated.height);
        ctx.restore();
    }
    /** @private */ _draw() {
        if (!this._isActive || !this.$.image || !this._canvas || !this._ctx) return;
        let canvas = this._canvas;
        let ctx = this._ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this._drawImage();
    }
    /**
   * @private
   * @param {{ fromViewer?: boolean }} options
   */ _animateIn({ fromViewer: fromViewer }) {
        if (this.$.image) {
            this.ref['frame-el'].toggleThumbs(true);
            this._transitionToImage();
            setTimeout(()=>{
                this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                    active_from_viewer: fromViewer,
                    active_from_editor: !fromViewer,
                    inactive_to_editor: false
                });
            });
        }
    }
    /**
   * @private
   * @returns {NonNullable<import('./types.js').Transformations['crop']>['dimensions']}
   */ _getCropDimensions() {
        let cropBox = this.$['*cropBox'];
        let imageBox = this.$['*imageBox'];
        let operations = this.$['*operations'];
        let { rotate: rotate } = operations;
        let { width: previewWidth, height: previewHeight } = imageBox;
        let { width: sourceWidth, height: sourceHeight } = (0, $b5c04c21728a4369$export$9e53471bfbfdc361)(this._imageSize, rotate);
        let { width: cropWidth, height: cropHeight } = cropBox;
        let ratioW = previewWidth / sourceWidth;
        let ratioH = previewHeight / sourceHeight;
        /** @type {[Number, Number]} */ let dimensions = [
            (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.round(cropWidth / ratioW), 1, sourceWidth),
            (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.round(cropHeight / ratioH), 1, sourceHeight)
        ];
        return dimensions;
    }
    /**
   * @private
   * @returns {import('./types.js').Transformations['crop']}
   */ _getCropTransformation() {
        let cropBox = this.$['*cropBox'];
        let imageBox = this.$['*imageBox'];
        let operations = this.$['*operations'];
        let { rotate: rotate } = operations;
        let { width: previewWidth, height: previewHeight, x: previewX, y: previewY } = imageBox;
        let { width: sourceWidth, height: sourceHeight } = (0, $b5c04c21728a4369$export$9e53471bfbfdc361)(this._imageSize, rotate);
        let { x: cropX, y: cropY } = cropBox;
        let ratioW = previewWidth / sourceWidth;
        let ratioH = previewHeight / sourceHeight;
        let dimensions = this._getCropDimensions();
        let crop = {
            dimensions: dimensions,
            coords: /** @type {[Number, Number]} */ [
                (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.round((cropX - previewX) / ratioW), 0, sourceWidth - dimensions[0]),
                (0, $b5c04c21728a4369$export$7d15b64cf5a3a4c4)(Math.round((cropY - previewY) / ratioH), 0, sourceHeight - dimensions[1])
            ]
        };
        if (!$2faf70473f377dd1$var$validateCrop(crop)) {
            console.error('Cropper is trying to create invalid crop object', {
                payload: crop
            });
            return undefined;
        }
        if (dimensions[0] === sourceWidth && dimensions[1] === sourceHeight) return undefined;
        return crop;
    }
    /** @private */ _commit() {
        if (!this.isConnected) return;
        let operations = this.$['*operations'];
        let { rotate: rotate, mirror: mirror, flip: flip } = operations;
        let crop = this._getCropTransformation();
        /** @type {import('./types.js').Transformations} */ let editorTransformations = this.$['*editorTransformations'];
        let transformations = {
            ...editorTransformations,
            crop: crop,
            rotate: rotate,
            mirror: mirror,
            flip: flip
        };
        this.$['*editorTransformations'] = transformations;
    }
    /**
   * @param {String} operation
   * @param {Number} value
   * @returns {void}
   */ setValue(operation, value) {
        this.$['*operations'] = {
            ...this.$['*operations'],
            [operation]: value
        };
        if (!this._isActive) return;
        this._alignImage();
        this._alignCrop();
        this._draw();
    }
    /**
   * @param {keyof Operations} operation
   * @returns {Number | boolean}
   */ getValue(operation) {
        return this.$['*operations'][operation];
    }
    /**
   * @param {import('./types.js').ImageSize} imageSize
   * @param {{ fromViewer?: boolean }} options
   */ async activate(imageSize, { fromViewer: fromViewer } = {}) {
        if (this._isActive) return;
        this._isActive = true;
        this._imageSize = imageSize;
        this.removeEventListener('transitionend', this._reset);
        try {
            this.$.image = await this._waitForImage(this.$['*originalUrl'], this.$['*editorTransformations']);
            this._syncTransformations();
            this._animateIn({
                fromViewer: fromViewer
            });
        } catch (err) {
            console.error('Failed to activate cropper', {
                error: err
            });
        }
        this._observer = new ResizeObserver(([entry])=>{
            const nonZeroSize = entry.contentRect.width > 0 && entry.contentRect.height > 0;
            if (nonZeroSize && this._isActive && this.$.image) this._handleResizeThrottled();
        });
        this._observer.observe(this);
    }
    deactivate({ reset: reset = false } = {}) {
        if (!this._isActive) return;
        !reset && this._commit();
        this._isActive = false;
        this._transitionToCrop();
        this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
            active_from_viewer: false,
            active_from_editor: false,
            inactive_to_editor: true
        });
        this.ref['frame-el'].toggleThumbs(false);
        this.addEventListener('transitionend', this._reset, {
            once: true
        });
        this._observer?.disconnect();
    }
    /** @private */ _transitionToCrop() {
        let dimensions = this._getCropDimensions();
        let scaleX = Math.min(this.offsetWidth, dimensions[0]) / this.$['*cropBox'].width;
        let scaleY = Math.min(this.offsetHeight, dimensions[1]) / this.$['*cropBox'].height;
        let scale = Math.min(scaleX, scaleY);
        let cropCenterX = this.$['*cropBox'].x + this.$['*cropBox'].width / 2;
        let cropCenterY = this.$['*cropBox'].y + this.$['*cropBox'].height / 2;
        this.style.transform = `scale(${scale}) translate(${(this.offsetWidth / 2 - cropCenterX) / scale}px, ${(this.offsetHeight / 2 - cropCenterY) / scale}px)`;
        this.style.transformOrigin = `${cropCenterX}px ${cropCenterY}px`;
    }
    /** @private */ _transitionToImage() {
        let cropCenterX = this.$['*cropBox'].x + this.$['*cropBox'].width / 2;
        let cropCenterY = this.$['*cropBox'].y + this.$['*cropBox'].height / 2;
        this.style.transform = `scale(1)`;
        this.style.transformOrigin = `${cropCenterX}px ${cropCenterY}px`;
    }
    /** @private */ _reset() {
        if (this._isActive) return;
        this.$.image = null;
    }
    /**
   * @private
   * @param {String} originalUrl
   * @param {import('./types.js').Transformations} transformations
   * @returns {Promise<HTMLImageElement>}
   */ _waitForImage(originalUrl, transformations) {
        let width = this.offsetWidth;
        transformations = {
            ...transformations,
            crop: undefined,
            rotate: undefined,
            flip: undefined,
            mirror: undefined
        };
        let src = this.proxyUrl((0, $eb0010873b7f2095$export$fac0f4feef8b6807)(originalUrl, width, transformations));
        let { promise: promise, cancel: cancel, image: image } = (0, $f210f3bd10d5f203$export$d8536155e595e20f)(src);
        let stop = this._handleImageLoading(src);
        image.addEventListener('load', stop, {
            once: true
        });
        image.addEventListener('error', stop, {
            once: true
        });
        this._cancelPreload && this._cancelPreload();
        this._cancelPreload = cancel;
        return promise.then(()=>image).catch((err)=>{
            console.error('Failed to load image', {
                error: err
            });
            this.$['*networkProblems'] = true;
            return Promise.resolve(image);
        });
    }
    /**
   * @private
   * @param {String} src
   * @returns {() => void} Destructor
   */ _handleImageLoading(src) {
        let operation = 'crop';
        let loadingOperations = this.$['*loadingOperations'];
        if (!loadingOperations.get(operation)) loadingOperations.set(operation, new Map());
        if (!loadingOperations.get(operation).get(src)) {
            loadingOperations.set(operation, loadingOperations.get(operation).set(src, true));
            this.$['*loadingOperations'] = loadingOperations;
        }
        return ()=>{
            if (loadingOperations?.get(operation)?.has(src)) {
                loadingOperations.get(operation).delete(src);
                this.$['*loadingOperations'] = loadingOperations;
            }
        };
    }
    initCallback() {
        super.initCallback();
        this.sub('*imageBox', ()=>{
            this._draw();
        });
        this.sub('*cropBox', ()=>{
            if (this.$.image) this._commitDebounced();
        });
        this.sub('*cropPresetList', ()=>{
            this._alignCrop();
        });
        setTimeout(()=>{
            this.sub('*networkProblems', (networkProblems)=>{
                if (!networkProblems) this._isActive && this.activate(this._imageSize, {
                    fromViewer: false
                });
            });
        }, 0);
    }
    destroyCallback() {
        super.destroyCallback();
        this._observer?.disconnect();
    }
}
$2faf70473f377dd1$export$fc01d462d57ea6e6.template = /* HTML */ `
  <canvas class="canvas" ref="canvas-el"></canvas>
  <lr-crop-frame ref="frame-el"></lr-crop-frame>
`;





/**
 * @param {Number} a Start of sample (int)
 * @param {Number} b End of sample (int)
 * @param {Number} n Number of elements (int)
 * @returns {Number[]}
 */ function $03fee674b28fa26d$export$71255ea3f595147c(a, b, n) {
    let ret = Array(n);
    n--;
    for(let i = n; i >= 0; i--)ret[i] = Math.ceil((i * b + (n - i) * a) / n);
    return ret;
}





/**
 * @param {Number[]} numbers
 * @returns {[Number, Number][]}
 */ function $37112e1b54821784$var$splitBySections(numbers) {
    return numbers.reduce((acc, point, idx)=>idx < numbers.length - 1 ? [
            ...acc,
            [
                point,
                numbers[idx + 1]
            ]
        ] : acc, []);
}
/**
 * @param {Number[]} keypoints
 * @param {Number} value
 * @param {Number} zero
 */ function $37112e1b54821784$var$calculateOpacities(keypoints, value, zero) {
    let section = $37112e1b54821784$var$splitBySections(keypoints).find(([left, right])=>left <= value && value <= right);
    return keypoints.map((point)=>{
        let distance = Math.abs(section[0] - section[1]);
        let relation = Math.abs(value - section[0]) / distance;
        if (section[0] === point) return value > zero ? 1 : 1 - relation;
        if (section[1] === point) return value >= zero ? relation : 1;
        return 0;
    });
}
/**
 * @param {Number[]} keypoints
 * @param {Number} zero
 */ function $37112e1b54821784$var$calculateZIndices(keypoints, zero) {
    return keypoints.map((point, idx)=>point < zero ? keypoints.length - idx : idx);
}
/**
 * @param {String} operation
 * @param {Number} value
 * @returns {Number[]}
 */ function $37112e1b54821784$var$keypointsRange(operation, value) {
    let n = (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[operation].keypointsNumber;
    let { range: range, zero: zero } = (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[operation];
    return [
        ...new Set([
            ...(0, $03fee674b28fa26d$export$71255ea3f595147c)(range[0], zero, n + 1),
            ...(0, $03fee674b28fa26d$export$71255ea3f595147c)(zero, range[1], n + 1),
            zero,
            value
        ])
    ].sort((a, b)=>a - b);
}
class $37112e1b54821784$export$15eaf4dbf84459f1 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    constructor(){
        super();
        /**
     * @private
     * @type {Boolean}
     */ this._isActive = false;
        /**
     * @private
     * @type {Boolean}
     */ this._hidden = true;
        /** @private */ this._addKeypointDebounced = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._addKeypoint.bind(this), 600);
        this.classList.add('inactive_to_cropper');
    }
    /**
   * @private
   * @param {String} src
   * @returns {() => void} Destructor
   */ _handleImageLoading(src) {
        let operation = this._operation;
        let loadingOperations = this.$['*loadingOperations'];
        if (!loadingOperations.get(operation)) loadingOperations.set(operation, new Map());
        if (!loadingOperations.get(operation).get(src)) {
            loadingOperations.set(operation, loadingOperations.get(operation).set(src, true));
            this.$['*loadingOperations'] = loadingOperations;
        }
        return ()=>{
            if (loadingOperations?.get(operation)?.has(src)) {
                loadingOperations.get(operation).delete(src);
                this.$['*loadingOperations'] = loadingOperations;
            }
        };
    }
    /** @private */ _flush() {
        window.cancelAnimationFrame(this._raf);
        this._raf = window.requestAnimationFrame(()=>{
            for (let kp of this._keypoints){
                let { image: image } = kp;
                if (image) {
                    image.style.opacity = kp.opacity.toString();
                    image.style.zIndex = kp.zIndex.toString();
                }
            }
        });
    }
    /**
   * @private
   * @param {Object} options
   * @param {String} [options.url]
   * @param {String} [options.filter]
   * @param {String} [options.operation]
   * @param {Number} [options.value]
   * @returns {String}
   */ _imageSrc({ url: url = this._url, filter: filter = this._filter, operation: operation, value: value } = {}) {
        let transformations = {
            ...this._transformations
        };
        if (operation) transformations[operation] = filter ? {
            name: filter,
            amount: value
        } : value;
        // do not use getBoundingClientRect because scale transform affects it
        let width = this.offsetWidth;
        return this.proxyUrl((0, $eb0010873b7f2095$export$fac0f4feef8b6807)(url, width, transformations));
    }
    /**
   * @private
   * @param {String} operation
   * @param {Number} value
   * @returns {Keypoint}
   */ _constructKeypoint(operation, value) {
        let src = this._imageSrc({
            operation: operation,
            value: value
        });
        return {
            src: src,
            image: null,
            opacity: 0,
            zIndex: 0,
            value: value
        };
    }
    /**
   * Check if current operation and filter equals passed ones
   *
   * @private
   * @param {String} operation
   * @param {String} [filter]
   * @returns {Boolean}
   */ _isSame(operation, filter) {
        return this._operation === operation && this._filter === filter;
    }
    /**
   * @private
   * @param {String} operation
   * @param {String | null} filter
   * @param {Number} value
   */ _addKeypoint(operation, filter, value) {
        let shouldSkip = ()=>!this._isSame(operation, filter) || this._value !== value || !!this._keypoints.find((kp)=>kp.value === value);
        if (shouldSkip()) return;
        let keypoint = this._constructKeypoint(operation, value);
        let image = new Image();
        image.src = keypoint.src;
        let stop = this._handleImageLoading(keypoint.src);
        image.addEventListener('load', stop, {
            once: true
        });
        image.addEventListener('error', stop, {
            once: true
        });
        keypoint.image = image;
        image.classList.add('fader-image');
        image.addEventListener('load', ()=>{
            if (shouldSkip()) return;
            let keypoints = this._keypoints;
            let idx = keypoints.findIndex((kp)=>kp.value > value);
            let insertBeforeNode = idx < keypoints.length ? keypoints[idx].image : null;
            if (!this._container || insertBeforeNode && !this._container.contains(insertBeforeNode)) return;
            keypoints.splice(idx, 0, keypoint);
            this._container.insertBefore(image, insertBeforeNode);
            this._update(operation, value);
        }, {
            once: true
        });
        image.addEventListener('error', ()=>{
            this.$['*networkProblems'] = true;
        }, {
            once: true
        });
    }
    /** @param {String | Number} value */ set(value) {
        value = typeof value === 'string' ? parseInt(value, 10) : value;
        this._update(this._operation, value);
        this._addKeypointDebounced(this._operation, this._filter, value);
    }
    /**
   * @private
   * @param {String} operation
   * @param {Number} value
   */ _update(operation, value) {
        this._operation = operation;
        this._value = value;
        let { zero: zero } = (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[operation];
        let keypointValues = this._keypoints.map((kp)=>kp.value);
        let opacities = $37112e1b54821784$var$calculateOpacities(keypointValues, value, zero);
        let zIndices = $37112e1b54821784$var$calculateZIndices(keypointValues, zero);
        for (let [idx, kp] of Object.entries(this._keypoints)){
            kp.opacity = opacities[idx];
            kp.zIndex = zIndices[idx];
        }
        this._flush();
    }
    /** @private */ _createPreviewImage() {
        let image = new Image();
        image.classList.add('fader-image', 'fader-image--preview');
        image.style.opacity = '0';
        return image;
    }
    /** @private */ async _initNodes() {
        let fr = document.createDocumentFragment();
        this._previewImage = this._previewImage || this._createPreviewImage();
        !this.contains(this._previewImage) && fr.appendChild(this._previewImage);
        let container = document.createElement('div');
        fr.appendChild(container);
        let srcList = this._keypoints.map((kp)=>kp.src);
        let { images: images, promise: promise, cancel: cancel } = (0, $f210f3bd10d5f203$export$e425c08b8185563d)(srcList);
        images.forEach((node)=>{
            let stop = this._handleImageLoading(node.src);
            node.addEventListener('load', stop);
            node.addEventListener('error', stop);
        });
        this._cancelLastImages = ()=>{
            cancel();
            this._cancelLastImages = undefined;
        };
        let operation = this._operation;
        let filter = this._filter;
        await promise;
        if (this._isActive && this._isSame(operation, filter)) {
            this._container && this._container.remove();
            this._container = container;
            this._keypoints.forEach((kp, idx)=>{
                let kpImage = images[idx];
                kpImage.classList.add('fader-image');
                kp.image = kpImage;
                this._container.appendChild(kpImage);
            });
            this.appendChild(fr);
            this._flush();
        }
    }
    /** @param {import('./types.js').Transformations} transformations */ setTransformations(transformations) {
        this._transformations = transformations;
        if (this._previewImage) {
            let src = this._imageSrc();
            let stop = this._handleImageLoading(src);
            this._previewImage.src = src;
            this._previewImage.addEventListener('load', stop, {
                once: true
            });
            this._previewImage.addEventListener('error', stop, {
                once: true
            });
            this._previewImage.style.opacity = '1';
            this._previewImage.addEventListener('error', ()=>{
                this.$['*networkProblems'] = true;
            }, {
                once: true
            });
        }
    }
    /**
   * @param {object} options
   * @param {String} options.url
   * @param {String} options.operation
   * @param {Number} options.value
   * @param {String} [options.filter]
   */ preload({ url: url, filter: filter, operation: operation, value: value }) {
        this._cancelBatchPreload && this._cancelBatchPreload();
        let keypoints = $37112e1b54821784$var$keypointsRange(operation, value);
        let srcList = keypoints.map((kp)=>this._imageSrc({
                url: url,
                filter: filter,
                operation: operation,
                value: kp
            }));
        let { cancel: cancel } = (0, $f210f3bd10d5f203$export$e425c08b8185563d)(srcList);
        this._cancelBatchPreload = cancel;
    }
    /** @private */ _setOriginalSrc(src) {
        let image = this._previewImage || this._createPreviewImage();
        !this.contains(image) && this.appendChild(image);
        this._previewImage = image;
        if (image.src === src) {
            image.style.opacity = '1';
            image.style.transform = 'scale(1)';
            this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                active_from_viewer: this._fromViewer,
                active_from_cropper: !this._fromViewer,
                inactive_to_cropper: false
            });
            return;
        }
        image.style.opacity = '0';
        let stop = this._handleImageLoading(src);
        image.addEventListener('error', stop, {
            once: true
        });
        image.src = src;
        image.addEventListener('load', ()=>{
            stop();
            if (image) {
                image.style.opacity = '1';
                image.style.transform = 'scale(1)';
                this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                    active_from_viewer: this._fromViewer,
                    active_from_cropper: !this._fromViewer,
                    inactive_to_cropper: false
                });
            }
        }, {
            once: true
        });
        image.addEventListener('error', ()=>{
            this.$['*networkProblems'] = true;
        }, {
            once: true
        });
    }
    /**
   * @param {object} options
   * @param {String} options.url
   * @param {String} [options.operation]
   * @param {Number} [options.value]
   * @param {String} [options.filter]
   * @param {Boolean} [options.fromViewer]
   */ activate({ url: url, operation: operation, value: value, filter: filter, fromViewer: fromViewer }) {
        this._isActive = true;
        this._hidden = false;
        this._url = url;
        this._operation = operation || 'initial';
        this._value = value;
        this._filter = filter;
        this._fromViewer = fromViewer;
        let isOriginal = typeof value !== 'number' && !filter;
        if (isOriginal) {
            let src = this._imageSrc({
                operation: operation,
                value: value
            });
            this._setOriginalSrc(src);
            this._container && this._container.remove();
            return;
        }
        this._keypoints = $37112e1b54821784$var$keypointsRange(operation, value).map((keyValue)=>this._constructKeypoint(operation, keyValue));
        this._update(operation, value);
        this._initNodes();
    }
    /** @param {{ hide?: Boolean }} options */ deactivate({ hide: hide = true } = {}) {
        this._isActive = false;
        this._cancelLastImages && this._cancelLastImages();
        this._cancelBatchPreload && this._cancelBatchPreload();
        if (hide && !this._hidden) {
            this._hidden = true;
            if (this._previewImage) this._previewImage.style.transform = 'scale(1)';
            this.className = (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)({
                active_from_viewer: false,
                active_from_cropper: false,
                inactive_to_cropper: true
            });
            this.addEventListener('transitionend', ()=>{
                this._container && this._container.remove();
            }, {
                once: true
            });
        } else this._container && this._container.remove();
    }
}



const $f18686f36602dda4$var$X_THRESHOLD = 1;
class $f18686f36602dda4$export$88b72cf03cc30a69 extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    initCallback() {
        super.initCallback();
        this.addEventListener('wheel', (e)=>{
            e.preventDefault();
            let { deltaY: deltaY, deltaX: deltaX } = e;
            if (Math.abs(deltaX) > $f18686f36602dda4$var$X_THRESHOLD) this.scrollLeft += deltaX;
            else this.scrollLeft += deltaY;
        });
    }
}
$f18686f36602dda4$export$88b72cf03cc30a69.template = /* HTML */ ` <slot></slot> `;



// @ts-check









/** @param {String} id */ function $79853253e74da0e3$var$renderTabToggle(id) {
    return /* HTML */ `
    <lr-presence-toggle class="tab-toggle" set="visible: presence.tabToggle.${id}; styles: presence.tabToggleStyles;">
      <lr-btn-ui
        theme="boring"
        ref="tab-toggle-${id}"
        data-id="${id}"
        icon="${id}"
        tabindex="0"
        set="onclick: on.clickTab;"
      >
      </lr-btn-ui>
    </lr-presence-toggle>
  `;
}
/** @param {String} id */ function $79853253e74da0e3$var$renderTabContent(id) {
    return /* HTML */ `
    <lr-presence-toggle class="tab-content" set="visible: presence.tabContent.${id}; styles: presence.tabContentStyles">
      <lr-editor-scroller hidden-scrollbar>
        <div class="controls-list_align">
          <div class="controls-list_inner" ref="controls-list-${id}"></div>
        </div>
      </lr-editor-scroller>
    </lr-presence-toggle>
  `;
}
class $79853253e74da0e3$export$477aaffea178bc4e extends (0, $030d48f659208578$export$bfab8e80be0da35) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            '*sliderEl': null,
            /** @type {import('./types.js').LoadingOperations} */ '*loadingOperations': new Map(),
            '*showSlider': false,
            '*currentFilter': (0, $127203a35c886dd7$export$e252352c431a3ba),
            '*currentOperation': null,
            showLoader: false,
            filters: (0, $1ce1dd3703477f5c$export$5773a777940e5760),
            colorOperations: (0, $1ce1dd3703477f5c$export$68b0885f31248db9),
            cropOperations: (0, $1ce1dd3703477f5c$export$daf320f6382e1d0a),
            '*operationTooltip': null,
            'l10n.cancel': this.l10n('cancel'),
            'l10n.apply': this.l10n('apply'),
            'presence.mainToolbar': true,
            'presence.subToolbar': false,
            'presence.tabToggles': true,
            'presence.tabContent.crop': false,
            'presence.tabContent.tuning': false,
            'presence.tabContent.filters': false,
            'presence.tabToggle.crop': true,
            'presence.tabToggle.tuning': true,
            'presence.tabToggle.filters': true,
            'presence.subTopToolbarStyles': {
                hidden: 'sub-toolbar--top-hidden',
                visible: 'sub-toolbar--visible'
            },
            'presence.subBottomToolbarStyles': {
                hidden: 'sub-toolbar--bottom-hidden',
                visible: 'sub-toolbar--visible'
            },
            'presence.tabContentStyles': {
                hidden: 'tab-content--hidden',
                visible: 'tab-content--visible'
            },
            'presence.tabToggleStyles': {
                hidden: 'tab-toggle--hidden',
                visible: 'tab-toggle--visible'
            },
            'presence.tabTogglesStyles': {
                hidden: 'tab-toggles--hidden',
                visible: 'tab-toggles--visible'
            },
            'on.cancel': ()=>{
                this._cancelPreload && this._cancelPreload();
                this.$['*on.cancel']();
            },
            'on.apply': ()=>{
                this.$['*on.apply'](this.$['*editorTransformations']);
            },
            'on.applySlider': ()=>{
                this.ref['slider-el'].apply();
                this._onSliderClose();
            },
            'on.cancelSlider': ()=>{
                this.ref['slider-el'].cancel();
                this._onSliderClose();
            },
            /** @param {MouseEvent} e */ 'on.clickTab': (e)=>{
                const id = /** @type {HTMLElement} */ e.currentTarget.getAttribute('data-id');
                if (id) this._activateTab(id, {
                    fromViewer: false
                });
            }
        };
        /** @private */ this._debouncedShowLoader = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(this._showLoader.bind(this), 500);
    }
    /** @private */ _onSliderClose() {
        this.$['*showSlider'] = false;
        if (this.$['*tabId'] === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).TUNING) this.ref['tooltip-el'].classList.toggle('info-tooltip_visible', false);
    }
    /**
   * @private
   * @param {String} operation
   */ _createOperationControl(operation) {
        let el = new (0, $a3c4677821912179$export$cf5be688aafa2355)();
        // @ts-expect-error TODO: fix
        el.operation = operation;
        return el;
    }
    /**
   * @private
   * @param {String} filter
   */ _createFilterControl(filter) {
        let el = new (0, $4b898949c88745a4$export$1cf4b09278d815ee)();
        // @ts-expect-error TODO: fix
        el.filter = filter;
        return el;
    }
    /**
   * @private
   * @param {String} operation
   */ _createToggleControl(operation) {
        let el = new (0, $e33b22ad871900d8$export$603075e7d8e604b2)();
        // @ts-expect-error TODO: fix
        el.operation = operation;
        return el;
    }
    /**
   * @private
   * @param {String} tabId
   */ _renderControlsList(tabId) {
        let listEl = this.ref[`controls-list-${tabId}`];
        let fr = document.createDocumentFragment();
        if (tabId === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP) this.$.cropOperations.forEach(/** @param {string} operation */ (operation)=>{
            let el = this._createToggleControl(operation);
            // @ts-ignore
            fr.appendChild(el);
        });
        else if (tabId === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).FILTERS) [
            (0, $127203a35c886dd7$export$e252352c431a3ba),
            ...this.$.filters
        ].forEach((filterId)=>{
            let el = this._createFilterControl(filterId);
            // @ts-ignore
            fr.appendChild(el);
        });
        else if (tabId === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).TUNING) this.$.colorOperations.forEach(/** @param {string} operation */ (operation)=>{
            let el = this._createOperationControl(operation);
            // @ts-ignore
            fr.appendChild(el);
        });
        [
            ...fr.children
        ].forEach((el, idx)=>{
            if (idx === fr.childNodes.length - 1) el.classList.add('controls-list_last-item');
        });
        listEl.innerHTML = '';
        listEl.appendChild(fr);
    }
    /**
   * @private
   * @param {String} id
   * @param {{ fromViewer?: Boolean }} options
   */ _activateTab(id, { fromViewer: fromViewer }) {
        this.$['*tabId'] = id;
        if (id === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).CROP) {
            this.$['*faderEl'].deactivate();
            this.$['*cropperEl'].activate(this.$['*imageSize'], {
                fromViewer: fromViewer
            });
        } else {
            this.$['*faderEl'].activate({
                url: this.$['*originalUrl'],
                fromViewer: fromViewer
            });
            this.$['*cropperEl'].deactivate();
        }
        for (let tabId of (0, $1ce1dd3703477f5c$export$d9a4cca3740decc7)){
            let isCurrentTab = tabId === id;
            let tabToggleEl = this.ref[`tab-toggle-${tabId}`];
            tabToggleEl.active = isCurrentTab;
            if (isCurrentTab) {
                this._renderControlsList(id);
                this._syncTabIndicator();
            } else this._unmountTabControls(tabId);
            this.$[`presence.tabContent.${tabId}`] = isCurrentTab;
        }
    }
    /**
   * @private
   * @param {String} tabId
   */ _unmountTabControls(tabId) {
        let listEl = this.ref[`controls-list-${tabId}`];
        if (listEl) listEl.innerHTML = '';
    }
    /** @private */ _syncTabIndicator() {
        let tabToggleEl = this.ref[`tab-toggle-${this.$['*tabId']}`];
        let indicatorEl = this.ref['tabs-indicator'];
        indicatorEl.style.transform = `translateX(${tabToggleEl.offsetLeft}px)`;
    }
    /** @private */ _preloadEditedImage() {
        if (this.$['*imgContainerEl'] && this.$['*originalUrl']) {
            let width = this.$['*imgContainerEl'].offsetWidth;
            let src = this.proxyUrl((0, $eb0010873b7f2095$export$fac0f4feef8b6807)(this.$['*originalUrl'], width, this.$['*editorTransformations']));
            this._cancelPreload && this._cancelPreload();
            let { cancel: cancel } = (0, $f210f3bd10d5f203$export$e425c08b8185563d)([
                src
            ]);
            this._cancelPreload = ()=>{
                cancel();
                this._cancelPreload = undefined;
            };
        }
    }
    /**
   * @private
   * @param {boolean} show
   */ _showLoader(show) {
        this.$.showLoader = show;
    }
    _updateInfoTooltip = (0, $60594be474a773dd$export$61fc7d43ac8f84b0)(()=>{
        const transformations = this.$['*editorTransformations'];
        /** @type {keyof COLOR_OPERATIONS_CONFIG} */ const currentOperation = this.$['*currentOperation'];
        let text = '';
        let visible = false;
        if (this.$['*tabId'] === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).FILTERS) {
            visible = true;
            if (this.$['*currentFilter'] && transformations?.filter?.name === this.$['*currentFilter']) {
                let value = transformations?.filter?.amount || 100;
                text = this.l10n(this.$['*currentFilter']) + ' ' + value;
            } else text = this.l10n((0, $127203a35c886dd7$export$e252352c431a3ba));
        } else if (this.$['*tabId'] === (0, $1ce1dd3703477f5c$export$bb9ea7aab152411a).TUNING && currentOperation) {
            visible = true;
            let value = transformations?.[currentOperation] || (0, $1ce1dd3703477f5c$export$e3dcdd21a8cd88f9)[currentOperation].zero;
            text = currentOperation + ' ' + value;
        }
        if (visible) this.$['*operationTooltip'] = text;
        this.ref['tooltip-el'].classList.toggle('info-tooltip_visible', visible);
    }, 0);
    initCallback() {
        super.initCallback();
        this.$['*sliderEl'] = this.ref['slider-el'];
        this.sub('*imageSize', (imageSize)=>{
            if (imageSize) setTimeout(()=>{
                this._activateTab(this.$['*tabId'], {
                    fromViewer: true
                });
            }, 0);
        });
        this.sub('*editorTransformations', (editorTransformations)=>{
            let appliedFilter = editorTransformations?.filter?.name;
            if (this.$['*currentFilter'] !== appliedFilter) this.$['*currentFilter'] = appliedFilter;
        });
        this.sub('*currentFilter', ()=>{
            this._updateInfoTooltip();
        });
        this.sub('*currentOperation', ()=>{
            this._updateInfoTooltip();
        });
        this.sub('*tabId', ()=>{
            this._updateInfoTooltip();
        });
        this.sub('*originalUrl', ()=>{
            this.$['*faderEl'] && this.$['*faderEl'].deactivate();
        });
        this.sub('*editorTransformations', (transformations)=>{
            this._preloadEditedImage();
            if (this.$['*faderEl']) this.$['*faderEl'].setTransformations(transformations);
        });
        this.sub('*loadingOperations', (/** @type {import('./types.js').LoadingOperations} */ loadingOperations)=>{
            let anyLoading = false;
            for (let [, mapping] of loadingOperations.entries()){
                if (anyLoading) break;
                for (let [, loading] of mapping.entries())if (loading) {
                    anyLoading = true;
                    break;
                }
            }
            this._debouncedShowLoader(anyLoading);
        });
        this.sub('*showSlider', (showSlider)=>{
            this.$['presence.subToolbar'] = showSlider;
            this.$['presence.mainToolbar'] = !showSlider;
        });
        this.sub('*tabList', (tabList)=>{
            this.$['presence.tabToggles'] = tabList.length > 1;
            for (const tabId of (0, $1ce1dd3703477f5c$export$d9a4cca3740decc7)){
                this.$[`presence.tabToggle.${tabId}`] = tabList.includes(tabId);
                const toggleEl = this.ref[`tab-toggle-${tabId}`];
                toggleEl.style.gridColumn = tabList.indexOf(tabId) + 1;
            }
            if (!tabList.includes(this.$['*tabId'])) this._activateTab(tabList[0], {
                fromViewer: false
            });
        });
        this._updateInfoTooltip();
    }
}
$79853253e74da0e3$export$477aaffea178bc4e.template = /* HTML */ `
  <lr-line-loader-ui set="active: showLoader"></lr-line-loader-ui>
  <div class="info-tooltip_container">
    <div class="info-tooltip_wrapper">
      <div ref="tooltip-el" class="info-tooltip info-tooltip_hidden">{{*operationTooltip}}</div>
    </div>
  </div>
  <div class="toolbar-container">
    <lr-presence-toggle class="sub-toolbar" set="visible: presence.mainToolbar; styles: presence.subTopToolbarStyles">
      <div class="tab-content-row">${(0, $1ce1dd3703477f5c$export$d9a4cca3740decc7).map($79853253e74da0e3$var$renderTabContent).join('')}</div>
      <div class="controls-row">
        <lr-btn-ui theme="boring" icon="closeMax" set="onclick: on.cancel"> </lr-btn-ui>
        <lr-presence-toggle class="tab-toggles" set="visible: presence.tabToggles; styles: presence.tabTogglesStyles">
          <div ref="tabs-indicator" class="tab-toggles_indicator"></div>
          ${(0, $1ce1dd3703477f5c$export$d9a4cca3740decc7).map($79853253e74da0e3$var$renderTabToggle).join('')}
        </lr-presence-toggle>
        <lr-btn-ui theme="primary" icon="done" set="onclick: on.apply"> </lr-btn-ui>
      </div>
    </lr-presence-toggle>
    <lr-presence-toggle class="sub-toolbar" set="visible: presence.subToolbar; styles: presence.subBottomToolbarStyles">
      <div class="slider">
        <lr-editor-slider ref="slider-el"></lr-editor-slider>
      </div>
      <div class="controls-row">
        <lr-btn-ui theme="boring" set="@text: l10n.cancel; onclick: on.cancelSlider;"> </lr-btn-ui>
        <lr-btn-ui theme="primary" set="@text: l10n.apply; onclick: on.applySlider;"> </lr-btn-ui>
      </div>
    </lr-presence-toggle>
  </div>
`;




class $8c5555ff86dfc600$export$3899e04dfd1bb237 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._iconReversed = false;
        this._iconSingle = false;
        this._iconHidden = false;
        this.init$ = {
            ...this.init$,
            text: '',
            icon: '',
            iconCss: this._iconCss(),
            theme: null
        };
        this.defineAccessor('active', (active)=>{
            if (active) this.setAttribute('active', '');
            else this.removeAttribute('active');
        });
    }
    _iconCss() {
        return (0, $1de04e4a7162860e$export$ce4ab0c55987d1ff)('icon', {
            icon_left: !this._iconReversed,
            icon_right: this._iconReversed,
            icon_hidden: this._iconHidden,
            icon_single: this._iconSingle
        });
    }
    initCallback() {
        super.initCallback();
        this.sub('icon', (iconName)=>{
            this._iconSingle = !this.$.text;
            this._iconHidden = !iconName;
            this.$.iconCss = this._iconCss();
        });
        this.sub('theme', (theme)=>{
            if (theme !== 'custom') this.className = theme;
        });
        this.sub('text', (txt)=>{
            this._iconSingle = false;
        });
        this.setAttribute('role', 'button');
        if (this.tabIndex === -1) this.tabIndex = 0;
        if (!this.hasAttribute('theme')) this.setAttribute('theme', 'default');
    }
    set reverse(val) {
        if (this.hasAttribute('reverse')) {
            this.style.flexDirection = 'row-reverse';
            this._iconReversed = true;
        } else {
            this._iconReversed = false;
            this.style.flexDirection = null;
        }
    }
}
$8c5555ff86dfc600$export$3899e04dfd1bb237.bindAttributes({
    text: 'text',
    icon: 'icon',
    reverse: 'reverse',
    theme: 'theme'
});
$8c5555ff86dfc600$export$3899e04dfd1bb237.template = /* HTML */ `
  <lr-icon size="20" set="className: iconCss; @name: icon;"></lr-icon>
  <div class="text">{{text}}</div>
`;



class $0b5e3841f204f961$export$21cd7d08dbb08eff extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._active = false;
        this._handleTransitionEndRight = ()=>{
            let lineEl = this.ref['line-el'];
            lineEl.style.transition = `initial`;
            lineEl.style.opacity = '0';
            lineEl.style.transform = `translateX(-101%)`;
            this._active && this._start();
        };
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor('active', (active)=>{
            if (typeof active === 'boolean') {
                if (active) this._start();
                else this._stop();
            }
        });
    }
    _start() {
        this._active = true;
        let { width: width } = this.getBoundingClientRect();
        let lineEl = this.ref['line-el'];
        lineEl.style.transition = `transform 1s`;
        lineEl.style.opacity = '1';
        lineEl.style.transform = `translateX(${width}px)`;
        lineEl.addEventListener('transitionend', this._handleTransitionEndRight, {
            once: true
        });
    }
    _stop() {
        this._active = false;
    }
}
$0b5e3841f204f961$export$21cd7d08dbb08eff.template = /* HTML */ `
  <div class="inner">
    <div class="line" ref="line-el"></div>
  </div>
`;




/**
 * @typedef {Object} Style
 * @property {String} [transition]
 * @property {String} [visible]
 * @property {String} [hidden]
 */ /** @type {Style} */ const $a2e1e00685856b5d$var$DEFAULT_STYLE = {
    transition: 'transition',
    visible: 'visible',
    hidden: 'hidden'
};
class $a2e1e00685856b5d$export$62b432f031007740 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._visible = false;
        this._visibleStyle = $a2e1e00685856b5d$var$DEFAULT_STYLE.visible;
        this._hiddenStyle = $a2e1e00685856b5d$var$DEFAULT_STYLE.hidden;
        this._externalTransitions = false;
        this.defineAccessor('styles', (styles)=>{
            if (!styles) return;
            this._externalTransitions = true;
            this._visibleStyle = styles.visible;
            this._hiddenStyle = styles.hidden;
        });
        this.defineAccessor('visible', (visible)=>{
            if (typeof visible !== 'boolean') return;
            this._visible = visible;
            this._handleVisible();
        });
    }
    _handleVisible() {
        this.style.visibility = this._visible ? 'inherit' : 'hidden';
        (0, $1de04e4a7162860e$export$7efcd118c973e827)(this, {
            [$a2e1e00685856b5d$var$DEFAULT_STYLE.transition]: !this._externalTransitions,
            [this._visibleStyle]: this._visible,
            [this._hiddenStyle]: !this._visible
        });
        this.setAttribute('aria-hidden', this._visible ? 'false' : 'true');
    }
    initCallback() {
        super.initCallback();
        this.setAttribute('hidden', '');
        if (!this._externalTransitions) this.classList.add($a2e1e00685856b5d$var$DEFAULT_STYLE.transition);
        this._handleVisible();
        setTimeout(()=>this.removeAttribute('hidden'), 0);
    }
}
$a2e1e00685856b5d$export$62b432f031007740.template = /* HTML */ ` <slot></slot> `;



class $05fbd40f7ffb2d55$export$facfb944826701a2 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        disabled: false,
        min: 0,
        max: 100,
        onInput: null,
        onChange: null,
        defaultValue: null,
        'on.sliderInput': ()=>{
            let value = parseInt(this.ref['input-el'].value, 10);
            this._updateValue(value);
            this.$.onInput && this.$.onInput(value);
        },
        'on.sliderChange': ()=>{
            let value = parseInt(this.ref['input-el'].value, 10);
            this.$.onChange && this.$.onChange(value);
        }
    };
    constructor(){
        super();
        this.setAttribute('with-effects', '');
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor('disabled', (disabled)=>{
            this.$.disabled = disabled;
        });
        this.defineAccessor('min', (min)=>{
            this.$.min = min;
        });
        this.defineAccessor('max', (max)=>{
            this.$.max = max;
        });
        this.defineAccessor('defaultValue', (defaultValue)=>{
            this.$.defaultValue = defaultValue;
            this.ref['input-el'].value = defaultValue;
            this._updateValue(defaultValue);
        });
        this.defineAccessor('zero', (zero)=>{
            this._zero = zero;
        });
        this.defineAccessor('onInput', (onInput)=>{
            if (!onInput) return;
            this.$.onInput = onInput;
        });
        this.defineAccessor('onChange', (onChange)=>{
            if (!onChange) return;
            this.$.onChange = onChange;
        });
        this._updateSteps();
        this._observer = new ResizeObserver(()=>{
            this._updateSteps();
            let value = parseInt(this.ref['input-el'].value, 10);
            this._updateValue(value);
        });
        this._observer.observe(this);
        this._thumbSize = parseInt(window.getComputedStyle(this).getPropertyValue('--l-thumb-size'), 10);
        setTimeout(()=>{
            let value = parseInt(this.ref['input-el'].value, 10);
            this._updateValue(value);
        }, 0);
        this.sub('disabled', (disabled)=>{
            let el = this.ref['input-el'];
            if (disabled) el.setAttribute('disabled', 'disabled');
            else el.removeAttribute('disabled');
        });
        let inputEl = this.ref['input-el'];
        inputEl.addEventListener('focus', ()=>{
            this.style.setProperty('--color-effect', 'var(--hover-color-rgb)');
        });
        inputEl.addEventListener('blur', ()=>{
            this.style.setProperty('--color-effect', 'var(--idle-color-rgb)');
        });
    }
    _updateValue(value) {
        this._updateZeroDot(value);
        let { width: width } = this.getBoundingClientRect();
        let slope = 100 / (this.$.max - this.$.min);
        let mappedValue = slope * (value - this.$.min);
        let offset = mappedValue * (width - this._thumbSize) / 100;
        window.requestAnimationFrame(()=>{
            this.ref['thumb-el'].style.transform = `translateX(${offset}px)`;
        });
    }
    _updateZeroDot(value) {
        if (!this._zeroDotEl) return;
        if (value === this._zero) this._zeroDotEl.style.opacity = '0';
        else this._zeroDotEl.style.opacity = '0.2';
        let { width: width } = this.getBoundingClientRect();
        let slope = 100 / (this.$.max - this.$.min);
        let mappedValue = slope * (this._zero - this.$.min);
        let offset = mappedValue * (width - this._thumbSize) / 100;
        window.requestAnimationFrame(()=>{
            this._zeroDotEl.style.transform = `translateX(${offset}px)`;
        });
    }
    _updateSteps() {
        const STEP_GAP = 15;
        let stepsEl = this.ref['steps-el'];
        let { width: width } = stepsEl.getBoundingClientRect();
        let half = Math.ceil(width / 2);
        let count = Math.ceil(half / STEP_GAP) - 2;
        if (this._stepsCount === count) return;
        let fr = document.createDocumentFragment();
        let minorStepEl = document.createElement('div');
        let borderStepEl = document.createElement('div');
        minorStepEl.className = 'minor-step';
        borderStepEl.className = 'border-step';
        fr.appendChild(borderStepEl);
        for(let i = 0; i < count; i++)fr.appendChild(minorStepEl.cloneNode());
        fr.appendChild(borderStepEl.cloneNode());
        for(let i = 0; i < count; i++)fr.appendChild(minorStepEl.cloneNode());
        fr.appendChild(borderStepEl.cloneNode());
        let zeroDotEl = document.createElement('div');
        zeroDotEl.className = 'zero-dot';
        fr.appendChild(zeroDotEl);
        this._zeroDotEl = zeroDotEl;
        stepsEl.innerHTML = '';
        stepsEl.appendChild(fr);
        this._stepsCount = count;
    }
    destroyCallback() {
        this._observer?.disconnect();
    }
}
$05fbd40f7ffb2d55$export$facfb944826701a2.template = /* HTML */ `
  <div class="steps" ref="steps-el"></div>
  <div ref="thumb-el" class="thumb"></div>
  <input
    class="input"
    type="range"
    ref="input-el"
    tabindex="0"
    set="oninput: on.sliderInput; onchange: on.sliderChange; @min: min; @max: max; @value: defaultValue;"
  />
`;




$parcel$exportWildcard($016f44b216a56b5b$exports, $2049556ade30f986$exports);


// @ts-check



class $65a22f2aae92e351$export$cb7e12222b993acb extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            cdnUrl: null
        };
    }
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>this.mountEditor(),
            onDeactivate: ()=>this.unmountEditor()
        });
        this.sub('*focusedEntry', (/** @type {import('../../abstract/TypedData.js').TypedData} */ entry)=>{
            if (!entry) return;
            this.entry = entry;
            this.entry.subscribe('cdnUrl', (cdnUrl)=>{
                if (cdnUrl) this.$.cdnUrl = cdnUrl;
            });
        });
        this.subConfigValue('cropPreset', (cropPreset)=>{
            if (this._instance && this._instance.getAttribute('crop-preset') !== cropPreset) this._instance.setAttribute('crop-preset', cropPreset);
        });
        this.subConfigValue('cloudImageEditorTabs', (tabs)=>{
            if (this._instance && this._instance.getAttribute('tabs') !== tabs) this._instance.setAttribute('tabs', tabs);
        });
    }
    /** @param {CustomEvent<import('../CloudImageEditor/src/types.js').ApplyResult>} e */ handleApply(e) {
        if (!this.entry) return;
        let result = e.detail;
        this.entry.setMultipleValues({
            cdnUrl: result.cdnUrl,
            cdnUrlModifiers: result.cdnUrlModifiers
        });
        this.historyBack();
    }
    handleCancel() {
        this.historyBack();
    }
    mountEditor() {
        const instance = new (0, $dfe930b7333347e3$export$20cace3f5dd477e2)();
        const cdnUrl = this.$.cdnUrl;
        const cropPreset = this.cfg.cropPreset;
        const tabs = this.cfg.cloudImageEditorTabs;
        instance.setAttribute('ctx-name', this.ctxName);
        instance.setAttribute('cdn-url', cdnUrl);
        if (cropPreset) instance.setAttribute('crop-preset', cropPreset);
        if (tabs) instance.setAttribute('tabs', tabs);
        instance.addEventListener('apply', (e)=>{
            const customEvent = /** @type {CustomEvent<import('../CloudImageEditor/src/types.js').ApplyResult>} */ e;
            this.handleApply(customEvent);
            this.debugPrint(`editor event "apply"`, customEvent.detail);
        });
        instance.addEventListener('cancel', (e)=>{
            const customEvent = /** @type {CustomEvent<void>} */ e;
            this.handleCancel();
            this.debugPrint(`editor event "cancel"`, customEvent.detail);
        });
        instance.addEventListener('change', (e)=>{
            const customEvent = /** @type {CustomEvent<import('../CloudImageEditor/src/types.js').ChangeResult>} */ e;
            this.debugPrint(`editor event "change"`, customEvent.detail);
        });
        this.innerHTML = '';
        this.appendChild(instance);
        this._mounted = true;
        /** @private */ this._instance = instance;
    }
    unmountEditor() {
        this._instance = undefined;
        this.innerHTML = '';
    }
}


// @ts-check




/**
 * @param {string} str
 * @returns {string}
 */ const $d525e9350b1635b4$var$escapeRegExp = function(str) {
    return str.replace(/[\\-\\[]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $d525e9350b1635b4$export$2c080af651447618 = function(str, flags = 'i') {
    const parts = str.split('*').map($d525e9350b1635b4$var$escapeRegExp);
    return new RegExp('^' + parts.join('.+') + '$', flags);
};


let $4481d51613d4eb94$var$styleToCss = (style)=>{
    let css = Object.keys(style).reduce((acc, selector)=>{
        let propertiesObj = style[selector];
        let propertiesStr = Object.keys(propertiesObj).reduce((acc, prop)=>{
            let value = propertiesObj[prop];
            return acc + `${prop}: ${value};`;
        }, '');
        return acc + `${selector}{${propertiesStr}}`;
    }, '');
    return css;
};
function $4481d51613d4eb94$export$5115a192ad9bf57f({ textColor: textColor, backgroundColor: backgroundColor, linkColor: linkColor, linkColorHover: linkColorHover, shadeColor: shadeColor }) {
    let border = `solid 1px ${shadeColor}`;
    // TODO: we need to update source source styles, add css custom properties to control theme
    return $4481d51613d4eb94$var$styleToCss({
        body: {
            color: textColor,
            'background-color': backgroundColor
        },
        '.side-bar': {
            background: 'inherit',
            'border-right': border
        },
        '.main-content': {
            background: 'inherit'
        },
        '.main-content-header': {
            background: 'inherit'
        },
        '.main-content-footer': {
            background: 'inherit'
        },
        '.list-table-row': {
            color: 'inherit'
        },
        '.list-table-row:hover': {
            background: shadeColor
        },
        '.list-table-row .list-table-cell-a, .list-table-row .list-table-cell-b': {
            'border-top': border
        },
        '.list-table-body .list-items': {
            'border-bottom': border
        },
        '.bread-crumbs a': {
            color: linkColor
        },
        '.bread-crumbs a:hover': {
            color: linkColorHover
        },
        '.main-content.loading': {
            background: `${backgroundColor} url(/static/images/loading_spinner.gif) center no-repeat`,
            'background-size': '25px 25px'
        },
        '.list-icons-item': {
            'background-color': shadeColor
        },
        '.source-gdrive .side-bar-menu a, .source-gphotos .side-bar-menu a': {
            color: linkColor
        },
        '.source-gdrive .side-bar-menu a, .source-gphotos .side-bar-menu a:hover': {
            color: linkColorHover
        },
        '.side-bar-menu a': {
            color: linkColor
        },
        '.side-bar-menu a:hover': {
            color: linkColorHover
        },
        '.source-gdrive .side-bar-menu .current, .source-gdrive .side-bar-menu a:hover, .source-gphotos .side-bar-menu .current, .source-gphotos .side-bar-menu a:hover': {
            color: linkColorHover
        },
        '.source-vk .side-bar-menu a': {
            color: linkColor
        },
        '.source-vk .side-bar-menu a:hover': {
            color: linkColorHover,
            background: 'none'
        }
    });
}


let $dc8f89bfa29b59f5$var$cbMapping = {};
window.addEventListener('message', (e)=>{
    let message;
    try {
        message = JSON.parse(e.data);
    } catch (err) {
        return;
    }
    if (message?.type in $dc8f89bfa29b59f5$var$cbMapping) {
        let cbList = $dc8f89bfa29b59f5$var$cbMapping[message.type];
        for (let [sender, callback] of cbList)if (e.source === sender) callback(message);
    }
});
const $dc8f89bfa29b59f5$export$dc076a8ad1b3dccc = function(type, sender, callback) {
    if (!(type in $dc8f89bfa29b59f5$var$cbMapping)) $dc8f89bfa29b59f5$var$cbMapping[type] = [];
    $dc8f89bfa29b59f5$var$cbMapping[type].push([
        sender,
        callback
    ]);
};
const $dc8f89bfa29b59f5$export$1bfd60213de7d898 = function(type, sender) {
    if (type in $dc8f89bfa29b59f5$var$cbMapping) $dc8f89bfa29b59f5$var$cbMapping[type] = $dc8f89bfa29b59f5$var$cbMapping[type].filter((item)=>item[0] !== sender);
};


/**
 * @param {{ [key: string]: string | number | boolean | null | undefined }} params
 * @returns {string}
 */ function $d14d6cdfc3eca9d6$export$ded69dcd8ce7e468(params) {
    let list = [];
    for (let [key, value] of Object.entries(params)){
        if (value === undefined || value === null || typeof value === 'string' && value.length === 0) continue;
        list.push(`${key}=${encodeURIComponent(value)}`);
    }
    return list.join('&');
}


class $a47f32e481c99b09$export$ffc19e40a21f08eb extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.EXTERNAL;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            activityIcon: '',
            activityCaption: '',
            selectedList: [],
            counter: 0,
            multiple: false,
            onDone: ()=>{
                for (const message of this.$.selectedList){
                    const url = this.extractUrlFromMessage(message);
                    const { filename: filename } = message;
                    const { externalSourceType: externalSourceType } = this.activityParams;
                    this.addFileFromUrl(url, {
                        fileName: filename,
                        source: externalSourceType
                    });
                }
                this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            },
            onCancel: ()=>{
                this.historyBack();
            }
        };
    }
    /**
   * @private
   * @type {HTMLIFrameElement | null}
   */ _iframe = null;
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>{
                let { externalSourceType: externalSourceType } = /** @type {ActivityParams} */ this.activityParams;
                this.set$({
                    activityCaption: `${externalSourceType?.[0].toUpperCase()}${externalSourceType?.slice(1)}`,
                    activityIcon: externalSourceType
                });
                this.mountIframe();
            }
        });
        this.sub('*currentActivity', (val)=>{
            if (val !== this.activityType) this.unmountIframe();
        });
        this.sub('selectedList', (list)=>{
            this.$.counter = list.length;
        });
        this.subConfigValue('multiple', (multiple)=>{
            this.$.multiple = multiple;
        });
    }
    /**
   * @private
   * @param {SelectedFileMessage} message
   */ extractUrlFromMessage(message) {
        if (message.alternatives) {
            const preferredTypes = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(this.cfg.externalSourcesPreferredTypes);
            for (const preferredType of preferredTypes){
                const regexp = (0, $d525e9350b1635b4$export$2c080af651447618)(preferredType);
                for (const [type, typeUrl] of Object.entries(message.alternatives)){
                    if (regexp.test(type)) return typeUrl;
                }
            }
        }
        return message.url;
    }
    /**
   * @private
   * @param {Message} message
   */ sendMessage(message) {
        this._iframe?.contentWindow?.postMessage(JSON.stringify(message), '*');
    }
    /**
   * @private
   * @param {SelectedFileMessage} message
   */ async handleFileSelected(message) {
        if (!this.$.multiple && this.$.selectedList.length) return;
        this.$.selectedList = [
            ...this.$.selectedList,
            message
        ];
        if (!this.$.multiple) this.$.onDone();
    }
    /** @private */ handleIframeLoad() {
        this.applyStyles();
    }
    updateCssData = ()=>{
        if (this.isActivityActive) {
            this._inheritedUpdateCssData();
            this.applyStyles();
        }
    };
    /** @private */ _inheritedUpdateCssData = this.updateCssData;
    /**
   * @private
   * @param {string} propName
   */ getCssValue(propName) {
        let style = window.getComputedStyle(this);
        return style.getPropertyValue(propName).trim();
    }
    /** @private */ applyStyles() {
        let colors = {
            backgroundColor: this.getCssValue('--clr-background-light'),
            textColor: this.getCssValue('--clr-txt'),
            shadeColor: this.getCssValue('--clr-shade-lv1'),
            linkColor: '#157cfc',
            linkColorHover: '#3891ff'
        };
        this.sendMessage({
            type: 'embed-css',
            style: (0, $4481d51613d4eb94$export$5115a192ad9bf57f)(colors)
        });
    }
    /** @private */ remoteUrl() {
        let pubkey = this.cfg.pubkey;
        let imagesOnly = false.toString();
        let { externalSourceType: externalSourceType } = this.activityParams;
        let params = {
            lang: this.getCssData('--l10n-locale-name')?.split('-')?.[0] || 'en',
            public_key: pubkey,
            images_only: imagesOnly,
            pass_window_open: false,
            session_key: this.cfg.remoteTabSessionKey
        };
        let url = new URL(this.cfg.socialBaseUrl);
        url.pathname = `/window3/${externalSourceType}`;
        url.search = (0, $d14d6cdfc3eca9d6$export$ded69dcd8ce7e468)(params);
        return url.toString();
    }
    /** @private */ mountIframe() {
        /** @type {HTMLIFrameElement} */ // @ts-ignore
        let iframe = (0, $7868cd5b229e5c15$export$185802fd694ee1f5)({
            tag: 'iframe',
            attributes: {
                src: this.remoteUrl(),
                marginheight: 0,
                marginwidth: 0,
                frameborder: 0,
                allowTransparency: true
            }
        });
        iframe.addEventListener('load', this.handleIframeLoad.bind(this));
        this.ref.iframeWrapper.innerHTML = '';
        this.ref.iframeWrapper.appendChild(iframe);
        (0, $dc8f89bfa29b59f5$export$dc076a8ad1b3dccc)('file-selected', iframe.contentWindow, this.handleFileSelected.bind(this));
        this._iframe = iframe;
        this.$.selectedList = [];
    }
    /** @private */ unmountIframe() {
        this._iframe && (0, $dc8f89bfa29b59f5$export$1bfd60213de7d898)('file-selected', this._iframe.contentWindow);
        this.ref.iframeWrapper.innerHTML = '';
        this._iframe = null;
        this.$.selectedList = [];
        this.$.counter = 0;
    }
}
$a47f32e481c99b09$export$ffc19e40a21f08eb.template = /* HTML */ `
  <lr-activity-header>
    <button type="button" class="mini-btn" set="onclick: *historyBack">
      <lr-icon name="back"></lr-icon>
    </button>
    <div>
      <lr-icon set="@name: activityIcon"></lr-icon>
      <span>{{activityCaption}}</span>
    </div>
    <button type="button" class="mini-btn close-btn" set="onclick: *historyBack">
      <lr-icon name="close"></lr-icon>
    </button>
  </lr-activity-header>
  <div class="content">
    <div ref="iframeWrapper" class="iframe-wrapper"></div>
    <div class="toolbar">
      <button type="button" class="cancel-btn secondary-btn" set="onclick: onCancel" l10n="cancel"></button>
      <div></div>
      <div set="@hidden: !multiple" class="selected-counter"><span l10n="selected-count"></span>{{counter}}</div>
      <button type="button" class="done-btn primary-btn" set="onclick: onDone; @disabled: !counter">
        <lr-icon name="check"></lr-icon>
      </button>
    </div>
  </div>
`;





class $1b696d7bad6d3150$export$b2539bed5023c21c extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    /** @param {String} tabL10nStr */ setCurrentTab(tabL10nStr) {
        if (!tabL10nStr) return;
        let ctxList = [
            ...this.ref.context.querySelectorAll('[tab-ctx]')
        ];
        ctxList.forEach((ctxEl)=>{
            if (ctxEl.getAttribute('tab-ctx') === tabL10nStr) ctxEl.removeAttribute('hidden');
            else ctxEl.setAttribute('hidden', '');
        });
        for(let lStr in this._tabMap)if (lStr === tabL10nStr) this._tabMap[lStr].setAttribute('current', '');
        else this._tabMap[lStr].removeAttribute('current');
    }
    initCallback() {
        super.initCallback();
        /**
     * @private
     * @type {Object<string, HTMLElement>}
     */ this._tabMap = {};
        this.defineAccessor('tab-list', (/** @type {String} */ val)=>{
            if (!val) return;
            let tabList = (0, $87af14daf04b29b8$export$b9ca061da17f2d30)(val);
            tabList.forEach((tabL10nStr)=>{
                let tabEl = (0, $7868cd5b229e5c15$export$185802fd694ee1f5)({
                    tag: 'div',
                    attributes: {
                        class: 'tab'
                    },
                    properties: {
                        onclick: ()=>{
                            this.setCurrentTab(tabL10nStr);
                        }
                    }
                });
                tabEl.textContent = this.l10n(tabL10nStr);
                this.ref.row.appendChild(tabEl);
                this._tabMap[tabL10nStr] = tabEl;
            });
        });
        this.defineAccessor('default', (val)=>{
            this.setCurrentTab(val);
        });
        if (!this.hasAttribute('default')) this.setCurrentTab(Object.keys(this._tabMap)[0]);
    }
}
$1b696d7bad6d3150$export$b2539bed5023c21c.bindAttributes({
    'tab-list': null,
    default: null
});
$1b696d7bad6d3150$export$b2539bed5023c21c.template = /* HTML */ `
  <div ref="row" class="tabs-row"></div>
  <div ref="context" class="tabs-context">
    <slot></slot>
  </div>
`;


// @ts-check


class $95a63dc49e5fa8b0$export$fd970bbd10854e43 extends (0, $7465cac7cdfffcd5$export$5ece2da0ca12cb21) {
    requireCtxName = true;
    _createValidationInput() {
        const validationInput = document.createElement('input');
        validationInput.type = 'text';
        validationInput.name = this.ctxName;
        validationInput.required = this.cfg.multipleMin > 0;
        validationInput.tabIndex = -1;
        (0, $7868cd5b229e5c15$export$41428deff1a0db9e)(validationInput, {
            opacity: 0,
            height: 0,
            width: 0
        });
        return validationInput;
    }
    initCallback() {
        super.initCallback();
        this._validationInputElement = this._createValidationInput();
        this.appendChild(this._validationInputElement);
        this.sub('*collectionState', (/** @type {import('../../types/index.js').OutputCollectionState} */ collectionState)=>{
            {
                if (!this._dynamicInputsContainer) {
                    this._dynamicInputsContainer = document.createElement('div');
                    this.appendChild(this._dynamicInputsContainer);
                }
                if (!this._validationInputElement) {
                    const input = this._createValidationInput();
                    this.appendChild(input);
                    this._validationInputElement = input;
                }
                this._dynamicInputsContainer.innerHTML = '';
                if (collectionState.status === 'uploading' || collectionState.status === 'idle') {
                    this._validationInputElement.value = '';
                    this._validationInputElement.setCustomValidity('');
                    return;
                }
                if (collectionState.status === 'failed') {
                    const errorMsg = collectionState.errors[0]?.message;
                    this._validationInputElement.value = '';
                    this._validationInputElement.setCustomValidity(errorMsg);
                    return;
                }
                const group = collectionState.group ? collectionState.group : null;
                if (group) {
                    this._validationInputElement.value = group.cdnUrl;
                    this._validationInputElement.setCustomValidity('');
                    return;
                }
                const cdnUrls = collectionState.allEntries.map((entry)=>entry.cdnUrl);
                if (!this.cfg.multiple && cdnUrls.length === 1) {
                    this._validationInputElement.value = cdnUrls[0];
                    this._validationInputElement.setCustomValidity('');
                    return;
                }
                // Remove validation input to prevent it from being submitted
                this._validationInputElement.remove();
                this._validationInputElement = null;
                const fr = new DocumentFragment();
                for (let value of cdnUrls){
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `${this.ctxName}[]`;
                    input.value = value;
                    fr.appendChild(input);
                }
                this._dynamicInputsContainer.replaceChildren(fr);
            }
        }, false);
    }
}



class $e98489404589cace$export$cdc1ca0f45c41261 extends (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747) {
}



class $fd57f1e30ae4cd0e$export$ef9b1a59e592288f extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        currentText: '',
        options: [],
        selectHtml: '',
        onSelect: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.value = this.ref.select.value;
            this.$.currentText = this.$.options.find((opt)=>{
                return opt.value == this.value;
            })?.text || '';
            this.dispatchEvent(new Event('change'));
        }
    };
    initCallback() {
        super.initCallback();
        this.sub('options', (/** @type {{ text: String; value: String }[]} */ options)=>{
            this.$.currentText = options?.[0]?.text || '';
            let html = '';
            options?.forEach((opt)=>{
                html += /* HTML */ `<option value="${opt.value}">${opt.text}</option>`;
            });
            this.$.selectHtml = html;
        });
    }
}
$fd57f1e30ae4cd0e$export$ef9b1a59e592288f.template = /* HTML */ `
  <button>
    {{currentText}}
    <lr-icon name="select"></lr-icon>
    <select ref="select" set="innerHTML: selectHtml; onchange: onSelect"></select>
  </button>
`;



/** @enum {String} */ const $9fa21cf0fb6e0b82$var$ICO_MAP = {
    PLAY: 'play',
    PAUSE: 'pause',
    FS_ON: 'fullscreen-on',
    FS_OFF: 'fullscreen-off',
    VOL_ON: 'unmute',
    VOL_OFF: 'mute',
    CAP_ON: 'captions',
    CAP_OFF: 'captions-off'
};
// TODO: refactor and move fullscreen adapter to utils:
const $9fa21cf0fb6e0b82$var$FSAPI = {
    requestFullscreen: (el)=>{
        if (el.requestFullscreen) el.requestFullscreen();
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    },
    exitFullscreen: ()=>{
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document['webkitExitFullscreen']) document['webkitExitFullscreen']();
    }
};
class $9fa21cf0fb6e0b82$export$ae01dedf5c052bb extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    togglePlay() {
        if (this._video.paused || this._video.ended) this._video.play();
        else this._video.pause();
    }
    toggleFullscreen() {
        if ((document.fullscreenElement || document['webkitFullscreenElement']) === this) $9fa21cf0fb6e0b82$var$FSAPI.exitFullscreen();
        else $9fa21cf0fb6e0b82$var$FSAPI.requestFullscreen(this);
    }
    toggleCaptions() {
        if (this.$.capIcon === $9fa21cf0fb6e0b82$var$ICO_MAP.CAP_OFF) {
            this.$.capIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.CAP_ON;
            this._video.textTracks[0].mode = 'showing';
            window.localStorage.setItem($9fa21cf0fb6e0b82$export$ae01dedf5c052bb.is + ':captions', '1');
        } else {
            this.$.capIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.CAP_OFF;
            this._video.textTracks[0].mode = 'hidden';
            window.localStorage.removeItem($9fa21cf0fb6e0b82$export$ae01dedf5c052bb.is + ':captions');
        }
    }
    toggleSound() {
        if (this.$.volIcon === $9fa21cf0fb6e0b82$var$ICO_MAP.VOL_ON) {
            this.$.volIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.VOL_OFF;
            this.$.volumeDisabled = true;
            this._video.muted = true;
        } else {
            this.$.volIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.VOL_ON;
            this.$.volumeDisabled = false;
            this._video.muted = false;
        }
    }
    setVolume(val) {
        window.localStorage.setItem($9fa21cf0fb6e0b82$export$ae01dedf5c052bb.is + ':volume', val);
        let volume = val ? val / 100 : 0;
        this._video.volume = volume;
    }
    /** @type {HTMLElement} */ get progress() {
        return this.ref.progress;
    }
    init$ = {
        ...this.init$,
        src: '',
        ppIcon: $9fa21cf0fb6e0b82$var$ICO_MAP.PLAY,
        fsIcon: $9fa21cf0fb6e0b82$var$ICO_MAP.FS_ON,
        volIcon: $9fa21cf0fb6e0b82$var$ICO_MAP.VOL_ON,
        capIcon: $9fa21cf0fb6e0b82$var$ICO_MAP.CAP_OFF,
        totalTime: '00:00',
        currentTime: '00:00',
        progressCssWidth: '0',
        hasSubtitles: false,
        volumeDisabled: false,
        volumeValue: 0,
        onPP: ()=>{
            this.togglePlay();
        },
        onFs: ()=>{
            this.toggleFullscreen();
        },
        onCap: ()=>{
            this.toggleCaptions();
        },
        onMute: ()=>{
            this.toggleSound();
        },
        onVolChange: (e)=>{
            // TODO: cast range.value instead of range.$.value
            let val = parseFloat(e.currentTarget.$.value);
            this.setVolume(val);
        },
        progressClicked: (e)=>{
            let progressRect = this.progress.getBoundingClientRect();
            this._video.currentTime = this._video.duration * (e.offsetX / progressRect.width);
        }
    };
    /**
   * @private
   * @param {String} input
   */ _getUrl(input) {
        return input.includes('/') ? input : `https://ucarecdn.com/${input}/`;
    }
    /**
   * @private
   * @param {Object<string, any>} desc
   */ _desc2attrs(desc) {
        let attrs = [];
        for(let attr in desc){
            let val = attr === 'src' ? this._getUrl(desc[attr]) : desc[attr];
            attrs.push(`${attr}="${val}"`);
        }
        return attrs.join(' ');
    }
    /**
   * @private
   * @param {Number} seconds
   */ _timeFmt(seconds) {
        // TODO: add hours
        let date = new Date(Math.round(seconds) * 1000);
        return [
            date.getMinutes(),
            date.getSeconds()
        ].map((n)=>{
            return n < 10 ? '0' + n : n;
        }).join(':');
    }
    /** @private */ _initTracks() {
        [
            ...this._video.textTracks
        ].forEach((track)=>{
            track.mode = 'hidden';
        });
        if (window.localStorage.getItem($9fa21cf0fb6e0b82$export$ae01dedf5c052bb.is + ':captions')) this.toggleCaptions();
    }
    /** @private */ _castAttributes() {
        let toCast = [
            'autoplay',
            'loop',
            'muted'
        ];
        [
            ...this.attributes
        ].forEach((attr)=>{
            if (toCast.includes(attr.name)) this._video.setAttribute(attr.name, attr.value);
        });
    }
    initCallback() {
        super.initCallback();
        /**
     * @private
     * @type {HTMLVideoElement}
     */ this._video = this.ref.video;
        this._castAttributes();
        this._video.addEventListener('play', ()=>{
            this.$.ppIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.PAUSE;
            this.setAttribute('playback', '');
        });
        this._video.addEventListener('pause', ()=>{
            this.$.ppIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.PLAY;
            this.removeAttribute('playback');
        });
        this.addEventListener('fullscreenchange', (e)=>{
            console.log(e);
            if (document.fullscreenElement === this) this.$.fsIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.FS_OFF;
            else this.$.fsIcon = $9fa21cf0fb6e0b82$var$ICO_MAP.FS_ON;
        });
        this.sub('src', (src)=>{
            if (!src) return;
            let url = this._getUrl(src);
            this._video.src = url;
        });
        this.sub('video', async (descPath)=>{
            if (!descPath) return;
            let desc = await (await window.fetch(this._getUrl(descPath))).json();
            if (desc.poster) this._video.poster = this._getUrl(desc.poster);
            let html = '';
            desc?.sources.forEach((srcDesc)=>{
                html += /* HTML */ `<source ${this._desc2attrs(srcDesc)} />`;
            });
            if (desc.tracks) {
                desc.tracks.forEach((trackDesc)=>{
                    html += /* HTML */ `<track ${this._desc2attrs(trackDesc)} />`;
                });
                this.$.hasSubtitles = true;
            }
            this._video.innerHTML += html;
            this._initTracks();
            console.log(desc);
        });
        this._video.addEventListener('loadedmetadata', (e)=>{
            this.$.currentTime = this._timeFmt(this._video.currentTime);
            this.$.totalTime = this._timeFmt(this._video.duration);
        });
        this._video.addEventListener('timeupdate', (e)=>{
            let perc = Math.round(100 * (this._video.currentTime / this._video.duration));
            this.$.progressCssWidth = perc + '%';
            this.$.currentTime = this._timeFmt(this._video.currentTime);
        });
        let volume = window.localStorage.getItem($9fa21cf0fb6e0b82$export$ae01dedf5c052bb.is + ':volume');
        if (volume) {
            let vol = parseFloat(volume);
            this.setVolume(vol);
            this.$.volumeValue = vol;
        }
    }
}
$9fa21cf0fb6e0b82$export$ae01dedf5c052bb.template = /* HTML */ `
  <div class="video-wrapper">
    <video ref="video" preload="metadata" crossorigin="anonymous"></video>
  </div>

  <div class="toolbar">
    <div class="progress" ref="progress" set -onclick="progressClicked">
      <div class="bar" set -style.width="progressCssWidth"></div>
    </div>

    <div class="tb-block">
      <button set -onclick="onPP">
        <lr-icon set -@name="ppIcon"></lr-icon>
      </button>
      <div class="timer">{{currentTime}} / {{totalTime}}</div>
    </div>

    <div class="tb-block">
      <button set -onclick="onCap" -@hidden="!hasSubtitles">
        <lr-icon set -@name="capIcon"></lr-icon>
      </button>

      <button set -onclick="onMute">
        <lr-icon set -@name="volIcon"></lr-icon>
      </button>

      <lr-range type="range" set -onchange="onVolChange" -@disabled="volumeDisabled" -value="volumeValue"> </lr-range>

      <button set -onclick="onFs">
        <lr-icon set -@name="fsIcon"></lr-icon>
      </button>
    </div>
  </div>
`;
$9fa21cf0fb6e0b82$export$ae01dedf5c052bb.bindAttributes({
    video: 'video',
    src: 'src'
});


// @ts-check


const $cb5cf34cacde6aab$var$CSS_ATTRIBUTE = 'css-src';
function $cb5cf34cacde6aab$export$3ba84baa65014afa(Base) {
    // @ts-ignore
    return class extends Base {
        renderShadow = true;
        pauseRender = true;
        requireCtxName = true;
        shadowReadyCallback() {}
        /**
     * @private
     *
     *   This is super tricky workaround to wait for shadow styles to load. When `shadowStyles` is defined, symbiote will
     *   wait for it to load before rendering the component. So the `render` method becomes async. We need to call
     *   `shadowReadyCallback` right after the rendering is done. But we can't just call it after `render` because it's
     *   async. So we need to wait for the shadow styles to load and then call `shadowReadyCallback`.
     */ async _waitForShadowStylesLoad() {
            if (!this.shadowRoot) return;
            // @ts-expect-error
            const shadowStylesUrl = this.constructor['__shadowStylesUrl'];
            /** @type {HTMLLinkElement | null} */ const link = this.shadowRoot.querySelector(`link[href="${shadowStylesUrl}"]`);
            if (!link) return;
            await new Promise((resolve, reject)=>{
                link.addEventListener('load', resolve);
                link.addEventListener('error', reject);
            });
        }
        initCallback() {
            super.initCallback();
            this.setAttribute('hidden', '');
            (0, $b621c7eab37d9df5$export$bf3e2014f0f6687e)({
                element: this,
                attribute: $cb5cf34cacde6aab$var$CSS_ATTRIBUTE,
                onSuccess: (href)=>{
                    this.attachShadow({
                        mode: 'open'
                    });
                    let link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = href;
                    link.onload = ()=>{
                        // CSS modules can be not loaded at this moment
                        // TODO: investigate better solution
                        window.requestAnimationFrame(async ()=>{
                            this.render();
                            await this._waitForShadowStylesLoad();
                            window.setTimeout(()=>{
                                this.removeAttribute('hidden');
                                this.shadowReadyCallback();
                            });
                        });
                    };
                    // @ts-ignore TODO: fix this
                    this.shadowRoot.prepend(link);
                },
                onTimeout: ()=>{
                    console.error('Attribute `css-src` is required and it is not set. See migration guide: https://uploadcare.com/docs/file-uploader/migration-to-0.25.0/');
                }
            });
        }
    };
}
class $cb5cf34cacde6aab$export$4ebb490b3ccfc72f extends $cb5cf34cacde6aab$export$3ba84baa65014afa((0, $e746289f30c91f4f$export$d96a8827a60d6b69)) {
}



class $74158b9931238736$export$7b024d8cdfcd6192 extends (0, $e746289f30c91f4f$export$d96a8827a60d6b69) {
    initCallback() {
        super.initCallback();
        this.subConfigValue('removeCopyright', /** @param {number} value */ (value)=>{
            this.toggleAttribute('hidden', !!value);
        });
    }
    static template = /* HTML */ `
    <a
      href="https://uploadcare.com/?utm_source=copyright&utm_medium=referral&utm_campaign=v4"
      target="_blank noopener"
      class="credits"
      >Powered by Uploadcare</a
    >
  `;
}


// @ts-check


class $6bc8bca9ab6a0fc2$export$bec543de6927e621 extends (0, $cb5cf34cacde6aab$export$4ebb490b3ccfc72f) {
    requireCtxName = true;
    init$ = (0, $9a2b059e07de0fba$export$e6278a3220543f46)(this);
    _template = null;
    static set template(value) {
        this._template = value + /** HTML */ `<slot></slot>`;
    }
    static get template() {
        return this._template;
    }
}



class $077d76b129d28a75$export$2c9ccda59fbaf1f6 extends (0, $6bc8bca9ab6a0fc2$export$bec543de6927e621) {
    shadowReadyCallback() {
        super.shadowReadyCallback();
        this.sub('*modalActive', (modalActive)=>{
            if (this._lastModalActive !== modalActive) this.emit(modalActive ? (0, $a25d4bde048879ae$export$3d7865934588d77e).MODAL_OPEN : (0, $a25d4bde048879ae$export$3d7865934588d77e).MODAL_CLOSE, undefined, {
                debounce: true
            });
            /** @private */ this._lastModalActive = modalActive;
        }, false);
    }
}
$077d76b129d28a75$export$2c9ccda59fbaf1f6.template = /* HTML */ `
  <lr-simple-btn></lr-simple-btn>

  <lr-modal strokes block-body-scrolling>
    <lr-start-from>
      <lr-drop-area with-icon clickable></lr-drop-area>
      <lr-source-list wrap></lr-source-list>
      <button type="button" l10n="start-from-cancel" class="secondary-btn" set="onclick: *historyBack"></button>
      <lr-copyright></lr-copyright>
    </lr-start-from>
    <lr-upload-list></lr-upload-list>
    <lr-camera-source></lr-camera-source>
    <lr-url-source></lr-url-source>
    <lr-external-source></lr-external-source>
    <lr-cloud-image-editor-activity></lr-cloud-image-editor-activity>
  </lr-modal>

  <lr-progress-bar-common></lr-progress-bar-common>
`;




class $a300d3f190295733$export$e225fbea59169a64 extends (0, $6bc8bca9ab6a0fc2$export$bec543de6927e621) {
    pauseRender = true;
    shadowReadyCallback() {
        /** @type {import('../../../abstract/UploaderBlock.js').UploaderBlock} */ const uBlock = this.ref.uBlock;
        this.sub('*currentActivity', (val)=>{
            if (!val) this.$['*currentActivity'] = uBlock.initActivity || (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.sub('*uploadList', (list)=>{
            if (list?.length > 0) this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            else this.$['*currentActivity'] = uBlock.initActivity || (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.subConfigValue('sourceList', (sourceList)=>{
            if (sourceList !== 'local') this.cfg.sourceList = 'local';
        });
        this.subConfigValue('confirmUpload', (confirmUpload)=>{
            if (confirmUpload !== false) this.cfg.confirmUpload = false;
        });
    }
}
$a300d3f190295733$export$e225fbea59169a64.template = /* HTML */ `
  <lr-start-from>
    <lr-drop-area clickable l10n="choose-file"></lr-drop-area>
    <lr-copyright></lr-copyright>
  </lr-start-from>
  <lr-upload-list ref="uBlock"></lr-upload-list>
`;


// @ts-check


class $b8c00f3377f851f8$export$1930c3118e9a7a5e extends (0, $6bc8bca9ab6a0fc2$export$bec543de6927e621) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            couldCancel: false,
            cancel: ()=>{
                if (this.couldHistoryBack) this.$['*historyBack']();
                else if (this.couldShowList) this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            }
        };
    }
    get couldHistoryBack() {
        const history = this.$['*history'];
        return history.length > 1 && history[history.length - 1] !== (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM;
    }
    get couldShowList() {
        return this.cfg.showEmptyList || this.$['*uploadList'].length > 0;
    }
    shadowReadyCallback() {
        /** @type {import('../../../abstract/UploaderBlock.js').UploaderBlock} */ const uBlock = this.ref.uBlock;
        this.sub('*currentActivity', (val)=>{
            if (!val) this.$['*currentActivity'] = uBlock.initActivity || (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.sub('*uploadList', (list)=>{
            if (list?.length > 0 && this.$['*currentActivity'] === (uBlock.initActivity || (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.START_FROM)) this.$['*currentActivity'] = (0, $7cc70e522976ff2d$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
        });
        this.sub('*history', ()=>{
            this.$['couldCancel'] = this.couldHistoryBack || this.couldShowList;
        });
    }
}
$b8c00f3377f851f8$export$1930c3118e9a7a5e.template = /* HTML */ ` <lr-start-from>
    <lr-drop-area with-icon clickable></lr-drop-area>
    <lr-source-list wrap></lr-source-list>
    <button
      type="button"
      l10n="start-from-cancel"
      class="cancel-btn secondary-btn"
      set="onclick: cancel; @hidden: !couldCancel"
    ></button>
    <lr-copyright></lr-copyright>
  </lr-start-from>
  <lr-upload-list ref="uBlock"></lr-upload-list>
  <lr-camera-source></lr-camera-source>
  <lr-url-source></lr-url-source>
  <lr-external-source></lr-external-source>
  <lr-progress-bar></lr-progress-bar>
  <lr-cloud-image-editor-activity></lr-cloud-image-editor-activity>`;


// @ts-check


class $1a286198d18de5c3$export$f41f1027242219f6 extends (0, $cb5cf34cacde6aab$export$3ba84baa65014afa)((0, $dfe930b7333347e3$export$20cace3f5dd477e2)) {
    shadowReadyCallback() {
        /** @private */ this.__shadowReady = true;
        this.$['*faderEl'] = this.ref['fader-el'];
        this.$['*cropperEl'] = this.ref['cropper-el'];
        this.$['*imgContainerEl'] = this.ref['img-container-el'];
        this.initEditor();
    }
    async initEditor() {
        if (this.__shadowReady) await super.initEditor();
    }
}


/** @param {Object<string, any>} blockExports */ function $5a62190a7e34aa03$export$30be252fed5ebf56(blockExports) {
    for(let blockName in blockExports){
        let tagName = [
            ...blockName
        ].reduce((name, char)=>{
            if (char.toUpperCase() === char) char = '-' + char.toLowerCase();
            return name += char;
        }, '');
        if (tagName.startsWith('-')) tagName = tagName.replace('-', '');
        if (!tagName.startsWith('lr-')) tagName = 'lr-' + tagName;
        if (blockExports[blockName].reg) blockExports[blockName].reg(tagName);
    }
}



const $5ba4cc5583602415$export$e50a250b485ae478 = 'LR';
async function $5ba4cc5583602415$export$30b3ebf06e5925ee(url, register = false) {
    return new Promise((resolve, reject)=>{
        if (typeof document !== 'object') {
            resolve(null);
            return;
        }
        if (typeof window === 'object' && window[$5ba4cc5583602415$export$e50a250b485ae478]) {
            resolve(window[$5ba4cc5583602415$export$e50a250b485ae478]);
            return;
        }
        let script = document.createElement('script');
        script.async = true;
        script.src = url;
        script.onerror = ()=>{
            reject();
        };
        script.onload = ()=>{
            /** @type {import('../index.js')} */ let blocks = window[$5ba4cc5583602415$export$e50a250b485ae478];
            register && (0, $5a62190a7e34aa03$export$30be252fed5ebf56)(blocks);
            resolve(blocks);
        };
        document.head.appendChild(script);
    });
}




var $37ef1ae8275b4f62$exports = {};
/* eslint-disable import/export */ var $b2ef6e54746530cf$exports = {};


var $551e8c11bbfde661$exports = {};


$parcel$exportWildcard($37ef1ae8275b4f62$exports, $b2ef6e54746530cf$exports);
$parcel$exportWildcard($37ef1ae8275b4f62$exports, $551e8c11bbfde661$exports);


$parcel$exportWildcard($4a05c9542a452669$exports, $016f44b216a56b5b$exports);
$parcel$exportWildcard($4a05c9542a452669$exports, $5dd66a549cd783d2$exports);
$parcel$exportWildcard($4a05c9542a452669$exports, $37ef1ae8275b4f62$exports);


$4a05c9542a452669$exports.registerBlocks($4a05c9542a452669$exports);
(()=>{
    const providerNode = document.getElementById("my-uploader-provider");
    const previewsNode = document.getElementById("previews");
    const input = document.getElementById("uploader-input");
    const dimensions = input?.dataset.dimensions;
    if (!providerNode || !previewsNode || !input) return;
    providerNode.addEventListener("change", (event)=>{
        renderFiles(event.detail.allEntries.filter((file)=>file.status === "success"));
    });
    function renderFiles(files) {
        const renderedFiles = files.map((file)=>{
            const imgNode = document.createElement("img");
            const fileName = `${file.cdnUrl}-/scale_crop/${dimensions}/center/-/format/auto/-/quality/smart/`;
            imgNode.setAttribute("src", fileName);
            input.value = fileName;
            imgNode.setAttribute("alt", file.fileInfo.originalFilename);
            return imgNode;
        });
        previewsNode.replaceChildren(...renderedFiles);
    }
})();


const $578fef1af64c64a0$var$selectors = {
    items: "[data-role='grid-hover-item']",
    title: "[data-role='grid-hover-item-title']",
    layer: "[data-role='grid-hover-item-layer']",
    image: "[data-role='grid-hover-item-image']"
};
const $578fef1af64c64a0$var$items = document.querySelectorAll($578fef1af64c64a0$var$selectors.items);
$578fef1af64c64a0$var$items.forEach((item)=>{
    const image = item.querySelector($578fef1af64c64a0$var$selectors.image);
    if (!image) return;
    item.addEventListener("mouseenter", ()=>{
        image.classList.toggle("lg:grayscale");
        image.classList.toggle("lg:opacity-40");
    });
    item.addEventListener("touchstart", ()=>{
        image.classList.toggle("lg:grayscale");
        image.classList.toggle("lg:opacity-40");
    });
    item.addEventListener("mouseleave", ()=>{
        image.classList.toggle("lg:grayscale");
        image.classList.toggle("lg:opacity-40");
    });
    item.addEventListener("touchend", ()=>{
        image.classList.toggle("lg:grayscale");
        image.classList.toggle("lg:opacity-40");
    });
});


(()=>{
    const items = document.querySelectorAll("[data-role='review-toggler']");
    items.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            e.preventDefault();
            const parent = item.parentElement;
            const short = parent?.querySelector("[data-role='short-review']");
            const full = parent?.querySelector("[data-role='review']");
            short?.classList.toggle("hidden");
            full?.classList.toggle("hidden");
            if (item.innerHTML == "\u0427\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E") item.innerHTML = "\u0421\u043A\u0440\u044B\u0442\u044C";
            else item.innerHTML = "\u0427\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E";
        });
    });
})();
const $413b47a5b83c98c0$var$reviewBtns = document.querySelectorAll("[data-role='review-btn']");
$413b47a5b83c98c0$var$reviewBtns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        // Define value of btn
        const btnValue = btn.getAttribute("data-value");
        // Set all buttons gray color
        $413b47a5b83c98c0$var$reviewBtns.forEach((item)=>{
            item.classList.remove("bg-skb");
            item.classList.remove("text-white");
            item.classList.add("bg-lightGray");
        });
        // set blue color to clicked button
        btn.classList.add("bg-skb");
        btn.classList.add("text-white");
        document.querySelectorAll("[data-role='review-item']").forEach((item)=>{
            if (item.getAttribute("data-value") == btnValue) item.classList.remove("hidden");
            else if (btnValue == "all") item.classList.remove("hidden");
            else item.classList.add("hidden");
        });
    });
});



/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $5137c3620ef83169$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5137c3620ef83169$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5137c3620ef83169$var$ownKeys(Object(source), true).forEach(function(key) {
            $5137c3620ef83169$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5137c3620ef83169$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5137c3620ef83169$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5137c3620ef83169$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $5137c3620ef83169$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5137c3620ef83169$var$_typeof(obj);
}
function $5137c3620ef83169$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5137c3620ef83169$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5137c3620ef83169$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5137c3620ef83169$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5137c3620ef83169$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5137c3620ef83169$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5137c3620ef83169$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5137c3620ef83169$var$_setPrototypeOf(subClass, superClass);
}
function $5137c3620ef83169$var$_getPrototypeOf(o) {
    $5137c3620ef83169$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5137c3620ef83169$var$_getPrototypeOf(o);
}
function $5137c3620ef83169$var$_setPrototypeOf(o, p) {
    $5137c3620ef83169$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5137c3620ef83169$var$_setPrototypeOf(o, p);
}
function $5137c3620ef83169$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5137c3620ef83169$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5137c3620ef83169$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5137c3620ef83169$var$_assertThisInitialized(self);
}
function $5137c3620ef83169$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5137c3620ef83169$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5137c3620ef83169$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5137c3620ef83169$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5137c3620ef83169$var$_possibleConstructorReturn(this, result);
    };
}
function $5137c3620ef83169$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5137c3620ef83169$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $5137c3620ef83169$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $5137c3620ef83169$var$_get = Reflect.get;
    else $5137c3620ef83169$var$_get = function _get(target, property, receiver) {
        var base = $5137c3620ef83169$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $5137c3620ef83169$var$_get.apply(this, arguments);
}
var $5137c3620ef83169$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: 'slider',
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: '',
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: 'ltr',
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: 'glide--swipeable',
        dragging: 'glide--dragging',
        direction: {
            ltr: 'glide--ltr',
            rtl: 'glide--rtl'
        },
        type: {
            slider: 'glide--slider',
            carousel: 'glide--carousel'
        },
        slide: {
            clone: 'glide__slide--clone',
            active: 'glide__slide--active'
        },
        arrow: {
            disabled: 'glide__arrow--disabled'
        },
        nav: {
            active: 'glide__bullet--active'
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $5137c3620ef83169$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isString(value) {
    return typeof value === 'string';
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$isObject(value) {
    var type = $5137c3620ef83169$var$_typeof(value);
    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isFunction(value) {
    return typeof value === 'function';
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isUndefined(value) {
    return typeof value === 'undefined';
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $5137c3620ef83169$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($5137c3620ef83169$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $5137c3620ef83169$var$warn('Extension must be a function');
    for(var _name in components)if ($5137c3620ef83169$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $5137c3620ef83169$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $5137c3620ef83169$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $5137c3620ef83169$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty('classes')) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        var properties = [
            'direction',
            'type',
            'slide',
            'arrow',
            'nav'
        ];
        properties.forEach(function(property) {
            if (settings.classes.hasOwnProperty(property)) options.classes[property] = $5137c3620ef83169$var$_objectSpread2($5137c3620ef83169$var$_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
        });
    }
    if (settings.hasOwnProperty('breakpoints')) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $5137c3620ef83169$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $5137c3620ef83169$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $5137c3620ef83169$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $5137c3620ef83169$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $5137c3620ef83169$var$mergeOptions($5137c3620ef83169$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit('mount.before');
                if ($5137c3620ef83169$var$isObject(extensions)) this._c = $5137c3620ef83169$var$mount(this, extensions, this._e);
                else $5137c3620ef83169$var$warn('You need to provide a object on `mount()`');
                this._e.emit('mount.after');
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($5137c3620ef83169$var$isArray(transformers)) this._t = transformers;
                else $5137c3620ef83169$var$warn('You need to provide a array on `mutate()`');
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $5137c3620ef83169$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty('startAt')) this.index = settings.startAt;
                this._e.emit('update');
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit('destroy');
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit('play');
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit('pause');
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($5137c3620ef83169$var$isObject(o)) this._o = o;
                else $5137c3620ef83169$var$warn('Options must be an `object` instance.');
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $5137c3620ef83169$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $5137c3620ef83169$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit('run.before', this.move);
                this.calculate();
                Events.emit('run', this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit('run.start', _this.move);
                    if (_this.isEnd()) Events.emit('run.end', _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit('run.offset', _this.move);
                    }
                    Events.emit('run.after', _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === '=') {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $5137c3620ef83169$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === '>' && steps === '>') {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === '<' && steps === '<') {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === '|') viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === '>' || direction === '|' && steps === '>') {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === '<' || direction === '|' && steps === '<') {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $5137c3620ef83169$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === '|>') return this.move.direction === '|' && this.move.steps === '>';
             // did we view to the left?
            if (direction === '|<') return this.move.direction === '|' && this.move.steps === '<';
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType('carousel')) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType('carousel')) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType('carousel')) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType('carousel')) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $5137c3620ef83169$var$define(Run, 'move', {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $5137c3620ef83169$var$toInt(step) ? $5137c3620ef83169$var$toInt(step) : step : 0
            };
        }
    });
    $5137c3620ef83169$var$define(Run, 'length', {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($5137c3620ef83169$var$toInt(settings.perView) - 1) + $5137c3620ef83169$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $5137c3620ef83169$var$define(Run, 'offset', {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $5137c3620ef83169$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout, context, args, result;
    var previous = 0;
    var later = function later() {
        previous = options.leading === false ? 0 : $5137c3620ef83169$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $5137c3620ef83169$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $5137c3620ef83169$var$MARGIN_TYPE = {
    ltr: [
        'marginLeft',
        'marginRight'
    ],
    rtl: [
        'marginRight',
        'marginLeft'
    ]
};
function $5137c3620ef83169$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = '';
                if (i !== slides.length - 1) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = '';
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = '';
                style.marginRight = '';
            }
        }
    };
    $5137c3620ef83169$var$define(Gaps, 'value', {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $5137c3620ef83169$var$toInt(Glide.settings.gap);
        }
    });
    $5137c3620ef83169$var$define(Gaps, 'grow', {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $5137c3620ef83169$var$define(Gaps, 'reductor', {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        'build.after',
        'update'
    ], $5137c3620ef83169$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $5137c3620ef83169$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $5137c3620ef83169$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $5137c3620ef83169$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $5137c3620ef83169$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($5137c3620ef83169$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $5137c3620ef83169$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $5137c3620ef83169$var$define(Html, 'root', {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($5137c3620ef83169$var$isString(r)) r = document.querySelector(r);
            if (r !== null) Html._r = r;
            else $5137c3620ef83169$var$warn('Root element must be a existing Html node');
        }
    });
    $5137c3620ef83169$var$define(Html, 'track', {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            Html._t = t;
        }
    });
    $5137c3620ef83169$var$define(Html, 'wrapper', {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on('update', function() {
        Html.collectSlides();
    });
    return Html;
}
function $5137c3620ef83169$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $5137c3620ef83169$var$define(Peek, 'value', {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$isObject(value)) {
                value.before = $5137c3620ef83169$var$toInt(value.before);
                value.after = $5137c3620ef83169$var$toInt(value.after);
            } else value = $5137c3620ef83169$var$toInt(value);
            Peek._v = value;
        }
    });
    $5137c3620ef83169$var$define(Peek, 'reductor', {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($5137c3620ef83169$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        'resize',
        'update'
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $5137c3620ef83169$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit('move', {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit('move.after', {
                    movement: _this.value
                });
            });
        }
    };
    $5137c3620ef83169$var$define(Move, 'offset', {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$5137c3620ef83169$var$isUndefined(value) ? $5137c3620ef83169$var$toInt(value) : 0;
        }
    });
    $5137c3620ef83169$var$define(Move, 'translate', {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $5137c3620ef83169$var$define(Move, 'value', {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is('rtl')) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        'build.before',
        'run'
    ], function() {
        Move.make();
    });
    return Move;
}
function $5137c3620ef83169$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = '';
            Components.Html.wrapper.style.width = '';
        }
    };
    $5137c3620ef83169$var$define(Sizes, 'length', {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $5137c3620ef83169$var$define(Sizes, 'width', {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $5137c3620ef83169$var$define(Sizes, 'wrapperSize', {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $5137c3620ef83169$var$define(Sizes, 'slideWidth', {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        'build.before',
        'resize',
        'update'
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on('destroy', function() {
        Sizes.remove();
    });
    return Sizes;
}
function $5137c3620ef83169$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit('build.before');
            this.typeClass();
            this.activeClass();
            Events.emit('build.after');
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $5137c3620ef83169$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        'resize',
        'update'
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on('move.after', function() {
        Build.activeClass();
    });
    return Build;
}
function $5137c3620ef83169$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType('carousel')) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length > 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $5137c3620ef83169$var$define(Clones, 'grow', {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on('update', function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on('build.before', function() {
        if (Glide.isType('carousel')) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on('destroy', function() {
        Clones.remove();
    });
    return Clones;
}
var $5137c3620ef83169$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $5137c3620ef83169$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $5137c3620ef83169$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('resize', window, $5137c3620ef83169$var$throttle(function() {
                Events.emit('resize');
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('resize', window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on('destroy', function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $5137c3620ef83169$var$VALID_DIRECTIONS = [
    'ltr',
    'rtl'
];
var $5137c3620ef83169$var$FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
};
function $5137c3620ef83169$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is('rtl')) return pattern.split(token).join($5137c3620ef83169$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $5137c3620ef83169$var$define(Direction, 'value', {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $5137c3620ef83169$var$warn('Direction value must be `ltr` or `rtl`');
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on('update', function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        'build.before',
        'update'
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is('rtl')) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($5137c3620ef83169$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === 'center') return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $5137c3620ef83169$var$Gap,
        $5137c3620ef83169$var$Grow,
        $5137c3620ef83169$var$Peeking,
        $5137c3620ef83169$var$Focusing
    ].concat(Glide._t, [
        $5137c3620ef83169$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($5137c3620ef83169$var$isFunction(transformer) && $5137c3620ef83169$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $5137c3620ef83169$var$warn('Transformer should be a function that returns an object with `modify()` method');
            }
            return translate;
        }
    };
}
function $5137c3620ef83169$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $5137c3620ef83169$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = '';
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on('move', function(context) {
        if (!Glide.isType('carousel') || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit('translate.jump');
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Translate.remove();
    });
    return Translate;
}
function $5137c3620ef83169$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (disabled) return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = '';
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $5137c3620ef83169$var$define(Transition, 'duration', {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType('slider') && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on('move', function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        'build.before',
        'resize',
        'translate.jump'
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on('run', function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $5137c3620ef83169$var$supportsPassive = false;
try {
    var $5137c3620ef83169$var$opts = Object.defineProperty({}, 'passive', {
        get: function get() {
            $5137c3620ef83169$var$supportsPassive = true;
        }
    });
    window.addEventListener('testPassive', null, $5137c3620ef83169$var$opts);
    window.removeEventListener('testPassive', null, $5137c3620ef83169$var$opts);
} catch (e) {}
var $5137c3620ef83169$var$supportsPassive$1 = $5137c3620ef83169$var$supportsPassive;
var $5137c3620ef83169$var$START_EVENTS = [
    'touchstart',
    'mousedown'
];
var $5137c3620ef83169$var$MOVE_EVENTS = [
    'touchmove',
    'mousemove'
];
var $5137c3620ef83169$var$END_EVENTS = [
    'touchend',
    'touchcancel',
    'mouseup',
    'mouseleave'
];
var $5137c3620ef83169$var$MOUSE_EVENTS = [
    'mousedown',
    'mousemove',
    'mouseup',
    'mouseleave'
];
function $5137c3620ef83169$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $5137c3620ef83169$var$toInt(swipe.pageX);
                swipeStartY = $5137c3620ef83169$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit('swipe.start');
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $5137c3620ef83169$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $5137c3620ef83169$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $5137c3620ef83169$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit('swipe.move');
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit('swipe.end');
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, $5137c3620ef83169$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on('build.after', function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on('destroy', function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $5137c3620ef83169$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('dragstart', Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on('destroy', function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $5137c3620ef83169$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll('a');
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('click', Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('click', Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $5137c3620ef83169$var$define(Anchors, 'items', {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on('swipe.move', function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on('swipe.end', function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on('destroy', function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $5137c3620ef83169$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $5137c3620ef83169$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
var $5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");
function $5137c3620ef83169$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($5137c3620ef83169$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($5137c3620ef83169$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            item.classList.add(settings.classes.nav.active);
            $5137c3620ef83169$var$siblings(item).forEach(function(sibling) {
                sibling.classList.remove(settings.classes.nav.active);
            });
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            item === null || item === void 0 || item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on('click', elements[i], this.click);
                Binder.on('touchstart', elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                'click',
                'touchstart'
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$5137c3620ef83169$var$supportsPassive$1 && event.type === 'touchstart') event.preventDefault();
            var direction = event.currentTarget.getAttribute('data-glide-dir');
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $5137c3620ef83169$var$define(Controls, 'items', {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        'mount.after',
        'move.after'
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        'mount.after',
        'run'
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on('destroy', function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $5137c3620ef83169$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('keyup', document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('keyup', document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            var arrowSymbols = {
                ArrowRight: '>',
                ArrowLeft: '<'
            };
            if ([
                'ArrowRight',
                'ArrowLeft'
            ].includes(event.code)) Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on('update', function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on('destroy', function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $5137c3620ef83169$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($5137c3620ef83169$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make('>');
                    _this.start();
                    Events.emit('autoplay');
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on('mouseover', Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on('mouseout', Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                'mouseover',
                'mouseout'
            ], Components.Html.root);
        }
    };
    $5137c3620ef83169$var$define(Autoplay, 'time', {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');
            if (autoplay) return $5137c3620ef83169$var$toInt(autoplay);
            return $5137c3620ef83169$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        'run.before',
        'swipe.start',
        'update'
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        'pause',
        'destroy'
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        'run.after',
        'swipe.end'
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        'play'
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on('update', function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on('destroy', function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $5137c3620ef83169$var$sortBreakpoints(points) {
    if ($5137c3620ef83169$var$isObject(points)) return $5137c3620ef83169$var$sortKeys(points);
    else $5137c3620ef83169$var$warn("Breakpoints option must be an object");
    return {};
}
function $5137c3620ef83169$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $5137c3620ef83169$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== 'undefined') {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on('resize', window, $5137c3620ef83169$var$throttle(function() {
        Glide.settings = $5137c3620ef83169$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on('update', function() {
        points = $5137c3620ef83169$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on('destroy', function() {
        Binder.off('resize', window);
    });
    return Breakpoints;
}
var $5137c3620ef83169$var$COMPONENTS = {
    // Required
    Html: $5137c3620ef83169$var$Html,
    Translate: $5137c3620ef83169$var$Translate,
    Transition: $5137c3620ef83169$var$Transition,
    Direction: $5137c3620ef83169$var$Direction,
    Peek: $5137c3620ef83169$var$Peek,
    Sizes: $5137c3620ef83169$var$Sizes,
    Gaps: $5137c3620ef83169$var$Gaps,
    Move: $5137c3620ef83169$var$Move,
    Clones: $5137c3620ef83169$var$Clones,
    Resize: $5137c3620ef83169$var$Resize,
    Build: $5137c3620ef83169$var$Build,
    Run: $5137c3620ef83169$var$Run,
    // Optional
    Swipe: $5137c3620ef83169$var$Swipe,
    Images: $5137c3620ef83169$var$Images,
    Anchors: $5137c3620ef83169$var$Anchors,
    Controls: $5137c3620ef83169$var$Controls,
    Keyboard: $5137c3620ef83169$var$Keyboard,
    Autoplay: $5137c3620ef83169$var$Autoplay,
    Breakpoints: $5137c3620ef83169$var$Breakpoints
};
var $5137c3620ef83169$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $5137c3620ef83169$var$_inherits(Glide, _Core);
    var _super = $5137c3620ef83169$var$_createSuper(Glide);
    function Glide() {
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $5137c3620ef83169$var$_get($5137c3620ef83169$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $5137c3620ef83169$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($5137c3620ef83169$var$Glide$1);


const $ba1d64a125ec4e3a$var$slider = document.querySelector(".glide");
const $ba1d64a125ec4e3a$var$amount = document.querySelector("[data-role='slide-baker-amount']");
if ($ba1d64a125ec4e3a$var$slider && $ba1d64a125ec4e3a$var$amount) {
    const totalSlideCount = $ba1d64a125ec4e3a$var$amount.getAttribute("data-count");
    const glide = new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(".glide", {
        perView: 1.3
    });
    glide.on([
        "mount.after",
        "run"
    ], function() {
        const index = glide.index + 1;
        $ba1d64a125ec4e3a$var$amount.innerHTML = `${index.toString()} / ${totalSlideCount}`;
    });
    glide.mount();
}




var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");
function $459ec97bd49637f7$var$ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t && (i = i.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, i);
    }
    return r;
}
function $459ec97bd49637f7$var$_objectSpread2(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $459ec97bd49637f7$var$ownKeys(Object(r), !0).forEach(function(t) {
            $459ec97bd49637f7$var$_defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $459ec97bd49637f7$var$ownKeys(Object(r)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
    }
    return e;
}
function $459ec97bd49637f7$var$_classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $459ec97bd49637f7$var$_defineProperties(e, t) {
    for(var r = 0; r < t.length; r++){
        var i = t[r];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
}
function $459ec97bd49637f7$var$_createClass(e, t, r) {
    return t && $459ec97bd49637f7$var$_defineProperties(e.prototype, t), r && $459ec97bd49637f7$var$_defineProperties(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $459ec97bd49637f7$var$_defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function $459ec97bd49637f7$var$_extends() {
    return ($459ec97bd49637f7$var$_extends = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
        }
        return e;
    }).apply(this, arguments);
}
function $459ec97bd49637f7$var$_inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && $459ec97bd49637f7$var$_setPrototypeOf(e, t);
}
function $459ec97bd49637f7$var$_getPrototypeOf(e) {
    return ($459ec97bd49637f7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
}
function $459ec97bd49637f7$var$_setPrototypeOf(e, t) {
    return ($459ec97bd49637f7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function $459ec97bd49637f7$var$_isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (e) {
        return !1;
    }
}
function $459ec97bd49637f7$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r, i, n = {}, s = Object.keys(e);
    for(i = 0; i < s.length; i++)r = s[i], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
function $459ec97bd49637f7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var r, i, n = $459ec97bd49637f7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(i = 0; i < s.length; i++)r = s[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function $459ec97bd49637f7$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $459ec97bd49637f7$var$_possibleConstructorReturn(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return $459ec97bd49637f7$var$_assertThisInitialized(e);
}
function $459ec97bd49637f7$var$_createSuper(e) {
    var t = $459ec97bd49637f7$var$_isNativeReflectConstruct();
    return function() {
        var r, i = $459ec97bd49637f7$var$_getPrototypeOf(e);
        if (t) {
            var n = $459ec97bd49637f7$var$_getPrototypeOf(this).constructor;
            r = Reflect.construct(i, arguments, n);
        } else r = i.apply(this, arguments);
        return $459ec97bd49637f7$var$_possibleConstructorReturn(this, r);
    };
}
function $459ec97bd49637f7$var$_toConsumableArray(e) {
    return $459ec97bd49637f7$var$_arrayWithoutHoles(e) || $459ec97bd49637f7$var$_iterableToArray(e) || $459ec97bd49637f7$var$_unsupportedIterableToArray(e) || $459ec97bd49637f7$var$_nonIterableSpread();
}
function $459ec97bd49637f7$var$_arrayWithoutHoles(e) {
    if (Array.isArray(e)) return $459ec97bd49637f7$var$_arrayLikeToArray(e);
}
function $459ec97bd49637f7$var$_iterableToArray(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function $459ec97bd49637f7$var$_unsupportedIterableToArray(e, t) {
    if (e) {
        if ("string" == typeof e) return $459ec97bd49637f7$var$_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? $459ec97bd49637f7$var$_arrayLikeToArray(e, t) : void 0;
    }
}
function $459ec97bd49637f7$var$_arrayLikeToArray(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var r = 0, i = new Array(t); r < t; r++)i[r] = e[r];
    return i;
}
function $459ec97bd49637f7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $459ec97bd49637f7$var$createCommonjsModule(e, t) {
    return t = {
        exports: {}
    }, e(t, t.exports), t.exports;
}
function $459ec97bd49637f7$var$emptyFunction() {}
function $459ec97bd49637f7$var$emptyFunctionWithReset() {}
function $459ec97bd49637f7$var$cn(e) {
    return e.map(function(e) {
        return !1 === e ? null : e;
    }).join(" ").replace(/\s+/g, " ").trim();
}
function $459ec97bd49637f7$var$slideSize(e, t) {
    return 100 / e * t / t;
}
function $459ec97bd49637f7$var$slideTraySize(e, t) {
    return 100 * e / t;
}
function $459ec97bd49637f7$var$pct(e) {
    return "".concat(e, "%");
}
function $459ec97bd49637f7$var$equal(e, t, r) {
    if (e === t) return !0;
    var i = $459ec97bd49637f7$var$types[$459ec97bd49637f7$var$jkrosoType(e)], n = $459ec97bd49637f7$var$types[$459ec97bd49637f7$var$jkrosoType(t)];
    return !(!i || i !== n) && i(e, t, r);
}
function $459ec97bd49637f7$var$memoGaurd(e) {
    return function(t, r, i) {
        if (!i) return e(t, r, []);
        for(var n, s = i.length; n = i[--s];)if (n[0] === t && n[1] === r) return !0;
        return e(t, r, i);
    };
}
function $459ec97bd49637f7$var$arrayEqual(e, t, r) {
    var i = e.length;
    if (i !== t.length) return !1;
    for(r.push([
        e,
        t
    ]); i--;)if (!$459ec97bd49637f7$var$equal(e[i], t[i], r)) return !1;
    return !0;
}
function $459ec97bd49637f7$var$objectEqual(e, t, r) {
    if ("function" == typeof e.equal) return r.push([
        e,
        t
    ]), e.equal(t, r);
    var i = $459ec97bd49637f7$var$getEnumerableProperties(e), n = $459ec97bd49637f7$var$getEnumerableProperties(t), s = i.length;
    if (s !== n.length) return !1;
    for(i.sort(), n.sort(); s--;)if (i[s] !== n[s]) return !1;
    for(r.push([
        e,
        t
    ]), s = i.length; s--;){
        var o = i[s];
        if (!$459ec97bd49637f7$var$equal(e[o], t[o], r)) return !1;
    }
    return !0;
}
function $459ec97bd49637f7$var$getEnumerableProperties(e) {
    var t = [];
    for(var r in e)"constructor" !== r && t.push(r);
    return t;
}
function $459ec97bd49637f7$var$isNonNullObject(e) {
    return !!e && "object" == typeof e;
}
function $459ec97bd49637f7$var$isSpecial(e) {
    var t = Object.prototype.toString.call(e);
    return "[object RegExp]" === t || "[object Date]" === t || $459ec97bd49637f7$var$isReactElement(e);
}
function $459ec97bd49637f7$var$isReactElement(e) {
    return e.$$typeof === $459ec97bd49637f7$var$REACT_ELEMENT_TYPE;
}
function $459ec97bd49637f7$var$emptyTarget(e) {
    return Array.isArray(e) ? [] : {};
}
function $459ec97bd49637f7$var$cloneUnlessOtherwiseSpecified(e, t) {
    return !1 !== t.clone && t.isMergeableObject(e) ? $459ec97bd49637f7$var$deepmerge($459ec97bd49637f7$var$emptyTarget(e), e, t) : e;
}
function $459ec97bd49637f7$var$defaultArrayMerge(e, t, r) {
    return e.concat(t).map(function(e) {
        return $459ec97bd49637f7$var$cloneUnlessOtherwiseSpecified(e, r);
    });
}
function $459ec97bd49637f7$var$mergeObject(e, t, r) {
    var i = {};
    return r.isMergeableObject(e) && Object.keys(e).forEach(function(t) {
        i[t] = $459ec97bd49637f7$var$cloneUnlessOtherwiseSpecified(e[t], r);
    }), Object.keys(t).forEach(function(n) {
        r.isMergeableObject(t[n]) && e[n] ? i[n] = $459ec97bd49637f7$var$deepmerge(e[n], t[n], r) : i[n] = $459ec97bd49637f7$var$cloneUnlessOtherwiseSpecified(t[n], r);
    }), i;
}
function $459ec97bd49637f7$var$deepmerge(e, t, r) {
    (r = r || {}).arrayMerge = r.arrayMerge || $459ec97bd49637f7$var$defaultArrayMerge, r.isMergeableObject = r.isMergeableObject || $459ec97bd49637f7$var$isMergeableObject;
    var i = Array.isArray(t);
    return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : $459ec97bd49637f7$var$mergeObject(e, t, r) : $459ec97bd49637f7$var$cloneUnlessOtherwiseSpecified(t, r);
}
function $459ec97bd49637f7$export$4e3bb82032960c4b(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function() {
        return {};
    }, r = function(r) {
        function i(e, r) {
            var s;
            return $459ec97bd49637f7$var$_classCallCheck(this, i), s = n.call(this, e, r), s.state = t($459ec97bd49637f7$var$_objectSpread2({}, r.state)), s.updateStateProps = s.updateStateProps.bind($459ec97bd49637f7$var$_assertThisInitialized(s)), s;
        }
        $459ec97bd49637f7$var$_inherits(i, r);
        var n = $459ec97bd49637f7$var$_createSuper(i);
        return $459ec97bd49637f7$var$_createClass(i, [
            {
                key: "componentDidMount",
                value: function() {
                    this.context.subscribe(this.updateStateProps);
                }
            },
            {
                key: "shouldComponentUpdate",
                value: function(e, t) {
                    return !$459ec97bd49637f7$var$equals(t, this.state) || !$459ec97bd49637f7$var$equals(e, this.props);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.context.unsubscribe(this.updateStateProps);
                }
            },
            {
                key: "updateStateProps",
                value: function() {
                    this.setState(t($459ec97bd49637f7$var$_objectSpread2({}, this.context.state)));
                }
            },
            {
                key: "render",
                value: function() {
                    var t = this, r = $459ec97bd49637f7$var$deepmerge_1(this.state, this.props);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(e, $459ec97bd49637f7$var$_extends({
                        ref: function(e) {
                            t.instance = e;
                        }
                    }, r, {
                        carouselStore: {
                            getStoreState: this.context.getStoreState,
                            masterSpinnerError: this.context.masterSpinnerError,
                            masterSpinnerSuccess: this.context.masterSpinnerSuccess,
                            setStoreState: this.context.setStoreState,
                            subscribeMasterSpinner: this.context.subscribeMasterSpinner,
                            unsubscribeAllMasterSpinner: this.context.unsubscribeAllMasterSpinner,
                            unsubscribeMasterSpinner: this.context.unsubscribeMasterSpinner
                        }
                    }), this.props.children);
                }
            }
        ]), i;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
    return $459ec97bd49637f7$var$_defineProperty(r, "contextType", $459ec97bd49637f7$export$762b25d1c14c81e4), $459ec97bd49637f7$var$_defineProperty(r, "propTypes", {
        children: $459ec97bd49637f7$var$CarouselPropTypes.children
    }), $459ec97bd49637f7$var$_defineProperty(r, "defaultProps", {
        children: null
    }), r;
}
var $459ec97bd49637f7$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", $459ec97bd49637f7$var$ReactPropTypesSecret_1 = $459ec97bd49637f7$var$ReactPropTypesSecret;
$459ec97bd49637f7$var$emptyFunctionWithReset.resetWarningCache = $459ec97bd49637f7$var$emptyFunction;
var $459ec97bd49637f7$var$factoryWithThrowingShims = function() {
    function e(e, t, r, i, n, s) {
        if (s !== $459ec97bd49637f7$var$ReactPropTypesSecret_1) {
            var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw o.name = "Invariant Violation", o;
        }
    }
    function t() {
        return e;
    }
    e.isRequired = e;
    var r = {
        array: e,
        bigint: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: $459ec97bd49637f7$var$emptyFunctionWithReset,
        resetWarningCache: $459ec97bd49637f7$var$emptyFunction
    };
    return r.PropTypes = r, r;
}, $459ec97bd49637f7$var$propTypes = $459ec97bd49637f7$var$createCommonjsModule(function(e) {
    e.exports = $459ec97bd49637f7$var$factoryWithThrowingShims();
}), $459ec97bd49637f7$var$LOADING = "loading", $459ec97bd49637f7$var$SUCCESS = "success", $459ec97bd49637f7$var$ERROR = "error", $459ec97bd49637f7$var$CarouselPropTypes = {
    children: $459ec97bd49637f7$var$propTypes.oneOfType([
        $459ec97bd49637f7$var$propTypes.arrayOf($459ec97bd49637f7$var$propTypes.node),
        $459ec97bd49637f7$var$propTypes.node
    ]),
    direction: $459ec97bd49637f7$var$propTypes.oneOf([
        "forward",
        "backward"
    ]),
    height: function(e, t) {
        var r = e[t];
        return "vertical" !== e.orientation || null !== r && "number" == typeof r ? null : new Error("Missing required property '".concat(t, "' when orientation is vertical.  You must supply a number representing the height in pixels"));
    },
    orientation: $459ec97bd49637f7$var$propTypes.oneOf([
        "horizontal",
        "vertical"
    ]),
    isBgImage: function(e, t) {
        return !0 === e[t] && "img" === e.tag ? new Error("HTML img elements should not have a backgroundImage.  Please use ".concat(t, " for other block-level HTML tags, like div, a, section, etc...")) : null;
    }
}, $459ec97bd49637f7$var$boundedRange = function(e) {
    var t = e.min, r = e.max, i = e.x;
    return Math.min(r, Math.max(t, i));
}, $459ec97bd49637f7$var$s = {
    buttonBack: "buttonBack___1mlaL"
}, $459ec97bd49637f7$var$_excluded = [
    "carouselStore",
    "className",
    "currentSlide",
    "disabled",
    "onClick",
    "step",
    "totalSlides",
    "visibleSlides",
    "infinite"
], $459ec97bd49637f7$export$7cd3b4b6bd9374ef = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props, r = t.carouselStore, i = t.currentSlide, n = t.onClick, s = t.step, o = t.infinite, a = t.visibleSlides, l = t.totalSlides - a, c = Math.max(i - s, 0);
                o && (c = 0 === i ? l : c), r.setStoreState({
                    currentSlide: c,
                    isPlaying: !1
                }, null !== n && n.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, r = (e.carouselStore, e.className), i = (e.currentSlide, e.disabled, e.onClick, e.step, e.totalSlides, e.visibleSlides, e.infinite), n = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded), o = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s.buttonBack,
                    "carousel__back-button",
                    r
                ]), a = t.setDisabled(this.props.disabled, this.props.currentSlide, i);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    type: "button",
                    "aria-label": "previous",
                    className: o,
                    onClick: this.handleOnClick,
                    disabled: a
                }, n), this.props.children);
            }
        }
    ], [
        {
            key: "setDisabled",
            value: function(e, t, r) {
                return null !== e ? e : 0 === t && !r;
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$export$7cd3b4b6bd9374ef, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disabled: $459ec97bd49637f7$var$propTypes.bool,
    onClick: $459ec97bd49637f7$var$propTypes.func,
    step: $459ec97bd49637f7$var$propTypes.number.isRequired,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    infinite: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$export$7cd3b4b6bd9374ef, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null,
    infinite: !1
});
var $459ec97bd49637f7$var$jkrosoType = $459ec97bd49637f7$var$createCommonjsModule(function(e, t) {
    var r = {}.toString, i = "undefined" != typeof window ? window.Node : Function;
    e.exports = t = function(e) {
        var t = typeof e;
        if ("object" != t) return t;
        if (t = n[r.call(e)], "object" == t) return e instanceof Map ? "map" : e instanceof Set ? "set" : "object";
        if (t) return t;
        if (e instanceof i) switch(e.nodeType){
            case 1:
                return "element";
            case 3:
                return "text-node";
            case 9:
                return "document";
            case 11:
                return "document-fragment";
            default:
                return "dom-node";
        }
    };
    var n = t.types = {
        "[object Function]": "function",
        "[object Date]": "date",
        "[object RegExp]": "regexp",
        "[object Arguments]": "arguments",
        "[object Array]": "array",
        "[object Set]": "set",
        "[object String]": "string",
        "[object Null]": "null",
        "[object Undefined]": "undefined",
        "[object Number]": "number",
        "[object Boolean]": "boolean",
        "[object Object]": "object",
        "[object Map]": "map",
        "[object Text]": "text-node",
        "[object Uint8Array]": "bit-array",
        "[object Uint16Array]": "bit-array",
        "[object Uint32Array]": "bit-array",
        "[object Uint8ClampedArray]": "bit-array",
        "[object Error]": "error",
        "[object FormData]": "form-data",
        "[object File]": "file",
        "[object Blob]": "blob"
    };
}), $459ec97bd49637f7$var$jkrosoType_1 = $459ec97bd49637f7$var$jkrosoType.types, $459ec97bd49637f7$var$types = {};
$459ec97bd49637f7$var$types.number = function(e, t) {
    return e !== e && t !== t;
}, $459ec97bd49637f7$var$types.function = function(e, t, r) {
    return e.toString() === t.toString() && $459ec97bd49637f7$var$types.object(e, t, r) && $459ec97bd49637f7$var$equal(e.prototype, t.prototype);
}, $459ec97bd49637f7$var$types.date = function(e, t) {
    return +e == +t;
}, $459ec97bd49637f7$var$types.regexp = function(e, t) {
    return e.toString() === t.toString();
}, $459ec97bd49637f7$var$types.element = function(e, t) {
    return e.outerHTML === t.outerHTML;
}, $459ec97bd49637f7$var$types.textnode = function(e, t) {
    return e.textContent === t.textContent;
}, $459ec97bd49637f7$var$types.arguments = $459ec97bd49637f7$var$types["bit-array"] = $459ec97bd49637f7$var$types.array = $459ec97bd49637f7$var$memoGaurd($459ec97bd49637f7$var$arrayEqual), $459ec97bd49637f7$var$types.object = $459ec97bd49637f7$var$memoGaurd($459ec97bd49637f7$var$objectEqual);
var $459ec97bd49637f7$var$equals = $459ec97bd49637f7$var$equal, $459ec97bd49637f7$var$isMergeableObject = function(e) {
    return $459ec97bd49637f7$var$isNonNullObject(e) && !$459ec97bd49637f7$var$isSpecial(e);
}, $459ec97bd49637f7$var$canUseSymbol = "function" == typeof Symbol && Symbol.for, $459ec97bd49637f7$var$REACT_ELEMENT_TYPE = $459ec97bd49637f7$var$canUseSymbol ? Symbol.for("react.element") : 60103;
$459ec97bd49637f7$var$deepmerge.all = function(e, t) {
    if (!Array.isArray(e)) throw new Error("first argument should be an array");
    return e.reduce(function(e, r) {
        return $459ec97bd49637f7$var$deepmerge(e, r, t);
    }, {});
};
var $459ec97bd49637f7$var$deepmerge_1 = $459ec97bd49637f7$var$deepmerge, $459ec97bd49637f7$export$762b25d1c14c81e4 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(), $459ec97bd49637f7$var$deepFreeze = function e(t) {
    return Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function(r) {
        !t.hasOwnProperty(r) || null === t[r] || "object" != typeof t[r] && "function" != typeof t[r] || Object.isFrozen(t[r]) || e(t[r]);
    }), t;
}, $459ec97bd49637f7$var$DEFAULT_STATE = {
    masterSpinnerFinished: !1
}, $459ec97bd49637f7$export$390f32400eaf98c9 = function() {
    function e(t) {
        $459ec97bd49637f7$var$_classCallCheck(this, e), this.state = $459ec97bd49637f7$var$deepFreeze($459ec97bd49637f7$var$deepmerge_1($459ec97bd49637f7$var$DEFAULT_STATE, t)), this.subscriptions = [], this.masterSpinnerSubscriptions = {}, this.setStoreState = this.setStoreState.bind(this), this.getStoreState = this.getStoreState.bind(this), this.subscribe = this.subscribe.bind(this), this.unsubscribe = this.unsubscribe.bind(this), this.updateSubscribers = this.updateSubscribers.bind(this), this.subscribeMasterSpinner = this.subscribeMasterSpinner.bind(this), this.unsubscribeMasterSpinner = this.unsubscribeMasterSpinner.bind(this), this.unsubscribeAllMasterSpinner = this.unsubscribeAllMasterSpinner.bind(this), this.masterSpinnerSuccess = this.masterSpinnerSuccess.bind(this), this.masterSpinnerError = this.masterSpinnerError.bind(this);
    }
    return $459ec97bd49637f7$var$_createClass(e, [
        {
            key: "setStoreState",
            value: function(e, t) {
                this.state = $459ec97bd49637f7$var$deepFreeze($459ec97bd49637f7$var$deepmerge_1(this.state, e)), this.updateSubscribers(t);
            }
        },
        {
            key: "getStoreState",
            value: function() {
                return $459ec97bd49637f7$var$deepmerge_1({}, this.state);
            }
        },
        {
            key: "subscribe",
            value: function(e) {
                this.subscriptions.push(e);
            }
        },
        {
            key: "unsubscribe",
            value: function(e) {
                var t = this.subscriptions.indexOf(e);
                -1 !== t && this.subscriptions.splice(t, 1);
            }
        },
        {
            key: "updateSubscribers",
            value: function(e) {
                this.subscriptions.forEach(function(e) {
                    return e();
                }), "function" == typeof e && e(this.getStoreState());
            }
        },
        {
            key: "subscribeMasterSpinner",
            value: function(e) {
                -1 === Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.masterSpinnerSubscriptions[e] = {
                    success: !1,
                    error: !1,
                    complete: !1
                });
            }
        },
        {
            key: "unsubscribeMasterSpinner",
            value: function(e) {
                return -1 !== Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.setMasterSpinnerFinished(), delete this.masterSpinnerSubscriptions[e]);
            }
        },
        {
            key: "unsubscribeAllMasterSpinner",
            value: function() {
                this.masterSpinnerSubscriptions = {}, this.setMasterSpinnerFinished();
            }
        },
        {
            key: "masterSpinnerSuccess",
            value: function(e) {
                this.masterSpinnerSubscriptions[e].success = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
            }
        },
        {
            key: "masterSpinnerError",
            value: function(e) {
                this.masterSpinnerSubscriptions[e].error = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
            }
        },
        {
            key: "setMasterSpinnerFinished",
            value: function() {
                this.setStoreState({
                    masterSpinnerFinished: this.isMasterSpinnerFinished()
                });
            }
        },
        {
            key: "isMasterSpinnerFinished",
            value: function() {
                var e = this;
                return 0 === Object.keys(this.masterSpinnerSubscriptions).filter(function(t) {
                    return !0 !== e.masterSpinnerSubscriptions[t].complete;
                }).length;
            }
        }
    ]), e;
}(), $459ec97bd49637f7$var$_excluded$1 = [
    "children",
    "className",
    "currentSlide",
    "disableAnimation",
    "disableKeyboard",
    "hasMasterSpinner",
    "interval",
    "isPageScrollLocked",
    "isPlaying",
    "lockOnWindowScroll",
    "naturalSlideHeight",
    "naturalSlideWidth",
    "orientation",
    "playDirection",
    "step",
    "dragStep",
    "tag",
    "totalSlides",
    "touchEnabled",
    "dragEnabled",
    "visibleSlides",
    "infinite",
    "isIntrinsicHeight"
], $459ec97bd49637f7$var$_class, $459ec97bd49637f7$export$42591ef794b036fd = ($459ec97bd49637f7$var$_class = function(e) {
    function t(e) {
        var i;
        if ($459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), e.isIntrinsicHeight && "horizontal" !== e.orientation) throw Error('isIntrinsicHeight can only be used in "horizontal" orientation. See Readme for more information.');
        var n = {
            currentSlide: e.currentSlide,
            disableAnimation: e.disableAnimation,
            disableKeyboard: e.disableKeyboard,
            hasMasterSpinner: e.hasMasterSpinner,
            imageErrorCount: 0,
            imageSuccessCount: 0,
            interval: e.interval,
            isPageScrollLocked: e.isPageScrollLocked,
            isPlaying: e.isPlaying,
            lockOnWindowScroll: e.lockOnWindowScroll,
            masterSpinnerThreshold: 0,
            naturalSlideHeight: e.naturalSlideHeight,
            naturalSlideWidth: e.naturalSlideWidth,
            orientation: e.orientation,
            playDirection: e.playDirection,
            privateUnDisableAnimation: !1,
            slideSize: $459ec97bd49637f7$var$slideSize(e.totalSlides, e.visibleSlides),
            slideTraySize: $459ec97bd49637f7$var$slideTraySize(e.totalSlides, e.visibleSlides),
            step: e.step,
            dragStep: e.dragStep,
            totalSlides: e.totalSlides,
            touchEnabled: e.touchEnabled,
            dragEnabled: e.dragEnabled,
            visibleSlides: e.visibleSlides,
            infinite: e.infinite,
            isIntrinsicHeight: e.isIntrinsicHeight
        };
        return i.carouselStore = new $459ec97bd49637f7$export$390f32400eaf98c9(n), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "componentDidUpdate",
            value: function(e) {
                var t = this, r = {};
                [
                    "currentSlide",
                    "disableAnimation",
                    "disableKeyboard",
                    "hasMasterSpinner",
                    "interval",
                    "isPlaying",
                    "naturalSlideHeight",
                    "naturalSlideWidth",
                    "lockOnWindowScroll",
                    "orientation",
                    "playDirection",
                    "step",
                    "dragStep",
                    "totalSlides",
                    "touchEnabled",
                    "dragEnabled",
                    "visibleSlides"
                ].forEach(function(i) {
                    e[i] !== t.props[i] && (r[i] = t.props[i]);
                }), this.props.currentSlide !== e.currentSlide && !this.props.disableAnimation && (r.disableAnimation = !0, r.privateUnDisableAnimation = !0), this.props.totalSlides === e.totalSlides && this.props.visibleSlides === e.visibleSlides || (r.slideSize = $459ec97bd49637f7$var$slideSize(this.props.totalSlides, this.props.visibleSlides), r.slideTraySize = $459ec97bd49637f7$var$slideTraySize(this.props.totalSlides, this.props.visibleSlides)), this.carouselStore.state.currentSlide >= this.props.totalSlides && (r.currentSlide = Math.max(this.props.totalSlides - 1, 0)), Object.keys(r).length > 0 && this.carouselStore.setStoreState(r);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.carouselStore.unsubscribeAllMasterSpinner();
            }
        },
        {
            key: "getStore",
            value: function() {
                return this.carouselStore;
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.children, e.className, e.currentSlide, e.disableAnimation, e.disableKeyboard, e.hasMasterSpinner, e.interval, e.isPageScrollLocked, e.isPlaying, e.lockOnWindowScroll, e.naturalSlideHeight, e.naturalSlideWidth, e.orientation, e.playDirection, e.step, e.dragStep, e.tag), r = (e.totalSlides, e.touchEnabled, e.dragEnabled, e.visibleSlides, e.infinite, e.isIntrinsicHeight, $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$1)), i = $459ec97bd49637f7$var$cn([
                    "carousel",
                    this.props.className
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(t, $459ec97bd49637f7$var$_extends({
                    className: i
                }, r), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$762b25d1c14c81e4.Provider, {
                    value: this.carouselStore
                }, this.props.children));
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class, "propTypes", {
    children: $459ec97bd49637f7$var$CarouselPropTypes.children.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number,
    disableAnimation: $459ec97bd49637f7$var$propTypes.bool,
    disableKeyboard: $459ec97bd49637f7$var$propTypes.bool,
    hasMasterSpinner: $459ec97bd49637f7$var$propTypes.bool,
    interval: $459ec97bd49637f7$var$propTypes.number,
    isPageScrollLocked: $459ec97bd49637f7$var$propTypes.bool,
    isPlaying: $459ec97bd49637f7$var$propTypes.bool,
    lockOnWindowScroll: $459ec97bd49637f7$var$propTypes.bool,
    naturalSlideHeight: $459ec97bd49637f7$var$propTypes.number.isRequired,
    naturalSlideWidth: $459ec97bd49637f7$var$propTypes.number.isRequired,
    orientation: $459ec97bd49637f7$var$CarouselPropTypes.orientation,
    playDirection: $459ec97bd49637f7$var$CarouselPropTypes.direction,
    step: $459ec97bd49637f7$var$propTypes.number,
    dragStep: $459ec97bd49637f7$var$propTypes.number,
    tag: $459ec97bd49637f7$var$propTypes.string,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    touchEnabled: $459ec97bd49637f7$var$propTypes.bool,
    dragEnabled: $459ec97bd49637f7$var$propTypes.bool,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number,
    infinite: $459ec97bd49637f7$var$propTypes.bool,
    isIntrinsicHeight: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class, "defaultProps", {
    className: null,
    currentSlide: 0,
    disableAnimation: !1,
    disableKeyboard: !1,
    hasMasterSpinner: !1,
    interval: 5e3,
    isPageScrollLocked: !1,
    isPlaying: !1,
    lockOnWindowScroll: !1,
    orientation: "horizontal",
    playDirection: "forward",
    step: 1,
    dragStep: 1,
    tag: "div",
    touchEnabled: !0,
    dragEnabled: !0,
    visibleSlides: 1,
    infinite: !1,
    isIntrinsicHeight: !1
}), $459ec97bd49637f7$var$_class);
$459ec97bd49637f7$export$762b25d1c14c81e4.Consumer;
var $459ec97bd49637f7$export$3d1fa4549003c3af = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$7cd3b4b6bd9374ef, function(e) {
    return {
        currentSlide: e.currentSlide,
        step: e.step,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides,
        infinite: e.infinite
    };
}), $459ec97bd49637f7$var$s$1 = {
    buttonFirst: "buttonFirst___2rhFr"
}, $459ec97bd49637f7$var$_excluded$2 = [
    "carouselStore",
    "className",
    "currentSlide",
    "disabled",
    "onClick",
    "totalSlides"
], $459ec97bd49637f7$var$_class$1, $459ec97bd49637f7$export$7a6adeb74a8a0c7 = ($459ec97bd49637f7$var$_class$1 = function(e) {
    function t() {
        var e;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(e)), e;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props, r = t.carouselStore, i = t.onClick;
                r.setStoreState({
                    currentSlide: 0,
                    isPlaying: !1
                }, null !== i && i.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.className), r = e.currentSlide, i = e.disabled, n = (e.onClick, e.totalSlides, $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$2)), s = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$1.buttonFirst,
                    "carousel__first-button",
                    t
                ]), o = null !== i ? i : 0 === r;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    type: "button",
                    "aria-label": "first",
                    className: s,
                    onClick: this.handleOnClick,
                    disabled: o
                }, n), this.props.children);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$1, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disabled: $459ec97bd49637f7$var$propTypes.bool,
    onClick: $459ec97bd49637f7$var$propTypes.func,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$1, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
}), $459ec97bd49637f7$var$_class$1), $459ec97bd49637f7$export$149f4fd6616e6e02 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$7a6adeb74a8a0c7, function(e) {
    return {
        currentSlide: e.currentSlide,
        totalSlides: e.totalSlides
    };
}), $459ec97bd49637f7$var$s$2 = {
    buttonLast: "buttonLast___2yuh0"
}, $459ec97bd49637f7$var$_excluded$3 = [
    "carouselStore",
    "className",
    "currentSlide",
    "disabled",
    "onClick",
    "totalSlides",
    "visibleSlides"
], $459ec97bd49637f7$var$_class$2, $459ec97bd49637f7$export$3e62da9914bf9501 = ($459ec97bd49637f7$var$_class$2 = function(e) {
    function t() {
        var e;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(e)), e;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props, r = t.carouselStore, i = t.onClick, n = t.totalSlides, s = t.visibleSlides;
                r.setStoreState({
                    currentSlide: n - s,
                    isPlaying: !1
                }, null !== i && i.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.className), r = e.currentSlide, i = e.disabled, n = (e.onClick, e.totalSlides), s = e.visibleSlides, o = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$3), a = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$2.buttonLast,
                    "carousel__last-button",
                    t
                ]), l = null !== i ? i : r >= n - s;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    type: "button",
                    "aria-label": "last",
                    className: a,
                    onClick: this.handleOnClick,
                    disabled: l
                }, o), this.props.children);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$2, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disabled: $459ec97bd49637f7$var$propTypes.bool,
    onClick: $459ec97bd49637f7$var$propTypes.func,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$2, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
}), $459ec97bd49637f7$var$_class$2), $459ec97bd49637f7$export$5d207e8879874e2f = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$3e62da9914bf9501, function(e) {
    return {
        currentSlide: e.currentSlide,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides
    };
}), $459ec97bd49637f7$var$s$3 = {
    buttonNext: "buttonNext___2mOCa"
}, $459ec97bd49637f7$var$_excluded$4 = [
    "carouselStore",
    "className",
    "currentSlide",
    "disabled",
    "onClick",
    "step",
    "totalSlides",
    "visibleSlides",
    "infinite"
], $459ec97bd49637f7$var$_class$3, $459ec97bd49637f7$export$4a1d9a90191d5c6e = ($459ec97bd49637f7$var$_class$3 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props, r = t.currentSlide, i = t.onClick, n = t.step, s = t.carouselStore, o = t.infinite, a = t.totalSlides - t.visibleSlides, l = n + r, c = Math.min(l, a);
                o && (c = a === r ? 0 : c), s.setStoreState({
                    currentSlide: c,
                    isPlaying: !1
                }, null !== i && i.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, r = (e.carouselStore, e.className), i = e.currentSlide, n = e.disabled, s = (e.onClick, e.step, e.totalSlides), o = e.visibleSlides, a = e.infinite, l = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$4), c = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$3.buttonNext,
                    "carousel__next-button",
                    r
                ]), u = t.setDisabled(n, i, o, s, a);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    type: "button",
                    "aria-label": "next",
                    className: c,
                    onClick: this.handleOnClick,
                    disabled: u
                }, l), this.props.children);
            }
        }
    ], [
        {
            key: "setDisabled",
            value: function(e, t, r, i, n) {
                return null !== e ? e : t >= i - r && !n;
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$3, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disabled: $459ec97bd49637f7$var$propTypes.bool,
    onClick: $459ec97bd49637f7$var$propTypes.func,
    step: $459ec97bd49637f7$var$propTypes.number.isRequired,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    infinite: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$3, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null,
    infinite: !1
}), $459ec97bd49637f7$var$_class$3), $459ec97bd49637f7$export$e16037d7748137b = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$4a1d9a90191d5c6e, function(e) {
    return {
        currentSlide: e.currentSlide,
        step: e.step,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides,
        infinite: e.infinite
    };
}), $459ec97bd49637f7$var$s$4 = {
    buttonNext: "buttonNext___3Lm3s"
}, $459ec97bd49637f7$var$_excluded$5 = [
    "carouselStore",
    "children",
    "childrenPaused",
    "childrenPlaying",
    "className",
    "isPlaying",
    "onClick"
], $459ec97bd49637f7$var$_class$4, $459ec97bd49637f7$export$4d87092972cbf567 = ($459ec97bd49637f7$var$_class$4 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props.onClick;
                this.props.carouselStore.setStoreState({
                    isPlaying: !this.props.isPlaying
                }, null !== t && t.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.children, e.childrenPaused), r = e.childrenPlaying, i = e.className, n = e.isPlaying, s = (e.onClick, $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$5)), o = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$4.buttonNext,
                    "carousel__play-button",
                    i
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    type: "button",
                    "aria-label": "play",
                    className: o,
                    onClick: this.handleOnClick
                }, s), n && r, !n && t, this.props.children);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$4, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$propTypes.node,
    childrenPaused: $459ec97bd49637f7$var$propTypes.node,
    childrenPlaying: $459ec97bd49637f7$var$propTypes.node,
    className: $459ec97bd49637f7$var$propTypes.string,
    isPlaying: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    onClick: $459ec97bd49637f7$var$propTypes.func
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$4, "defaultProps", {
    children: null,
    childrenPaused: null,
    childrenPlaying: null,
    className: null,
    onClick: null
}), $459ec97bd49637f7$var$_class$4), $459ec97bd49637f7$export$23b1e8580c697083 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$4d87092972cbf567, function(e) {
    return {
        isPlaying: e.isPlaying
    };
}), $459ec97bd49637f7$var$s$5 = {
    dot: "dot___3c3SI"
}, $459ec97bd49637f7$var$_excluded$6 = [
    "carouselStore",
    "children",
    "className",
    "currentSlide",
    "disabled",
    "onClick",
    "selected",
    "slide",
    "totalSlides",
    "visibleSlides"
], $459ec97bd49637f7$var$_class$5, $459ec97bd49637f7$export$b0118499ddf539c5 = ($459ec97bd49637f7$var$_class$5 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "handleOnClick",
            value: function(e) {
                var t = this.props, r = t.carouselStore, i = t.onClick, n = t.slide, s = t.totalSlides, o = t.visibleSlides, a = n >= s - o ? s - o : n;
                r.setStoreState({
                    currentSlide: a,
                    isPlaying: !1
                }, null !== i && i.call(this, e));
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.children, e.className), r = e.currentSlide, i = e.disabled, n = (e.onClick, e.selected), s = e.slide, o = (e.totalSlides, e.visibleSlides), a = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$6), l = s >= r && s < r + o, c = "boolean" == typeof n ? n : l, u = !0 === l, p = "boolean" == typeof i ? i : u, d = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$5.dot,
                    c && $459ec97bd49637f7$var$s$5.dotSelected,
                    "carousel__dot",
                    "carousel__dot--".concat(s),
                    c && "carousel__dot--selected",
                    t
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", $459ec97bd49637f7$var$_extends({
                    "aria-label": "slide dot",
                    type: "button",
                    onClick: this.handleOnClick,
                    className: d,
                    disabled: p
                }, a), this.props.children);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$5, "propTypes", {
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disabled: $459ec97bd49637f7$var$propTypes.bool,
    onClick: $459ec97bd49637f7$var$propTypes.func,
    selected: $459ec97bd49637f7$var$propTypes.bool,
    slide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$5, "defaultProps", {
    children: null,
    className: null,
    disabled: null,
    onClick: null,
    selected: null
}), $459ec97bd49637f7$var$_class$5), $459ec97bd49637f7$export$d046b3c4a416f60d = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$b0118499ddf539c5, function(e) {
    return {
        currentSlide: e.currentSlide,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides
    };
}), $459ec97bd49637f7$var$s$6 = {}, $459ec97bd49637f7$var$_excluded$7 = [
    "renderDots"
], $459ec97bd49637f7$var$_excluded2 = [
    "carouselStore",
    "children",
    "className",
    "currentSlide",
    "dotNumbers",
    "totalSlides",
    "visibleSlides",
    "disableActiveDots",
    "showAsSelectedForCurrentSlideOnly",
    "renderDots"
], $459ec97bd49637f7$var$_class$6, $459ec97bd49637f7$export$88994c8c04246b56 = ($459ec97bd49637f7$var$_class$6 = function(e) {
    function t() {
        return $459ec97bd49637f7$var$_classCallCheck(this, t), r.apply(this, arguments);
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "renderDots",
            value: function() {
                var e = this.props, t = e.currentSlide, r = e.totalSlides, i = e.visibleSlides, n = e.disableActiveDots, s = e.showAsSelectedForCurrentSlideOnly, o = e.renderDots;
                if (o) {
                    var a = this.props;
                    a.renderDots;
                    return o($459ec97bd49637f7$var$_objectWithoutProperties(a, $459ec97bd49637f7$var$_excluded$7));
                }
                for(var l = [], c = 0; c < r; c += 1){
                    var u = c >= t && c < t + i, p = c === t, d = s ? p : u, h = c >= r - i ? r - i : c;
                    l.push((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$d046b3c4a416f60d, {
                        key: c,
                        slide: h,
                        selected: d,
                        disabled: !!n && d
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", {
                        className: $459ec97bd49637f7$var$cn["carousel__dot-group-dot"]
                    }, this.props.dotNumbers && c + 1)));
                }
                return l;
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.children), r = e.className, i = (e.currentSlide, e.dotNumbers, e.totalSlides, e.visibleSlides, e.disableActiveDots, e.showAsSelectedForCurrentSlideOnly, e.renderDots, $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded2)), n = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$6.DotGroup,
                    "carousel__dot-group",
                    r
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", $459ec97bd49637f7$var$_extends({
                    className: n
                }, i), this.renderDots(), t);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$6, "propTypes", {
    children: $459ec97bd49637f7$var$CarouselPropTypes.children,
    className: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    dotNumbers: $459ec97bd49637f7$var$propTypes.bool,
    disableActiveDots: $459ec97bd49637f7$var$propTypes.bool,
    showAsSelectedForCurrentSlideOnly: $459ec97bd49637f7$var$propTypes.bool,
    renderDots: $459ec97bd49637f7$var$propTypes.func
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$6, "defaultProps", {
    children: null,
    className: null,
    dotNumbers: !1,
    disableActiveDots: !0,
    showAsSelectedForCurrentSlideOnly: !1,
    renderDots: null
}), $459ec97bd49637f7$var$_class$6), $459ec97bd49637f7$export$d6a83f43bd30da55 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$88994c8c04246b56, function(e) {
    return {
        currentSlide: e.currentSlide,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides
    };
}), $459ec97bd49637f7$var$s$7 = {
    image: "image___xtQGH"
}, $459ec97bd49637f7$var$_excluded$8 = [
    "src",
    "alt"
], $459ec97bd49637f7$var$_excluded2$1 = [
    "carouselStore",
    "children",
    "className",
    "hasMasterSpinner",
    "isBgImage",
    "onError",
    "onLoad",
    "renderError",
    "renderLoading",
    "style",
    "tag"
], $459ec97bd49637f7$export$cdec36d3df60b560 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.state = {
            imageStatus: $459ec97bd49637f7$var$LOADING
        }, i.handleImageLoad = i.handleImageLoad.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleImageError = i.handleImageError.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.image = null, i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "componentDidMount",
            value: function() {
                t.subscribeMasterSpinner(this.props), this.initImage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                e.src !== this.props.src && (t.unsubscribeMasterSpinner(e), t.subscribeMasterSpinner(this.props), this.initImage());
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                t.unsubscribeMasterSpinner(this.props), this.image.removeEventListener("load", this.handleImageLoad), this.image.removeEventListener("error", this.handleImageError), this.image = null;
            }
        },
        {
            key: "initImage",
            value: function() {
                if (this.setState({
                    imageStatus: $459ec97bd49637f7$var$LOADING
                }), this.image = document.createElement("img"), this.image.addEventListener("load", this.handleImageLoad, !1), this.image.addEventListener("error", this.handleImageError, !1), this.image.src = this.props.src, this.image.readyState || this.image.complete) {
                    var e = this.image.src;
                    this.image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", this.image.src = e;
                }
            }
        },
        {
            key: "handleImageLoad",
            value: function(e) {
                this.setState({
                    imageStatus: $459ec97bd49637f7$var$SUCCESS
                }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerSuccess(this.props.src), this.props.onLoad && this.props.onLoad(e);
            }
        },
        {
            key: "handleImageError",
            value: function(e) {
                this.setState({
                    imageStatus: $459ec97bd49637f7$var$ERROR
                }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerError(this.props.src), this.props.onError && this.props.onError(e);
            }
        },
        {
            key: "tempTag",
            value: function() {
                return "img" === this.props.tag ? "div" : this.props.tag;
            }
        },
        {
            key: "customRender",
            value: function(e) {
                return "function" == typeof this.props[e] ? this.props[e]() : this.props.children;
            }
        },
        {
            key: "renderLoading",
            value: function(e) {
                var t = this.tempTag(), r = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$7.image,
                    $459ec97bd49637f7$var$s$7.imageLoading,
                    "carousel__image",
                    this.props.isBgImage && "carousel__image--with-background",
                    "carousel__image--loading",
                    this.props.className
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(t, $459ec97bd49637f7$var$_extends({
                    className: r
                }, e), this.customRender("renderLoading"));
            }
        },
        {
            key: "renderError",
            value: function(e) {
                var t = this.tempTag(), r = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$7.image,
                    $459ec97bd49637f7$var$s$7.imageError,
                    "carousel__image",
                    this.props.isBgImage && "carousel__image--with-background",
                    "carousel__image--error",
                    this.props.className
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(t, $459ec97bd49637f7$var$_extends({
                    className: r
                }, e), this.customRender("renderError"));
            }
        },
        {
            key: "renderSuccess",
            value: function(e) {
                var t = this.props, r = t.style, i = t.tag, n = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$7.image,
                    "carousel__image",
                    this.props.isBgImage && "carousel__image--with-background",
                    "carousel__image--success",
                    this.props.className
                ]), s = $459ec97bd49637f7$var$_extends({}, r), o = e;
                if ("img" !== i) {
                    var a = e.src;
                    e.alt;
                    o = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$8), s = $459ec97bd49637f7$var$_extends({}, r, {
                        backgroundImage: 'url("'.concat(a, '")'),
                        backgroundSize: "cover"
                    });
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(i, $459ec97bd49637f7$var$_extends({
                    className: n,
                    style: s
                }, o), this.props.children);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = (e.carouselStore, e.children, e.className, e.hasMasterSpinner, e.isBgImage, e.onError, e.onLoad, e.renderError, e.renderLoading, e.style, e.tag, $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded2$1));
                switch(this.state.imageStatus){
                    case $459ec97bd49637f7$var$LOADING:
                        return this.renderLoading(t);
                    case $459ec97bd49637f7$var$SUCCESS:
                        return this.renderSuccess(t);
                    case $459ec97bd49637f7$var$ERROR:
                        return this.renderError(t);
                    default:
                        throw new Error("unknown value for this.state.imageStatus");
                }
            }
        }
    ], [
        {
            key: "subscribeMasterSpinner",
            value: function(e) {
                e.hasMasterSpinner && e.carouselStore.subscribeMasterSpinner(e.src);
            }
        },
        {
            key: "unsubscribeMasterSpinner",
            value: function(e) {
                e.hasMasterSpinner && e.carouselStore.unsubscribeMasterSpinner(e.src);
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component);
$459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$export$cdec36d3df60b560, "propTypes", {
    alt: $459ec97bd49637f7$var$propTypes.string,
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children,
    className: $459ec97bd49637f7$var$propTypes.string,
    hasMasterSpinner: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    isBgImage: $459ec97bd49637f7$var$CarouselPropTypes.isBgImage,
    onError: $459ec97bd49637f7$var$propTypes.func,
    onLoad: $459ec97bd49637f7$var$propTypes.func,
    renderError: $459ec97bd49637f7$var$propTypes.func,
    renderLoading: $459ec97bd49637f7$var$propTypes.func,
    src: $459ec97bd49637f7$var$propTypes.string.isRequired,
    style: $459ec97bd49637f7$var$propTypes.object,
    tag: $459ec97bd49637f7$var$propTypes.string
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$export$cdec36d3df60b560, "defaultProps", {
    alt: "",
    children: null,
    className: null,
    isBgImage: !1,
    onError: null,
    onLoad: null,
    renderError: null,
    renderLoading: null,
    style: null,
    tag: "img"
});
var $459ec97bd49637f7$export$3e431a229df88919 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$cdec36d3df60b560, function(e) {
    return {
        hasMasterSpinner: e.hasMasterSpinner,
        orientation: e.orientation
    };
}), $459ec97bd49637f7$var$s$8 = {
    spinner: "spinner___27VUp",
    spin: "spin___S3UuE"
}, $459ec97bd49637f7$var$_excluded$9 = [
    "className"
], $459ec97bd49637f7$var$_class$7, $459ec97bd49637f7$export$7f7cbe89f1eacd2 = ($459ec97bd49637f7$var$_class$7 = function(e) {
    function t() {
        return $459ec97bd49637f7$var$_classCallCheck(this, t), r.apply(this, arguments);
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.className, r = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$9), i = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$8.spinner,
                    "carousel__spinner",
                    t
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", $459ec97bd49637f7$var$_extends({
                    className: i
                }, r));
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$7, "propTypes", {
    className: $459ec97bd49637f7$var$propTypes.string
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$7, "defaultProps", {
    className: null
}), $459ec97bd49637f7$var$_class$7), $459ec97bd49637f7$var$s$9 = {
    container: "container___2O72F",
    overlay: "overlay___IV4qY",
    hover: "hover___MYy31",
    zoom: "zoom___3kqYk",
    loading: "loading___1pvNI",
    imageLoadingSpinnerContainer: "imageLoadingSpinnerContainer___3UIPD"
}, $459ec97bd49637f7$var$_excluded$a = [
    "alt",
    "bgImageProps",
    "bgImageTag",
    "carouselStore",
    "className",
    "imageClassName",
    "overlayClassName",
    "isPinchZoomEnabled",
    "spinner",
    "src",
    "srcZoomed",
    "tag"
], $459ec97bd49637f7$var$_class$8, $459ec97bd49637f7$var$MOUSE_SCALE = 2, $459ec97bd49637f7$var$MAX_TOUCH_SCALE = 3, $459ec97bd49637f7$export$179178a21d6d2c43 = ($459ec97bd49637f7$var$_class$8 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.state = {
            isImageLoading: !0,
            isImageLoadingError: !0,
            isHovering: !1,
            isZooming: !1,
            x: null,
            y: null,
            scale: 1
        }, i.tpCache = {}, i.handleImageComplete = i.handleImageComplete.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleImageLoadError = i.handleImageLoadError.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseOut = i.handleOnMouseOut.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseOver = i.handleOnMouseOver.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "componentDidUpdate",
            value: function(e, t) {
                !1 === t.isZooming && !0 === this.state.isZooming && this.props.carouselStore.setStoreState({
                    isPageScrollLocked: !0
                }), !0 === t.isZooming && !1 === this.state.isZooming && this.props.carouselStore.setStoreState({
                    isPageScrollLocked: !1
                });
            }
        },
        {
            key: "handleImageComplete",
            value: function(e) {
                this.setState({
                    isImageLoading: !1
                }), this.props && this.props.onLoad && this.props.onLoad(e);
            }
        },
        {
            key: "handleImageLoadError",
            value: function(e) {
                this.setState({
                    isImageLoadingError: !0,
                    isImageLoading: !1
                }), this.props && this.props.onError && this.props.onError(e);
            }
        },
        {
            key: "handleOnMouseOver",
            value: function() {
                this.state.isZooming || this.setState({
                    isHovering: !0,
                    scale: $459ec97bd49637f7$var$MOUSE_SCALE
                });
            }
        },
        {
            key: "handleOnMouseOut",
            value: function() {
                this.state.isZooming || this.setState({
                    isHovering: !1,
                    scale: 1
                });
            }
        },
        {
            key: "handleOnMouseMove",
            value: function(e) {
                if (!this.state.isZooming) {
                    var t = $459ec97bd49637f7$var$pct(e.nativeEvent.offsetX / e.target.offsetWidth * 100), r = $459ec97bd49637f7$var$pct(e.nativeEvent.offsetY / e.target.offsetHeight * 100);
                    this.setState({
                        x: t,
                        y: r
                    });
                }
            }
        },
        {
            key: "handleOnTouchStart",
            value: function(e) {
                var t = this;
                this.props.isPinchZoomEnabled && ($459ec97bd49637f7$var$_toConsumableArray(e.targetTouches).forEach(function(e) {
                    t.tpCache[e.identifier] = {
                        clientX: e.clientX,
                        clientY: e.clientY
                    };
                }), this.setState(function(e) {
                    return {
                        isZooming: e.isZooming || Object.keys(t.tpCache).length > 1
                    };
                }));
            }
        },
        {
            key: "handleOnTouchMove",
            value: function(e) {
                var r = this;
                if (this.state.isZooming) {
                    e.persist();
                    var i = $459ec97bd49637f7$var$_toConsumableArray(e.targetTouches).filter(function(e) {
                        return r.tpCache[e.identifier];
                    }).slice(0, 2);
                    if (2 === i.length) {
                        e.stopPropagation();
                        var n = e.target.getBoundingClientRect(), s = i[0].identifier, o = i[1].identifier, a = {
                            x1: this.tpCache[s].clientX,
                            y1: this.tpCache[s].clientY,
                            x2: this.tpCache[o].clientX,
                            y2: this.tpCache[o].clientY
                        };
                        a.distance = t.distanceBetweenTwoTouches($459ec97bd49637f7$var$_objectSpread2({}, a));
                        var l = t.midpointBetweenTwoTouches($459ec97bd49637f7$var$_objectSpread2({}, a));
                        a.cx = l.x, a.cy = l.y;
                        var c = {
                            x1: i[0].clientX,
                            y1: i[0].clientY,
                            x2: i[1].clientX,
                            y2: i[1].clientY
                        };
                        c.distance = t.distanceBetweenTwoTouches($459ec97bd49637f7$var$_objectSpread2({}, c));
                        var u = t.midpointBetweenTwoTouches($459ec97bd49637f7$var$_objectSpread2({}, c));
                        c.cx = u.x, c.cy = u.y;
                        var p = $459ec97bd49637f7$var$pct($459ec97bd49637f7$var$boundedRange({
                            min: 0,
                            max: 100,
                            x: (c.cx - n.left) / n.width * 100
                        })), d = $459ec97bd49637f7$var$pct($459ec97bd49637f7$var$boundedRange({
                            min: 0,
                            max: 100,
                            x: (c.cy - n.top) / n.height * 100
                        })), h = function(e) {
                            return $459ec97bd49637f7$var$boundedRange({
                                min: 1,
                                max: $459ec97bd49637f7$var$MAX_TOUCH_SCALE,
                                x: e.scale + (c.distance - a.distance) / 100
                            });
                        };
                        this.setState(function(e) {
                            return {
                                isZooming: 1 !== h(e),
                                scale: h(e),
                                x: p,
                                y: d
                            };
                        });
                    }
                }
            }
        },
        {
            key: "handleOnTouchEnd",
            value: function(e) {
                var t = this;
                this.props.isPinchZoomEnabled && ($459ec97bd49637f7$var$_toConsumableArray(e.changedTouches).forEach(function(e) {
                    delete t.tpCache[e.identifier];
                }), 0 === Object.keys(this.tpCache).length && this.setState({
                    isZooming: !1
                }));
            }
        },
        {
            key: "renderLoading",
            value: function() {
                if (this.state.isImageLoading) {
                    var e = this.props.spinner;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                        className: $459ec97bd49637f7$var$cn([
                            $459ec97bd49637f7$var$s$9.imageLoadingSpinnerContainer,
                            "carousel__image-loading-spinner-container"
                        ])
                    }, e && e(), !e && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$7f7cbe89f1eacd2, null));
                }
                return null;
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.alt, r = e.bgImageProps, i = e.bgImageTag, n = (e.carouselStore, e.className), s = e.imageClassName, o = e.overlayClassName, a = (e.isPinchZoomEnabled, e.spinner, e.src), l = e.srcZoomed, c = e.tag, u = $459ec97bd49637f7$var$_objectWithoutProperties(e, $459ec97bd49637f7$var$_excluded$a), p = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$9.container,
                    n
                ]), d = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$9.image,
                    "carousel__zoom-image",
                    s
                ]), h = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$9.overlay,
                    "carousel__zoom-image-overlay",
                    this.state.isHovering && $459ec97bd49637f7$var$s$9.hover,
                    this.state.isZooming && $459ec97bd49637f7$var$s$9.zoom,
                    this.state.isHovering && "carousel__zoom-image-overlay--hovering",
                    this.state.isZooming && "carousel__zoom-image-overlay--zooming",
                    o
                ]), y = {};
                return (this.state.isHovering || this.state.isZooming) && (y.transformOrigin = "".concat(this.state.x, " ").concat(this.state.y), y.transform = "scale(".concat(this.state.scale, ")")), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(c, $459ec97bd49637f7$var$_extends({
                    className: p
                }, u), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$3e431a229df88919, $459ec97bd49637f7$var$_extends({
                    alt: t,
                    className: d,
                    tag: i,
                    src: a,
                    onLoad: this.handleImageComplete,
                    onError: this.handleImageLoadError
                }, r)), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$3e431a229df88919, {
                    className: h,
                    tag: "div",
                    src: l || a,
                    style: y,
                    isBgImage: !0,
                    onFocus: this.handleOnMouseOver,
                    onMouseOver: this.handleOnMouseOver,
                    onBlur: this.handleOnMouseOut,
                    onMouseOut: this.handleOnMouseOut,
                    onMouseMove: this.handleOnMouseMove,
                    onTouchStart: this.handleOnTouchStart,
                    onTouchEnd: this.handleOnTouchEnd,
                    onTouchMove: this.handleOnTouchMove
                }), this.renderLoading());
            }
        }
    ], [
        {
            key: "midpointBetweenTwoTouches",
            value: function(e) {
                var t = e.x1, r = e.y1;
                return {
                    x: (t + e.x2) / 2,
                    y: (r + e.y2) / 2
                };
            }
        },
        {
            key: "distanceBetweenTwoTouches",
            value: function(e) {
                var t = e.x1, r = e.y1, i = e.x2, n = e.y2;
                return Math.sqrt(Math.pow(i - t, 2) + Math.pow(n - r, 2));
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$8, "propTypes", {
    alt: $459ec97bd49637f7$var$propTypes.string,
    bgImageProps: $459ec97bd49637f7$var$propTypes.object,
    bgImageTag: $459ec97bd49637f7$var$propTypes.string,
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    imageClassName: $459ec97bd49637f7$var$propTypes.string,
    overlayClassName: $459ec97bd49637f7$var$propTypes.string,
    spinner: $459ec97bd49637f7$var$propTypes.func,
    onLoad: $459ec97bd49637f7$var$propTypes.func,
    onError: $459ec97bd49637f7$var$propTypes.func,
    src: $459ec97bd49637f7$var$propTypes.string.isRequired,
    srcZoomed: $459ec97bd49637f7$var$propTypes.string,
    tag: $459ec97bd49637f7$var$propTypes.string,
    isPinchZoomEnabled: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$8, "defaultProps", {
    alt: void 0,
    bgImageProps: {},
    bgImageTag: "div",
    className: null,
    imageClassName: null,
    overlayClassName: null,
    isPinchZoomEnabled: !0,
    spinner: null,
    onLoad: null,
    onError: null,
    srcZoomed: null,
    tag: "div"
}), $459ec97bd49637f7$var$_class$8), $459ec97bd49637f7$export$f04d5a0a6506c4d9 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$179178a21d6d2c43, function() {
    return {};
}), $459ec97bd49637f7$var$s$a = {
    slide: "slide___3-Nqo",
    slideHorizontal: "slideHorizontal___1NzNV",
    slideInner: "slideInner___2mfX9",
    focusRing: "focusRing___1airF"
}, $459ec97bd49637f7$var$_excluded$b = [
    "ariaLabel",
    "carouselStore",
    "children",
    "className",
    "classNameHidden",
    "classNameVisible",
    "currentSlide",
    "index",
    "innerClassName",
    "innerTag",
    "naturalSlideHeight",
    "naturalSlideWidth",
    "onBlur",
    "onFocus",
    "orientation",
    "slideSize",
    "style",
    "tag",
    "totalSlides",
    "visibleSlides",
    "isIntrinsicHeight"
], $459ec97bd49637f7$var$_class$9, $459ec97bd49637f7$export$5dd047ad0877a630 = ($459ec97bd49637f7$var$_class$9 = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.handleOnFocus = i.handleOnFocus.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnBlur = i.handleOnBlur.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.state = {
            focused: !1
        }, i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "isVisible",
            value: function() {
                var e = this.props, t = e.currentSlide, r = e.index, i = e.visibleSlides;
                return r >= t && r < t + i;
            }
        },
        {
            key: "handleOnFocus",
            value: function(e) {
                var t = this, r = this.props.onFocus;
                this.setState({
                    focused: !0
                }, function() {
                    null !== r && r.call(t, e);
                });
            }
        },
        {
            key: "handleOnBlur",
            value: function(e) {
                var t = this, r = this.props.onBlur;
                this.setState({
                    focused: !1
                }, function() {
                    null !== r && r.call(t, e);
                });
            }
        },
        {
            key: "renderFocusRing",
            value: function() {
                return this.state.focused ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                    className: [
                        $459ec97bd49637f7$var$s$a.focusRing,
                        "carousel__slide-focus-ring"
                    ].join(" ")
                }) : null;
            }
        },
        {
            key: "render",
            value: function() {
                var e = this, t = this.props, r = t.ariaLabel, i = (t.carouselStore, t.children, t.className), n = t.classNameHidden, s = t.classNameVisible, o = (t.currentSlide, t.index, t.innerClassName), a = t.innerTag, l = t.naturalSlideHeight, c = t.naturalSlideWidth, u = (t.onBlur, t.onFocus, t.orientation), p = t.slideSize, d = t.style, h = t.tag, y = t.totalSlides, S = (t.visibleSlides, t.isIntrinsicHeight), b = $459ec97bd49637f7$var$_objectWithoutProperties(t, $459ec97bd49637f7$var$_excluded$b), m = {};
                "horizontal" === u ? (m.width = $459ec97bd49637f7$var$pct(p), m.paddingBottom = $459ec97bd49637f7$var$pct(100 * l / (c * y))) : (m.width = $459ec97bd49637f7$var$pct(100), m.paddingBottom = $459ec97bd49637f7$var$pct(100 * l / c));
                var f = {};
                S && ("horizontal" === u ? m.height = "unset" : m.width = "unset", m.paddingBottom = "unset", f.position = "unset");
                var g = $459ec97bd49637f7$var$_extends({}, m, d), v = this.isVisible(), _ = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$a.slide,
                    "horizontal" === u && $459ec97bd49637f7$var$s$a.slideHorizontal,
                    "carousel__slide",
                    this.state.focused && "carousel__slide--focused",
                    v && s,
                    v && "carousel__slide--visible",
                    !v && n,
                    !v && "carousel__slide--hidden",
                    i
                ]), T = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$a.slideInner,
                    "carousel__inner-slide",
                    o
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(h, $459ec97bd49637f7$var$_extends({
                    ref: function(t) {
                        e.tagRef = t;
                    },
                    "aria-selected": this.isVisible(),
                    "aria-label": r,
                    role: this.props.role,
                    onFocus: this.handleOnFocus,
                    onBlur: this.handleOnBlur,
                    className: _,
                    style: g
                }, b), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(a, {
                    ref: function(t) {
                        e.innerTagRef = t;
                    },
                    className: T,
                    style: f
                }, this.props.children, this.renderFocusRing()));
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).PureComponent), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$9, "propTypes", {
    ariaLabel: $459ec97bd49637f7$var$propTypes.string,
    carouselStore: $459ec97bd49637f7$var$propTypes.object,
    children: $459ec97bd49637f7$var$CarouselPropTypes.children,
    className: $459ec97bd49637f7$var$propTypes.string,
    classNameHidden: $459ec97bd49637f7$var$propTypes.string,
    classNameVisible: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    index: $459ec97bd49637f7$var$propTypes.number.isRequired,
    innerClassName: $459ec97bd49637f7$var$propTypes.string,
    innerTag: $459ec97bd49637f7$var$propTypes.string,
    naturalSlideHeight: $459ec97bd49637f7$var$propTypes.number.isRequired,
    naturalSlideWidth: $459ec97bd49637f7$var$propTypes.number.isRequired,
    onBlur: $459ec97bd49637f7$var$propTypes.func,
    onFocus: $459ec97bd49637f7$var$propTypes.func,
    orientation: $459ec97bd49637f7$var$CarouselPropTypes.orientation.isRequired,
    slideSize: $459ec97bd49637f7$var$propTypes.number.isRequired,
    role: $459ec97bd49637f7$var$propTypes.string,
    style: $459ec97bd49637f7$var$propTypes.object,
    tag: $459ec97bd49637f7$var$propTypes.string,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    isIntrinsicHeight: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$9, "defaultProps", {
    ariaLabel: "slide",
    carouselStore: null,
    children: null,
    className: null,
    classNameHidden: null,
    classNameVisible: null,
    innerClassName: null,
    innerTag: "div",
    onBlur: null,
    onFocus: null,
    role: "option",
    style: {},
    tag: "div",
    isIntrinsicHeight: !1
}), $459ec97bd49637f7$var$_class$9), $459ec97bd49637f7$export$d8dc01b5c85a37b9 = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$5dd047ad0877a630, function(e) {
    return {
        currentSlide: e.currentSlide,
        naturalSlideHeight: e.naturalSlideHeight,
        naturalSlideWidth: e.naturalSlideWidth,
        orientation: e.orientation,
        slideSize: e.slideSize,
        totalSlides: e.totalSlides,
        visibleSlides: e.visibleSlides,
        isIntrinsicHeight: e.isIntrinsicHeight
    };
}), $459ec97bd49637f7$var$GetScrollParent = function() {
    function e() {
        $459ec97bd49637f7$var$_classCallCheck(this, e);
    }
    return $459ec97bd49637f7$var$_createClass(e, [
        {
            key: "parents",
            value: function(e, t) {
                return null === e.parentNode ? t : this.parents(e.parentNode, t.concat([
                    e
                ]));
            }
        },
        {
            key: "scrollParent",
            value: function(t) {
                for(var r = this.parents(t.parentNode, []), i = 0; i < r.length; i += 1)if (e.scroll(r[i])) return r[i];
                return document.scrollingElement || document.documentElement;
            }
        },
        {
            key: "getScrollParent",
            value: function(t) {
                return e.isNodeValid(t) ? this.scrollParent(t) : null;
            }
        }
    ], [
        {
            key: "style",
            value: function(e, t) {
                return getComputedStyle(e, null).getPropertyValue(t);
            }
        },
        {
            key: "overflow",
            value: function(t) {
                return e.style(t, "overflow") + e.style(t, "overflow-y") + e.style(t, "overflow-x");
            }
        },
        {
            key: "scroll",
            value: function(t) {
                return /(auto|scroll)/.test(e.overflow(t));
            }
        },
        {
            key: "isNodeValid",
            value: function(e) {
                return e instanceof HTMLElement || e instanceof SVGElement;
            }
        }
    ]), e;
}(), $459ec97bd49637f7$var$s$b = {
    horizontalSlider: "horizontalSlider___281Ls",
    touchDisabled: "touchDisabled___2qs4y",
    horizontalSliderTray: "horizontalSliderTray___1L-0W",
    verticalSlider: "verticalSlider___34ZFD",
    verticalSliderTray: "verticalSliderTray___267D8",
    verticalTray: "verticalTray___12Key",
    verticalSlideTrayWrap: "verticalSlideTrayWrap___2nO7o",
    sliderTray: "sliderTray___-vHFQ",
    sliderAnimation: "sliderAnimation___300FY",
    masterSpinnerContainer: "masterSpinnerContainer___1Z6hB"
}, $459ec97bd49637f7$var$_excluded$c = [
    "ariaLabel",
    "carouselStore",
    "children",
    "className",
    "classNameAnimation",
    "classNameTray",
    "classNameTrayWrap",
    "currentSlide",
    "disableAnimation",
    "disableKeyboard",
    "dragEnabled",
    "hasMasterSpinner",
    "interval",
    "isPageScrollLocked",
    "isPlaying",
    "lockOnWindowScroll",
    "masterSpinnerFinished",
    "moveThreshold",
    "naturalSlideHeight",
    "naturalSlideWidth",
    "onMasterSpinner",
    "orientation",
    "playDirection",
    "privateUnDisableAnimation",
    "slideSize",
    "slideTraySize",
    "spinner",
    "style",
    "totalSlides",
    "touchEnabled",
    "trayProps",
    "trayTag",
    "visibleSlides",
    "isIntrinsicHeight"
], $459ec97bd49637f7$var$_excluded2$2 = [
    "dragStep",
    "step",
    "infinite",
    "preventVerticalScrollOnTouch",
    "preventingVerticalScroll",
    "horizontalPixelThreshold",
    "verticalPixelThreshold"
], $459ec97bd49637f7$var$_excluded3 = [
    "className",
    "onClickCapture",
    "onMouseDown",
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "ref",
    "style"
], $459ec97bd49637f7$var$_class$a, $459ec97bd49637f7$export$cb60be91423cd1fe = ($459ec97bd49637f7$var$_class$a = function(e) {
    function t(e) {
        var i;
        return $459ec97bd49637f7$var$_classCallCheck(this, t), i = r.call(this, e), i.getSliderRef = i.getSliderRef.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleDocumentScroll = i.handleDocumentScroll.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnClickCapture = i.handleOnClickCapture.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnKeyDown = i.handleOnKeyDown.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseDown = i.handleOnMouseDown.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnMouseUp = i.handleOnMouseUp.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchCancel = i.handleOnTouchCancel.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.playBackward = i.playBackward.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.playForward = i.playForward.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.callCallback = i.callCallback.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.blockWindowScroll = i.blockWindowScroll.bind($459ec97bd49637f7$var$_assertThisInitialized(i)), i.state = {
            cancelNextClick: !1,
            deltaX: 0,
            deltaY: 0,
            isBeingMouseDragged: !1,
            isBeingTouchDragged: !1,
            preventingVerticalScroll: !1,
            startX: 0,
            startY: 0
        }, i.interval = null, i.isDocumentScrolling = null, i.moveTimer = null, i.originalOverflow = null, i.scrollParent = null, i.scrollStopTimer = null, i;
    }
    $459ec97bd49637f7$var$_inherits(t, e);
    var r = $459ec97bd49637f7$var$_createSuper(t);
    return $459ec97bd49637f7$var$_createClass(t, [
        {
            key: "componentDidMount",
            value: function() {
                this.props.lockOnWindowScroll && window.addEventListener("scroll", this.handleDocumentScroll, !1), (this.props.touchEnabled || this.props.preventVerticalScrollOnTouch) && window.addEventListener("touchmove", this.blockWindowScroll, !1), document.documentElement.addEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.addEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.addEventListener("mouseup", this.handleOnMouseUp, !1), this.props.isPlaying && this.play();
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                !e.isPlaying && this.props.isPlaying && this.play(), e.isPlaying && !this.props.isPlaying && this.stop(), !e.isPageScrollLocked && this.props.isPageScrollLocked && this.lockScroll(), e.isPageScrollLocked && !this.props.isPageScrollLocked && this.unlockScroll(), !1 === e.privateUnDisableAnimation && !0 === this.props.privateUnDisableAnimation && this.props.carouselStore.setStoreState({
                    privateUnDisableAnimation: !1,
                    disableAnimation: !1
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                document.documentElement.removeEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.removeEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.removeEventListener("mouseup", this.handleOnMouseUp, !1), window.removeEventListener("scroll", this.handleDocumentScroll, !1), window.removeEventListener("touchmove", this.blockWindowScroll, !1), this.stop(), window.cancelAnimationFrame.call(window, this.moveTimer), window.clearTimeout(this.scrollStopTimer), this.isDocumentScrolling = null, this.moveTimer = null, this.scrollStopTimer = null;
            }
        },
        {
            key: "getSliderRef",
            value: function(e) {
                if (this.sliderTrayElement = e, e && window) {
                    var t = e.closest(".carousel");
                    t && (this.rtl = "rtl" === window.getComputedStyle(t, null).getPropertyValue("direction"));
                }
            }
        },
        {
            key: "fakeOnDragStart",
            value: function(e) {
                var t = e.screenX, r = e.screenY, i = e.touchDrag, n = void 0 !== i && i, s = e.mouseDrag, o = void 0 !== s && s;
                this.props.carouselStore.setStoreState({
                    isPlaying: !1
                }), window.cancelAnimationFrame.call(window, this.moveTimer), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
                    isPageScrollLocked: !0
                }), this.setState({
                    isBeingTouchDragged: n,
                    isBeingMouseDragged: o,
                    startX: t,
                    startY: r
                });
            }
        },
        {
            key: "fakeOnDragMove",
            value: function(e, t) {
                var r = this;
                window.cancelAnimationFrame.call(window, this.moveTimer), this.moveTimer = window.requestAnimationFrame.call(window, function() {
                    r.setState(function(i) {
                        return {
                            deltaX: (e - i.startX) * (r.rtl ? -1 : 1),
                            deltaY: t - i.startY,
                            preventingVerticalScroll: Math.abs(t - i.startY) <= r.props.verticalPixelThreshold && Math.abs(e - i.startX) >= r.props.horizontalPixelThreshold
                        };
                    });
                });
            }
        },
        {
            key: "fakeOnDragEnd",
            value: function() {
                window.cancelAnimationFrame.call(window, this.moveTimer), this.computeCurrentSlide(), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
                    isPageScrollLocked: !1
                }), this.setState({
                    deltaX: 0,
                    deltaY: 0,
                    isBeingTouchDragged: !1,
                    isBeingMouseDragged: !1
                }), this.isDocumentScrolling = !this.props.lockOnWindowScroll && null;
            }
        },
        {
            key: "callCallback",
            value: function(e, t) {
                var r = this.props.trayProps;
                r && "function" == typeof r[e] && (t.persist(), r[e](t));
            }
        },
        {
            key: "handleOnMouseDown",
            value: function(e) {
                if (!this.props.dragEnabled) return void this.callCallback("onMouseDown", e);
                e.preventDefault(), this.fakeOnDragStart({
                    screenX: e.screenX,
                    screenY: e.screenY,
                    mouseDrag: !0
                }), this.callCallback("onMouseDown", e);
            }
        },
        {
            key: "handleOnMouseMove",
            value: function(e) {
                this.state.isBeingMouseDragged && (this.setState({
                    cancelNextClick: !0
                }), e.preventDefault(), this.fakeOnDragMove(e.screenX, e.screenY));
            }
        },
        {
            key: "handleOnMouseUp",
            value: function(e) {
                this.state.isBeingMouseDragged && (e.preventDefault(), this.fakeOnDragEnd());
            }
        },
        {
            key: "handleOnClickCapture",
            value: function(e) {
                if (!this.state.cancelNextClick) return void this.callCallback("onClickCapture", e);
                e.preventDefault(), this.setState({
                    cancelNextClick: !1
                }), this.callCallback("onClickCapture", e);
            }
        },
        {
            key: "handleOnTouchStart",
            value: function(e) {
                if (!this.props.touchEnabled) return void this.callCallback("onTouchStart", e);
                "vertical" === this.props.orientation && e.preventDefault();
                var t = e.targetTouches[0];
                this.fakeOnDragStart({
                    screenX: t.screenX,
                    screenY: t.screenY,
                    touchDrag: !0
                }), this.callCallback("onTouchStart", e);
            }
        },
        {
            key: "handleDocumentScroll",
            value: function() {
                var e = this;
                this.props.touchEnabled && (this.isDocumentScrolling = !0, window.clearTimeout(this.scrollStopTimer), this.scrollStopTimer = window.setTimeout(function() {
                    e.isDocumentScrolling = !1;
                }, 66));
            }
        },
        {
            key: "handleOnTouchMove",
            value: function(e) {
                if (!this.props.touchEnabled || this.props.lockOnWindowScroll && this.isDocumentScrolling) return void this.callCallback("onTouchMove", e);
                var t = e.targetTouches[0];
                t && (this.fakeOnDragMove(t.screenX, t.screenY), this.callCallback("onTouchMove", e));
            }
        },
        {
            key: "forward",
            value: function() {
                var e = this.props, t = e.currentSlide, r = e.step, i = e.totalSlides, n = e.visibleSlides;
                return Math.min(t + r, i - n);
            }
        },
        {
            key: "backward",
            value: function() {
                var e = this.props, t = e.currentSlide, r = e.step;
                return Math.max(t - r, 0);
            }
        },
        {
            key: "handleOnKeyDown",
            value: function(e) {
                var t = e.keyCode, r = this.props, i = r.carouselStore, n = r.currentSlide, s = r.disableKeyboard, o = r.totalSlides, a = r.visibleSlides, l = {};
                !0 === s || o <= a || (37 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.max(0, n - 1), l.isPlaying = !1), 39 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.min(o - a, n + 1), l.isPlaying = !1), i.setStoreState(l));
            }
        },
        {
            key: "playForward",
            value: function() {
                var e = this.props, t = e.carouselStore, r = e.currentSlide;
                t.setStoreState({
                    currentSlide: this.forward() === r ? 0 : this.forward()
                });
            }
        },
        {
            key: "playBackward",
            value: function() {
                var e = this.props, t = e.carouselStore, r = e.currentSlide, i = e.totalSlides, n = e.visibleSlides;
                t.setStoreState({
                    currentSlide: this.backward() === r ? i - n : this.backward()
                });
            }
        },
        {
            key: "play",
            value: function() {
                var e = this.props.playDirection;
                this.interval = setInterval("forward" === e ? this.playForward : this.playBackward, this.props.interval);
            }
        },
        {
            key: "stop",
            value: function() {
                window.clearInterval(this.interval), this.interval = null;
            }
        },
        {
            key: "lockScroll",
            value: function() {
                var e = new $459ec97bd49637f7$var$GetScrollParent;
                this.scrollParent = e.getScrollParent(this.sliderTrayElement), this.scrollParent && (this.originalOverflow = this.originalOverflow || this.scrollParent.style.overflow, this.scrollParent.style.overflow = "hidden");
            }
        },
        {
            key: "unlockScroll",
            value: function() {
                this.scrollParent && (this.scrollParent.style.overflow = this.originalOverflow, this.originalOverflow = null, this.scrollParent = null);
            }
        },
        {
            key: "blockWindowScroll",
            value: function(e) {
                this.state.preventingVerticalScroll && (e.preventDefault(), e.stopImmediatePropagation());
            }
        },
        {
            key: "computeCurrentSlide",
            value: function() {
                var e = t.slideSizeInPx(this.props.orientation, this.sliderTrayElement.clientWidth, this.sliderTrayElement.clientHeight, this.props.totalSlides), r = t.slidesMoved(this.props.moveThreshold, this.props.orientation, this.state.deltaX, this.state.deltaY, e, this.props.dragStep), i = this.props.totalSlides - Math.min(this.props.totalSlides, this.props.visibleSlides), n = $459ec97bd49637f7$var$boundedRange({
                    min: 0,
                    max: i,
                    x: this.props.currentSlide + r
                });
                this.props.infinite && (this.props.currentSlide >= i && r > 0 && (n = 0), 0 === this.props.currentSlide && r < 0 && (n = i)), this.props.carouselStore.setStoreState({
                    currentSlide: n
                });
            }
        },
        {
            key: "focus",
            value: function() {
                this.sliderElement.focus();
            }
        },
        {
            key: "handleOnTouchEnd",
            value: function(e) {
                this.endTouchMove(), this.callCallback("onTouchEnd", e);
            }
        },
        {
            key: "handleOnTouchCancel",
            value: function(e) {
                this.endTouchMove(), this.callCallback("onTouchCancel", e);
            }
        },
        {
            key: "endTouchMove",
            value: function() {
                this.props.touchEnabled && this.fakeOnDragEnd();
            }
        },
        {
            key: "renderMasterSpinner",
            value: function() {
                var e = this.props, t = e.hasMasterSpinner, r = e.masterSpinnerFinished, i = e.spinner;
                return t && !r ? ("function" == typeof this.props.onMasterSpinner && this.props.onMasterSpinner(), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                    className: $459ec97bd49637f7$var$cn([
                        $459ec97bd49637f7$var$s$b.masterSpinnerContainer,
                        "carousel__master-spinner-container"
                    ])
                }, i && i(), !i && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($459ec97bd49637f7$export$7f7cbe89f1eacd2, null))) : null;
            }
        },
        {
            key: "render",
            value: function() {
                var e = this, t = this.props, r = t.ariaLabel, i = (t.carouselStore, t.children), n = t.className, s = t.classNameAnimation, o = t.classNameTray, a = t.classNameTrayWrap, l = t.currentSlide, c = t.disableAnimation, u = (t.disableKeyboard, t.dragEnabled, t.hasMasterSpinner, t.interval, t.isPageScrollLocked, t.isPlaying, t.lockOnWindowScroll, t.masterSpinnerFinished, t.moveThreshold, t.naturalSlideHeight), p = t.naturalSlideWidth, d = (t.onMasterSpinner, t.orientation), h = (t.playDirection, t.privateUnDisableAnimation, t.slideSize), y = t.slideTraySize, S = (t.spinner, t.style), b = (t.totalSlides, t.touchEnabled), m = t.trayProps, f = t.trayTag, g = t.visibleSlides, v = t.isIntrinsicHeight, _ = $459ec97bd49637f7$var$_objectWithoutProperties(t, $459ec97bd49637f7$var$_excluded$c), T = $459ec97bd49637f7$var$_extends({}, S), k = {};
                "vertical" === d && (k.height = 0, k.paddingBottom = $459ec97bd49637f7$var$pct(100 * u * g / p), k.width = $459ec97bd49637f7$var$pct(100));
                var C = {}, O = $459ec97bd49637f7$var$pct(h * l * -1);
                (this.state.isBeingTouchDragged || this.state.isBeingMouseDragged || c) && (C.transition = "none"), v && (C.display = "flex", C.alignItems = "stretch"), "vertical" === d ? (C.transform = "translateY(".concat(O, ") translateY(").concat(this.state.deltaY, "px)"), C.width = $459ec97bd49637f7$var$pct(100), C.flexDirection = "column") : (C.width = $459ec97bd49637f7$var$pct(y), C.transform = "translateX(".concat(O, ") translateX(").concat(this.state.deltaX, "px)"), C.flexDirection = "row");
                var P = $459ec97bd49637f7$var$cn([
                    "vertical" === d ? $459ec97bd49637f7$var$s$b.verticalSlider : $459ec97bd49637f7$var$s$b.horizontalSlider,
                    !b && $459ec97bd49637f7$var$s$b.touchDisabled,
                    "carousel__slider",
                    "vertical" === d ? "carousel__slider--vertical" : "carousel__slider--horizontal",
                    n
                ]), E = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$b.sliderTrayWrap,
                    "carousel__slider-tray-wrapper",
                    "vertical" === d ? $459ec97bd49637f7$var$s$b.verticalSlideTrayWrap : $459ec97bd49637f7$var$s$b.horizontalTrayWrap,
                    "vertical" === d ? "carousel__slider-tray-wrap--vertical" : "carousel__slider-tray-wrap--horizontal",
                    a
                ]), w = $459ec97bd49637f7$var$cn([
                    $459ec97bd49637f7$var$s$b.sliderTray,
                    s || $459ec97bd49637f7$var$s$b.sliderAnimation,
                    "carousel__slider-tray",
                    "vertical" === d ? $459ec97bd49637f7$var$s$b.verticalTray : $459ec97bd49637f7$var$s$b.horizontalTray,
                    "vertical" === d ? "carousel__slider-tray--vertical" : "carousel__slider-tray--horizontal",
                    o
                ]), M = (_.dragStep, _.step, _.infinite, _.preventVerticalScrollOnTouch, _.preventingVerticalScroll, _.horizontalPixelThreshold, _.verticalPixelThreshold, $459ec97bd49637f7$var$_objectWithoutProperties(_, $459ec97bd49637f7$var$_excluded2$2)), x = (m.className, m.onClickCapture, m.onMouseDown, m.onTouchCancel, m.onTouchEnd, m.onTouchMove, m.onTouchStart, m.ref, m.style, $459ec97bd49637f7$var$_objectWithoutProperties(m, $459ec97bd49637f7$var$_excluded3));
                return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", $459ec97bd49637f7$var$_extends({
                    ref: function(t) {
                        e.sliderElement = t;
                    },
                    className: P,
                    "aria-live": "polite",
                    "aria-label": r,
                    role: this.props.role,
                    style: T,
                    onKeyDown: this.handleOnKeyDown
                }, M), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
                    className: E,
                    style: k
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(f, $459ec97bd49637f7$var$_extends({
                    ref: this.getSliderRef,
                    className: w,
                    style: C,
                    onTouchStart: this.handleOnTouchStart,
                    onTouchMove: this.handleOnTouchMove,
                    onTouchEnd: this.handleOnTouchEnd,
                    onTouchCancel: this.handleOnTouchCancel,
                    onMouseDown: this.handleOnMouseDown,
                    onClickCapture: this.handleOnClickCapture
                }, x), i), this.renderMasterSpinner()));
            }
        }
    ], [
        {
            key: "slideSizeInPx",
            value: function(e, t, r, i) {
                return ("horizontal" === e ? t : r) / i;
            }
        },
        {
            key: "slidesMoved",
            value: function(e, t, r, i, n, s) {
                var o = "horizontal" === t ? r : i, a = Math.abs(Math.round(o / n)), l = Math.abs(o) >= n * e ? s : 0, c = Math.max(l, a);
                if (o < 0) return c;
                var u = -c;
                return 0 === u ? 0 : u;
            }
        }
    ]), t;
}((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$a, "propTypes", {
    ariaLabel: $459ec97bd49637f7$var$propTypes.string,
    carouselStore: $459ec97bd49637f7$var$propTypes.object.isRequired,
    children: $459ec97bd49637f7$var$propTypes.node.isRequired,
    className: $459ec97bd49637f7$var$propTypes.string,
    classNameAnimation: $459ec97bd49637f7$var$propTypes.string,
    classNameTray: $459ec97bd49637f7$var$propTypes.string,
    classNameTrayWrap: $459ec97bd49637f7$var$propTypes.string,
    currentSlide: $459ec97bd49637f7$var$propTypes.number.isRequired,
    disableAnimation: $459ec97bd49637f7$var$propTypes.bool,
    disableKeyboard: $459ec97bd49637f7$var$propTypes.bool,
    dragEnabled: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    dragStep: $459ec97bd49637f7$var$propTypes.number,
    hasMasterSpinner: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    infinite: $459ec97bd49637f7$var$propTypes.bool,
    interval: $459ec97bd49637f7$var$propTypes.number.isRequired,
    isPageScrollLocked: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    isPlaying: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    lockOnWindowScroll: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    preventVerticalScrollOnTouch: $459ec97bd49637f7$var$propTypes.bool,
    horizontalPixelThreshold: $459ec97bd49637f7$var$propTypes.number,
    verticalPixelThreshold: $459ec97bd49637f7$var$propTypes.number,
    masterSpinnerFinished: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    moveThreshold: $459ec97bd49637f7$var$propTypes.number,
    naturalSlideHeight: $459ec97bd49637f7$var$propTypes.number.isRequired,
    naturalSlideWidth: $459ec97bd49637f7$var$propTypes.number.isRequired,
    onMasterSpinner: $459ec97bd49637f7$var$propTypes.func,
    orientation: $459ec97bd49637f7$var$CarouselPropTypes.orientation.isRequired,
    playDirection: $459ec97bd49637f7$var$CarouselPropTypes.direction.isRequired,
    privateUnDisableAnimation: $459ec97bd49637f7$var$propTypes.bool,
    role: $459ec97bd49637f7$var$propTypes.string,
    slideSize: $459ec97bd49637f7$var$propTypes.number.isRequired,
    slideTraySize: $459ec97bd49637f7$var$propTypes.number.isRequired,
    spinner: $459ec97bd49637f7$var$propTypes.func,
    step: $459ec97bd49637f7$var$propTypes.number.isRequired,
    style: $459ec97bd49637f7$var$propTypes.object,
    totalSlides: $459ec97bd49637f7$var$propTypes.number.isRequired,
    touchEnabled: $459ec97bd49637f7$var$propTypes.bool.isRequired,
    trayProps: $459ec97bd49637f7$var$propTypes.shape({
        className: $459ec97bd49637f7$var$propTypes.string,
        onClickCapture: $459ec97bd49637f7$var$propTypes.func,
        onMouseDown: $459ec97bd49637f7$var$propTypes.func,
        onTouchCancel: $459ec97bd49637f7$var$propTypes.func,
        onTouchEnd: $459ec97bd49637f7$var$propTypes.func,
        onTouchMove: $459ec97bd49637f7$var$propTypes.func,
        onTouchStart: $459ec97bd49637f7$var$propTypes.func,
        ref: $459ec97bd49637f7$var$propTypes.shape({}),
        style: $459ec97bd49637f7$var$propTypes.string
    }),
    trayTag: $459ec97bd49637f7$var$propTypes.string,
    visibleSlides: $459ec97bd49637f7$var$propTypes.number,
    isIntrinsicHeight: $459ec97bd49637f7$var$propTypes.bool
}), $459ec97bd49637f7$var$_defineProperty($459ec97bd49637f7$var$_class$a, "defaultProps", {
    ariaLabel: "slider",
    className: null,
    classNameAnimation: null,
    classNameTray: null,
    classNameTrayWrap: null,
    disableAnimation: !1,
    disableKeyboard: !1,
    dragStep: 1,
    infinite: !1,
    preventVerticalScrollOnTouch: !0,
    horizontalPixelThreshold: 15,
    verticalPixelThreshold: 10,
    moveThreshold: .1,
    onMasterSpinner: null,
    privateUnDisableAnimation: !1,
    role: "listbox",
    spinner: null,
    style: {},
    trayProps: {},
    trayTag: "div",
    visibleSlides: 1,
    isIntrinsicHeight: !1
}), $459ec97bd49637f7$var$_class$a), $459ec97bd49637f7$export$472062a354075cee = $459ec97bd49637f7$export$4e3bb82032960c4b($459ec97bd49637f7$export$cb60be91423cd1fe, function(e) {
    return {
        currentSlide: e.currentSlide,
        disableAnimation: e.disableAnimation,
        privateUnDisableAnimation: e.privateUnDisableAnimation,
        disableKeyboard: e.disableKeyboard,
        dragEnabled: e.dragEnabled,
        hasMasterSpinner: e.hasMasterSpinner,
        infinite: e.infinite,
        interval: e.interval,
        isPageScrollLocked: e.isPageScrollLocked,
        isPlaying: e.isPlaying,
        lockOnWindowScroll: e.lockOnWindowScroll,
        preventingVerticalScroll: e.preventingVerticalScroll,
        masterSpinnerFinished: e.masterSpinnerFinished,
        naturalSlideHeight: e.naturalSlideHeight,
        naturalSlideWidth: e.naturalSlideWidth,
        orientation: e.orientation,
        playDirection: e.playDirection,
        slideSize: e.slideSize,
        slideTraySize: e.slideTraySize,
        step: e.step,
        dragStep: e.dragStep,
        totalSlides: e.totalSlides,
        touchEnabled: e.touchEnabled,
        visibleSlides: e.visibleSlides,
        isIntrinsicHeight: e.isIntrinsicHeight
    };
});





var $8NFma = parcelRequire("8NFma");



const $54f13a8b273c14ac$export$29ab0a58e0457c56 = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
            "fill-rule": "evenodd",
            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
        })
    });
};
const $54f13a8b273c14ac$export$6172d85aadfc9b96 = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
            "fill-rule": "evenodd",
            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
        })
    });
};


const $c86bc7693025f91d$export$972bd6ac6d6ad82b = ({ activeItem: activeItem, currentSlide: currentSlide, setCurrentSlide: setCurrentSlide })=>{
    const carouselContext = (0, $8NFma.useContext)((0, $459ec97bd49637f7$export$762b25d1c14c81e4));
    (0, $8NFma.useEffect)(()=>{
        carouselContext.subscribe(()=>{
            setCurrentSlide(carouselContext.state.currentSlide);
        });
    }, []);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $459ec97bd49637f7$export$472062a354075cee), {
                children: activeItem.images.map((item, index)=>{
                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $459ec97bd49637f7$export$d8dc01b5c85a37b9), {
                        index: index,
                        className: "panel",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            style: {
                                background: `url(${item}) no-repeat`,
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                height: "100%"
                            }
                        })
                    }, `${activeItem.id}-${index}`);
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "flex gap-2 mt-4 text-2xl font-medium",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $459ec97bd49637f7$export$3d1fa4549003c3af), {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $54f13a8b273c14ac$export$29ab0a58e0457c56), {})
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            currentSlide + 1,
                            " / ",
                            activeItem.images.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $459ec97bd49637f7$export$e16037d7748137b), {
                        onClick: ()=>{
                            setCurrentSlide(currentSlide + 1);
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $54f13a8b273c14ac$export$6172d85aadfc9b96), {})
                    })
                ]
            })
        ]
    });
};




var $8NFma = parcelRequire("8NFma");

const $09b56984dfc656a4$export$a5c7b93649eaf8f8 = ({ markers: markers, setActiveItem: setActiveItem, ymaps3Reactify: ymaps3Reactify })=>{
    const reactify = ymaps3Reactify.reactify.bindTo((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))), (0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))));
    const { YMap: YMap, YMapDefaultSchemeLayer: YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer: YMapDefaultFeaturesLayer, YMapMarker: YMapMarker } = reactify.module(ymaps3);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: "h-96 pb-5",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)(YMap, {
            location: {
                center: [
                    44.006516,
                    56.326797
                ],
                zoom: 10,
                duration: 300
            },
            mode: "vector",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(YMapDefaultSchemeLayer, {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(YMapDefaultFeaturesLayer, {}),
                markers.map((item, key)=>{
                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(YMapMarker, {
                        hideOutsideViewport: true,
                        coordinates: item.coord,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            onClick: ()=>{
                                setActiveItem(item);
                            },
                            className: "h-8 w-8 absolute -left-4 -top-4 bg-gray-800 flex items-center justify-center rounded-full cursor-pointer",
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                src: "/img/skb-icon.svg",
                                className: "w-4/6"
                            })
                        })
                    }, key);
                })
            ]
        })
    });
};



const $c5e13dc5a3ae89b6$var$load = async ()=>{
    const ymaps3Reactify = await ymaps3.import("@yandex/ymaps3-reactify");
    const Gallery = ()=>{
        const [markers, setMarkers] = (0, $8NFma.useState)([]);
        const [activeItem, setActiveItem] = (0, $8NFma.useState)(null);
        const [currentSlide, setCurrentSlide] = (0, $8NFma.useState)(0);
        const getMarkers = async ()=>{
            const response = await fetch("/api/gallery/get");
            const result = response.json();
            return result;
        };
        (0, $8NFma.useEffect)(()=>{
            (async ()=>{
                setMarkers(await getMarkers());
            })();
        }, []);
        (0, $8NFma.useEffect)(()=>{
            setCurrentSlide(0);
        }, [
            activeItem
        ]);
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $09b56984dfc656a4$export$a5c7b93649eaf8f8), {
                    markers: markers,
                    setActiveItem: setActiveItem,
                    ymaps3Reactify: ymaps3Reactify
                }),
                activeItem && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "fixed top-0 right-0 h-screen w-full bg-white z-40 shadow-lg transform transition-transform duration-200 ease-in-out px-5",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "container mx-auto pt-2",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "py-6 flex justify-end",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                                    onClick: ()=>setActiveItem(null),
                                    className: "focus:outline-none",
                                    "data-action": "toggle-sidebar",
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            id: "line1",
                                            className: "block w-8 h-0.5 bg-black transition-all duration-300 rotate-45 transform translate-y-1.5"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            id: "line2",
                                            className: "block w-8 h-0.5 mt-1 bg-black transition-all duration-300 -rotate-45"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "flex flex-col gap-4 lg:flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        className: "w-full lg:w-1/4",
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                                                className: "text-xl lg:text-3xl uppercase font-bold pb-5",
                                                children: activeItem.title
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                children: activeItem.address
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                className: "rounded-full border border-gray-600 py-4 px-6 text-gray-600 mt-4",
                                                onClick: (0, $87580384247dcec3$export$2859119d518272d1),
                                                children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        className: "w-full lg:w-3/4",
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $459ec97bd49637f7$export$42591ef794b036fd), {
                                            naturalSlideWidth: 100,
                                            naturalSlideHeight: 60,
                                            currentSlide: currentSlide,
                                            totalSlides: activeItem.images.length,
                                            infinite: true,
                                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c86bc7693025f91d$export$972bd6ac6d6ad82b), {
                                                activeItem: activeItem,
                                                setCurrentSlide: setCurrentSlide,
                                                currentSlide: currentSlide
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "grid grid-cols-2 lg:grid-cols-3 gap-5",
                    children: markers.map((item, index)=>{
                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            onClick: ()=>setActiveItem(item),
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    src: `/uploads/240x180/${item.coverImage}`,
                                    className: "w-full"
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "py-5 font-semibold lg:text-xl",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "text-sm lg:text-lg",
                                    children: item.address
                                })
                            ]
                        }, index);
                    })
                })
            ]
        });
    };
    const container = document.getElementById("gallery");
    if (container) {
        const root = (0, (/*@__PURE__*/$parcel$interopDefault($503937b663c395c4$exports))).createRoot(container);
        root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Gallery, {}));
    }
};
$c5e13dc5a3ae89b6$var$load();




const $dc706e5c8817037c$var$slider = document.querySelector(".glide-zee");
const $dc706e5c8817037c$var$amount = document.querySelector("[data-role='slide-zee-amount']");
if ($dc706e5c8817037c$var$slider && $dc706e5c8817037c$var$amount) {
    const totalSlideCount = $dc706e5c8817037c$var$amount.getAttribute("data-count");
    const glide = new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(".glide-zee", {
        perView: 1.2
    });
    glide.on([
        "mount.after",
        "run"
    ], function() {
        const index = glide.index + 1;
        $dc706e5c8817037c$var$amount.innerHTML = `${index.toString()} / ${totalSlideCount}`;
    });
    glide.mount();
}


const $e74ac7809edb4cda$var$serviceBtns = document.querySelectorAll("[data-role='service-btn']");
$e74ac7809edb4cda$var$serviceBtns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        // Define value of btn
        const btnValue = btn.getAttribute("data-value");
        // Set all buttons gray color
        $e74ac7809edb4cda$var$serviceBtns.forEach((item)=>{
            item.classList.remove("bg-skb");
            item.classList.remove("text-white");
            item.classList.add("bg-lightGray");
        });
        // set blue color to clicked button
        btn.classList.add("bg-skb");
        btn.classList.add("text-white");
        document.querySelectorAll("[data-role='grid-hover-item']").forEach((item)=>{
            if (item.getAttribute("data-value") == btnValue) item.classList.remove("hidden");
            else if (btnValue == "all") item.classList.remove("hidden");
            else item.classList.add("hidden");
        });
    });
});



})();
//# sourceMappingURL=index.js.map
